import React from 'react'
import Image from "next/image";
import Head from "next/head"
import upscWebBanner from "../../assets/images/upsc/about-upsc.jpg";
import styles from "../about-upsc/about-upsc.module.css";
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Interest from '../../components/might-be-interest';
import Link from 'next/link';



const Upsc_Syllabus= () => {
   
    const list =[
        {listcont:"Current events of national and international importance"},
        {listcont:"History of India and the Indian National Movement"},
        {listcont:"Indian and World Geography-Physical, Social and Economic Geography of India and the World"},
        {listcont:"Indian Polity and Governance-Constitution, Political System, Panchayati Raj, Public Policy, Rights Issues, etc."},
        {listcont:"Economic and Social Development-Sustainable Development, Poverty, Inclusion, Demographics, Social Sector initiatives, etc."},
        {listcont:"General issues on Environmental Ecology, Bio-diversity and Climate Change - that do not require subject specialization."},
        {listcont:"General Science."}
      ]
    const secondlist =[
        {list:"Comprehension"},
        {list:"Interpersonal skills including communication skills"},
        {list:"Logical reasoning and Analytical ability"},
        {list:"Decision-making and Problem-solving"},
        {list:"General mental ability"},
        {list:"Decision-making and Problem-solving"},
        {list:"Basic numeracy (numbers and their relations, orders of magnitude, etc.) (Class X level), Data interpretation (charts, graphs, tables, data sufficiency etc.(Class X level)."}
      ]
    
    const thirdlist =[
        {list:"Indian culture will cover the salient aspects of Art Forms, Literature and Architecture from ancient to modern times."},
        {list:"Modern Indian history from about the middle of the eighteenth century until the present- significant events, personalities and issues."},
        {list:"The Freedom Struggle - its various stages and important contributors /contributions from different parts of the country."},
        {list:"Post-independence consolidation and reorganization within the country."},
        {list:"History of the world will include events from 18th century such as the industrial revolution, world wars, redrawal of national boundaries, colonization, decolonization, political philosophies like communism, capitalism, socialism etc. their forms and effect on the society."},
        {list:"Salient features of the Indian Society Diversity of India."},
        {list:"Role of women and women’s organizations, population and associated issues, poverty and developmental issues, urbanization, their problems and their remedies."},
        {list:"Effects of globalization on the Indian society. Social empowerment, communalism, regionalism and secularism."},
        {list:"Salient features of world’s physical geography."},
        {list:"Distribution of key natural resources across the world (including South Asia and the Indian subcontinent); factors responsible for the location of primary, secondary, and tertiary sector industries in various parts of the world (including India)"},
        {list:"Important Geophysical phenomena such as earthquakes, Tsunami, Volcanic activity, cyclone etc., geographical features and their location- changes in critical geographical features (including water bodies and ice-caps) and in flora and fauna and the effects of such changes."}
      ]
    
    const fourthlist =[
        {list:"Indian Constitution- historical underpinnings, evolution, features, amendments, significant provisions and basic structure."},
        {list:"Functions and responsibilities of the Union and the States, issues and challenges pertaining to the federal structure, devolution of powers and finances up to local levels and challenges therein."},
        {list:"Separation of powers between various organs dispute redressal mechanisms and institutions."},
        {list:"Comparison of the Indian constitutional scheme with that of other countries"},
        {list:"Parliament and State Legislatures - structure, functioning, conduct of business, powers & privileges and issues arising out of these."},
        {list:"Structure, organization and functioning of the Executive and the Judiciary Ministries and Departments of the Government; pressure groups and formal/informal associations and their role in the Polity."},
        {list:"Salient features of the Representation of People’s Act."},
        {list:"Appointment to various Constitutional posts, powers, functions and responsibilities of various Constitutional Bodies."},
        {list:"Statutory, regulatory and various quasi-judicial bodies"},
        {list:"Government policies and interventions for development in various sectors and issues arising out of their design and implementation."},
        {list:"Development processes and the development industry- the role of NGOs, SHGs, various groups and associations, donors, charities, institutional and other stakeholders"},
        {list:"Welfare schemes for vulnerable sections of the population by the Centre and States and the performance of these schemes; mechanisms, laws, institutions and Bodies constituted for the protection and betterment of these vulnerable sections."},
        {list:"Issues relating to development and management of Social Sector/Services relating to Health, Education, Human Resources."},
        {list:"Issues relating to poverty and hunger."},
        {list:"Important aspects of governance, transparency and accountability, e-governance- applications, models, successes, limitations, and potential; citizens charters, transparency & accountability and institutional and other measures."},
        {list:"Role of civil services in a democracy."},
        {list:"India and its neighborhood-relations."},
        {list:"Bilateral, regional and global groupings and agreements involving India and/or affecting India’s interests"},
        {list:"Effect of policies and politics of developed and developing countries on India’s interests, Indian diaspora."},
        {list:"Important International institutions, agencies and fora- their structure, mandate."}
      ]
    
    const fifthlist =[
        {list:"Indian Economy and issues relating to planning, mobilization of resources, growth, development and employment."},
        {list:"Inclusive growth and issues arising from it."},
        {list:"Government Budgeting."},
        {list:"Major crops cropping patterns in various parts of the country, different types of irrigation and irrigation systems storage, transport and marketing of agricultural produce and issues and related constraints; etechnology in the aid of farmers"},
        {list:"Issues related to direct and indirect farm subsidies and minimum support prices; Public Distribution System- objectives, functioning, limitations, revamping; issues of buffer stocks and food security;"},
        {list:"Technology missions; economics of animal-rearing."},
        {list:"Food processing and related industries in India- scope and significance, location, upstream and downstream requirements, supply chain management."},
        {list:"Land reforms in India."},
        {list:"Effects of liberalization on the economy, changes in industrial policy and their effects on industrial growth."},
        {list:"Infrastructure: Energy, Ports, Roads, Airports, Railways etc."},
        {list:"Investment models."},
        {list:"Science and Technology - developments and their applications and effects in everyday life"},
        {list:"Awareness in the fields of IT, Space, Computers, robotics, nano-technology, bio-technology and issues relating to intellectual property rights."},
        {list:"Conservation, environmental pollution and degradation, environmental impact assessment"},
        {list:"Disaster and disaster management."},
        {list:"Linkages between development and spread of extremism."},
        {list:"Role of external state and non-state actors in creating challenges to internal security."},
        {list:"Challenges to internal security through communication networks, role of media and social networking sites in internal security challenges, basics of Cyber security; money- laundering and its prevention"},
        {list:"Security challenges and their management in border areas; linkages of organized crime with terrorism"},
        {list:" Various Security forces and agencies and their mandate."}
      ]
    
    const sixthlist =[
        {list:"Attitude: content, structure, function; its influence and relation with thought and behaviour; moral and political attitudes; social influence and persuasion."},
        {list:"Aptitude and foundational values for Civil Service, integrity, impartiality and non- partisanship, objectivity, dedication to public service, empathy, tolerance and compassion towards the weaker sections."},
        {list:"Emotional intelligence-concepts, and their utilities and application in administration and governance."},
        {list:"Contributions of moral thinkers and philosophers from India and world."},
        {list:"Public/Civil service values and Ethics in Public administration: Status and problems; ethical concerns and dilemmas in government and private institutions; laws, rules, regulations and conscience as sources of ethical guidance; accountability and ethical governance; strengthening of ethical and moral values in governance; ethical issues in international relations and funding; corporate governance."},
        {list:"Probity in Governance: Concept of public service; Philosophical basis of governance and probity;"},
        {list:"Information sharing and transparency in government, Right to Information, Codes of Ethics, Codes of Conduct, Citizen’s Charters, Work culture, Quality of service delivery, Utilization of public funds, challenges of corruption."},
        {list:" Case Studies on above issues."} 
      ]

    
    const data = [
        { heading: 'No. of Questions', value: '100' },
        { heading: 'Type of Questions', value: 'Objective (MCQ) type' },
        { heading: 'Total  Marks', value: '200' },
        { heading: 'Duration of Exam', value: '2 hrs. each (20 minutes per hour extra time for blind candidates & candidates with Locomotor Disability & Cerebral Palsy [minimum 40% impairment])' },
        { heading: 'Marks for Correct Answer', value: '2' },
        { heading: 'Marks for Incorrect Answer', value: '-0.66' },
        { heading: 'Medium of Exam', value: 'Bilingual (Hindi & English)' },
         ]

    const csatdata = [
        { heading: 'No. of Questions', value: '80' },
        { heading: 'Type of Questions', value: 'Objective (MCQ) type' },
        { heading: 'Total  Marks', value: '200' },
        { heading: 'Duration of Exam', value: '2 hrs. each (20 minutes per hour extra time for blind candidates & candidates with Locomotor Disability & Cerebral Palsy [minimum 40% impairment])' },
        { heading: 'Marks for Correct Answer', value: '2.5' },
        { heading: 'Marks for Incorrect Answer', value: '-0.83' },
        { heading: 'Medium of Exam', value: 'Bilingual (Hindi & English)' },
         ]


    const mainsdata =[
        { heading: 'Paper-A',   value: 'One of the Indian Language to be selected by the candidate from the Languages included in the Eighth Schedule to the Constitution', mark: '300' },
        { heading: 'Paper-B',   value: 'English', mark: '300' },
        { heading: 'Paper-I',   value: 'Essay', mark: '250' },
        { heading: 'Paper-II',  value: 'General Studies-I (Indian Heritage and Culture, History and Geography of the World and Society)', mark: '250' },
        { heading: 'Paper-III', value: 'General Studies-II (Governance, Constitution, Polity, Social Justice and International relations)', mark: '250' },
        { heading: 'Paper-IV',  value: 'General Studies-III (Technology, Economic Development, Bio-diversity, Environment, Security and Disaster Management)', mark: '250' },
        { heading: 'Paper-V',   value: 'General Studies-IV (Ethics, Integrity, and Aptitude)', mark: '250' },
        { heading: 'Paper-VI',  value: 'Optional Subject Paper-I', mark: '250' },
        { heading: 'Paper-VII', value: 'Optional Subject Paper-II', mark: '250' },
        { heading: 'Sub Total (Written Test)', value: '', mark: '1750' },
        { heading: 'Personality Test', value: '', mark: '275' }

        ]

  return (
    <>
            <Head>
                <meta charset="UTF-8" />           
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="index,follow" />
                <meta name="robots" content="index,follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title>UPSC Syllabus 2025 | IAS Prelims & Mains Syllabus PDF</title>
                <meta name="title" content="UPSC Syllabus 2025 | IAS Prelims & Mains Syllabus PDF" />
                <meta name="description" content="UPSC Syllabus 2025 for IAS Prelims and Mains explained in detail. Download the IAS syllabus PDF and know what to study for each stage of the exam." />
                <link rel="canonical" href="https://www.shankariasacademy.com/upsc-syllabus/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="UPSC Syllabus 2025 | IAS Prelims & Mains Syllabus PDF" />
                <meta property="og:description" content="UPSC Syllabus 2025 for IAS Prelims and Mains explained in detail. Download the IAS syllabus PDF and know what to study for each stage of the exam." />
                <meta property="og:url" content="https://www.shankariasacademy.com/upsc-syllabus/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
            </Head>
    
    <Navbar title="upsc" />

    <div className="container">
        <div className="row pt-3 pt-md-4">
            <div className="col-md-12 col-12">
            <h1 className={`${styles.pagemaintitle}`}>UPSC Syllabus 2025 | IAS Prelims & Mains Syllabus PDF</h1>
            </div>
            </div>
    </div>

    <div className="container pt-3 pt-md-2">
            <div className="row">
                <div className="col">

                    <div className="row">
                        <div className="col">
                            <a href="/upsc-admission-anna-nagar">
                            <Image src={upscWebBanner} className="img-fluid w-100" alt="upsc syllabus" title="Civil service exam"/>
                        </a>
                        </div>
                    </div>
                </div>
            </div>
    </div>

    {/*Syllabus Button Start */}

    <div className="container pt-4">
        <div className="row">
            <div className="col-md-4 offset-md-1 pt-2 pt-md-0">
                <Link href="/upsc-syllabus/#gspcm"  className={`${styles.redbutton} btn btn-primary btn-lg`} role="button" aria-pressed="true">
                   Prelims Syllabus  
                </Link>
            </div>

            <div className="col-md-3 pt-2 pt-md-0 ">
                <Link href="/upsc-syllabus/#gsmains"  className={`${styles.redbutton} btn btn-primary btn-lg`} role="button" aria-pressed="true">
                   Mains Syllabus  
                </Link>
            </div>

            <div className="col-md-4 pt-2 pt-md-0">
                <Link href="/upsc-syllabus/#optional"  className={`${styles.redbutton} btn btn-primary btn-lg`} role="button" aria-pressed="true">
                   Optional Syllabus  
                </Link>
            </div>          
        </div>
    </div>


    {/*Syllabus Section Start */}

    <section id="courseandfees" className="py-5 bg-light">
       <div className="container">
            <p className={`${styles.sectiontitle} mb-0 pt-md-2`}>Paper I - General Studies</p>
            <div className="row justify-content-center pt-2" id="gspcm">
                <div className="col-md-6 col-lg-6 pt-2">
                    <div className="rounded-4 shadow border overflow-hidden" style={{background: 'rgba(255, 255, 255, 0.95)', backdropFilter: 'blur(6px)',}} >
                        <div className="py-3 px-4 text-center text-white fw-bold" style={{background: 'linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))',fontSize: '1rem',letterSpacing: '0.05em',}}>
                            General Studies Paper–I
                        </div>
                        <div className="table-responsive">
                            <table className="table table-sm table-bordered align-middle mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th className="px-3 py-2 text-center" style={{ width: '40%' }}>Category</th>
                                        <th className="px-3 py-2 text-center">Details</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, idx) => (
                                        <tr key={idx}>
                                            <td className="fw-semibold px-3 py-2 text-center">{item.heading}</td>
                                            <td className="text-muted px-3 py-2 text-center">{item.value}</td>
                                        </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
       </div>
   </section>


    <div className="container pt-3">
        <div className="row">
            <div className="col">
                <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                    {list.map((item,index)=>(
                      <li className={`${styles.ulliclass} ${styles.acheiverrank}`} key={index} id={styles.acheiverrankspecial}>
                          <div className="d-inline">
                                <p className={`${styles.ullispan} d-inline`}>
                                    {item.listcont}
                                </p>
                            </div>
                        </li>
                    ))}            
                </ul>
          </div>
      </div>
    </div>

    <section id="courseandfees" className="py-5 bg-light">
        <div className="container">
           <div className="row justify-content-center">
                <p className={`${styles.sectiontitle} mb-0 pt-3`}>Paper II - CSAT</p>
                <div className="col-md-6 col-lg-6 pt-2">
                    <div className="rounded-4 shadow border overflow-hidden"style={{background: 'rgba(255, 255, 255, 0.95)', backdropFilter: 'blur(6px)',}}>
                        <div className="py-3 px-4 text-center text-white fw-bold" style={{background: 'linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))',fontSize: '1rem',letterSpacing: '0.05em',}}>
                              CSAT – Paper II
                        </div>
                        <div className="table-responsive">
                            <table className="table table-sm table-bordered align-middle mb-0">
                                <thead className="table-light">
                                    <tr>
                                       <th className="px-3 py-2 text-center" style={{ width: '40%' }}>Category</th>
                                       <th className="px-3 py-2 text-center">Details</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {csatdata.map((item, idx) => (
                                       <tr key={idx}>
                                           <td className="fw-semibold px-3 py-2 text-center">{item.heading}</td>
                                           <td className="text-muted px-3 py-2 text-center">{item.value}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>             
        </div>
        <p className= 'text-center pt-4 m-4'> For Wrong answers one - third of the marks assigned to that question will be deducted as penalty.</p>
    </section>

    <div className="container pt-3">
        <div className="row">
            <div className="col">
                 <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                   {secondlist.map((item,index)=>(
                    <li className={`${styles.ulliclass} ${styles.acheiverrank}`} key={index} id={styles.acheiverrankspecial}>
                        <div className="d-inline">
                            <p className={`${styles.ullispan} d-inline`}>
                                {item.list}
                             </p>
                         </div>
                    </li>
                  ))}       
                </ul>
            </div>
        </div>
    </div>
    


    <div className="container pt-3">
        <div className="row">
            <div className="col" style={{color: "#DB1B0D"}}>
                <p className="">Note 1: The questions will be of multiple choice, objective type.</p>
                <p className="">Note 2: It is mandatory for the candidate to appear in both the Papers
                    of Civil Services (Prelim) Examination for the purpose of evaluation. Therefore a 
                    candidate will be disqualified in case he/she does not appear in both the papers of Civil Services (Prelim).</p>
                <p className="">Note 3: Appearing in any one of the papers on the examination day will be counted as an attempt.</p>
                <p className="">Note 4: If a candidate has applied but not appeared for the examination, it will not be counted as an attempt.</p>
            </div>
        </div>
    </div>


    <section id="courseandfees" className="py-5 bg-light">
           <div className="container">
              <div className="row justify-content-center" id="gsmains">
                <h2 className={`${styles.sectiontitle} mb-2`}>Civil Service Mains Examinations</h2>
                <div className="col-md-10 col-lg-10 pt-2">
                    <div className="rounded-4 shadow border overflow-hidden" style={{background: 'rgba(255, 255, 255, 0.95)',backdropFilter: 'blur(6px)',}}>
                        <div className="py-3 px-4 text-center text-white fw-bold"style={{background: 'linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))',fontSize: '1rem',letterSpacing: '0.05em',}}>
                            Mains  Overview
                        </div>

                        <div className="table-responsive">
                            <table className="table table-sm table-bordered align-middle mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th className="px-3 py-2 text-center" style={{ width: '20%' }}>Qualifying Papers</th>
                                        <th className="px-3 py-2 text-center">Subject</th>
                                        <th className="px-3 py-2 text-center"style={{ width: '20%' }}>Marks</th>
                                    </tr>
                                </thead>
                                <tbody>
                                      {mainsdata.map((item, idx) => (
                                        <tr key={idx}>
                                            <td className="fw-semibold px-3 py-2 text-center">{item.heading}</td>
                                            <td className="text-muted px-3 py-2 text-center">{item.value}</td>
                                            <td className="text-muted px-3 py-2 text-center">{item.mark}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
              </div>
            </div>
    </section>

    <div className="container">
        <div className="row">
            <div className="col">
               <p className={`${styles.aboutheading1} mb-0 pt-md-2`}>Paper I</p>
                    <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                        <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                            <div className="d-inline">
                                <p className={`${styles.ullispan} d-inline`}>
                                    Essay : Candidates will be required to write essays on specific topics given in the examination.
                                </p>
                            </div>
                        </li>

                        <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                            <div className="d-inline">
                                <p className={`${styles.ullispan} d-inline`}>
                                    They will be expected to keep closely to the subject of the essay to arrange their ideas in an orderly fashion and to write concisely. Credit will be given for effective and exact expression.
                                </p>
                            </div>
                        </li>
                    </ul>
                <p className={`${styles.aboutheading1} mb-0 pt-3`}>Paper II - General Studies - I</p>
                <p className={`${styles.aboutheading2}`}>Indian Heritage and Culture, History and Geography of the World and Society of India.</p>
                    <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                        {thirdlist.map((item,index)=>(
                            <li className={`${styles.ulliclass} ${styles.acheiverrank}`} key={index} id={styles.acheiverrankspecial}>
                                <div className="d-inline">
                                <p className={`${styles.ullispan} d-inline`}>
                                {item.list}
                                </p>
                                </div>
                            </li>
                        ))}
                    </ul>

                <p className={`${styles.aboutheading1} pt-3 mb-0`}>Paper III - General Studies - II</p>
                <p className={`${styles.aboutheading2}`}>Governance, Constitution, Polity, Social Justice and International relations.</p>
                
                    <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                        {fourthlist.map((item,index)=>(
                            <li className={`${styles.ulliclass} ${styles.acheiverrank}`} key={index} id={styles.acheiverrankspecial}>
                                <div className="d-inline">
                                    <p className={`${styles.ullispan} d-inline`}>
                                        {item.list}
                                    </p>
                                </div>
                            </li>
                        ))}
                    </ul>

                <p className={`${styles.aboutheading1} mb-0 pt-3`}>Paper IV - General Studies - III</p>
                <p className={`${styles.aboutheading2}`}>Technology, Economic Development, Bio-diversity, Environment, Security and Disaster Management.</p>
                    
                    <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                        {fifthlist.map((item,index)=>(
                            <li className={`${styles.ulliclass} ${styles.acheiverrank}`} key={index} id={styles.acheiverrankspecial}>
                                <div className="d-inline">
                                    <p className={`${styles.ullispan} d-inline`}>
                                        {item.list}
                                    </p>
                                </div>
                            </li>
                        ))}
                    </ul>

                <p className={`${styles.aboutheading1} mb-0 pt-3`}>Paper V - General Studies - IV</p>
                <p className={`${styles.aboutheading2}`}>Ethics, Integrity, and Aptitude</p>
                    
                    <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                        <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                            <div className="d-inline">
                                <p className={`${styles.ullispan} d-inline`}>
                                    This paper will include questions to test the candidates’ attitude and approach to issues relating to integrity, probity in public life and his problem solving approach to various issues and conflicts faced by him in dealing with society. Questions may utilize the case study approach to determine these aspects. The following broad areas will be covered.
                                </p>
                            </div>
                        </li>
                    </ul>


                <p className={`${styles.aboutheading2}`}>Ethics and Human Interface</p> 
                <p className={`${styles.acheiverrank}`}>Essence, determinants and consequences of Ethics in human actions; dimensions of ethics; ethics in private and public relationships. Human Values – lessons from the lives and teachings of great leaders, reformers and administrators; role of family, society and educational institutions in inculcating values.</p>

                    <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                    {sixthlist.map((item,index)=>(
                        <li className={`${styles.ulliclass} ${styles.acheiverrank}`} key={index} id={styles.acheiverrankspecial}>
                            <div className="d-inline">
                            <p className={`${styles.ullispan} d-inline`}>
                                {item.list}
                                </p>
                            </div>
                        </li>
                        ))}  
                    </ul>
            </div>
        </div>
    </div>

<section id="optional" className="py-5 bg-light">
    <div className="container">
        <h2 className={`${styles.sectiontitle} mb-2` }>Civil Service Optional Examinations</h2>
        <div className="row justify-content-center pt-2" id="optionalpcm">
            <div className="col-md-6 col-lg-6 pt-2">
                <div className="rounded-4 shadow border overflow-hidden" style={{ background: "rgba(255, 255, 255, 0.95)",backdropFilter: "blur(6px)",}}>
                    <div className="py-3 px-4 text-center text-white fw-bold" style={{ background: 'linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))', fontSize: "1rem",letterSpacing: "0.05em",}}>
                        Civil Services (Main) – Optional Subject Papers
                    </div>

                    <div className="table-responsive">
                        <table className="table table-sm table-bordered align-middle mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th className="px-3 py-2 text-center"style={{ width: "40%" }}> Category</th>
                                    <th className="px-3 py-2 text-center">Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="fw-semibold px-3 py-2 text-center"> No. of Papers</td>
                                    <td className="text-muted px-3 py-2 text-center"> 2 (Paper–I & Paper–II)</td>
                                </tr>

                                <tr>
                                    <td className="fw-semibold px-3 py-2 text-center"> Type of Questions</td>
                                    <td className="text-muted px-3 py-2 text-center">Conventional (Descriptive)</td>   
                                </tr>

                                <tr>
                                    <td className="fw-semibold px-3 py-2 text-center"> Marks per Paper</td>
                                    <td className="text-muted px-3 py-2 text-center">250</td>
                                </tr>

                                <tr>
                                    <td className="fw-semibold px-3 py-2 text-center">Total Marks</td>
                                    <td className="text-muted px-3 py-2 text-center">500</td>   
                                </tr>

                                <tr>
                                    <td className="fw-semibold px-3 py-2 text-center"> Duration</td>
                                    <td className="text-muted px-3 py-2 text-center">3 hours per paper</td> 
                                </tr>

                                <tr>
                                    <td className="fw-semibold px-3 py-2 text-center">Medium of Exam</td>
                                    <td className="text-muted px-3 py-2 text-center">English / Hindi / Other languages permitted by UPSC</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div className="container">
        <div className="row" >
           <div className="col">  
                <p className={`${styles.aboutheading1} mb-0 pt-3`}>Paper - VI & Paper VII</p>
                <p className={`${styles.aboutheading2}`}>Optional Subject : Papers I and II</p>
                <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                    <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                       <div className="d-inline">
                            <p className={`${styles.ullispan} d-inline`}>
                                Government strives to have a workforce which reflects gender balance and women candidates are encouraged to apply
                            </p>
                        </div>
                    </li>

                    <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                        <div className="d-inline">
                            <p className={`${styles.ullispan} d-inline`}>
                                Candidates may choose from the following Optional Subjects for the Civil Services (Main) Examination.
                             </p>
                        </div>
                    </li>
                </ul>
           </div>
        </div>
    </div>
</section>

{/* 1 AGRICULTURE */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
       <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        1 </span> AGRICULTURE
    </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
       Agriculture - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
        <p className={`${styles.aboutoption}`}>
            Ecology and its relevance to man, natural resources, their sustainable management and
            conservation. Physical and social environment as factors of crop distribution and production. Agro ecology;
            cropping pattern as indicators of environments. Environmental pollution and associated hazards to crops,
            animals and humans. Climate change—International conventions and global initiatives. Green house effect
            and global warming. Advance tools for ecosystem analysis—Remote Sensing (RS) and Geographic
            Information Systems (GIS).
        </p>

        <p className={`${styles.aboutoption}`}>
            Cropping patterns in different agro-climatic zones of the country. Impact of high-yielding and shortduration
            varieties on shifts in cropping patterns. Concepts of various cropping, and farming systems.
            Organic and Precision farming. Package of practices for production of important cereals, pulses, oil seeds,
            fibres, sugar, commercial and fodder crops.
        </p>

        <p className={`${styles.aboutoption}`}>
            Important features, and scope of various types of forestry plantations such as social forestry, agroforestry,
            and natural forests: Propagation of forest plants. Forest products. Agro-forestry and value addition.
            Conservation of forest flora and fauna.
        </p>

        <p className={`${styles.aboutoption}`}>
            Weeds, their characteristics, dissemination and association with various crops; their multiplications;
            cultural, biological, and chemical control of weeds.
        </p>

        <p className={`${styles.aboutoption}`}>
            Soil—physical, chemical and biological properties. Processes and factors of soil formation. soils of
            India. Mineral and organic constituents of soils and their role in maintaining soil productivity. Essential
            plant nutrients and other beneficial elements in soils and plants. Principles of soil fertility, soil testing and
            fertiliser recommendations, integrated nutrient management Biofertilizers. Losses of nitrogen in soil,
            nitrogen-use efficiency in submerged rice soils, nitrogen fixation in soils. Efficient phosphoruse and
            potassium use. Problem soils and their reclamation. Soil factors affecting green house gas emission.
        </p>

        <p className={`${styles.aboutoption}`}>
            Soil conservation, integrated watershed management. Soil erosion and its management. Dry land
            agriculture and its problems. Technology for stabilising agriculture production in rainfed areas.
        </p>

        <p className={`${styles.aboutoption}`}>
            Water-use efficiency in relation to crop production, criteria for scheduling irrigations, ways and
            means of reducing run-off losses of irrigation water. Rainwater harvesting. Drip and sprinkler irrigation.
            Drainage of water-logged soils, quality of irrigation water, effect of industrial effluents on soil and water
            pollution. Irrigation projects in India.
        </p>

        <p className={`${styles.aboutoption}`}>
            Farm management, scope, importance and characteristics, farm planning. Optimum resource use
            and budgeting. Economics of different types of farming systems. Marketing management strategies for
            development, market intelligence. price fluctuations and their cost; role of co-operatives in agricultural
            economy; types and systems of farming and factors affecting them. Agricultural price policy. Crop Insurance.
        </p>

        <p className={`${styles.aboutoption}`}>
            Agricultural extension, its importance and role, methods of evaluation of extension programmes,
            socio-economic survey and status of big, small and marginal farmers and landless agricultural labourers;
            Training programmes for extension workers. Role of Krishi Vigyan Kendra’s (KVK) in dissemination of
            Agricultural technologies. Non-Government Organisation (NGO) and self-help group approach for rural
            development.
        </p>
      </div>
    </div>

{/* Agriculture Paper II*/}

     <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
       Agriculture - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      >
        <p className={`${styles.aboutoption}`}>
            Cell structure, function and cell cycle. Synthesis, structure and function of genetic material. Laws
            of heredity. Chromosome structure, chromosomal aberrations, linkage and cross-over, and their
            significance in recombination breeding. Polyploidy, euploids and aneuploids. Mutation—and their role in
            crop improvement. Heritability, sterility and incompatibility, classification and their application in crop
            improvement. Cytoplasmic inheritance, sex-linked, sex-influenced and sex-limited characters.
        </p>

        <p className={`${styles.aboutoption}`}>
            History of plant breeding. Modes of reproduction, selfing and crossing techniques. Origin, evolution
            and domestication of crop plants, center of origin, law of homologous series, crop genetic resources—
            conservation and utilization. Application of principles of plant breeding, improvement of crop plants.
            Molecular markers and their application in plant improvement. Pure-line selection, pedigree, mass and
            recurrent selections, combining ability, its significance in plant breeding. Heterosis and its exploitation.
            Somatic hybridization. Breeding for disease and pest resistance. Role of interspecific and intergeneric
            hybridization. Role of genetic engineering and biotechnology in crop improvement Gernetically modified
            crop plants.
        </p>

        <p className={`${styles.aboutoption}`}>
            Seed production and processing technologies. Seed certification, Seed testing and storage. DNA
            finger printing and seed registration. Role of public and private sectors in seed production, and marketing.
            Intellectual Property Rights (IPR) issues, WTO issues and its impact on Agriculture.
        </p>

        <p className={`${styles.aboutoption}`}>
           Principles of Plant Physiology with reference to plant nutrition, absorption, translocation and
           metabolism of nutrients. Soil-water-plant relationship.
        </p>

        <p className={`${styles.aboutoption}`}>
            Enzymes and plant pigments; photosynthesis—modern concepts and factors affecting the process,
            aerobic and anaerobic respiration; C3, C4 and CAM mechanisms. Carbohydrate, protein and fat
            metabolism. Growth and development; photoperiodism and vernalization. Plant growth substances and
            their role in crop production. Physiology of seed development and germination; dormancy. Stress
            physiology—draught, salt and water stress.
        </p>

        <p className={`${styles.aboutoption}`}>
            major fruits, plantation crops, vegetables, spices and flower crops. package practices of major
            horticultural crops. Protected cultivation and high tech horticulture. Post-harvest technology and value
            addition of fruits and vegetables. Landscaping and commercial floriculture. Medicinal and aromatic plants.
            Role of fruits and vegetables in human nutrition.
        </p>

        <p className={`${styles.aboutoption}`}>
            Diagnosis of pests and diseases of field crops, vegetables, orchard and plantation crops and their
            economic importance. Classification of pests and diseases and their management. Intergrated pest and
            diseases management. Storage pests and their management. Biological control of pests and diseases.
            Epidemiology and forecasting of major crop pests and diseases. Plant quarantine measures. Pesticides, their
            formulation and modes of action.
        </p>

        <p className={`${styles.aboutoption}`}>
            Food production and consumption trends in India. Food security and growing population—vision
            2020. Reasons for grain surplus. National and International food policies. Production, procurement,
            distribution constraints. Availability of foodgtrains, per capita expenditure on food. Trends in poverty, Public
            Distribution System and Below Poverty Line population, Targeted Public Distribution System (PDS), policy
            implementation in context to globalization. Processing constraints. Relation of food production to National
            Dietary Guidelines and food consumption pattern. Food based dietary approaches to eliminate hunger.
            Nutrient deficiency—Micro nutrient deficiency: Protein Energy Malnutrition or Protein Calorie Malnutrition
            (PEM or PCM), Micro nutrient deficiency and HRD in context of work capacity of women and children. Food
            grain productivity and food security.
        </p>

        
      </div>
    </div>
  </div>
</div>

{/* 2 ANTHROPOLOGY*/}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
       <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        2 </span> ANTHROPOLOGY
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
       Anthropology - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
        <p className={`${styles.aboutheading2}`}>
           Meaning, Scope and development of Anthropology.
        </p>

        <p className={`${styles.aboutheading2}`}>
           Relationships with other disciplines :
        </p>

        <p className={`${styles.aboutoption}`}>
            Social Sciences, behavioural Sciences, Life Sciences, Medical
            Sciences, Earth Sciences and Humanities.
        </p>

        <p className={`${styles.aboutheading2}`}>
           Main branches of Anthropology, their scope and relevance :
        </p>
         <ul>
            <li>Social-cultural Anthropology.</li>
            <li>biological Anthropology.</li>
            <li>Archaeological Anthropology.</li>
            <li>Linguistic Anthropology.</li>
         </ul>

        <p className={`${styles.aboutheading2}`}>
            Human Evolution and emergence of Man :
        </p>

        <ul>
            <li>Biological and Cultural factors in human evolution.</li>
            <li>Theories of Organic Evolution (Pre-Darwinian, Darwinian and Post-Darwinian).</li>
            <li>Synthetic theory of evolution; Brief outline of terms and concepts of evolutionary biology
                (Doll’s rule, Cope’s rule, Gause’s rule, parallelism, convergence, adaptive radiation, and
                mosaic evolution).
            </li>
        </ul>

        <p className={`${styles.aboutoption}`}>
            Characteristics of Primates; Evolutionary Trend and Primate Taxonomy; Primate Adaptations;
            (Arboreal and Terrestrial) Primate Taxonomy; Primate Behaviour; Tertiary and Quaternary fossil
            primates; Living Major Primates; Comparative Anatomy of Man and Apes; Skeletal changes due to
            erect posture and its implications.
        </p>

        <p className={`${styles.aboutheading2}`}>
            Phylogenetic status, characteristics and geographical distribution of the following :
        </p>

        <ul>
            <li>Plio-preleistocene hominids inSouth and East Africa—Australopithecines.</li>
            <li>Homo erectus : Africa (Paranthropus), Europe (Homo erectus (heidelbergensis), Asia (Homo
                erectus javanicus, Homo erectus pekinensis.</li>
             <li>Neanderthal man—La-chapelle-aux-saints (Classical type), Mt. Carmel (Progressive type).</li>   
            <li>Rhodesian man.</li> 
            <li>Homo sapiens—Cromagnon, Grimaldi and Chancelede.</li>      
        </ul>

        <p className={`${styles.aboutheading2}`}>
           The biological basis of Life :
        </p>

        <p className={`${styles.aboutoption}`}>
             The Cell, DNA structure and replication, Protein Synthesis, Gene,
            Mutation, Chromosomes, and Cell Division.
        </p>

        <ul>
            <li>Principles of Prehistoric Archaeology. Chronology : Relative and Absolute Dating methods.</li>
            <li>Cultural Evolution—Broad Outlines of Prehistoric cultures :</li>
            <li>Paleolithic</li>
            <li>Mesolithic</li>
            <li>Neolithic</li>
            <li>Chalcolithic</li>
            <li>Copper-Bronze age</li>
            <li>Iron Age</li>
        </ul>
 
        <p className={`${styles.aboutheading2}`}>The Nature of Culture :</p>

        <p className={`${styles.aboutoption}`}>
             The concept and Characteristics of culture and civilization; Ethnocentrism
            vis-a-vis cultural Relativism.
        </p>

       <p className={`${styles.aboutheading2}`}> The Nature of Society :</p>

        <p className={`${styles.aboutoption}`}>
            Concept of Society; Society and Culture; Social Institution; Social groups; and Social stratification.
        </p>

        <p className={`${styles.aboutheading2}`}> </p>

        <p className={`${styles.aboutoption}`}>
           <span className="fw-bold text-dark">Marriage : </span>Definition and universality; Laws of marriage (endogamy, exogamy, hypergamy,
            hypogamy, incest taboo); Type of marriage (monogamy, polygamy, polyandry, group marriage).
            Functions of marriage; Marriage regulations (preferential, prescriptive and proscriptive); Marriage
            payments (bride wealth and dowry).
        </p>

        
        <p className={`${styles.aboutoption}`}>
           <span className="fw-bold text-dark">Family :</span> Definition and universality; Family, household and domestic groups; functions of family;
            Types of family (from the perspectives of structure, blood relation, marriage, residence and
            succession); Impact of urbanization, industrialization and feminist movements on family.
       </p>

       <p className={`${styles.aboutoption}`}><span className="fw-bold text-dark"> Kinship : </span> Consanguinity and Affinity; Principles and types of descent (Unilineal, Double, Bilateral
            Ambilineal); Forms of descent groups (lineage, clan, phratry, moiety and kindred); Kinship
            terminology (descriptive and classificatory); Descent, Filiation and Complimentary Filiation;Decent
            and Alliance.
      </p>
      <p className={`${styles.aboutoption}`}><span className="fw-bold text-dark"> Economic Organization :</span> Meaning, scope and relevance of economic anthropology; Formalist and
            Substantivist debate; Principles governing production, distribution and exchange (reciprocity,
            redistribution and market), in communities, subsisting on hunting and gathering, fishing,
            swiddening, pastoralism, horticulture, and agriculture; globalization and indigenous economic
            systems.</p>

        <p className={`${styles.aboutoption}`}>
            Political Organization and Social Control : Band, tribe, chiefdom, kingdom and state; concepts of
            power, authority and legitimacy; social control, law and justice in simple Societies.
        </p>

        <p className={`${styles.aboutoption}`}>
            <span className="fw-bold text-dark">Religion :</span> Anthropological approaches to the study of religion (evolutionary, psychological and
            functional); monotheism and polytheism; sacred and profane; myths and rituals; forms of religion in
            tribal and peasant Societies (animism, animatism, fetishism, naturism and totemism); religion,
            magic and science distinguished; magico-religious functionaries (priest, shaman, medicine man,
            sorcerer and witch).
        </p>

        <p className={`${styles.aboutheading2}`}>Anthropological theories :</p>
            <ul>
                <li>Classical evolutionism (Tylor, Morgan and Frazer)</li>
                <li>Functionalism (Malinowski); Structural—Functionlism (Radcliffe-Brown</li>
                <li>Structuralism (L’evi-Strauss and E. Leach)</li>
                <li>Culture and personality (Benedict, Mead, Linton, Kardiner and Cora-du Bois)</li>
                <li>Neo—evolutionism (Childe, White, Steward, Sahlins and Service)</li>
                <li>Cultural materialism (Harris)</li>
                <li>Symbolic and interpretive theories (Turner, Schneider and Geertz)</li>
                <li>Cognitive theories (Tyler, Conklin)</li>
                <li>Post-modernism in anthropology.</li>
            </ul>
        <p className={`${styles.aboutheading2}`}>Culture, Language and Communication :</p>

        <p className={`${styles.aboutoption}`}>
                Nature, origin and characteristics of language; verbal and non-verbal communication; social contex
                of language use.</p>
        
        <p className={`${styles.aboutheading2}`}>Research methods in Anthropology :</p>
          <ul>
                <li>Fieldwork tradition in anthropology</li>
                <li>Distinction between technique, method and methodology</li>
                <li>Tools of data collection : observation, interview, schedules, questionnaire, case study, genealogy,
                    life-history, oral history, secondary sources of information, participatory methods.</li>
                <li>Analysis, interpretation and presentation of data.</li>
                
            </ul>
        <p className={`${styles.aboutoption}`}>
           <span className="fw-bold text-dark"> Human Genetics :</span> Methods and Application : Methods for study of genetic principles in man-family
            study (pedigree analysis, twin study, foster child, co-twin method, cytogenetic method, chromosomal
            and karyo-type analysis), biochemical methods, immunological methods, D.N.A. technology and
            recombinant technologies.
       </p>    

       <p className={`${styles.aboutoption}`}>
            Mendelian genetics in man-family study, single factor, multifactor, lethal, sub-lethal and polygenic
            inheritance in man.
      </p>

      <p className={`${styles.aboutoption}`}>
            Concept of genetic polymorphism and selection, Mendelian population, Hardy-Weinberg law; causes
            and changes which bring down frequency-mutation, isolation, migration, selection, inbreeding and
            genetic drift. Consanguineous and non-consanguineous mating, genetic load, genetic effect of
            consanguineous and cousin marriages.
      </p>

      <p className={`${styles.aboutoption}`}>Chromosomes and chromosomal aberrations in man, methodology.</p> 

        <ul>
            <li>Numerical and structural aberrations (disorders).</li>
            <li>Sex chromosomal aberration- Klinefelter (XXY), Turner (XO), Super female (XXX), intersex and
                other syndromic disorders.</li>
            <li>Autosomal aberrations- Down syndrome, Patau, Edward and Cri-du-chat syndromes.</li>
            <li>Genetic imprints in human disease, genetic screening, genetic counseling, human DNA profiling,
                gene mapping and genome study.</li>
        </ul>

        <p className={`${styles.aboutoption}`}>
                Race and racism, biological basis of morphological variation of non-metric and characters. Racial
                criteria, racial traits in relation to heredity and environment; biological basis of racial classification,
                racial differentiation and race crossing in man.
        </p>

        <p className={`${styles.aboutoption}`}>
                Age, sex and population variation as genetic marker :ABO, Rh blood groups, HLA Hp,
                transferring, Gm, blood enzymes. Physiological characteristics-Hb level, body fat, pulse rate,
                respiratory functions and sensory perceptions in different cultural and socio-ecomomic groups.
        </p >

        <p className={`${styles.aboutoption}`}>
                Concepts and methods of Ecological Anthropology : Bio-cultural Adaptations—Genetic and Nongenetic
                factors. Man’s physiological responses to environmental stresses: hot desert, cold, high
                altitude climate.
        </p>

        <p className={`${styles.aboutoption}`}>
                Epidemiological Anthropology : Health and disease. Infectious and non-infectious diseases,
                Nutritional deficiency related diseases.
        </p>

        <p className={`${styles.aboutoption}`}>
            Concept of human growth and Development : Stages of growth—pre-natal, natal, infant,
            childhood, adolescence, maturity, senescence.
        </p>

        <ul>
            <li>—Factors affecting growth and development genetic, environmental, biochemical, nutritional,
                cultural and socio-economic.</li>

            <li>—Ageing and senescence. Theories and observations</li>

            <li>—biological and chronological longevity. Human physique and somatotypes. Methodologies for
                growth studies.</li>
        </ul>

        <p className={`${styles.aboutoption}`}>
            Relevance of menarche, menopause and other bioevents to fertility. Fertility patterns and
            differentials.
        </p>

        <p className={`${styles.aboutoption}`}>
            Demographic theories-biological, social and cultural.
        </p>

        <p className={`${styles.aboutoption}`}>
            Biological and socio-ecological factors influencing fecundity, fertility, natality and mortality.
        </p>

        <p className={`${styles.aboutoption}`}>
           <span className="fw-bold text-dark"> Applications of Anthropology :</span> Anthropology of sports, Nutritional anthropology, Anthroplogy in
            designing of defence and other equipments, Forensic Anthroplogy, Methods and principles of
            personal identification and reconstruction, Applied human genetics—Paternity diagnosis, genetic
            counselling and eugenics, DNA technology in diseases and medicine, serogenetics and cytogenetics
            in reproductive biology.
        </p>

      </div>
    </div>

{/* ANTHROPOLOGY II*/}

     <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
       Anthroplogy - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      >
        <p className={`${styles.aboutoption}`}>
            Evolution of the Indian Culture and Civilization—Prehistoric (Palaeolithic, Mesolithic, Neolithic
            and Neolithic-Chalcolithic), Protohistoric (Indus Civilization). Pre-Harappan, Harappan and post-
            Harappan cultures. Contributions of the tribal cultures to Indian civilization.
        </p>

        <p className={`${styles.aboutoption}`}>
            Palaeo—Anthropological evidences from India with special reference to Siwaliks and Narmada basin
           (Ramapithecus, Sivapithecus and Narmada Man).
        </p>

        <p className={`${styles.aboutoption}`}>
            Ethno-archaeology in India: The concept of ethno-archaeology; Survivals and Parallels among the
            hunting, foraging, fishing, pastoral and peasant communities including arts and crafts producing
            communities.
        </p>

        <p className={`${styles.aboutoption}`}>
            Demographic profile of India—Ethnic and linguistic elements in the Indian population and their
            distribution. Indian population—factors influencing its structure and growth.
        </p>

        <p className={`${styles.aboutoption}`}>
            The structure and nature of traditional Indian social system—Varnashram, Purushartha, Karma,
            Rina and Rebirth.
        </p>

        <p className={`${styles.aboutoption}`}>
            Caste system in India— Structure and characteristics Varna and caste, Theories of origin of caste
            system, Dominant caste, Caste mobility, Future of caste system, Jajmani system. Tribe-case
            continuum.
        </p>

        <p className={`${styles.aboutoption}`}>
           Sacred Complex and Nature-Man-Spirit Complex.
        </p>

        <p className={`${styles.aboutoption}`}>
           Impact of Buddhism, Jainism, Islam and Christianity of Indian society.
        </p>

        <p className={`${styles.aboutoption}`}>
            Emergence, growth and development in India—Contributions of the 18th, 19th and early 20th
            Century scholar-administrators. Contributions of Indian anthropologists to tribal and caste studies.
        </p>

        <p className={`${styles.aboutoption}`}>
            Indian Village—Significane of village study in India; Indian village as a social system; Traditional
            and changing patterns of settlement and inter-caste relations; Agrarian relations in Indian villages;
            Impact of globalization on Indian villages.
        </p>

        <p className={`${styles.aboutoption}`}>
            Indigenous and exogenous processes of socio-cultural change in Indian society: Sanskritization,
            Westernization, Modernization; Inter-play of little and great traditions; Panchayati Raj and social
            change; Media and Social change.
        </p>

        <p className={`${styles.aboutoption}`}>
            Tribal situation in India—Bio-genetic variability, linguistic and socio-economic characteristics of
            the tribal populations and their distribution.
        </p>

        <p className={`${styles.aboutoption}`}>
            Problems of exploitation and deprivation of Scheduled Castes, Scheduled Tribes and Other Backward
            Classes. Constitutional safeguards for Scheduled Tribes and Scheduled Castes.
        </p>

        <p className={`${styles.aboutoption}`}>
            Social change and contemporary tribal societies : Impact of modern democratic institutions,
            development programmes and welfare measures on tribals and weaker sections.

        </p>

        <p className={`${styles.aboutoption}`}>
            The concept of ethnicity; Ethnic conflicts and political developments; Unrest among tribal
            communities; Regionalism and demand for autonomy; Pseudo-tribalism. Social change among the
            tribes during colonial and post-Independent India.
        </p>

        <p className={`${styles.aboutoption}`}>
            Impact of Hinduism, Buddhism, Christianity, Islam and other religions on tribal societies.
        </p>

        <p className={`${styles.aboutoption}`}>
            Tribe and nation state—a comparative study of tribal communities in India and other countries.
        </p>

        <p className={`${styles.aboutoption}`}>
            History of administration of tribal areas, tribal policies, plans, programmes of tribal development
            and their implementation. The concept of PTGs (Primitive Tribal Groups), their distribution, special
            programmes for their development. Role of N.G.O.s in tribal development.
        </p>

        <p className={`${styles.aboutoption}`}>
            Role of anthropology in tribal and rural development.
        </p>

        <p className={`${styles.aboutoption}`}>
            Contributions of anthropology to the understanding of regionalism, communalism and ethnic and
            political movements.
        </p>
      </div>
    </div>
  </div>
</div>

{/* 3 HISTORY */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        3</span> HISTORY
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        History - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >


        <p className={`${styles.aboutheading2} `}>
         Sources :
        </p>

        <p className={`${styles.aboutoption}`}      >
           Archaeological sources : <br/>
           Exploration, excavation, epigraphy, numismatics, monuments.
        </p>

        <p className={`${styles.aboutoption}`}>
           Literary sources : <br/>
           Indigenous: Primary and secondary; poetry, scientific literature, literature, literature in regional languages,
           religious literature.
        </p>

        <p className={`${styles.aboutoption}`}>Foreign account: Greek, Chinese and Arab writers.</p>

        <p className={`${styles.aboutheading2} `}>Pre-history and Proto-history : </p>

        <p className={`${styles.aboutoption}`}>
            Geographical factors; hunting and gathering (paleolithic and mesolithic); Beginning of agriculture (neolithic
            and chalcolithic).   
        </p>

        <p className={`${styles.aboutheading2} `}>Indus Valley Civilization :</p>

        <p className={`${styles.aboutoption}`}>
            Origin, date, extent, characteristics-decline, survival and significance, art and architecture.
        </p>

        <p className={`${styles.aboutheading2} pt-2`}>Megalithic Cultures :</p>

        <p className={`${styles.aboutoption}`}>
            Distribution of pastoral and farming cultures outside the Indus, Development of community life,
            Settlements, Development of agriculture, Crafts, Pottery, and Iron industry.
        </p>

       <p className={`${styles.aboutheading2} pt-2`}>Aryans and Vedic Period : </p> 

        <p className={`${styles.aboutoption}`}>
            Expansions of Aryans in India : <br/>
            Vedic Period: Religious and philosophic literature; Transformation from Rig Vedic period to the later Vedic
            period; Political, social and economical life; Significance of the Vedic Age; Evolution of Monarchy and Varna
            system.
        </p>

        <p className={`${styles.aboutheading2} pt-2`}>Period of Mahajanapadas : </p>
        <p className={`${styles.aboutoption}`}>
            Formation of States (Mahajanapada): Republics and monarchies; Rise of urban centres; Trade routes;
            Economic growth; Introduction of coinage; Spread of Jainism and Buddism; Rise of Magadha and Nandas.
            Iranian and Mecedonian invasions and their impact.
        </p>

        <p className={`${styles.aboutheading2} pt-2`}> Mauryan Empire : </p>

        <p className={`${styles.aboutoption}`}>
            Foundation of the Mauryan Empire, Chandragupta, Kautilya and Arthashastra; Ashoka; Concept of
            Dharma; Edicts; Polity, Administration, Economy; Art, architecture and sculpture; External contacts;
            Religion; Spread of religion; Literature.
            <br/>
            Disintegration of the empire; sungas and Kanvas.
        </p>

        <p className={`${styles.aboutheading2} pt-2`}>Post-Mauryan Period (Indo-Greeks, Sakas, Kushanas, Western Kshatrapas) :</p>

        <p className={`${styles.aboutoption}`}>
            Contact with outside world; growth of urban centres, economy, coinage, development of religions,
            Mahayana, social conditions, art, architecture, culture, literature and science.
        </p>
        <p className={`${styles.aboutheading2} pt-2`}>
            Early State and Society in Eastern India, Deccan and South India:
        </p>
        <p className={`${styles.aboutoption}`}>
            Kharavela, The Satavahanas, Tamil States of the Sangam Age; Administration, Economy, land grants,
            coinage, trade guilds and urban centres; Buddhist centres; Sangam literature and culture; Art and
            architecture.
        </p>
        <p className={`${styles.aboutheading2} pt-2`}>Guptas, Vakatakas and Vardhanas:</p>
        <p className={`${styles.aboutoption}`}>
            Polity and administration, Economic conditions, Coinage of the Guptas, Land grants, Decline of urban
            centres, Indian feudalism, Caste system, Position of women, Education and educational institutions;
            Nalanda, Vikramshila and Vallabhi, Literature, scientific literature, art and architecture.
        </p>

        <p className={`${styles.aboutheading2} pt-2`}>Regional States during Gupta Era:</p>
        <p className={`${styles.aboutoption}`}>
            The Kadambas, Pallavas, Chalukyas of Badami; Polity and Administration, Trade guilds, Literature; growth
            of Vaishnava and Saiva religions. Tamil Bhakit movement, Shankaracharya; Vedanta; Institutions of temple
            and temple architecture; Palas, Senas, Rashtrakutas, Paramaras, Polity and administration; Cultural
            aspects. Arab conquest of Sind; Alberuni, The Chaluky as of Kalyana, Cholas, Hoysalas, Pandyas; Polity
            and Administration; Local Government; Growth of art and architecture, religious sects, Institution of temple
            and Mathas, Agraharas, education and literature, economy and society.
        </p>
        <p className={`${styles.aboutheading2} pt-2`}>Themes in Early Indian Cultural History:</p>
        <p>
            Languages and texts, major stages in the evolution of art and architecture, major philosophical thinkers
            and schools, ideas in Science and Mathematics.
        </p>
        <p className={`${styles.aboutheading2} pt-2`}>
            Early Medieval India, 750-1200:
        </p>
        <ul>
            <li>Polity: Major political developments in Northern India and the peninsula, origin and the rise of Rajputs.</li>
            <li>The Cholas: administration, village economy and society “Indian Feudalism”.</li>
            <li>Agrarian economy and urban settlements.</li>
            <li>Trade and commerce.</li>
            <li>Society: the status of the Brahman and the new social order.</li>
            <li>Condition of women.</li>
            <li>Indian science and technology.</li>
        </ul>

        <p className={`${styles.aboutheading2} pt-2`}>Cultural Traditions in India, 750-1200:</p>
        <ul>
            <li>Philosophy: Skankaracharya and Vedanta, Ramanuja and Vishishtadvaita, Madhva and Brahma - Mimansa.</li>
            <li>Religion: Forms and features of religion, Tamil devotional cult, growth of Bhakti, Islam and its arrival in India, Sufism.</li>
            <li>Literature: Literature in Sanskrit, growth of Tamil literature, literature in the newly developing
                languages, Kalhan's Rajtarangini, Alberuni's India.</li>
            <li>Art and Architecture: Temple architecture, sculpture, painting.</li>    
        </ul>

        <p className={`${styles.aboutheading2} pt-2`}>The Thirteenth Century :</p>
        <ul>
            <li>Establishment of the Delhi Sultanate: The Ghurian invasions - factors behind Ghurian success</li>   
            <li>Economic, Social and cultural consequences.</li>    
            <li>Foundation of Delhi Sultanate and early Turkish Sultans.</li>
            <li>Consolidation: The rule of Iltutmish and Balban.</li>
        </ul>

        <p className={`${styles.aboutheading2} pt-2`}>The Fourteenth Century: </p>
        <ul>
            <li>“The Khalji Revolution”.</li>
            <li>Alauddin Khalji: Conquests and territorial expansion, agrarian and economic measure.</li>
            <li>Muhammad Tughluq: Major projects, agrarian measures, bureaucracy of Muhammad Tughluq.</li>
            <li>Firuz Tugluq: Agrarian measures, achievements in civil engineering and public works, decline of the Sultanate, foreign contacts and Ibn Battuta's account.</li>
        </ul>

        <p className={`${styles.aboutheading2} pt-2`}>Society, Culture and Economy in the Thirteenth and Fourteenth Centuries:</p>
        <ul>
            <li>Society: composition of rural society, ruling classes, town dwellers, women, religious classes, caste and
                slavery under the Sultanate, Bhakti movement, Sufi movement.</li>
            <li>Culture: Persian literature, literature in the regional languages of North India, literaute in the languages
                of South India, Sultanate architecture and new structural forms, painting, evolution of a composite culture.</li>
            <li>Economy: Agricultural Production, rise of urban economy and non-agricultural production, trade and
                commerce.</li>        
        </ul>

        <p className={`${styles.aboutheading2} pt-2`}>The Fifteenth and Early Sixteenth Century-Political Developments and Economy:</p>
        <ul>
            <li>Rise of Provincial Dynasties : Bengal, Kashmir (Zainul Abedin), Gujarat.</li>
            <li>Malwa, Bahmanids.</li>
            <li>The Vijayanagara Empire.</li>
            <li>Lodis.</li>
            <li>Mughal Empire, first phase : Babur, Humayun.</li>
            <li>The Sur Empire : Sher Shah’s administration.</li>
            <li>Portuguese colonial enterprise, Bhakti and Sufi Movements.</li>
        </ul>

        <p className={`${styles.aboutheading2} pt-2`}>The Fifteenth and Early Sixteenth Century-Society and culture:</p>
        <ul>
            <li>Regional cultures specificities.</li>
            <li>Literary traditions.</li>
            <li>Provincial architectural.</li>
            <li>Society, culture, literature and the arts in Vijayanagara Empire.</li>
        </ul>

        <p className={`${styles.aboutheading2} pt-2`}>Akbar :</p>

        <ul>
            <li>Conquests and consolidation of empire.</li>
            <li>Establishment of jagir and mansab systems.</li>
            <li>Rajput policy.</li>
            <li>Evolution of religious and social outlook. Theory of Sulh-i-kul and religious policy.</li>
            <li>Court patronage of art and technology.</li>
        </ul>

        <p className={`${styles.aboutheading2} pt-2`}>Mughal Empire in the Seventeenth Century :</p>

        <ul>
            <li>Major administrative policies of Jahangir, Shahjahan and Aurangzeb.</li>
            <li>The Empire and the Zamindars.</li>
            <li>Religious policies of Jahangir, Shahjahan and Aurangzeb.</li>
            <li>Nature of the Mughal State.</li>
            <li>Late Seventeenth Century crisis and the revolts.</li>
            <li>The Ahom kingdom.</li>
            <li>Shivaji and the early Maratha Kingdom.</li>
        </ul>

        <p className={`${styles.aboutheading2} pt-2`}>Economy and society, in the 16th and 17th Centuries :</p>
        <ul>
            <li>Population Agricultural and craft production.</li>
            <li>Towns, commerce with Europe through Dutch, English and French companies : a trade revolution.</li>
            <li>Indian mercantile classes. Banking, insurance and credit systems.</li>
            <li>Conditions of peasants, Condition of Women.</li>
            <li>Evolution of the Sikh community and the Khalsa Panth.</li>
        </ul>

        <p className={`${styles.aboutheading2} pt-2`}>Culture during Mughal Empire : </p>
        <ul>
            <li>Persian histories and other literature.</li>
            <li>Hindi and religious literatures.</li>
            <li>Mughal architecture.</li>
            <li>Mughal painting.</li>
            <li>Provincial architecture and painting.</li>
            <li>Classical music.</li>
            <li>Science and technology.</li>
        </ul>

        <p className={`${styles.aboutheading2} pt-2`}>The Eighteenth Century : </p>
        <ul>
            <li>Factors for the decline of the Mughal Empire.</li>
            <li>The regional principalities: Nizam’s Deccan, Bengal, Awadh.</li>
            <li>Maratha ascendancy under the Peshwas.</li>
            <li>The Maratha fiscal and financial system.</li>
            <li>Emergence of Afghan power Battle of Panipat, 1761.</li>
            <li>State of, political, cultural and economic, on eve of the British conquest.</li>
        </ul>

      </div>
    </div>

{/*  HISTORY II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        History - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      >
        

        <p className={`${styles.aboutheading2} `}>
           European Penetration into India :
        </p>
       <p className={`${styles.aboutoption}`}>
            The Early European Settlements; The Portuguese and the Dutch; The English and the French East
            India Companies; Their struggle for supremacy; Carnatic Wars; Bengal-The conflict between the English
            and the Nawabs of Bengal; Siraj and the English; The Battle of Plassey; Significance of Plassey.
        </p> 

        
        <p className={`${styles.aboutheading2} `}>
            British Expansion in India :
        </p>

        <p className={`${styles.aboutoption}`}>
            Bengal-Mir Jafar and Mir Kasim; The Battle of Buxar; Mysore; The Marathas; The three Anglo-Maratha
            Wars; The Punjab.
        </p>

        <p className={`${styles.aboutheading2} `}>Early Structure of the British Raj:</p>


       <p className={`${styles.aboutoption}`}> 
            The Early administrative structure; From diarchy to direct contol; The Regulating Act (1773); The Pitt's
            India Act (1784); The Charter Act (1833); The Voice of free trade and the changing character of British
            colonial rule; The English utilitarian and India.
        </p>

        <p className={`${styles.aboutheading2}`}>Economic Impact of British Colonial Rule :</p>

        <p className={`${styles.aboutoption}`}>
            Land revenue settlements in British India; The Permanent Settlement; Ryotwari Settlement; Mahalwari
            Settlement; Economic impact of the revenue arrangements; Commercialization of agriculture; Rise of
            landless agrarian labourers; Impoverishment of the rural society.
        </p>

        <p className={`${styles.aboutheading2}`}>Social and Cultural Developments: </p>

        <p className={`${styles.aboutoption}`}>
            The state of indigenous education, its dislocation; Orientalist-Anglicist controversy, The introduction
            of western education in India; The rise of press, literature and public opinion; The rise of modern vernacular
            literature; Progress of Science; Christian missionary activities in India.
        </p>

        <p className={`${styles.aboutheading2}`}>Social and Religious Reform Movements in Bengal and Other Areas:</p>

        <p className={`${styles.aboutoption}`}>
            Ram Mohan Roy, The Brahmo Movement; Devendranath Tagore; Iswarchandra Vidyasagar; The Young
            Bengal Movement; Dayanada Saraswati; The social reform movements in India including Sati, widow
            remarriage, child marriage etc.; The contribution of Indian renaissance to the growth of modern India;
            Islamic revivalism-the Feraizi and Wahabi Movements.
        </p>

        <p className={`${styles.aboutheading2}`}>Indian Response to British Rule : </p>

        <p className={`${styles.aboutoption}`}>
            Peasant movement and tribal uprisings in the 18th and 19th centuries including the Rangpur Dhing
            (1783), the Kol Rebellion (1832), the Mopla Rebellion in Malabar (1841-1920), the Santal Hul (1855), Indigo
            Rebellion (1859-60), Deccan Uprising (1875) and the Munda Ulgulan (1899-1900); The Great Revolt of 1857
            —Origin, character, casuses of failure, the consequences; The shift in the character of peasant uprisings in
            the post-1857 period; the peasant movements of the 1920s and 1930s.
        </p>

        <p className={`${styles.aboutoption}`}>
            Factors leading to the birth of Indian Nationalism; Politics of Association; The Foundation of the Indian
            National Congress; The Safety-valve thesis relating to the birth of the Congress; Programme and objectives
            of Early Congress; the social composition of early Congress leadership; the Moderates and Extremists; The
            Partition of Bengal (1905); The Swadeshi Movement in Bengal; the economic and political aspects of
            Swadeshi Movement; The beginning of revolutionary extremism in India.
        </p>

        <p className={`${styles.aboutoption}`}>
            Rise of Gandhi; Character of Gandhian nationalism; Gandhi's popular appeal; Rowlatt Satyagraha; the
            Khilafat Movement; the Non-cooperation Movement; National politics from the end of the Non-cooperation
            movement to the beginning of the Civil Disobedience Movement; the two phases of the Civil Disobedience
            Movement; Simon Commission; The Nehru Report; the Round Table Conferences; Nationalism and the
            Peasant Movements; Nationalism and Working class movements; Women and Indian youth and students in
            Indian politics (1885-1947); the election of 1937 and the formation of ministries; Cripps Mission; the Quit
            India Movement; the Wavell Plan; The Cabinet Mission.
        </p>

        <p className={`${styles.aboutoption}`}>Constitutional Developments in the Colonial India between 1858 and 1935.</p>

        <p className={`${styles.aboutoption}`}>
            Other strands in the National Movement. <br/>
            The Revolutionaries: Bengal, the Punjab, Maharashtra, U.P. the Madras Presidency, Outside India.
            The Left; The Left within the Congress: Jawaharlal Nehru, Subhas Chandra Bose, the Congress
            Socialist Party; the Communist Party of India, other left parties.
        </p>

        <p className={`${styles.aboutoption}`}>
            Politics of Separatism; the Muslim League; the Hindu Mahasabha; Communalism and the politics of
            partition; Transfer of power; Independence.
        </p>

        <p className={`${styles.aboutoption}`}>
            Consolidation as a Nation; Nehru's Foreign Policy; India and her neighbours (1947-1964); The linguistic
            reorganisation of States (1935-1947); Regionalism and regional inequality; Integration of Princely States;
            Princes in electoral politics; the Question of National Language.
        </p>

        <p className={`${styles.aboutoption}`}>
            Caste and Ethnicity after 1947; Backward Castes and Tribes in post-colonial electoral politics; Dalit movements.
        </p>

        <p className={`${styles.aboutoption}`}>
            Economic development and political change; Land reforms; the politics of planning and rural
            reconstruction; Ecology and environmental policy in post-colonial India; Progress of Science.
        </p>

        <p className={`${styles.aboutheading2}`}>Enlightenment and Modern ideas:</p>

        <ul>
            <li>Major Ideas of Enlightenment : Kant, Rousseau.</li>
            <li>Spread of Enlightenment in the colonies.</li>
            <li>Rise of socialist ideas (up to Marx); spread of Marxian Socialism.</li>
        </ul>
         
        <p className={`${styles.aboutheading2}`}>Origins of Modern Politics :</p> 

        <ul>
            <li>European States System.</li>
            <li>American Revolution and the Constitution.</li>
            <li>French Revolution and Aftermath, 1789-1815.</li>
            <li>American Civil War with reference to Abraham Lincoln and the abolition of slavery.</li>
            <li>British Democratic politics, 1815-1850 : Parliamentary Reformers, Free Traders, Chartists.</li>
        </ul>

        <p className={`${styles.aboutheading2}`}>Industrialization :</p>

        <ul>
            <li>English Industrial Revolution : Causes and Impact on Society.</li>
            <li>Industrialization in other countries : USA, Germany, Russia, Japan.</li>
            <li>Industrialization and Globalization.</li>
        </ul>

        <p className={`${styles.aboutheading2}`}>Nation-State System :</p>

        <ul>
            <li>Rise of Nationalism in 19th century.</li>
            <li>Nationalism : State-building in Germany and Italy.</li>
            <li>Disintegration of Empires in the face of the emergence of nationalities across the World.</li>
        </ul>

        <p className={`${styles.aboutheading2}`}>Imperialism and Colonialism : </p>

        <ul>
            <li>South and South-East Asia.</li>
            <li>Latin America and South Africa.</li>
            <li>Australia.</li>
            <li>Imperialism and free trade: Rise of neo-imperialism.</li>
        </ul>

        <p className={`${styles.aboutheading2}`}>Revolution and Counter-Revolution : </p>

        <ul>
            <li>19th Century European revolutions.</li>
            <li>The Russian Revolution of 1917-1921.</li>
            <li>Fascist Counter-Revolution, Italy and Germany.</li>
            <li>The Chinese Revolution of 1949.</li>
        </ul>

        <p className={`${styles.aboutheading2}`}>World Wars :</p>

        <ul>
            <li>1st and 2nd World Wars as Total Wars : Societal implications.</li>
            <li>World War I : Causes and Consequences.</li>
            <li>World War II : Causes and Consequences.</li>
        </ul>

        <p className={`${styles.aboutheading2}`}> The World after World War II : </p>

        <ul>
            <li>Emergence of Two power blocs.</li>
            <li>Emergence of Third World and non-alignment.</li>
            <li>UNO and the global disputes.</li>
        </ul>

        <p className={`${styles.aboutheading2}`}>Liberation from Colonial Rule : </p>

        <ul>
            <li>Latin America-Bolivar.</li>
            <li>Arab World-Egypt.</li>
            <li>Africa-Apartheid to Democracy.</li>
            <li>South-East Asia-Vietnam.</li>
        </ul>
 
        <p className={`${styles.aboutheading2}`}>Decolonization and Underdevelopment : </p>
         <ul>
             <li>Factors constraining Development ; Latin America, Africa.</li>
        </ul>

        <p className={`${styles.aboutheading2} pt-2`}>Unification of Europe : </p>

        <ul>
            <li>Post War Foundations ; NATO and European Community.</li>
            <li>Consolidation and Expansion of European Community</li>
            <li>European Union.</li>
        </ul>

        <p className={`${styles.aboutheading2} pt-2`}>Disintegration of Soviet Union and the Rise of the Unipolar World : </p>

        <ul>
            <li>Factors leading to the collapse of Soviet Communism and Soviet Union, 1985-1991.</li>
            <li>Political Changes in East Europe 1989-2001.</li>
            <li>End of the Cold War and US Ascendancy in the World as the lone superpower.</li>
        </ul>
       
        </div>
    </div>
  </div>
</div>

{/* 4 GEOGRAPHY */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        4</span> GEOGRAPHY
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Geography - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >

        <p className={`${styles.aboutheading2} text-center`}>
         PRINCIPLES OF GEOGRAPHY 
        </p>

        <p className={`${styles.aboutheading2} text-center`}>
         Physical Geography :
        </p>

        <p className={`${styles.aboutheading2} `}>
         GEOMORPHOLOGY :
        </p>

        <p className={`${styles.aboutoption}`}      >
            Factors controlling landform development; endogenetic and exogenetic forces;
            Origin and evolution of the earth’s crusts; Fundamentals of geomagnetism; Physical conditions of the earth’s
            interior; Geosynclines; Continental drift; Isostasy; Plate tectonics; Recent views on mountain building;
            Volcanicity; Earthquakes and Tsunamis; Concepts of geomorphic cycles and Land scape development;
            Denudation chronology; Channel morphology; Erosion surfaces; Slope development; Applied
            Geomorphology; Geomorphology, economic geology and environment.
        </p>

        <p className={`${styles.aboutheading2} `}>Climatology : </p>

        <p className={`${styles.aboutoption}`}>
            Temperature and pressure belts of the world; Heat budget of the earth; Atmospheric
            circulation; Atmospheric stability and instability. Planetary and local winds; Monsoons and jet streams; Air
            masses and fronto; Temperate and tropical cyclones; Types and distribution of precipitation; Weather and
            Climate; Koppen’s Thornthwaite’s and Trewar Tha’s classification of world climate; Hydrological cycle;
            Global climatic change, and role and response of man in climatic changes Applied climatology and Urban
            climate.    
        </p>

        <p className={`${styles.aboutheading2} pt-2`}>Oceanography :</p>

        <p className={`${styles.aboutoption}`}>
            Bottom topography of the Atlantic, Indian and Pacific Oceans; Temperature and
            salinity of the oceans; Heat and salt budgets, Ocean deposits; Waves, currents and tides; Marine resources;
            biotic, mineral and energy resources; Coral reefs coral bleaching; Sea-level changes; Law of the sea and
            marine pollution.
        </p>

       <p className={`${styles.aboutheading2} pt-2`}>Biogeography : </p> 

         <p className={`${styles.aboutoption}`}>
            Genesis of soils; Classification and distribution of soils; Soil profile; Soil erosion,
            Degrada-tion and conservation; Factors influencing world distribution of plants and animals; Problems of
            deforestation and conservation measures; Social forestry, agro-forestry; Wild life; Major gene pool centres.
        </p>

        <p className={`${styles.aboutheading2} pt-2`}>Environmental Geography :</p>

        <p className={`${styles.aboutoption}`}>
            Principle ecology; Human ecological adaptations; Influence of man on
            ecology and environment; Global and regional ecological changes and imbalances; Ecosystem their
            management and conservation; Environmental degradation, management and conservation; Biodiversity
            and sustainable development; Environmental policy; Environmental hazards and remedial measures;
            Environmental education and legislation.
        </p>

        <p className={`${styles.aboutheading2} text-center`}>
          Human Geography
        </p>
        <p className={`${styles.aboutheading2} `}>
            Perspectives in Human Geography :
        </p>
        <p className={`${styles.aboutoption}`}>
            Areal differentiation; Regional synthesis; Dichotomy and
            dualism; Environmentalism; Quantitative revolution and locational analysis; Radical, behavioural, human
            and welfare approaches; Languages, religions and secularisation; Cultural regions of the world; Human
            development indix.
        </p>

        <p className={`${styles.aboutheading2}`}> Economic Geography :</p>

        <p className={`${styles.aboutoption}`}>
            World economic development: measurement and problems; World resources
            and their distribution; Energy crisis; the limits to growth; World agriculture: typology of agricultural regions;
            Agricultural inputs and productivity; Food and nutritions problems; Food security; famine: causes, effects
            and remedies; World industries: location patterns and problems; Patterns of world trade.
        </p>

        <p className={`${styles.aboutheading2}`}>
            Population and Settlement Geography :
        </p>

        <p className={`${styles.aboutoption}`}>
            Growth and distribution of world population;
            Demographic attributes; Causes and consequences of migration; Concepts of over-under-and
            optimum population; Population theories, world population problems and policies, Social well-being and
            quality of life; Population as social capital.
        </p>

        <p className={`${styles.aboutoption}`}>
            Types and patterns of rural settlements; Environmental issues in rural settlements; Hierarchy of
            urban settlements; Urban morphology; Concept of primate city and rank-size rule; Functional classification
            of towns; Sphere of urban influence; Rural-urban fringe; Satellite towns; Problems and remedies of
            urbanization; Sustainable development of cities.
        </p>

        <p className={`${styles.aboutheading2}`}>regional Planning :</p>

        <p className={`${styles.aboutoption}`}>
            Concept of a region; Types of regions and methods of regionalisation; Growth
            centres and growth poles; Regional imbalances; Regional development strategies; Environmental issues in
            regional planning; Planning for sustainable development.
        </p>

        <p className={`${styles.aboutheading2}`}>Models, Theories and Laws in Human Geography :</p>
       
        <p lassName={`${styles.aboutoption}`}>
            System analysis in Human geography;
            Malthusian, Marxian and demographic transition models; Central Place theories of Christaller and Losch;
            Perroux and Boudeville; Von Thunen’s model of agricultural location; Weber’s model of industrial location;
            Ostov’s model of stages of growth. Heart-land and Rimland theories; Laws of international boundaries and
            frontiers
        </p>
                        
      </div>
    </div>

{/*  Geography II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
     Geography - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      >
        <p className={`${styles.aboutheading2} text-center`}>GEOGRAPHY OF INDIA</p>

        <p className={`${styles.aboutheading2} `}>
            Physical Setting :
        </p>
       <p className={`${styles.aboutoption}`}>
            Space relationship of India with neighbouring countries; Structure and relief;
            Drainage system and watersheds; Physiographic regions; Mechanism of Indian monsoons and rainfall
            patterns; Tropical cyclones and western disturbances; Floods and droughts; Climatic regions; Natural
            vegetation, Soil types and their distributions.
        </p> 

        <p className={`${styles.aboutheading2} `}>
            Resources :
        </p>

        <p className={`${styles.aboutoption}`}>
            Land, surface and ground water, energy, minerals, biotic and marine resources, Forest
            and wild life resources and their conservation; Energy crisis.
        </p>

        <p className={`${styles.aboutheading2} `}>
            Agriculture :
        </p>

        <p className={`${styles.aboutoption}`}>
            Infrastructure: irrigation, seeds, fertilizers, power; Institutional factors; land holdings,
            land tenure and land reforms; Cropping pattern, agricultural productivity, agricultural intensity, crop
            combination, land capability; Agro and social-forestry; Green revolution and its socio-economic and ecological implications; Significance of dry farming; Livestock resources and white revolution; Aqua-culture;
            Sericulture, Agriculture and poultry; Agricultural regionalisation; Agro-climatic zones; Agro-ecological
            regions.
        </p>

       <p className={`${styles.aboutheading2} `}>   
          Industry :
        </p>

        <p className={`${styles.aboutoption}`}>
            Evolution of industries; Locational factors of cotton, jute, textile, iron and steel,
            aluminium, fertiliser, paper, chemical and pharmaceutical, automobile, cottage and ago-based industries;
            Industrial houses and complexes including public sector underkings; Industrial regionalisation; New
            industrial policy; Multinationals and liberalisation; Special Economic Zones; Tourism including ecotourism.
        </p>

        <p className={`${styles.aboutheading2} `}>
            Transport, Communication and Trade :
        </p>

        <p className={`${styles.aboutoption}`}>
            Road, railway, waterway, airway and pipeline net works
            and their complementary roles in regional development; Growing importance of ports on national and foreign
            trade; Trade balance; Trade Policy;Export processing zones; Developments in communication and
            information technology and their impacts on economy and society; Indian space programme.
        </p>

        <p className={`${styles.aboutheading2} `}>Cultural Setting :</p>

        <p className={`${styles.aboutoption}`}>
            Historical Perspective of Indian Society; Racial linguistic and ethnic diversities;
            religious minorities; Major tribes, tribal areas and their problems; Cultural regions; Growth, distribution
            and density of population; Demographic attributes: sex-ratio, age structure, literacy rate, work-force,
            dependency ratio, longevity; migration (inter-regional, interaregional and international) and associated
            problems; Population problems and policies; Health indicators.
       </p>

       <p className={`${styles.aboutheading2} `}>Settlements :</p>

       <p className={`${styles.aboutoption}`}>
            Types, patterns and morphology of rural settlements; Urban developments;
            Morphology of Indian cities; Functional classification of Indian cities; Conurbations and metropolitan
            regions; Urban sprawl; Slums and asssociated problems; Town planning; Problems of urbanisation and
            remedies.
        </p>

        <p className={`${styles.aboutheading2} `}>Regional Development and Planning:</p>

        <p className={`${styles.aboutoption}`}>
            Experience of regional planning in India; Five Year Plans;
            Integrated rural development programmes; Panchayati Raj and decentralised planning; Command area
            development; Watershed management; Planning for backward area, desert, drought-prone, hill tribal area
            development; Multi-level planning; Regional planning and development of island territories.
        </p>

        <p className={`${styles.aboutheading2} `}>Political Aspects :</p>

        <p className={`${styles.aboutoption}`}>
            Geographical basis of Indian federalism; State reorganisation; Emergence of new
            states; Regional consciousness and inter-state issues; International boundary of India and related issues;
            Cross-border terrorism; India’s role in world affairs; Geopolitics of South Asia and Indian Ocean realm.
       </p>

       <p className={`${styles.aboutheading2} `}>Contemporary Issues : </p>

       <p className={`${styles.aboutoption}`}>
            Ecological issues: Environmental hazards: landslides, earthquakes,
            Tsunamis, floods and droughts, epidemics; Issues related to environmental pollution; Changes in patterns
            of land use; Principles of environmental impact assessment and environmental management; Population
            explosion and food security; Environmental degradation; Deforestation, desertification and soil erosion;
            Problems of agrarian and industrial unrest; Regional disparities in economic development; Concept of
            sustainable growth and development; Environmental awareness; Linkage of rivers; Globalisation and Indian
            economy.
       </p>

       <p className={`${styles.aboutoption}`}>
            <span className="fw-bold text-danger"> NOTE : </span> Candidates will be required to answer one compulsory map question pertinent to subjects
            covered by this paper.
       </p>

        </div>
    </div>
  </div>
</div>

{/* 5. SOCIOLOGY  */} 

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        5</span>SOCIOLOGY  
    </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
       Sociology - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
    
    <p className={`${styles.aboutheading2} text-center `}>FUNDAMENTALS OF SOCIOLOGY</p>

     
    <p className={`${styles.aboutheading2}  `}>
         1. Sociology - The Discipline:
    </p> 

    <ul className='list-unstyled'>
        <li>(a) Modernity and social changes in Europe and emergence of Sociology.</li>
        <li>(b) Scope of the subject and comparison with other social sciences.</li>
        <li>(c) Sociology and common sense.</li>
    </ul>
    
    <p className={`${styles.aboutheading2} `}>  
         2. Sociology as Science:
    </p> 

   <ul className='list-unstyled'>
        <li>(a) Science, scientific method and critique.</li>
        <li>(b) Major theoretical strands of research methodology.</li>
        <li>(c) Positivism and its critique. </li>
        <li>(d) Fact value and objectivity.</li>
        <li>(e) Non-positivist methodologies.</li>
    </ul>

    <p className={`${styles.aboutheading2} `}>
         3. Research Methods and Analysis:
    </p>

     <ul className='list-unstyled'>
       <li>(a) Qualitative and quantitative methods.</li> 
       <li>(b) Techniques of data collection.</li> 
       <li>(c) Variables, sampling, hypothesis, reliability and validity.</li> 
    </ul>

    <p className={`${styles.aboutheading2} `}>
         4. Sociological Thinkers:
    </p>

    <ul className='list-unstyled'>
      <li>(a) Karl Marx - Historical materialism, mode of production, alienation, class struggle.</li>
      <li>(b) Emile Durkhteim - Division of labour, social fact, suicide, religion and society.</li>
      <li>(c) Max Weber - Social action, ideal types, authority, bureaucracy, protestant ethic and the spirit of capitalism.</li>
      <li>(d) Talcolt Parsons - Social system, pattern variables.</li>
      <li>(e) Robert K. Merton - Latent and manifest functions, conformity and deviance, reference groups.</li>
      <li>(f) Mead - Self and identity.</li>
    </ul>

    <p className={`${styles.aboutheading2} `}>
         5. Stratification and Mobility :
    </p>
        <ul className='list-unstyled'>
            <li>(a) Concepts - equality, inequality, hierarchy, exclusion, poverty and deprivation.</li>
            <li>(b) Theories of social stratification - Structural func tionalist theory, Marxist theory, Weberian theory.</li>
            <li>(c) Dimensions - Social stratification of class, status groups, gender, ethnicity and race.</li>
            <li>(d) Social mobility - open and closed systems, types of mobility, sources and causes of mobility.</li>
        </ul>
    

    <p className={`${styles.aboutheading2} `}>
         6. Works and Economic Life :
    </p>

        <ul className='list-unstyled'>
            <li>(a) Social organization of work in different types of society - slave society, feudal society, industrial capitalist society.</li> 
            <li>(b) Formal and informal organization of work.</li> 
            <li>(c) Labour and society.</li> 
            </ul>

    <p className={`${styles.aboutheading2} `}>
        7. Politics and Society:
    </p>

        <ul className='list-unstyled'>
            <li>(a) Sociological theories of power.</li> 
            <li>(b) Power elite, bureaucracy, pressure groups and political parties.</li> 
            <li>(c) Nation, state, citizenship, democracy, civil society, ideology.</li> 
            <li>(d) Protest, agitation, social movements, collective action, revolution.</li>
        </ul>

    <p className={`${styles.aboutheading2} `}>
         8. Religion and Society :
    </p>

       <ul className='list-unstyled'>
            <li>(a) Sociological theories of religion.</li> 
            <li>(b) Types of religious practices: animism, monism, pluralism, sects, cults.</li> 
            <li>(c) Religion in modern society: religion and science, secularization, religious revivalism, fundamentalism.</li> 
        </ul>

    <p className={`${styles.aboutheading2} `}>
         9. Systems of Kinship:
    </p>   

    <ul className='list-unstyled'>
        <li>(a) Family, household, marriage.</li>
        <li>(b) Types and forms of family.</li>
        <li>(c) Lineage and descent.</li>
        <li>(d) Patriarchy and sexual division of labour.</li>
        <li>(e) Contem porary trends.</li>
    </ul>

    <p className={`${styles.aboutheading2} `}>
        10. Social Change in Modern Society :
    </p>   

     <ul className='list-unstyled'>
        <li>(a) Sociological theories of social change.</li>
        <li>(b) Development and dependency.</li>
        <li>(c) Agents of social change.</li>
        <li>(d) Education and social change.</li>
        <li>(e) Science, technology and social change.</li>
      </ul>


 </div>
</div>

{/* Sociology II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
         Sociology - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", 
            textAlign: "justify", 
            }}
      > 

        <p className={`${styles.aboutheading2} text-center`}>
            INDIAN SOCIETY : STRUCTURE AND CHANGE
        </p>
     
        <p className={`${styles.aboutheading2} text-center`}>
          A. Introducing Indian Society :
        </p>
              
        <p className={`${styles.aboutheading2} `}>
            (i) Perspectives on the Study of Indian Society :  
        </p>

        <ul className='list-unstyled'>
            <li>(a) Indology (G.S. Ghure).</li>
            <li>(b) Structural functionalism (M. N. Srinivas).</li>
            <li>(c) Marxist sociology (A. R. Desai).</li>
        </ul>

        <p className={`${styles.aboutheading2} `}>
            (ii) Impact of colonial rule on Indian society :
        </p>

         <ul className='list-unstyled'>
            <li>(a) Social background of Indian nationalism.</li>
            <li>(b) Modernization of Indian tradition.</li>
            <li>(c) Protests and movements during the colonial period.</li>
            <li>(d) Social reforms.</li>
        </ul>

        <p className={`${styles.aboutheading2} text-center `}>
            B. Social Structure:
        </p>
 
        <p className={`${styles.aboutheading2} `}>
           (i) Rural and Agrarian Social Structure:
        </p>

           <ul className='list-unstyled'>
                <li>(a) The idea of Indian village and village studies</li>
                <li>(b) Agrarian social structure — evolution of land tenure system, land reforms.</li>
            </ul>

        <p className={`${styles.aboutheading2} `}>
           (ii) Caste System:
        </p>

            <ul className='list-unstyled'>
                <li>(a) Perspectives on the study of caste systems: G. S. Ghurye, M. N. Srinivas, Louis Dumont, Andre Beteille.</li>
                <li>(b) Features of caste system.</li>
                <li>(c) Untouchability-forms and perspectives</li>
            </ul>

        <p className={`${styles.aboutheading2} `}>
            (iii) Tribal Communities in India:
        </p>

          <ul className='list-unstyled'>
            <li>(a) Definitional problems.</li>
            <li>(b) Geographical spread.</li>
            <li>(c) Colonial policies and tribes.</li>
            <li>(d) Issues of integration and autonomy.</li>
          </ul>

        <p className={`${styles.aboutheading2} `}>
            (iv) Social Classes in India:
        </p>

           <ul className='list-unstyled'>
              <li>(a) Agrarian class structure.</li>
              <li>(b) Industrial class structure.</li>
              <li>(c) Middle classes in India.</li>
           </ul>

        <p className={`${styles.aboutheading2} `}>
           (v) Systems of Kinship in India:
        </p>

            <ul className='list-unstyled'>
               <li>(a) Lineage and descent in India.</li>
               <li>(b) Types of kinship systems.</li>
               <li>(c) Family and marriage in India.</li>
               <li>(d) Household dimensions of the family.</li>
               <li>(e) Patriarchy, entitlements and sexual division oflabour.</li>
            </ul>

        <p className={`${styles.aboutheading2} `}>
            (vi) Religion and Society :
        </p> 

            <ul className='list-unstyled'>
                <li> (a) Religious communities in India.</li>
                <li> (b) Problems of religious minorities.</li>
            </ul>

        <p className={`${styles.aboutheading2} text-center`}>
            C. Social Changes in India:
        </p>

        <p className={`${styles.aboutheading2} `}>
            (i) Visions of Social Change in India:
        </p> 
           
            <ul className='list-unstyled'>
                <li>(a) Idea of development planning and mixed economy.</li>
                <li>(b) Constitution, law and social change.</li>
                <li>(c) Education and social change.</li>
            </ul>

        <p className={`${styles.aboutheading2} `}>
            (ii) Rural and Agrarian Transformation in India:
        </p>

            <ul className='list-unstyled'>
                <li>(a) Programmes of rural development, Community Development Programme, cooperatives, poverty alleviation schemes.</li>
                <li>(b) Green revolution and social change.</li>
                <li>(c) Changing modes of production in Indian agriculture.</li>
                <li>(d) Problems of rural labour, bondage, migration.</li>
            </ul>
        
        <p className={`${styles.aboutheading2} `}>   
            (iii) Industrialization and Urbanisation in India:
        </p>     
            <ul className='list-unstyled'>
               <li>(a) Evolution of modern industry in India.</li>
               <li>(b) Growth of urban settlements in India.</li>
               <li>(c) Working class: structure, growth, class mobilization.</li>
               <li>(d) Informal sector, child labour.</li>
               <li>(e) Slums and deprivation in urban areas.</li>
            </ul>

        <p className={`${styles.aboutheading2} `}>
            (iv) Politics and Society :
        </p>
            <ul className="list-unstyled">
                <li>(a) Nation, democracy and citizenship.</li>
                <li>(b) Political parties, pressure groups, social and political elite.</li>
                <li>(c) Regionalism and decentralization of power.</li>
                <li>(d) Secularization.</li>
            </ul>

        <p className={`${styles.aboutheading2} `}>
             (v) Social Movements in Modern India :
        </p>
            <ul className="list-unstyled">
                <li>(a) Peasants and farmers movements.</li>
                <li>(b) Women’s movement.</li>
                <li>(c) Backward classes & Dalit movements.</li>
                <li>(d) Environmental movements.</li>
                <li>(e) Ethnicity and Identity movements.</li>
            </ul>   

        <p className={`${styles.aboutheading2} `}>
            (vi) Population Dynamics :
        </p>
            <ul className="list-unstyled">
                <li>(a) Population size, growth, composition and distribution.</li>
                <li>(b) Components of population growth: birth, death, migration.</li>
                <li>(c) Population Policy and family planning.</li>
                <li>(d) Emerging issues: ageing, sex ratios, child and infant mortality, reproductive health</li>
            </ul>

         <p className={`${styles.aboutheading2} `}>
            (vii) Challenges of Social Transformation :
        </p>

            <ul className="list-unstyled">

                <li>(a) Crisis of development : displacement, environmental problems and sustainability.</li>
                <li>(b) Poverty, deprivation and inequalities.</li>
                <li>(c) Violence against women.</li>
                <li>(d) Caste conflicts.</li>
                <li>(e) Ethnic conflicts, communalism, religious revivalism.</li>
                <li>(f) Illiteracy and disparities in education.</li>

            </ul>

      </div>
    </div>
  </div>
</div>

{/* 6. PUBLIC ADMINISTRATION  */} 

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        6</span>PUBLIC ADMINISTRATION   
    </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
       Public Administration  - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
    
    <p className={`${styles.aboutheading2} text-center `}>Administration Theory</p>

     
    <p className={`${styles.aboutheading2}  `}>
      1. Introduction :
    </p> 

    <p className={`${styles.aboutheading} `}>
        Meaning, scope and significance of Public Administration, Wilson’s vision of Public Administration,
        Evolution of the discipline and its present status. New Public Administration, Public Choice approach;
        Challenges of liberalization, Privatisation, Globalisation; Good Governance: concept and application; New
        Public Management.
    </p>

    <p className={`${styles.aboutheading2} `}>  
       2. Administrative Thought :
    </p> 

    <p className={`${styles.aboutheading} `}>
        Scientific Management and Scientific Management movement; Classical Theory; Weber’s bureaucratic
        model its critique and post-Weberian Developments; Dynamic Administration (Mary Parker Follett); Human
        Relations School (Elton Mayo and others); Functions of the Executive (C.I. Barnard); Simon’s decisionmaking
        theory; Participative Management (R. Likert, C. Argyris, D. McGregor.)
    </p>

    <p className={`${styles.aboutheading2} `}>
       3. Administrative Behaviour :
    </p>

    <p className={`${styles.aboutheading} `}>
        Process and techniques of decision-making; Communication; Morale; Motivation Theories content,
        process and contemporary; Theories of Leadership: Traditional and Modem:
    </p>

    <p className={`${styles.aboutheading2} `}>
      4. Organisations :
    </p>

    <p className={`${styles.aboutheading} `}>
        Theories systems, contingency; Structure and forms: Ministries and Departments, Corporations,
        Companies; Boards and Commissions; Ad hoc, and advisory bodies; Headquarters and Field relationships;
        Regulatory Authorities; Public-Private Partnerships.
    </p>

    <p className={`${styles.aboutheading2} `}>
       5. Accountability and Control :
    </p>

    <p className={`${styles.aboutheading} `}>
        Concepts of accountability and control; Legislative, Executive and judicial control over administration;
        Citizen and Administration; Role of media, interest groups, voluntary organizations; Civil society; Citizen’s
        Charters; Right to Information; Social audit.
    </p>

    <p className={`${styles.aboutheading2} `}>
      6. Administrative Law :
    </p>

    <p className={`${styles.aboutheading} `}>
        Meaning, scope and significance; Dicey on Administrative law; Delegated legislation; Administrative
        Tribunals.
    </p>

    <p className={`${styles.aboutheading2} `}>
        7. Comparative Public Administration :
    </p>

    <p className={`${styles.aboutheading} `}>
        Historical and sociological factors affecting administrative systems; Administration and politics in
        different countries; Current status of Comparative Public Administration; Ecology and administration;
        Riggsian models and their critique.
    </p>

    <p className={`${styles.aboutheading2} `}>
       8. Development Dynamics :
    </p>

    <p className={`${styles.aboutheading} `}>
        Concept of development; Changing profile of development administration; ‘Anti-development thesis’;
        Bureaucracy and development; Strong state versus the market debate; Impact of liberalisation on
        administration in developing countries; Women and development the self-help group movement.
    </p> 

    <p className={`${styles.aboutheading2} `}>
      9.  Personnel Administration :
    </p>   

    <p className={`${styles.aboutheading} `}>
       Importance of human resource development; Recruitment, training, career advancement, position classification, discipline, performance appraisal, promotion, pray and service conditions; employeremployee
       relations, grievance redressal mechanism; Code of conduct; Administrative ethics.
    </p>

    <p className={`${styles.aboutheading2} `}>
        10. Public Policy :
    </p>

    <p className={`${styles.aboutheading} `}>
        Models of policy-making and their critique; Processes of conceptualisation, planning, implementation,
        monitoring, evaluation and review and their limitations; State theories and public policy formulation.
    </p>

    <p className={`${styles.aboutheading2} `}>
       11. Techniques of Adminstrative Improvement :
    </p>

     <p className={`${styles.aboutheading} `}>
       Organisation and methods, Work study and work management; e-governance and information
        technology; Management aid tools like network analysis, MIS, PERT, CPM.
    </p>

    <p className={`${styles.aboutheading2} `}>
        12. Financial Administration :
    </p>

    <p className={`${styles.aboutheading} `}>
       Monetary and fiscal policies: Public borrowings and public debt Budgets types and forms; Budgetary
       process; Financial accountability; Accounts and audit.
    </p>

 
 </div>
</div>

{/* Public Administration II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
         Public Administration - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", 
            textAlign: "justify", 
            }}
      > 

        <p className={`${styles.aboutheading2} text-center`}>
            Indian Administration
        </p>
     
        <p className={`${styles.aboutheading2}`}>
          1. Evolution of Indian Administration :
        </p>
              
        <p className={`${styles.aboutheading} `}>  
            Kautilya Arthashastra; Mughal administration; Legacy of British rule in politics and administration
            Indianization of Public services, revenue administration, district Administration, local self Government
        </p>

        <p className={`${styles.aboutheading2} `}> 
          2. Philosophical and Constitutional framework of Government :
        </p>

        <p className={`${styles.aboutheading} `}>
            Salient features and value premises; Constitutionalism; Political culture; Bureaucracy and democracy;
            Bureaucracy and development.
        </p>

        <p className={`${styles.aboutheading2} `}>
          3. Public Sector Undertakings :
        </p>

        <p className={`${styles.aboutheading} `}>
            Public sector in modern India; Forms of Public Sector Undertakings; Problems of autonomy,
            accountability and control; Impact of liberalization and privatization.
        </p>
 
        <p className={`${styles.aboutheading2} `}>
          4.Union Government and Administration :
        </p>

        <p className={`${styles.aboutheading} `}>
            Executive, Parliament, Judiciary-structure, functions, work processes; Recent trends; Intragovernmental
            relations; Cabinet Secretariat; Prime Minister’s Office; Central Secretariat; Ministries and
            Departments; Boards; Commissions; Attached offices; Field organizations.
        </p>

        <p className={`${styles.aboutheading2} `}>
            5. Plans and Priorities :
        </p>

        <p className={`${styles.aboutheading} `}>
            Machinery of planning; Role, composition and functions of the Planning Commission and the National
            Development Council; ‘Indicative’ planning; Process of plan formulation at Union and State levels;
            Constitutional Amendments (1992) and decentralized planning for economic development and social justice.
        </p>

        <p className={`${styles.aboutheading2} `}>
             6. State Government and Administration :
        </p>

        <p className={`${styles.aboutheading} `}>
            Union-State administrative, legislative and financial relations; Role of the Finance Commission; Governor;
            Chief Minister; Council of Ministers; Chief Secretary; State Secretariat; Directorates.
        </p>

        <p  className={`${styles.aboutheading2} `}>
            7. District Administration since Independence :
        </p>

        <p  className={`${styles.aboutheading} `}>
          Changing role of the Collector; Union-State-local relations; Imperatives of development management and law and order administration; District administration and democratic decentralization.
        </p>

        <p  className={`${styles.aboutheading2} `}>
           8. Civil Services :
        </p>
         
        <p className={`${styles.aboutheading} `}>
            Constitutional position; Structure, recruitment, training and capacity building; Good governance initiatives;
            Code of conduct and discipline; Staff associations; Political rights; Grievance redressal mechanism; Civil
            service neutrality; Civil service activism.
        </p> 

        <p className={`${styles.aboutheading2} `}>
           9. Financial Management :
        </p>

        <p className={`${styles.aboutheading} `}>
            Budget as a political instrument; Parliamentary control of public expenditure; Role of finance ministry in
            monetary and fiscal area; Accounting techniques; Audit; Role of Controller General of Accounts and
            Comptroller and Auditor General of India.
        </p>

        <p className={`${styles.aboutheading2} `}>
             10. Administrative Reforms since Independence :
        </p>

        <p className={`${styles.aboutheading} `}>
            Major concerns; Important Committees and Commissions; Reforms in financial management and human
            resource development; Problems of implementation.
        </p>

        <p className={`${styles.aboutheading2} `}>
            11. Rural Development :
        </p>

        <p className={`${styles.aboutheading} `}>
            Institutions and agencies since Independence; Rural development programmes: foci and strategies;
            Decentralization and Panchayati Raj; 73rd Constitutional amendment.
        </p>

        <p className={`${styles.aboutheading2} `}>
           12. Urban Local Government :
        </p>

        <p className={`${styles.aboutheading} `}>
            Municipal governance: main features, structures, finance and problem areas; 74th Constitutional
            Amendment; Global-local debate; New localism; Development dynamics, politics and administration with
            special reference to city management.
        </p>

        <p className={`${styles.aboutheading2} `}>
            13. Law and Order Administration:
        </p>
 
        <p className={`${styles.aboutheading} `}>  
            British legacy; National Police Commission; Investigative agencies; Role of Central and State Agencies
            including para military forces in maintenance of law and order and countering insurgency and terrorism;
            Criminalisation of politics and administration; Police-public relations; Reforms in Police.
        </p>

        <p className={`${styles.aboutheading2} `}>
            14. Significant issues in Indian Administration:
        </p>

        <p className={`${styles.aboutheading} `}>
            Values in public service; Regulatory Commissions; National Human Rights Commission; Problems of
            administration in coalition regimes; Citizen administration interface; Corruption and administration;
            Disaster management.
        </p>

      </div>
    </div>
  </div>
</div>

{/* 7. PSIR */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        7 </span> POLITICAL SCIENCE AND INTERNATIONAL RELATIONS  
    </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
       PSIR - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
    
    <p className={`${styles.aboutheading2} `}>Political Theory and Indian Politics :</p>

     <ul className='list-unstyled'>
        <li><span className=''style={{fontWeight:"bold"}} >1. Political Theory : </span> Meaning and approaches. </li>
        <li><span className=''style={{fontWeight:"bold"}} >2. Theories of state  : </span> Liberal, Neo-liberal, Marxist, Pluiralist, post-colonial and Feminist.</li>
        <li><span className=''style={{fontWeight:"bold"}} >3. Justice : </span>Conceptions of justice with special reference to Rawl’s theory of justice and its communitarian critiques</li>
        <li><span className=''style={{fontWeight:"bold"}} >4. Equality : </span>Social, political and economic; relationship between equality and freedom; Affirmative action.</li>
        <li><span className=''style={{fontWeight:"bold"}} >5. Rights : </span>Meaning and theories; different kinds of rights; Concept of Human Rights.</li>

        <li><span className=''style={{fontWeight:"bold"}} >6. Democracy : </span>Classical and contemporary theories; different models of democracy—representative, participatory and deliberative.</li>
        <li><span className=''style={{fontWeight:"bold"}} >7. Concept of power : </span>hegemony, ideology and legitimacy.</li>
        <li><span className=''style={{fontWeight:"bold"}} >8. Political Ideologies : </span>Liberalism, Socialism, Marxism, Fascism, Gandhism and Feminism.</li>
        <li><span className=''style={{fontWeight:"bold"}} >9. Indian Political Thought : </span>Dharamshastra, Arthashastra and Buddhist Traditions; Sir Syed Ahmed Khan, Sri Aurobindo, M. K. Gandhi, B. R. Ambedkar, M. N. Roy.</li>
        <li><span className=''style={{fontWeight:"bold"}} >10. Western Political Thought : </span> Plato, Aristotle, Machiavelli, Hobbes, Locke, John S. Mill, Marx, Gramsci, Hannah Arendt.</li>
     </ul>

    <p className={`${styles.aboutheading2} `}>
       Indian Government and Politics :
    </p> 

    <p className={`${styles.aboutheading2} `}>  
      1. Indian Nationalism :
    </p> 

    <p className={`${styles.aboutheading} `}>
      (a) Political Strategies of India’s Freedom Struggle : Constitutionalism to mass Satyagraha, Noncooperation,
      Civil Disobedience; Militant and Revolutionary Movements, Peasant and Workers Movements.
    </p>

    <p className={`${styles.aboutheading} `}>
       (b) Perspectives on Indian National Movement; Liberal, Socialist and Marxist; Radical Humanist and Dalit.
    </p>

    <p className={`${styles.aboutheading} `}>
      2. Making of the Indian Constitution : Legacies of the British rule; different social and political
      perspectives.
    </p>

    <p className={`${styles.aboutheading} `}>
        3. Salient Features of the Indian Constitution : The Preamble, Fundamental Rights and Duties, Directive
        Principles; Parliamentary System and Amendment Procedures; Judicial Review and Basic Structure
        doctrine.
    </p>

    <p className={`${styles.aboutheading} `}>
        4. (a) Principal Organs of the Union Government : Envisaged role and actual working of the Executive,
        Legislature and Supreme Court.
    </p>

    <p className={`${styles.aboutheading} `}>
        (b) Principal Organs of the State Government : Envisaged role and actual working of the Executive,
        Legislature and High Courts.
    </p>

    <p className={`${styles.aboutheading} `}>
        5. Grassroots Democracy : Panchayati Raj and Municipal Government; Significance of 73rd and 74th
        Amendments; Grassroot movements.
    </p>

    <p className={`${styles.aboutheading} `}>
        6. Statutory Institutions/Commissions : Election Commission, Comptroller and Auditor General, Finance
        Commission, Union Public Service Commission, National Commission for Scheduled Castes, National
        Commission for Scheduled Tribes, National Commission for Women; National Human Rights Commission,
        National Commission for Minorities, National Backward Classes Commission.
    </p>

    <p className={`${styles.aboutheading} `}>
        7. Federalism : Constitutional provisions; changing nature of centre-state relations; integrationist
        tendencies and regional aspirations; inter-state disputes.
    </p>

    <p className={`${styles.aboutheading} `}>
        8. Planning and Economic development : Nehruvian and Gandhian perspectives; Role of planning and
        public sector; Green Revolution, land reforms and agrarian relations; liberalization and economic reforms.
    </p>

    <p className={`${styles.aboutheading} `}>
        9. Caste, Religion and Ethnicity in Indian Politics.
    </p>

    <p className={`${styles.aboutheading} `}>
        10. Party System : National and regional political parties, ideological and social bases of parties; Patterns
        of coalition politics; Pressure groups, trends in electoral behaviour; changing socio-economic profile of
        Legislators.
    </p>

    <p className={`${styles.aboutheading} `}>
        11. Social Movement : Civil liberties and human rights movements; women’s movements; environmentalist
        movements.    
    </p>    

 
 </div>
</div>

{/* Physics   II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
         PSIR   - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", 
            textAlign: "justify", 
            }}
      > 

        <p className={`${styles.aboutheading2} text-center`}>
            Comparative Politics and International Relations
        </p>

        <p className={`${styles.aboutheading2} text-center`}>
            Comparative Political Analysis and International Politics :
        </p>
      
        <p className={`${styles.aboutheading}`}>
            1. Comparative Politics : Nature and major approaches; Political economy and political sociology
            perspectives; Limitations of the comparative method.
        </p>
              
        <p className={`${styles.aboutheading} `}>  
            2. State in Comparative Perspective : Characteristics and changing nature of the State in capitalist and
            socialist economies, and advanced industrial and developing societies.
        </p>

        <p className={`${styles.aboutheading} `}> 
            3. Politics of Representation and Participation : Political parties, pressure groups and social movements
             in advanced industrial and developing societies.
        </p>

        <p className={`${styles.aboutheading} `}>
           4. Globalisation : Responses from developed and developing societies.
        </p>

        <p className={`${styles.aboutheading} `}>
           5. Approaches to the Study of International Relations : Idealist, Realist, Marxist, Functionalist and
            Systems theory.
        </p>

        <p className={`${styles.aboutheading} `}>
           6. Key Concepts in International Relations : National interest, security and power; Balance of power and
            deterrence; Transational actors and collective security; World capitalist economy and globalisation.
        </p>
 
        <p className={`${styles.aboutheading} `}>
            7. Changing International Political Order :
        </p>

         <ul className='list-unstyled'>
            <li>(a) Rise of super powers; Strategic and ideological Bipolarity, arms race and cold war; Nuclear threat;</li>
            <li>(b) Non-aligned Movement : Aims and achievements.</li>
            <li>(c) Collapse of the Soviet Union; Unipolarity and American hegemony; Relevance of non-alignment in the contemporary world.</li>
         </ul>

        <p className={`${styles.aboutheading} `}>
            8. Evolution of the International Economic System : From Brettonwoods to WTO; Socialist economies and
            the CMEA (Council for Mutual Economic Assistance); Third World demand for new international economic
            order; Globalisation of the world economy.
        </p>

        <p className={`${styles.aboutheading} `}>
            9. United Nations : Envisaged role and actual record; Specialized UN agencies—aims and functioning;
            need for UN reforms.
        </p>

        <p className={`${styles.aboutheading} `}>
            10. Regionalisation of World Politics : EU, ASEAN, APEC, AARC, NAFTA.
        </p>

        <p className={`${styles.aboutheading} `}>
            11. Contemporary Global Concerns : Democracy, human rights, environment, gender justice terrorism,
            nuclear proliferation.
        </p>

        <p className={`${styles.aboutheading2} `}> India and the World</p>

        <p  className={`${styles.aboutheading} `}>
            1. Indian Foreign Policy : Determinants of foreign policy; the institutions of policy-making; Continuity and
            change.
        </p>

        <p  className={`${styles.aboutheading} `}>
            2. India’s Contribution to the Non-Alignment Movement Different phases; Current role.
        </p>

        <p  className={`${styles.aboutheading2} `}>
            3. India and South Asia :
        </p>
         
          <ul className='list-unstyled'>
            <li>(a) Regional Co-operation : SAARC-past performance and future prospects.</li>
            <li>(b) South Asia as a Free Trade Area.</li>
            <li>(c) India’s “Look East” policy.</li>
            <li>(d) Impediments to regional co-operation : River water disputes; illegal cross border migration; Ethnic conflicts and insurgencies; Border disputes.</li>
          </ul>

        <p className={`${styles.aboutheading} `}>
            4. India and the Global South : Relations with Africa and Latin America; Leadership role in the demand
            for NIEO and WTO negotiations.
        </p> 

        <p className={`${styles.aboutheading} `}>
            5. India and the Global Centres of Power : USA, EU, Japan, China and Russia.
        </p>

        <p className={`${styles.aboutheading} `}>
            6. India and the UN System: Role in UN Peace-keeping; Demand for Permanent Seat in the Security Council.
        </p>

        <p className={`${styles.aboutheading} `}>
            7. India and the Nuclear Question : Changing perceptions and policy.
        </p>

        <p className={`${styles.aboutheading} `}>
            8. Recent developments in Indian Foreign Policy : India’s position on the recent crises in Afghanistan,
            Iraq and West Asia, growing relations with US and Isreal; Vision of a new world order.
        </p>

       

      </div>
    </div>
  </div>
</div>

{/* 8 LAW */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        8</span> LAW
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
          Law - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >

        <p className={`${styles.aboutheading2} `}>
          Constitutional and administrative Law  :
        </p>

        <p>1. Constitution and Constitutionalism:The distinctive features of the Constitution.</p>
        <p>2. Fundamental Rights—Public interest litigation; Legal Aid; Legal services authority.</p>
        <p>3. Relationship between Fundamental rights, Directive principles and Fundamental duties.</p>
        <p>4. Constitutional Position of the President and relation with the Council of Ministers.</p>
        <p>5. Governor and his powers.</p>
        <p>6. Supreme Court and the High Courts:</p>
        <ul>
            <li>Appointments and transfer.</li>
            <li>Powers, functions and jurisdiction.</li>
        </ul>
        <p>7. Centre, States and local bodies:</p>
        <ul>
            <li>Distribution of legislative powers between the Union and the States.</li>
            <li>Local Bodies.</li>
            <li>Administrative relationship among Union, State and Local Bodies.</li>
            <li>Eminent domain-State property-common property-community property.</li>
        </ul>
        <p>8. Legislative powers, privileges and immunities.</p>
        <p>9. Services under the Union and the States:</p>
        <ul>
            <li>Recruitment and conditions of services;Constitutional safeguards; Administrative tribunals.</li>
            <li>Union Public Service Commission and StatePublic Service Commissions—Power andfunctions.</li>
            <li>Election Commission—Power and functions.</li>
        </ul>
        <p>10. Emergency provisions.</p>
        <p>11. Amendment of the Constitution.</p>
        <p>12. Principle of Natural Justice—Emerging trends and judicial approach.</p>
        <p>13. Delegated legislation and its constitutionality.</p>
        <p>14. Separation of powers and constitutional governance.</p>
        <p>15. Judicial review of administrative action.</p>
        <p>16. Ombudsman: Lokayukta, Lokpal etc.</p>

        <p className={`${styles.aboutheading2} `}>
            International Law : 
        </p>

        <p>1. Nature and Definition of International Law.</p>
        <p>2. Relationship between International Law and Municipal Law.</p>
        <p>3. State Recognition and State Succession.</p>
        <p>4. Law of the sea : Inland Waters,Territorial Sea, Contiguous Zone, Continental Shelf, Exclusive
              Economic Zone and High Seas.</p>
        <p>5. Individuals: Nationality, statelessness; Human Rights and procedures available for their
              enforcement.</p>
        <p>6. Territorial jurisdiction of States, Extradition and Asylum.</p>
        <p>7. Treaties : Formation, application, termination and reservation.</p>
        <p>8. United Nations : Its principal organs, powers and functions and reform.</p>
        <p>9. Peaceful settlement of disputes—different modes.</p>
        <p>10. Lawful recourse to force : aggressions, self-defence, intervention.</p>
        <p>11. Fundamental principles of international humanitarian law—International conventions and
              contemporary developments.</p>
        <p>12.Legality of the use of nuclear weapons; ban on testing of nuclear weapons; Nuclear non- proliferation
                treaty, CTST.</p>
        <p>13. International Terrorism, State sponsored terrorism, Hijacking, International Criminal Court.</p>        
        <p>14. New International Economic Order and Monetary Law : WTO, TRIPS, GATT, IMF, World Bank.</p>
        <p>15. Protection and Improvement of the Human Environment : International Efforts.</p>
              
      </div>
    </div>

{/*  Law II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Law - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      >

        <p className={`${styles.aboutheading2} `}>
            Law of Crimes :—
        </p>
        <p>1. General principles of Criminal liability : mens rea and actus reus, mens rea in statutory offences.</p>
        <p>2. Kinds of punishment and emerging trends as to abolition of capital punishment.</p>
        <p>3. Preparations and criminal attempt.</p>
        <p>4. General exceptions.</p>
        <p>5. Joint and constructive liability.</p>
        <p>6. Abetment.</p>
        <p>7. Criminal conspiracy.</p>
        <p>8. Offences against the State.</p>
        <p>9. Offences against public tranquility.</p>
        <p>10. Offences against human body.</p>
        <p>11. Offences against property.</p>
        <p>12. Offences against women.</p>
        <p>13. Defamation.</p>
        <p>14. Prevention of Corruption Act, 1988.</p>
        <p>15. Protection of Civil Rights Act, 1955 and subsequent legislative developments.</p>
        <p>16. Plea bargaining.</p>  

        <p className={`${styles.aboutheading2} `}>Law of Torts</p>

        <p>1. Nature and definition.</p>
        <p>2. Liability based upon fault and strict liability; Absolute liability.</p>
        <p>3. Vicarious liability including State Liability.</p>
        <p>4. General defences.</p>
        <p>5. Joint tort fessors.</p>
        <p>6. Remedies.</p>
        <p>7. Negligence.</p>
        <p>8. Defamation.</p>
        <p>9. Nuisance.</p>
        <p>10. Conspiracy.</p>
        <p>11. False imprisonment.</p>
        <p>12. Malicious prosecution.</p>
        <p>13. Consumer Protection Act, 1986.</p>

        <p className={`${styles.aboutheading2} `}>Law of Contracts and Mercantile Law</p>

        <p>Nature and formation of contract/E-contract.</p>
        <p>Factors vitiating free consent</p>
        <p>Void, voidable, illegal and unenforceable agreements.</p>
        <p>Performance and discharge of contracts.</p>
        <p>Quasi-contracts.</p>
        <p>Consequences of breach of contract.</p>
        <p>Contract of indemnity, guarantee and insurance.</p>
        <p>Contract of agency.</p>
        <p>Formation and dissolution of partnership.</p>
        <p>Negotiable Instruments Act, 1881.</p>
        <p>Arbitration and Conciliation Act, 1996.</p>
        <p>Standard form contracts.</p>

        <p className={`${styles.aboutheading2} `}>Contemporary Legal Developments</p>

        <p>Public Interest Litigation</p>
        <p>Intellectual property rights—Concept, types/prospects.</p>
        <p>Information Technology Law including Cyber Laws—Concept, purpose/prospects.</p>
        <p>Competition Law—Concept, purpose/prospects.</p>
        <p>Alternate Dispute Resolution—Concept, types/prospects.</p>
        <p>Major statutes concerning environmental law.</p>
        <p>Right to Information Act.</p>
        <p>Trial by media.</p>

    </div>
    </div>

  </div>
</div>

{/* 9. MATHEMATICS  */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        9</span> MATHEMATICS 
    </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Mathematics - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
       
    
    <p className={`${styles.aboutheading2} `}> (1) Linear Algebra :</p>

    <p className={`${styles.aboutheading} `}>
        Vector spaces over R and C, linear dependence and independence, subspaces, bases, dimensions, Linear
        transformations, rank and nullity, matrix of a linear transformation.
    </p>  
 
    <p className={`${styles.aboutheading} `}>  
        Algebra of Matrices; Row and column reduction, Echelon form, congruence’s and similarity; Rankof a
        matrix; Inverse of a matrix; Solution of system of linear equations; Eigenvalues and eigenvectors,
        characteristic polynomial, Cayley-Hamilton theorem, Symmetric, skew-symmetric, Hermitian, skew-
        Hermitian, orthogonal and unitary matrices and their eigenvalues.
    </p>

   <p className={`${styles.aboutheading2} `}> (2) Calculus :</p>

   <p className={`${styles.aboutheading} `}>
        Real numbers, functions of a real variable, limits, continuity, differentiability, mean-value theorem, Taylor’s
        theorem with remainders, indeterminate forms, maxima and minima, asymptotes; Curve tracing; Functions
        of two or three variables; Limits, continuity, partial derivatives, maxima and minima, Lagrange’s method of
        multipliers, Jacobian.
   </p>

   <p className={`${styles.aboutheading} `}>
        Riemann’s definition of definite integrals; Indefinite integrals; Infinite and improper integral; Double and
        triple integrals (evaluation techniques only); Areas, surface and volumes.
   </p>

    <p className={`${styles.aboutheading2} `}> (3) Analytic Geometry :</p>

    <p className={`${styles.aboutheading} `}> 
        Cartesian and polar coordinates in three dimensions, second degree equations in three variables, reduction
        to Canonical forms; straight lines, shortest distance between two skew lines, Plane, sphere, cone, cylinder,
        paraboloid, ellipsoid, hyperboloid of one and two sheets and their properties.
    </p>
 
  <p className={`${styles.aboutheading2}`}>(4) Ordinary Differential Equations :</p>

    <p className={`${styles.aboutheading} `}>
        Formulation of differential equations; Equations of first order and first degree, integrating factor; Orthogonal
        trajectory; Equations of first order but not of first degree, Clairaut’s equation, singular solution.
        Second and higher order liner equations with constant coefficients, complementary function, particular
        integral and general solution.
    </p>

    <p className={`${styles.aboutheading} `}>
        Section order linear equations with variable coefficients, Euler-Cauchy equation; Determination of complete
        solution when one solution is known using method of variation of parameters.
        Laplace and Inverse Laplace transforms and their properties, Laplace transforms of elementary functions.
        Application to initial value problems for 2nd order linear equations with constant coefficients.
    </p>

    <p className={`${styles.aboutheading2}`}>(5) Dynamics and Statics : </p>
       
    <p className={`${styles.aboutheading}`}> 
        Rectilinear motion, simple harmonic motion, motion in a plane, projectiles; Constrained motion; Work and
        energy, conservation of energy; Kepler’s laws, orbits under central forces.
        Equilibrium of a system of particles; Work and potential energy, friction, Common catenary; Principle of
        virtual work; Stability of equilibrium, equilibrium of forces in three dimensions.
    </p>

    <p className={`${styles.aboutheading2}`}> (6) Vector Analysis :</p>

    <p className={`${styles.aboutheading}`}> 
        Scalar and vector fields, differentiation of vector field of a scalar variable; Gradient, divergence and curl in
        cartesian and cylindrical coordinates; Higher order derivatives; Vector identities and vector equation.
        Application to geometry : Curves in space, curvature and torsion; Serret-Furenet's formulae.
        Gauss and Stokes’ theorems, Green's indentities.
    </p>  

 </div>
</div>

{/* Mathematics  II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
       Mathematics  - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", 
            textAlign: "justify", 
            }}
      > 
      
        <p className={`${styles.aboutheading2}`}>(1) Algebra : </p>
              
        <p className={`${styles.aboutheading} `}>  
            Groups, subgroups, cyclic groups, cosets, Lagrange’s Theorem, normal subgroups, quotient groups,
            homomorphism of groups, basic isomorphism theorems, permutation groups, Cayley’s theorem.
            Rings, subrings and ideals, homomorphisms of rings; Integral domains, principal ideal domains, Euclidean
            domains and unique factorization domains; Fields, quotient fields.
        </p>
        
        <p className={`${styles.aboutheading2} `}> (2) Real Analysis :</p>

        <p className={`${styles.aboutheading} `}>
            Real number system as an ordered field with least upper bound property; Sequences, limit of a sequence,
            Cauchy sequence, completeness of real line; Series and its convergence, absolute and conditional
            convergence of series of real and complex terms, rearrangement of series. Continuity and uniform continuity
            of functions, properties of continuous functions on compact sets.
        </p>

        <p className={`${styles.aboutheading} `}>
            Riemann integral, improper integrals; Fundamental theorems of integral calculus.
            Uniform convergence, continuity, differentiability and integrability for sequences and series of functions;
            Partial derivatives of functions of several (two or three) variables, maxima and minima.
        </p>

        <p className={`${styles.aboutheading2} `}>(3) Complex Analysis :</p>

        <p className={`${styles.aboutheading}`}>
            Analytic function, Cauchy-Riemann equations, Cauchy's theorem, Cauchy's integral formula, power series,
            representation of an analytic function, Taylor’s series; Singularities; Laurent’s series; Cauchy’s residue
            theorem; Contour integration.
        </p>

        <p className={`${styles.aboutheading2} `}>(4) Linear Programming :</p>
            
        <p className={`${styles.aboutheading} `}>
           Linear programming problems, basic solution, basic feasible solution and optimal solution; Graphical
           method and simplex method of solutions; Duality.
           Transportation and assignment problems.
        </p>

          
        <p className={`${styles.aboutheading2} `}>(5) Partial Differential Equations :</p>

        <p className={`${styles.aboutheading} `}>
            Family of surfaces in three dimensions and formulation of partial differential equations; Solution of
            quasilinear partial differential equations of the first order, Cauchy’s method of characteristics; Linear partial
            differential equations of the second order with constant coefficients, canonical form; Equation of a vibrating
            string, heatequation, Laplace equation and their solutions.
            
        </p> 

        <p className={`${styles.aboutheading2} `}> (6) Numerical Analysis and Computer Programming :</p> 

        <p className={`${styles.aboutheading} `}>
            Numerical methods: Solution of algebraic and transcendental equations of one variable by bisection,
            Regula-Falsi and Newton-Raphson methods, solution of system of linear equations by Gaussian Elimination
            and Gauss-Jorden (direct), Gauss-Seidel (iterative) methods. Newton’s (forward and backward) and
            interpolation, Lagrange’s interpolation.
        </p>

        <p className={`${styles.aboutheading} `}>
            Numerical integration: Trapezoidal rule, Simpson’s rule, Gaussian quadrature formula.
            Numerical solution of ordinary differential equations : Eular and Runga Kutta methods.
            Computer Programming : Binary system; Arithmetic and logical operations on numbers; Octal and
            Hexadecimal Systems; Conversion to and from decimal Systems; Algebra of binary numbers.
            Elements of computer systems and concept of memory; Basic logic gates and truth tables, Boolean algebra,
            normal forms.
        </p>

        <p className={`${styles.aboutheading} `}>
            Representation of unsigned integers, signed integers and reals, double precision reals and long integers.
            Algorithms and flow charts for solving numerical analysis problems.
        </p>

        <p className={`${styles.aboutheading2} `}>(7) Mechanics and Fluid Dynamics :</p>

        <p className={`${styles.aboutheading} `}>
            Generalised coordinates; D’Alembert’s principle and Lagrange’s equations; Hamilton equations; Moment of
            inertia; Motion of rigid bodies in two dimensions.
            Equation of continuity; Euler’s equation of motion for inviscid flow; Stream-lines, path of a particle; Potential
            flow; Two-dimensional and axisymmetric motion; Sources and sinks, vortex motion; Navier-Stokes equation
            for a viscous fluid.
        </p>

            
        </div>
    </div>
  </div>
</div>

{/* 10 ECONOMICS */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        10</span> ECONOMICS
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Economics - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >

        <p className={`${styles.aboutheading2}`}>
           Advanced Micro Economics :
        </p>
    
         <ul>
            <li>Marshallian and Walrasian Approaches to Price determination.</li>
            <li>Alternative Distribution Theories : Ricardo, Kaldor, Kalecki.</li>
            <li>Markets Structure : Monopolistic Competition, Duopoly, Oligopoly.</li>
            <li>Modern Welfare Criteria : Pareto Hicks and Scitovsky, Arrow’s Impossibility Theorem, A. K. Sen’s Social Welfare Function.</li>
        </ul>

        <p className={`${styles.aboutheading2} pt-2`}>
           Advance Macro Economics :
        </p>

        <p className={`${styles.aboutoption}`}>
            Approaches to Employment Income and Interest Rate determination : Classical, Keynes (IS-LM)
            curve, Neo-classical synthesis and New classical, Theories of Interest Rate determination and
            Interest Rate Structure.       
        </p>

        <p className={`${styles.aboutheading2} pt-2`}>Money-Banking and Finance :</p>

        <p className={`${styles.aboutoption}`}>Demand for and Supply of Money : Money Multiplier Quantity Theory of Money (Fisher, Pigou and
            Friedman) and Keynes’ Theory on Demand for Money, Goals and Instruments of Monetary
            Management in Closed and Open Economies. Relation between the Central Bank and the Treasury.
            Proposal for ceiling on growth rate of money.
        </p>

         <p className={`${styles.aboutoption}`}>
            Public Finance and its Role in market economy : in stabilization of supply, allocation of resources
            and in distribution and development. Sources of Government revenue, forms of Taxes and Subsidies,
            their incidence and effects. Limits to taxation, loans, crowding-out effects and limits to borrowings.
            Public expenditure and its effects.
        </p>

        <p className={`${styles.aboutheading2} pt-2`}>International Economics :</p>
        <p> a). Old and New theories of International Trade.</p>
        <ul>
            <li>Comparative advantage,</li>
            <li>Terms of Trade and offer curve.</li>
            <li>Product cycle and Strategic trade theories.</li>
            <li>Trade as an engine of growth and theories of underdevelopment in an open economy.</li>
        </ul>
        <p> b). Forms of protection : Tariff and quota.</p>
        <p> c). Balance of Payments Adjustments : Alternative Approaches.</p>
        <ul>
            <li>Price versus income, income adjustments under fixed exchange rates.</li>
            <li>Theories of Policy mix.</li>
            <li>Exchange rate adjustments under capital mobility.</li>
            <li>Floating Rates and their implications for developing Countries: Currency Boards.</li>
            <li>Trade Policy and Developing Countries.</li>
            <li>BOP, adjustments and Policy Coordination in open economy macro-model.</li>
            <li>Speculative attacks.</li>
            <li>Trade Blocks and Monetary Unions.</li>
            <li>WTO : Trims, TRIPS, Domestic Measures, Different Rounds of WTO talks.</li>
        </ul>
        <p className={`${styles.aboutheading2} pt-2`}>Growth and Development:</p>
        <ul>
            <li>Theories of growth : Harrod’s model;</li>
            <li>Lewis model of development with surplus labour.</li>
            <li>Balanced Unbalanced Growth.</li>
            <li>Human capitals and Economic Growth.</li>
            <li>Research and Development and Economic Growth.</li>
        </ul>
        <p> Process of Economic Development of less developed countries: Myrdal and Kuznets on economic
            development and structural change: Role of Agriculture in Economic Development of less developed
            countries.
        </p>
        <p>Economic Development and International Trade and Investment, Role of Multinationals. Partnership.</p>
      
        <p>Planning and economic Development: changing role of Markets and Planning, Private-Public</p>

        <p> Welfare indicators and measures of growth—Human development indices. The basic needs approach.</p>
    
        <p>
            Development and Environmental Sustainability—Renewable and Non Renewable Resources,
            Environmental Degradation, Intergenerational equity development.
        </p>
                
      </div>
    </div>

{/* Economics II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
     Economics - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      >
        <p className={`${styles.aboutheading2} `}>
            Indian Economy in Pre-Independence Era :
        </p>


        <p className={`${styles.aboutoption}`}>
            Land System and its changes, Commercialization of agriculture Drain theory, Laissez faire theory
            and critique. Manufacture and Transport: Jute, Cotton, Railways, Money and Credit.
        </p>

       <p className={`${styles.aboutheading2}`}>Indian Economy after Independence :</p>
       
       <p className={`${styles.aboutheading2}`}>The Pre-Liberalization Era :</p>
       <ul>
        <li>Contribution of Vakil, Gadgil and V.K.R.V. Rao. </li>
        <li>Agriculture: Land Reforms and land tenure system, Green Revolution and capital formation in agriculture.</li>
        <li>Industry Trends in composition and growth, Role of public and private sector, Small scale and
            cottage industries.</li>
        <li>National and Per capita income : patterns, trends, aggregate and Sectoral composition and
            changes therein.</li>
        <li>Broad factors determining National Income and distribution, Measures of poverty, Trends in
            poverty and inequality.</li>    
       </ul>

       <p className={`${styles.aboutheading2}`}>The Post Liberalization Era :</p>

       <p className={`${styles.aboutoption}`}>(i) New Economic Reform and Agriculture: Agriculture and WTO, Food processing, subsidies,
          Agricultural prices and public distribution system, Impact of public expenditure on agricultural
          growth.
      </p>

      <p className={`${styles.aboutoption}`}>(ii) New Economic Policy and Industry: Strategy of industrialization, Privatization, Disinvestments,
        Role of foreign direct investment and multinationals.
      </p>

      <p className={`${styles.aboutoption}`}>(iii) New Economic Policy and Trade: Intellectual property rights : Implications of TRIPS, TRIMS,
            GATS and new EXIM policy.</p>

      <p className={`${styles.aboutoption}`}>(iv) New Exchange Rate Regime: Partial and full convertibility, Capital account convertibility.</p>
      
      
      <p className={`${styles.aboutoption}`}>(v) New Economic Policy and Public Finance : Fiscal Responsibility Act, Twelfth Finance Commission
         and Fiscal Federalism and Fiscal Consolidation.
     </p>

     <p className={`${styles.aboutoption}`}>(vi) New Economic Policy and Monetary system. Role of RBI under the new regime.</p>

      <p className={`${styles.aboutoption}`}>(vii)  Planning: From central Planning to indicative planning, Relation between planning and markets
        for growth and decentralized planning: 73rd and 74th Constitutional amendments.
     </p>

      <p className={`${styles.aboutoption}`}>(viii) New Economic Policy and Employment: Employment and poverty, Rural wages, Employment
         Generation, Poverty alleviation schemes, New Rural, Employment Guarantee Scheme.
      </p>

      </div>
    </div>

  </div>
</div>


{/* 11. PSYCHOLOGY  */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        11 </span> PSYCHOLOGY
    </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
       Psychology - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
    
    <p className={`${styles.aboutheading2} `}>Foundations of Psychology</p>

     
    <p className={`${styles.aboutheading2} `}>
       Introduction :
    </p> 

    <p className={`${styles.aboutheading} `}>
        Definition of Psychology; Historical antecedents of Psychology and trends in the 21st
        centrury; Psychology and scientific methods; Psychology in relation to other social sciences and natural
        sciences; Application of Psychology to societal problems.
    </p>

    <p className={`${styles.aboutheading2} `}>  
       2. Methods of Psychology :
    </p> 

    <p className={`${styles.aboutheading} `}>
        Types of research : Descriptive, evaluative, diagnostic and prognostic;Methods of Research : Survey, observation, case-study and experiments; Characteristics of experimental
        design and non-experimental designs; quasi-experimental designs; Focussed group discussions, brain
        storming, grounded theory approach.
    </p>

    <p className={`${styles.aboutheading2} `}>
      3. Research methods :
    </p>

    <p className={`${styles.aboutheading} `}>
        Major steps in psychological research (problem statement, hypothesis
        formulation, research design, sampling, tools of data collection, analysis and interpretation and report
        writing); Fundamental versus applied research; Methods of data collection (interview, observation,
        questionnaire and case study). Research Designs (Ex-post facto and experimental). Application of statistical
        techniques (t-test, two-way ANOVA, correlation and regression and factor analysis) item response theory.
    </p>

    <p className={`${styles.aboutheading2} `}>
       4. Development of Human Behaviour :
    </p>

    <p className={`${styles.aboutheading} `}>
        Growth and development; Principles of development, Role of
        genetic and environmental factors in determining human behaviour; Influence of cultural factors in
        socialization; Life span development—Characteristics, development tasks, promoting psychological wellbeing
        across major stages of the life span.
    </p>

    <p className={`${styles.aboutheading2} `}>
        5. Sensation, Attention and Perception :
    </p>

    <p className={`${styles.aboutheading} `}>
        Sensation: concepts of threshold, absolute and difference
        thresholds, signal-detection and vigilance; Factors influencing attention including set and characteristics of
        stimulus; Definition and concept of perception, biological factors in perception; Perceptual organizationinfluence
        of past experiences, perceptual defence-factor influencing space and depth perception, size
        estimation and perceptual readiness; The plasticity of perception; Extrasensory perception; Culture and
        perception, Subliminal perception
    </p>

    <p className={`${styles.aboutheading2} `}>
       6. Learning :
    </p>

    <p className={`${styles.aboutheading} `}>
        Concepts and theories of learning (Behaviourists, Gestaltalist and Information processing
        models). The processes of extinction, discrimination and generalisation. Programmed learning, probability
        learning, self instructional learning, concepts, types and the schedules of reinforcement, escape, avoidance
        and punishment, modelling and social learning.
    </p>

    <p className={`${styles.aboutheading2} `}>
        7. Memory :
    </p>

    <p className={`${styles.aboutheading} `}>
        Encoding and remembering; Shot-term memory, Long-term memory, Sensory memory, Iconic
        memory, Echoic memory: The Multistore model, levels of processing; Organization and Mnemonic
        techniques to improve memory; Theories of forgetting: decay, interference and retrieval failure: Metamemory;
        Amnesia: Anterograde and retrograde.
    </p>

    <p className={`${styles.aboutheading2} `}>
        8. Thinking and Problem Solving :
    </p>

    <p className={`${styles.aboutheading} `}>
        Piaget’s theory of cognitive development; Concept formation processes;
        Information processing, Reasoning and problem solving, Facilitating and hindering factors in problem
        solving, Methods of problem solving: Creative thinking and fostering creativity; Factors influencing decision
        making and judgement; Recent trends.
    </p> 

    <p className={`${styles.aboutheading2} `}>
        9. Motivation and Emotion :
    </p>   

    <p className={`${styles.aboutheading} `}>
        Psychological and physiological basis of motivation and emotion;
        Measurement of motivation and emotion; Effects of motivation and emotion on behaviour; Extrinsic and
        intrinsic motivation; Factors influencing intrinsic motivation; Emotional competence and the related issues.
    </p>

    <p className={`${styles.aboutheading2} `}>
        10. Intelligence and Aptitude :
    </p>

    <p className={`${styles.aboutheading} `}>
        Concept of intelligence and aptitude, Nature and theories of intelligence-
        Spearman, Thurstone, Gulford Vernon, Sternberg and J.P. Das; Emotional Intelligence, Social intelligence,
        measurement of intelligence and aptitudes, concept of I Q deviation I Q, constancy of I Q; Measurement of
        multiple intelligence; Fluid intelligence and crystallized intelligence.
    </p>

    <p className={`${styles.aboutheading2} `}>
       11. Personality
    </p>

     <p className={`${styles.aboutheading} `}>
        Definition and concept of personality; Theories of personality (psychoanalytical, sociocultural,
        interpersonal, developmental, humanistic, behaviouristic, trait and type approaches);
        Measurement of personality (projective tests, pencil-paper test); The Indian approach to personality;
        Training for personality development; Latest approaches like big 5 factor theory; The notion of self in
        different traditions.
    </p>

    <p className={`${styles.aboutheading2} `}>
        12. Attitudes, Values and Interests :
    </p>

    <p className={`${styles.aboutheading} `}>
        Definitions of attitudes, values and interests; Components of attitudes; Formation and maintenance of attitudes. Measurement of attitudes, values and interests.
        Theories of attitude changes, strategies for fostering values. Formation of stereotypes and prejudices;
        Changing other’s behaviour, Theories of attribution; Recent trends.
    </p>

    <p className={`${styles.aboutheading2} `}>
       13. Language and Communication :
    </p>

    <p className={`${styles.aboutheading} `}>
        Human language—Properties, structure and linguistic hierarchy,
        Language acquisition—predispotion, critical period hypothesis; Theories of Language development—Skinner
        and Chomsky; Process and types of communication—effective commu-nication training.
    </p>

    <p className={`${styles.aboutheading2} `}>
        14. Issues and Perspectives in Modern Contemporary Psychology :
    </p>

    <p className={`${styles.aboutheading} `}>
        Computer application in the
        psychological laboratory and psychological testing; Artificial intelligence; Psychocybernetics; Study of
        consciousnessleep-wak schedules; dreams, stimulus deprivation, meditation, hypnotic/drug induced
        states; Extrasensory perception; Intersensory perception; Simulation studies.
    </p>
 
 </div>
</div>

{/* Physics   II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
         Psychology   - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", 
            textAlign: "justify", 
            }}
      > 

        <p className={`${styles.aboutheading2} text-center`}>
            Psychology : Issues and applications
        </p>
     
        <p className={`${styles.aboutheading2}`}>
            1. Psychological Measurement of Individual Differences :
        </p>
              
        <p className={`${styles.aboutheading} `}>  
            The nature of individual differences. Characteristics and construction of standardized psychological tests.
            Types of psychological tests. Use, misuse and limitation of psychological tests. Ethical issues in the use of
            psychological tests.
        </p>

        <p className={`${styles.aboutheading2} `}> 
           2. Psychological well being and Mental Disorders :
        </p>

        <p className={`${styles.aboutheading} `}>
            Concept of health-ill health positive health, well being casual factores in Mental disorders (Anxiety disorders,
            mood disorders; schizophrenia and delusional disorders; personality disorders, substance abuse disorders).
            Factors influencing positive health, well being; lifestyle and quality of life; Happiness disposition.
        </p>

        <p className={`${styles.aboutheading2} `}>
           3. Therapeutic Approaches :
        </p>

        <p className={`${styles.aboutheading} `}>
            Psychodynamic therapies. Behaviour therapies. Client centered therapy. Cognitive therapies. Indigenous
            therapies (Yoga, Meditation). Biofeedback therapy. Prevention and rehabilitation of the mentally ill;
            Fostering mental health.
        </p>
 
        <p className={`${styles.aboutheading2} `}>
          4. Work Psychology and Organisational Behaviour :
        </p>

        <p className={`${styles.aboutheading} `}>
            Personnel selection and training. Use of Psychological tests in the industry. Training and human resource
            development. Theories of work motivation. Herzberg, Maslow, Adam Equity theory, Porter and Lawler,
            Vroom; Leadership and participatory management; Advertising and marketing; Stress and its management;
            Ergonomics; consumer psychology; Managerial effectiveness; Transformational leadersip; Senitivity
            training; Power and politics in organizations.
        </p>

        <p className={`${styles.aboutheading2} `}>
          5. Application of Psychology to Educational Field :
        </p>

        <p className={`${styles.aboutheading} `}>
            Psychological principles underlying effective teaching-learning process. Learning styles. Gifted, retarded,
            learning disabled and their training. Training for improving memory and better academic achievement.
            Personality development and value education. Educational, vocational guidance and Career counselling.
            Use of Psychological tests in educational institutions; Effective strategies in guidance programmes.
        </p>

        <p className={`${styles.aboutheading2} `}>
           6. Community Psychology :
        </p>

        <p className={`${styles.aboutheading} `}>
            Definition and concept of Community Psychology. Use of small groups in social action. Arousing Community
            consciousness and action for handling social problems. Group decision making and leadership for social
            change. Effective strategies for social change.
        </p>

        <p  className={`${styles.aboutheading2} `}>
            7. Rehabilitation Psychology :
        </p>

        <p  className={`${styles.aboutheading} `}>
            Primary, secondary and tertiary prevention programmes—role of psychologists. Organising of services for
            rehabilitation of physically, mentally and socially challenged persons including old persons. Rehabilitation
            of persons suffering from substance abuse, juvenile delinquency, criminal behaviours. Rehabilitation of
            victims of violence. Rehabilitation of HIV/AIDS victims, the role of social agencies.
        </p>

        <p  className={`${styles.aboutheading2} `}>
            8. Application of Psychology to disadvantaged groups :
        </p>
         
        <p className={`${styles.aboutheading} `}>
            The concepts of disadvantaged, deprivation social, physical, cultural and economic consequences of
            disadvantaged and deprived groups. Educating and motivating the disadvantaged towards development;
            Relative and prolonged deprivation.
        </p> 

        <p className={`${styles.aboutheading2} `}>
            9. Psychological problem of social integration :
        </p>

        <p className={`${styles.aboutheading} `}>
            The concept of social integration. The problem of caste, class, religion and language conflicts and prejudice.
            Nature and manifestation of prejudice between the ingroup and outgroup. Casual factors of such conflicts
            and prejudices. Psychological strategies for handling the conflicts and prejudices. Measures to achieve social
            integration.
        </p>

        <p className={`${styles.aboutheading2} `}>
           10. Application of Psychology in Information Technology and Mass Media :
        </p>

        <p className={`${styles.aboutheading} `}>
            The present scenario of information technology and the mass media boom and the role of psychologists.
            Selection and training of Psychology professionals to work in the field of IT and mass media. Distance
            learning through IT and mass media. Entrepreneurship through e-commerce. Multilevel marketing. Impact
            of TV and fostering value through IT and mass media. Psychological consequences of recent developments
            in Information Technology.
        </p>

        <p className={`${styles.aboutheading2} `}>
             11. Psychology and Economic development :
        </p>

        <p className={`${styles.aboutheading} `}>
            Achievement motivation and economic development. Characteristics of entrepreneurial behaviour.
            Motivating and Training people for entrepreneurship and economic development; Consumer rights and
            consumer awareness, Government policies for promotion of entrepreneurship among youth including
            women entreprenures.
        </p>

        <p className={`${styles.aboutheading2} `}>
            12. Application of Psychology to environment and related fields :
        </p>

        <p className={`${styles.aboutheading} `}>
            Environmental Psychology effects of noise, pollution and crowding. Population Psychology : Psychological
            consequence of population explosion and high population density. Motivating for small family norms. Impact
            of rapid scientific and technological growth on degradation of environment.
        </p>

        <p className={`${styles.aboutheading2} `}>
            13. Application of psychology in other fields :
        </p>
          
          <ul className='list-unstyled'>
            <li className={`${styles.aboutheading2} `}>(a) Military Psychology</li>
            <li>
                Devising psycological tests for defence personnel for use in selection, Training, counseling; training
                psychologists to work , with defence personnel in promoting positive health; Human engineering in defence.
            </li>
            <li className={`${styles.aboutheading2} `}>(b) Sports Psychology</li>
            <li>
                Psychological interventions in improving performance of athletes and sports. Persons participating in
                Individual and Team Games.
            </li>
            <li className={`${styles.aboutheading2} `}>(c) Media influences on pro and anti-social behaviour.</li>
            <li className={`${styles.aboutheading2} `}>(d) Psychology of Terrorism.</li>
          </ul>

        <p className={`${styles.aboutheading2} `}>14. Psychology of Gender :  </p>

        <p className={`${styles.aboutheading} `}>
             Issues of discrimination, Management of diversity; Glass ceiling effect, Self-fulfilling prophesy, Women and
            Indian society.
        </p>

      </div>
    </div>
  </div>
</div>

{/* 12 GEOLOGY */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        12</span> GEOLOGY
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Geology - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >


        <p className={`${styles.aboutheading2} `}>
         General Geology :
        </p>

        <p className={`${styles.aboutoption}`}      >
            The Solar System, meteorites, origin and interior of the earth and age of earth; Volcanoes—causes
            and products, Volcanic belts. Earthquakes—causes, effects, seismic of zone of India; Island arcs, trenches and mid-ocean ridges; Continental drift; Seafloor spreading, plate tectonics. Isostasy.
        </p>

        <p className={`${styles.aboutheading2} `}>Geomorphology and Remote Sensing : </p>

        <p className={`${styles.aboutoption}`}>
            Basic concepts of geomorphology. Weathering and soil formations; Landforms, slopes and drainage.
            Geomorphic cycles and their interpretation. Morphology and its relation to structures and lithology; Coastal
            geomorphology; Applications of geomorphology in mineral prospecting, civil engineering; hydrology and
            environmental studies; Geomorphology of Indian sub-continent.   
        </p>

        <p className={`${styles.aboutoption}`}>
            Aerial photographs and their interpretation—merits and limitations; The Electromagnetic spectrum.
            Orbiting Satellites and Sensor Systems. Indian Remote Sensing Satellites. Satellite data products;
            Applications of remote sensing in geology; The Geographic Information System (GIS) and Global Positioning
            System (GPS)—its applications.
        </p>

        <p className={`${styles.aboutheading2} pt-2`}>Structural Geology :</p>

        <p className={`${styles.aboutoption}`}>
            Principles of geologic mapping and map reading, projection diagrams, Stress and strain ellipsoid and
            stress-strain relationships of elastic, plastic and viscous materials; Strain markers in deformed rocks.
            Behaviour of minerals and rocks under deformation conditions. Folds and faults classification and
            mechanics; Structural analysis of folds, foliations, lineations, joints and faults, unconformities; Timerelationship
            between crystallization and deformation.
        </p>

       <p className={`${styles.aboutheading2} pt-2`}>Paleontology : </p> 

         <p className={`${styles.aboutoption}`}>
            Species—definition and nomenclature; Megafossils and Microfossils. Modes of preservation of fossils;
            Different kinds of microfossils; Application of microfossils in correlation, petroleum exploration,
            paleoclimatic and paleoceanographic studies; Evolutionary trend in Hominidae, Equidae and Proboscidae.
            Siwalik fauna.<br/>
            Gondwana flora and fauna and its importance; Index fossils and their significance.
        </p>

        <p className={`${styles.aboutheading2} pt-2`}>Indian Stratigraphy :</p>

        <p className={`${styles.aboutoption}`}>
            Classification of stratigraphic sequences: lithostrati-graphic, biostratigraphic, chrono-stratigraphic
            and magnetostratigraphic and their interrelationships; Distribution and classification of Precambrian rocks
            of India; Study of stratigraphic distribution and lithology of Phanerozoic rocks of India with reference to
            fauna, flora and economic importance. Major boundary problems—Cambrian/ Precambrian,
            Permian/Triassic, Cretaceous/Tertiary and Pliocene/Pleistocene; Study of climatic conditions,
            paleogeography and igneous activity in the Indian sub-continent in the geological past. Tectonic framework
            of India. Evolution of the Himalayas.
        </p>

        <p className={`${styles.aboutheading2} `}>
          Hydrogeology and Engineering Geology :
        </p>
        
        <p className={`${styles.aboutoption}`}>
            Hydrologic cycle and genetic classification of water; Movement of subsurface water; Springs;
            Porosity, permeability, hydraulic conductivity, transmissivity and storage coefficient, classification of
            aquifers; Water-bearing characteristics of rocks; Groundwater chemistry. Salt water intrusion. Types of
            wells. Drainage basin morphometry; Exploration for groundwater; Groundwater recharge; Problems and
            management of groundwater; Rainwater harvesting; Engineering properties of rocks; Geological
            investigations for dams, tunnels highways, railway and bridges; Rock as construction material; Landslides
            causes, prevention and rehabilitation; Earthquake-resistant structures.
        </p>

        
                        
      </div>
    </div>

{/*  Geology II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
     Geology - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      >
        

        <p className={`${styles.aboutheading2} `}>
            Mineralogy :
        </p>
       <p className={`${styles.aboutoption}`}>
            Classification of crystals into systems and classes of symmetry; International system of
            crystallographic notation; Use of projection diagrams to represent crystal symmetry; Elements of X-ray crystallography.
        </p> 

        <p className={`${styles.aboutoption}`}>
            Physical and chemical characters of rock forming silicate mineral groups; Structural classification
            of silicates; Common minerals of igneous and metamorphic rocks; Minerals of the carbonate, phosphate,
            sulphide and halide groups; Clay minerals.
        </p>

        <p className={`${styles.aboutoption}`}>
            Optical properties of common rock forming minerals; Pleochroism, extinction angle, double
            refraction, birefringence, twinning and dispersion in minerals.
        </p>

        <p className={`${styles.aboutheading2} `}>
            Igneous and Metamorphic Petrology :
        </p>

        <p className={`${styles.aboutoption}`}>
            Generation and crystallisation of magmas. Crystallisation of albite—anorthite, diopside—anorthite
            and diopside—wollastonite—silica systems. Bowen's Reaction Principle; Magmatic differentiation and
            assimilation. Petrogenetic significance of the textures and structures of igneous rocks. Petrography and
            petrogenesis of granite, syenite, diorite, basic and ultrabasic groups, charnockite, anorthosite and alkaline
            rocks. Carbonatites. Deccan volcanic province.
        </p>

       <p className={`${styles.aboutoption}`}> 
            Types and agents of metamorphism. Metamorphic grades and zones; Phase rule. Facies of regional
            and contact metamorphism; ACF and AKF diagrams; Textures and structures of metamorphic rocks.
            Metamorphism of arenaceous, argillaceous and basic rocks; Minerals assemblages. Retrograde
            metamorphism; Metasomatism and granitisation, migmatites. Granulite terrains of India.
        </p>

        <p className={`${styles.aboutheading2}`}>Sedimenary Petrology :</p>

        <p className={`${styles.aboutoption}`}>
            Sedimentas and Sedimentary rocks: Processes of formation; digenesis and lithification; Clastic and
            non-clastic rocks-their classification, petrography and depositional environment; Sedimentary facies and
            provenance. Sedimentary structures and their significance. Heavy minerals and their significance.
            Sedimentary basins of India.
        </p>

        <p className={`${styles.aboutheading2}`}>Economic Geology :</p>

        <p className={`${styles.aboutoption}`}>
            Ore, ore mineral and gangue, tenor of ore. Classification of ore deposits; Processes of formation of
            mineral deposits; Controls of ore localisation; Ore texures and structures; Metallogenic epochs and
            provinces; Geology of the important Indian deposits of aluminium, chromium, copper, gold, iron, lead, zinc,
            manganese, titanium, uranium and thorium and industrial minerals; Deposits of coal and petroleum in
            India, National Mineral Policy; Conservation and utilization of mineral resources. Marine mineral resources
            and Law of Sea.
        </p>

        <p className={`${styles.aboutheading2}`}> Mining Geology : </p>

        <p className={`${styles.aboutoption}`}>
            Methods of prospecting—geological, geophysical, geochemical and geobotanical; Techniques of
            sampling. Estimation of reserves of ore; Methods of exploration and mining-metallic ores, industrial
            minerals, marine mineral resources and building stones. Mineral beneficiation and ore dressing.
        </p>

        <p className={`${styles.aboutheading2}`}>Geochemistry and Environmental Geology :</p>

        <p className={`${styles.aboutoption}`}>
            Cosmic abundance of elements. Composition of the planets and meteorites. Structure and
            composition of earth and distribution of elements. Trace elements. Elements of crystal chemistry-types of
            chemical bonds, coordination number. Isomorphism and polymorphism. Elementary thermodynamics.
            Natural hazards—floods, mass wasting, costal hazards, earthquakes and volcanic activity and mitigation;
            Environmental impact of urbanization, mining, industrial and radioactive waste disposal, use of fertilizers,
            dumping of mine waste and fly-ash. Pollution of ground and surface water, marine pollution. Environment
            protection—legislative measures in India; Sea level changes: causes and impact.
        </p>
  
        </div>
    </div>
  </div>
</div>

{/* 13. ZOOLOGY  */} 

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        13</span> ZOOLOGY 
    </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
       Zoology - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
       
    
    <p className={`${styles.aboutheading2} `}> 1. Non-chordata and Chordata :</p>

    <p className={`${styles.aboutheading} `}>
        (a) Classification and relationship of various phyla up to subclasses: Acoelomate and Coelomate, Protostomes and Deuterostomes, Bilateria and Radiata; Status of Protista, Parazoa, Onychophora and
        Hemichordata; Symmetry.
    </p> 

    <p className={`${styles.aboutheading} `}>  
       (b) Protozoa: Locomotion, nutrition, reproduction, sex; General features and life history of
        Paramaecium, Monocystis. Plasmodium and Leishmania.
    </p> 

    <p className={`${styles.aboutheading} `}>
        (c) Porifera: Skeleton, canal system and reproduction.
    </p>

     <p className={`${styles.aboutheading} `}> 
        (d) Cnidaria: Polymorphism, defensive structures and their mechanism; coral reefs and their
            formation; metagenesis; general features and life history of Obelia and Aurelia.
    </p>
        
    <p className={`${styles.aboutheading} `}>
        (e) Platyhelminthes: Parasitic adaptation; general features and life history of Fasciola and Taenia and
            their-Pathogenic symptoms.
    </p>

    <p className={`${styles.aboutheading} `}>
        (f) Nemathelminthes: General features, life history, parasitic adaptation of Ascaris andWuchereria.
    </p>

    <p className={`${styles.aboutheading} `}>
        (g) Annelida: Coelom and metamerism; modes of life in polychaetes; general features and life history
        of Nereis, earthworm and leach.
    </p>

    <p className={`${styles.aboutheading} `}>
        (h) Arthropoda: Larval forms and parasitism in Crustacea; vision and respiration in arthropods (Prawn,
            cockroach and scorpion); modification of mouth, parts in insects (cockroach, mosquito, housefly, honey bee
            and butterfly), metapmor phosis in insect and its hormonal regulation, socialbehaviour ofApis and termites.
    </p>

    <p className={`${styles.aboutheading} `}>
       (i) Molluscs: Feeding, respiration, locomotion, general features and life history of Lamellidens, Pila
        and Sepia. Torsion and detorsion in gastropods.
    </p>

    <p className={`${styles.aboutheading} `}>
        (j) Echinodermata: Feeding, respiration, locomotion, larval forms, general features and life history of
        Asterias.
     </p>

    <p className={`${styles.aboutheading} `}>
        (k) Protochordata: Origin of chordates; general features and life history of Branchiostoma and
        Herdmania.
    </p>
 
    <p className={`${styles.aboutheading} `}> 
        (l) Pisces: Respiration, locomotion and migration.
    </p>
 
    <p className={`${styles.aboutheading}`}>
        (m) Amphibia: Origin of tetrapods, parental care, paedomorphosis.
    </p>

    <p className={`${styles.aboutheading}`}>
        (n) Reptilia; Origin of reptiles, skull types, status of Sphenodon and crocodiles.
    </p>

    <p className={`${styles.aboutheading}`}>
        (o) Aves: Origin of birds, flight adaptation, migration.
    </p>

    <p className={`${styles.aboutheading}`}>
        (p) Mammalia: Origin of mammals, dentition, general features of egg laying mammals, pouchedmammals,
            aquatic mammals and primates, endocrine glands (pituitary, thyroid, parathyroid, adrenal,
            pancreas, gonads) and their interrelationships.
    </p>

    <p className={`${styles.aboutheading}`}>
        (q) Comparative functional anatomy of various systems of vertebrates. integument and its derivatives,
        endoskeleton, locomotory organs, digestive system,. respiratory system, circulatory system including heart
        and aortic arches, urinogenital system, brain and sense organs (eye and ear).
    </p>

    <p className={`${styles.aboutheading2}`}> 2. Ecology :</p>

    <p className={`${styles.aboutheading}`}>
        (a) Biosphere: concept of biosphere; biomes, Biogeochemical cycles, Human induced changes in atmosphere
        including green house effect, ecological succession, biomes and ecotones, community ecology.
    </p>

    <p className={`${styles.aboutheading}`}>
        (b) Concept of ecosystem; structure and function of ecosystem, types of ecosystem, ecological
        succession, ecological adaptation.
    </p>

    <p className={`${styles.aboutheading}`}>
        (c) Population; characteristics, population dynamics, population stabilization.
    </p>

    <p className={`${styles.aboutheading}`}>
        (d) Biodiversity and diversity conservation of natural resources.
    </p>  

    <p className={`${styles.aboutheading}`}>
        (e) Wildlife of India. 
    </p>

    <p className={`${styles.aboutheading}`}>
        (f) Remote sensing for sustainable development.
    </p>

    <p className={`${styles.aboutheading}`}>
        (g) Environmental biodegradation; pollution and its impact on biosphere and its prevention.
    </p>

    <p className={`${styles.aboutheading2}`}> 3. Ethology :</p>

    <p className={`${styles.aboutheading}`}>
        (a) Behaviour: Sensory filtering, responsiveness, sign stimuli, learning, and memory, instinct, habituation,
        conditioning, imprinting.
    </p>

    <p className={`${styles.aboutheading}`}>
        (b) Role of hormones in drive; role of pheromones in alarm spreading; crypsis, predator detection, predator
        tactics, social hierarchies in primates, social organization in insects;
    </p>

    <p className={`${styles.aboutheading}`}>
        (c) Orientation, navigation, homing; biological rhythms: biological clock, tidal, seasonal and circadian rhythms.
    </p>

    <p className={`${styles.aboutheading}`}>
       (d) Methods of studying animal behaviour including sexual conflict, selfishness, kinship and altruism.
    </p>

    <p className={`${styles.aboutheading2}`}>4. Economic Zoology :</p>

    <p className={`${styles.aboutheading}`}>
        (a) Apiculture, sericulture, lac culture, carp culture, pearl culture, prawn culture, vermiculture.
    </p>

    <p className={`${styles.aboutheading}`}>
        (b) Major infectious and communicable diseases (malaria, filaria, tuberculosis, cholera and AIDS) their
        vectors, pathogens and prevention.
    </p>

    <p className={`${styles.aboutheading}`}>
        (c) Cattle and livestock diseases, their pathogen (helminths) and vectors (ticks, mites, Tabanus, Stomoxys).
    </p>

    <p className={`${styles.aboutheading}`}>
        (d) Pests of sugar cane (Pyrilla perpusiella), oil seed (Achaeajanata) and rice (Sitophilus oryzae).
    </p>

    <p className={`${styles.aboutheading}`}>
        (e) Transgenic animals.
    </p>

    <p className={`${styles.aboutheading}`}>
        (f) Medical biotechnology, human genetic disease and genetic counselling, gene therapy.
    </p>

    <p className={`${styles.aboutheading}`}>    
        (g) Forensic biotechnology.
    </p>

    <p className={`${styles.aboutheading2}`}>5. Biostatistics :</p>

    <p className={`${styles.aboutheading}`}> 
        Designing of experiments; null hypothesis; correlation, regression, distribution and measure of central
        tendency, chi square, student-test, F-test (one-way & two-way F-test).
    </p>

    <p className={`${styles.aboutheading2}`}>6. Instrumentation methods :</p>

    <p className={`${styles.aboutheading}`}>
        (a) Spectrophotometer, phase contrast and fluorescence microscopy, radioactive tracer, ultra centrifuge,
        gel . electrophoresis, PCR, ELISA, FISH and chromosome painting.
    </p> 
    <p className={`${styles.aboutheading}`}>
        (b) Electron microscopy (TEM, SEM).
    </p>


 </div>
</div>

{/* Zoology II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
         Zoology  - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", 
            textAlign: "justify", 
            }}
      > 
      
        <p className={`${styles.aboutheading2}`}>
           1. Cell Biology :
        </p>
              
        <p className={`${styles.aboutheading} `}>  
           (a) Structure and function of cell and its organelles (nucleus, plasma membrane, mitochondria, Golgi
            bodies, endoplasmic reticulum, ribosomes and lysosomes), cell division (mitosis and meiosis), mitotic
            spindle and mitotic apparatus, chromosome movement chromosome type ploytene and lambrush,
            organization of chromatin, heterochromatin, Cell cycle regulation.
        </p>

        <p className={`${styles.aboutheading} `}> 
           (b) Nucleic acid topology, DNA motif, DNA replication, transcription, RNA processing, translation,
            protein foldings and transport.
        </p>

        <p className={`${styles.aboutheading2} `}>
          2. Genetics :
        </p>

        <p className={`${styles.aboutheading} `}>
            (a) Modern concept of gene, split gene, genetic regulation, genetic, code.
        </p>

        <p className={`${styles.aboutheading} `}>
            (b) Sex chromosomes and their evolution, sex determination in Drosophila and human
        </p>
 
        <p className={`${styles.aboutheading} `}>
           (c) Mendel’s laws of inheritance, recombination, linkage, multiple alleles, genetics of blood groups,
            pedigree analysis, hereditary diseases in human.
        </p>

        <p className={`${styles.aboutheading} `}>
            (d) Mutations and mutagenesis.
        </p>

        <p className={`${styles.aboutheading} `}>
          (e) Recombinant DNA technology, plasmid, cosmid, artificial chromosomes as vectors, transgenics, DNA
            cloning and whole animal cloning (principles and methods).
        </p>

        <p className={`${styles.aboutheading} `}>
          (f) Gene regulation and expression in prokaryotes and eukaryotes.
        </p>

        <p className={`${styles.aboutheading} `}>
         (g) Signal molecules, cell death, defects in signaling pathway and consequences.
        </p>

        <p className={`${styles.aboutheading} `}>
            (h) RFLP, RAPD and AFLF and application of RFLP in DNA finger-printing, ribozyme technologies, human genome project, genomics and protomics.
        </p>

        <p className={`${styles.aboutheading2} `}>
           3. Evolution :
        </p>

        <p className={`${styles.aboutheading} `}>
            (a) Theories of origin of life.
        </p>

        <p className={`${styles.aboutheading} `}>
            (b) Theories of evolution; Natural selection, role of mutation in evolution, evolutionary patterns, molecular
            drive, mimicry, variation, isolation and speciation.
        </p>

        <p className={`${styles.aboutheading} `}>
            (c) Evolution of horse, elephant and human using fossil data.
        </p>

        <p className={`${styles.aboutheading} `}>
            (d) Hardy-Weinberg Law.
        </p>

        <p className={`${styles.aboutheading} `}>
            (e) Continental drift and distribution of animals.
        </p>

        <p className={`${styles.aboutheading2} `}>
           4. Systematics  :
        </p>

        <p className={`${styles.aboutheading} `}>
            Zoological nomenclature, international code, cladistics, molecular taxonomy and biodiversity.
        </p>

        <p className={`${styles.aboutheading2} `}> 5. Biochemistry :</p> 

        <p className={`${styles.aboutheading} `}>
            (a) Structure and role of carbohydrates, fats, fatty acids, cholesterol, proteins and amino-acids, nucleic acids. Bioenergetics.
        </p> 

        <p className={`${styles.aboutheading} `}>
           (b) Glycolysis and Krebs cycle, oxidation and reduction, oxidative phosphorylation; energy conservation and
            release, ATP, cycl cyclic AMP-its structure and role.
        </p>

        <p className={`${styles.aboutheading} `}>
            (c) Hormone classification (steroid and peptide hormones), biosynthesis and functions.
        </p>

        <p className={`${styles.aboutheading} `}>
            (d) Enzymes: types and mechanisms of action.
        </p>

        <p className={`${styles.aboutheading} `}>
            (e) Vitamins and co-enzymes.
        </p>

        <p className={`${styles.aboutheading} `}>
           (f) Immunoglobulin and immunity.
        </p>

        <p className={`${styles.aboutheading2} `}>
            6. Physiology (with special reference to mammals) :
        </p>

        <p className={`${styles.aboutheading} `}>
            (a) Composition and constituents of blood; blood groups and Rh factor in human; factors and mechanism
            of coagulation; iron metabolism, acid-base balance, thermo regulation, anticoagulants.
        </p>

        <p className={`${styles.aboutheading} `}>
            (b) Haemoglobin: Composition, types and role in transport of oxygen and carbon dioxide.
        </p>

        <p className={`${styles.aboutheading} `}>
            (c) Digestion and absorption: Role of salivary glands, liver, pancreas and intestinal glands.
        </p>

        <p className={`${styles.aboutheading} `}>
            (d) Excretion: nephron and regulation of urine formation; osmo-regulation and excretory product.
        </p>

        <p className={`${styles.aboutheading} `}>
            (e) Muscles: Types, mechanism of contraction of skeletal muscles, effects of exercise on muscles.   
        </p> 

        <p className={`${styles.aboutheading} `}>
            (f) Neuron: nerve impulse—its conduction and synaptic transmission; neurotransmitters.
        </p>

        <p className={`${styles.aboutheading} `}> (g) Vision, hearing and olfaction in human.</p>

        <p className={`${styles.aboutheading} `}> (h) Physiology of reproduction puberty and menopause in human.</p>

        <p className={`${styles.aboutheading2} `}>7. Developmental Biology :</p>

        <p className={`${styles.aboutheading} `}>
            (a) Gametogenesis; spermatogenesis, composition of semen, in vitro and in vivo capacitation of mammalian
            sperm, Oogenesis, totipotency; fertilization, morphogenesis and morphogen; blastogeneis, establishment of
            body axes formation, fate map, gestulation in frog and chick; genes in development in chick homeotic genes,
            development of eye and heart, placenta in mammals.
        </p>

        <p className={`${styles.aboutheading} `}>
            (b) Cell lineage, cell to cell interaction, Genetic and induced teratogenesis, role of thyroxine in control of
            metamorphosisin amphibia, paedogenesis and neoteny, cell death, aging.
        </p>

        <p className={`${styles.aboutheading} `}>
            (c) Developmental genes in human, in vitro fertilization; and embryo transfer; cloning.
        </p>

        <p className={`${styles.aboutheading} `}>
            (d) Stem cells: Sources, types and their use in human welfare.
        </p>

        <p className={`${styles.aboutheading} `}>(e) Biogenetic law.</p>

      </div>
    </div>
  </div>
</div>

{/*14  BOTANY */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
       <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        14 </span> BOTANY
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Botany - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
        <p className={`${styles.aboutheading2}`}>
            Microbiology and Plant Pathology :
        </p>

        <p className={`${styles.aboutoption}`}>
            Structure and reproduction/multiplication of viruses,viroids, bacteria, fungi and mycoplasma;
            Applications of microbiology in agriculture, industry, medicine and in control of soil and water pollution;
            Prion and Prion hypothesis.
        </p>

        <p className={`${styles.aboutoption}`}>
            Important crop diseases caused by viruses, bacteria, mycoplasma, fungi and nematodes; Modes of
            infection and dissemination; Molecular basis of infection and disease resistance/defence; Physiology of
            parasitism and control measures. Fungal toxins. Modelling and disease forecasting; Plant quarantine.
        </p>

        <p className={`${styles.aboutheading2}`}>
            Cryptogams :
        </p>

        <p className={`${styles.aboutoption}`}>
            Algae, fungi, lichens, bryophytes, pteridophytes-structure and reproduction from evolutionary
            viewpoint; Distribution of Cryptogams in India and their ecological and economic importance.
        </p>

        <p className={`${styles.aboutheading2}`}>
            Phanerogams :
        </p>

        <p className={`${styles.aboutoption}`}>
            Gymnosperms : Concept of Progymnosperms. Classification and distribution of gymnosperms.
            Salient features of Cycadales, Ginkgoales, Coniferales and Gnetales, their structure and reproduction.
            General account of Cycadofilicales, Bennettitales and Cordiaitailes; Geological time scale; Type of fossils
            and their study techniques
        </p>

        <p className={`${styles.aboutoption}`}>
            Angiosperms : Systematics, anatomy, embryology, palynology and phylogency.
        </p>

        <p className={`${styles.aboutoption}`}>
            Taxonomic hierarchy; International Code of Botanical Nomenclature; Numerical taxomomy and
            chemotaxomomy; Evidence from anatomy, embryology and palynology.
        </p>

        <p className={`${styles.aboutoption}`}>
            Origin and evolution of angiosperms; Comparative account of various systems of classification of angiosperms; Study of angiospermic families— Mangnoliaceae, Ranunculaceae, Brassicaceae, Rosaceae,
            Fabaceae, Euphorbiaceae, Malvaceae, Dipterocarpaceae, Apiaceae, Asclepiadaceae, Verbenaceae,
            Solanaceae, Rubiaceae, Cucurbitaceae, Asteraceae, Poaceae, Arecaceae, Liliaceae, Musaceae and
            Orchidaceae.
        </p>

        <p className={`${styles.aboutoption}`}>
            Stomata and their types; Glandular and non-glandular trichomes; Unusual secondary growth;
            Anatomy of C3 and C4 plants; Xylem and phloem differentiation; Wood anatomy.
        </p>

        <p className={`${styles.aboutoption}`}>
            Development of male and female gametophytes, pollination, fertilization; Endosperm—its
            development and function. Patterns of embryo development; Polyembroyony, apomixes; Applications of
            palynology; Experimental embryology including pollen storage and test-tube fertilization.
        </p>

         <p className={`${styles.aboutheading2}`}>
            Plant Resource Development :
         </p>

         <p className={`${styles.aboutoption}`}>
            Domestication and introduction of plants; Origin of cultivated plants, Vavilov’s centres of origin.
            Plants as sources for food, fodder, fibres, spices, beverages, edible oils, drugs, narcotics, insecticides, timber,
            gums, resins and dyes; latex, cellulose, starch and its products; Perfumery; Importance of Ethnobotany in
            Indian context; Energy plantations; Botanical Gardens and Herbaria.
         </p>

         <p className={`${styles.aboutheading2}`}>
            Morphogenesis :
         </p>

         <p className={`${styles.aboutoption}`}>
            Totipotency, polarity, symmetry and differentiation; Cell, tissue, organ and protoplast culture.
            Somatic hybrids and Cybrids; Micropropagation; Somaclonal variation and its applications; Pollen haploids,
            embryo rescue methods and their applications.
         </p>



      </div>
    </div>

{/* Botany Paper II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
       Botany - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      >
         <p className={`${styles.aboutheading2}`}>
            Cell Biology :
         </p>

        <p className={`${styles.aboutoption}`}>
            Techniques of cell biology. Prokaryotic and eukaryotic cells—structural and ultrastructural details;
            Structure and function of extracellular matrix (cell wall) and membranes-cell adhesion, membrane transport
            and vesicular transport; Structure and function of cell organelles (chloroplasts, mitochondria, ER,
            dictyosomes ribosomes, endosomes,lysosomes, peroxisomes; Cytoskelaton and microtubules; Nucleus,
            nucleolus, nuclear pore complex; Chromatin and nucleosome; Cell signalling and cell receptors; Signal
            transduction Mitosis and meiosis; molecular basis of cell cycle. Numerical and structural variations in
            chromosomes and their significance; Chromatin organization and packaging of genome; Polytene
            chromosomes; B-chromosomes—structure, behaviour and significance.
        </p>

        <p className={`${styles.aboutheading2}`}>
            Genetics, Molecular Biology and Evolution :
         </p>

        <p className={`${styles.aboutoption}`}>
            Development of genetics, and gene versus allele concepts (Pseudoalleles); Quantitative genetics and
            multiple factors; Incomplete dominance, polygenic inheritance, multiple alleles; Linkage and crossing over
            of gene mapping including molecular maps (idea of mapping, function); Sex chromosomes and sex-linked
            inheritance; sex determination and molecular basis of sex differentiation; Mutations (biochemical and
            molecular basis); Cytoplasmic inheritance and cytoplasmic genes (including genetics of male sterility).
        </p>

        <p className={`${styles.aboutoption}`}>
            Structure and synthesis of nucleic acids and proteins; Genetic code and regulation of gene
            expression; Gene silencing; Multigene families; Organic evolution-evidences, mechanism and theories.
        </p>

        <p className={`${styles.aboutoption}`}>
           Role of RNA in origin and evolution.
        </p>

        <p className={`${styles.aboutheading2}`}>Plant Breeding, Biotechnology and Biostatistics </p>
        
        <p className={`${styles.aboutoption}`}>
            Methods of plant breeding—introduction, selection and hybridization (pedigree, backcross, mass
            selection, bulk method); Mutation, polyploidy, male sterility and heterosis breeding. Use of apomixes in
            plant breeding; DNA sequencing; Genetic engineering—methods of transfer of genes; Transgenic crops and biosafety aspects; Development and use of molecular markers in plant breeding; Tools and techniques—
            probe, southern blotting, DNA fingerprinting, PCR and FISH. Standard deviation and coefficient of variation
            (CV). Tests of significance (Z-test, t-test and chi-square tests). Probability and distributions (normal,
            binomial and Poisson). Correlation and regression.
        </p>

         <p className={`${styles.aboutheading2}`}>Physiology and Biochemistry :</p>

        <p className={`${styles.aboutoption}`}>
            Water relations, mineral nutrition and ion transport, mineral deficiencies. Photosynthesis—
            photochemical reactions, photophosphorylation and carbon fixation pathways; C3, C4 and CAM pathways;
            Mechanism of pholem transport, Respiration (anerobic and aerobic, including fermentation)—electron
            transport chain and oxidative phosphorylation; Photorespiration; Chemiosmotic theory and ATP synthesis;
            Lipid metabolism; Nitrogen fixation and nitrogen metabolism. Enzymes, coenzymes; Energy transfer and
            energy conservation. Importance of secondary metabolites. Pigments as photoreceptors (plastidial pigments
            and phytochrome). Plant movements; Photoperiodism and flowering, vernalization, senescence; Growth
            substances—their chemical nature, role and applications in agri-horticulture; growth indices, growth
            movements. Stress physiology (heat, water, salinity, metal); Fruit and seed physiology. Dormancy, storage
            and germination of seed. Fruit ripening—its molecular basis and manipulation.
        </p>

        <p className={`${styles.aboutheading2}`}>Ecology and Plant Geography :</p>

        <p className={`${styles.aboutoption}`}>
            Concept of ecosystem; Ecological factors. Concepts and dynamics of community; Plant succession.
            Concepts of biosphere; Ecosystems; Conservation; Pollution and its control (including phytoreme-diation);
            Plant indicators; Environment (Protection) Act.

        </p>

        <p className={`${styles.aboutoption}`}>
            Forest types of India—‘Ecological and ecomomic importance of forests, afforestation, deforestation
            and social forestry; Endangered plants, endemism IUCN categories, Red Data Books; Biodiversity and its
            conservation; Protected Area Network; Convention of Biological Diversity, Farmers’ Rights; and Intellectual
            Property Rights; Concept of Sustainable Development; Biogeochemical cycles. Global warming and climatic
            change; Invasive species; Environmetal Impact Assessment; Phytogeographical regions of India.
        </p>

        
      </div>
    </div>
  </div>
</div>

{/* 15. PHYSICS  */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        15 </span> PHYSICS 
    </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
       Physics - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
       
    
    <p className={`${styles.aboutheading2} `}> 1. (a) Mechanics of Particles :</p>

    <p className={`${styles.aboutheading} `}>
        Laws of motion; conservation of energy and momentum, applications to rotating frames, centripetal
        and Coriolis accelerations; Motion under a central force; Conservation of angular momentum, Kepler’s laws;
        Fields and potentials; Gravitational field and potential due to spherical bodies, Gauss and Poisson
        equations, gravitational self-energy; Two-body problem; Reduced mass; Rutherford scattering; Centre of mass and laboratory reference frames.
    </p> 

    <p className={`${styles.aboutheading2} `}>  
      (b) Mechanics of Rigid Bodies :
    </p> 

    <p className={`${styles.aboutheading} `}>
        System of particles; Centre of mass, angular momentum, equations of motion; Conservation theorems
        for energy, momentum and angular momentum; Elastic and inelastic collisions; Rigid Body; Degrees of
        freedom, Euler’s theorem, angular velocity, angular momentum, moments of inertia, theorems of parallel
        and perpendicular axes, equation of motion for rotation; Molecular rotations (as rigid bodies); Di and triatomic
        molecules; Precessional motion; top, gyroscope.
    </p>

    <p className={`${styles.aboutheading2} `}>
      (c) Mechanics of Continuous Media :
    </p>

    <p className={`${styles.aboutheading} `}>
      Elasticity, Hooke’s law and elastic constants of isotropic solids and their inter-relation; Streamline
      (Laminar) flow, viscosity, Poiseuille’s equation, Bernoulli’s equation, Stokes’ law and applications.
    </p>

    <p className={`${styles.aboutheading2} `}>
      (d) Special Relativity :
    </p>

    <p className={`${styles.aboutheading} `}>
        Michelson-Morely experiment and its implications; Lorentz transformations length contraction, time
        dilation, addition of relativistic velocities, aberration and Doppler effect, mass-energy relation, simple
        applications to a decay process. Four dimensional momentum vector; Covariance of equations of physics.
    </p>

    <p className={`${styles.aboutheading2} `}>
      2. Waves and Optics :
    </p>

     <p className={`${styles.aboutheading2} `}>
        (a) Waves :
     </p>

    <p className={`${styles.aboutheading} `}>
        Simple harmonic motion, damped oscillation, forced oscillation and resonance; Beats; Stationary
        waves in a string; Pulses and wave packets; Phase and group velocities; Reflection and refraction from
        Huygens’ principle.
    </p>
 
    <p className={`${styles.aboutheading2} `}> 
       (b) Geometrial Optics :
    </p>
 
    <p className={`${styles.aboutheading}`}>
        Laws of reflection and refraction from Fermat’s principle; Matrix method in paraxial optic-thin lens
        formula, nodal planes, system of two thin lenses, chromatic and spherical aberrations.
    </p>

    <p className={`${styles.aboutheading2}`}>
        (c) Interference :
    </p>

    <p className={`${styles.aboutheading} `}>
        Interference of light -Young’s experiment, Newton’s rings, interference by thin films, Michelson
        interferometer; Multiple beam interference and Fabry Perot interferometer
    </p>
    
    <p className={`${styles.aboutheading2}`}>
        (d) Diffraction :
    </p>
       
    <p className={`${styles.aboutheading}`}> 
        Fraunhofer diffraction - single slit, double slit, diffraction grating, resolving power; Diffraction by a
        circular aperture and the Airy pattern; Fresnel diffraction: half-period zones and zone plates, circular
        aperture.
    </p>
         
    <p className={`${styles.aboutheading2}`}> 
       (e) Polarisation and Modern Optics :
    </p> 

    <p className={`${styles.aboutheading}`}> 
        Production and detection of linearly and circularly polarized light; Double refraction, quarter wave
        plate; Optical activity; Principles of fibre optics, attenuation; Pulse dispersion in step index and parabolic
        index fibres; Material dispersion, single mode fibers; Lasers-Einstein A and B coefficients. Ruby and He-Ne
        lasers. Characteristics of laser light-spatial and temporal coherence; Focusing of laser beams. Three-level
        scheme for laser operation; Holography and simple applications.
    </p>

    <p className={`${styles.aboutheading2}`}> 
        3. Electricity and Magnetism :
    </p>

    <p className={`${styles.aboutheading2}`}>
        (a) Electrostatics and Magnetostatics :
    </p>

    <p className={`${styles.aboutheading}`}>
        Laplace and Poisson equations in electrostatics and their applications; Energy of a system of charges,
        multipole expansion of scalar potential; Method of images and its applications. Potential and field due to a
        dipole, force and torque on a dipole in an external field; Dielectrics, polarisation. Solutions to boundaryvalue
        problems-conducting and dielectric spheres in a uniform electric field; Magnetic shell, uniformly
        magnetised sphere; Ferromagnetic materials, hysteresis, energy loss.
    </p>

    <p className={`${styles.aboutheading2}`}>
        (b) Current Electricity :
    </p>

    <p className={`${styles.aboutheading}`}>
        Kirchhoff's laws and their applications. Biot-Savart law, Ampere’s law, Faraday’s law, Lenz’ law. Selfand
        mutual- inductances; Mean and rms values in AC circuits; DC and AC circuits with R, L and C
        components; Series and parallel resonance; Quality factor; Principle of transformer.
    </p>

    <p className={`${styles.aboutheading2}`}>
        4. Electromagnetic Waves and Blackbody Radiation :
    </p>

    <p className={`${styles.aboutheading}`}>
        Displacement current and Maxwell’s equations; Wave equations in vacuum, Poynting theorem; Vector
        and scalar potentials; Electromagnetic field tensor, covariance of Maxwell’s equations; Wave equations in
        isotropic dielectrics, reflection and refraction at the boundary of two dielectrics; Fresnel’s relations; Total
        internal reflection; Normal and anomalous dispersion; Rayleigh scattering; Blackbody radiation and
        Planck ’s radiation law- Stefan-Boltzmann law, Wien’s displacement law and Rayleigh-Jeans law.
    </p>

    <p className={`${styles.aboutheading2}`}>
        5. Thermal and Statistical Physics :
    </p>

    <p className={`${styles.aboutheading2}`}>
        (a) Thermodynamics :
    </p>

    <p className={`${styles.aboutheading}`}>
        Laws of thermodynamics, reversible and irreversible processes, entropy; Isothermal, adiabatic,
        isobaric, isochoric processes and entropy changes; Otto and Diesel engines, Gibbs’ phase rule and chemical
        potential; Van der Waals equation of state of a real gas, critical constants; Maxwell-Boltzmann distribution
        of molecular velocities, transport phenomena, equipartition and virial theorems; Dulong-Petit, Einstein, and
        Debye’s theories of specific heat of solids; Maxwell relations and application; Clausius-Clapeyron equation.
        Adiabatic demagnetisation, Joule-Kelvin effect and liquefaction of gases.
    </p>

    <p className={`${styles.aboutheading2}`}>
        (b) Statistical Physics :
    </p>

    <p className={`${styles.aboutheading}`}>
        Macro and micro states, statistical distributions, Maxwell-Boltzmann, Bose-Einstein and Fermi-Dirac
        Distributions, applications to specific heat of gases and blackbody radiation; Concept of negative
        temperatures.
    </p>

 </div>
</div>

{/* Physics   II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
         Physics   - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", 
            textAlign: "justify", 
            }}
      > 
      
        <p className={`${styles.aboutheading2}`}>
            1. Quantum Mechanics :
        </p>
              
        <p className={`${styles.aboutheading} `}>  
            Wave-particle duality; Schroedinger equation and expectation values; Uncertainty principle; Solutions of
            the one-dimensional Schroedinger equation for free particle (Gaussian wave-packet), particle in a box,
            particle in a finite well, linear harmonic oscillator; Reflection and transmission by a step potential and by a
            rectangular barrier; Particle in a three dimensional box, density of states, free electron theory of metals;
            Angular momentum; Hydrogen atom; Spin half particles, properties of Pauli spin matrices.
        </p>

        <p className={`${styles.aboutheading2} `}> 
           2. Atomic and Molecular Physics :
        </p>

        <p className={`${styles.aboutheading} `}>
            Stern-Gerlach experiment, electron spin, fine structure of hydrozen atom; L-S coupling, J-J coupling;
            Spectroscopic notation of atomic states; Zeeman effect; Franck-Condon principle and applications;
            Elementary theory of rotational, vibrational and electronic spectra of diatomic molecules; Raman effect and
            molecular structure; Laser Raman spectroscopy; Importance of neutral hydrogen atom, molecular hydrogen
            and molecular hydrogen ion in astronomy. Fluorescence and Phosphorescence; Elementary theory and
            applications of NMR and EPR; Elementary ideas about Lamb shift and its significance.
        </p>

        <p className={`${styles.aboutheading2} `}>
           3. Nuclear and Particle Physics :
        </p>

        <p className={`${styles.aboutheading} `}>
            Basic nuclear properties-size, binding energy, angular momentum, parity, magnetic moment; Semi empirical mass formula and applications. Mass parabolas; Ground state of a deuteron, magnetic moment
            and non-central forces; Meson theory of nuclear forces; Salient features of nuclear forces; Shell model of
            the nucleus - success and limitations; Violation of parity in beta decay; Gamma decay and internal
            conversion; Elementary ideas about Mossbauer spectroscopy; Q-value of nuclear reactions; Nuclear fission
            and fusion, energy production in stars. Nuclear reactors. <br/>

            Classification of elementary particles and their interactions; Conservation laws; Quark structure of
            hadrons : Field quanta of electroweak and strong interactions; Elementary ideas about unification of forces;
            Physics of neutrinos.
        </p>
 
        <p className={`${styles.aboutheading2} `}>
            4. Solid State Physics, Devices and Electronics :
        </p>

        <p className={`${styles.aboutheading} `}>
            Crystalline and amorphous structure of matter; Different crystal systems, space groups; Methods of
            determination of crystal structure; X-ray diffraction, scanning and transmission electron microscopies;
            Band theory of solids—conductors, insulators and semi-conductors; Thermal properties of solids, specific
            heat, Debye theory; Magnetism: dia, para and ferromagnetism; Elements of super-conductivity, Meissner
            effect, Josephson junctions and applications; Elementary ideas about high temperature super-conductivity.
        </p>

        <p className={`${styles.aboutheading} `}>
            Intrinsic and extrinsic semi-conductors- p-n-p and n-p-n transistors; Amplifiers and oscillators. Op-amps;
            FET, JFET and MOSFET; Digital electronics-Boolean identities, De Morgan’s laws, Logic gates and truth
            tables. Simple logic circuits; Thermistors, solar cells; Fundamentals of microprocessors and digital
            computers.
        </p>

      </div>
    </div>
  </div>
</div>

{/* 16 CHEMISTRY */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        16 </span> CHEMISTRY
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Chemistry - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
        <p className={`${styles.aboutheading2}`}>
           Atomic Structure :
        </p>

        <p className={`${styles.aboutoption}`}>
            Heisenberg's uncertainty principle Schrodinger wave equation (time independent); Interpretation of
            wave function, particle in one- dimensional box, quantum numbers, hydrogen atom wave functions; Shapes
            of s, p and d orbitals.
        </p>


        <p className={`${styles.aboutheading2}`}>
            Chemical bonding :
        </p>

        <p className={`${styles.aboutoption}`}>
            AIonic bond, characteristics of ionic compounds, lattice energy, Born-Haber cycle; covalent bond and
            its general characteristics, polarities of bonds in molecules and their dipole moments; Valence bond theory,
            concept of resonance and resonance energy; Molecular orbital theory (LCAO method); bonding H2 +, H2
            He2 + to Ne2, NO, CO, HF, CN–, Comparison of valence bond and molecular orbital theories, bond order,
            bond strength and bond length.        
        </p>

        <p className={`${styles.aboutheading2}`}>
           Solid state :
        </p>

        <p className={`${styles.aboutoption}`}>
            Crystal systems; Designation of crystal faces, lattice structures and unit cell; Bragg's law; X-ray
            diffraction by crystals; Close packing, radius ratio rules, calculation of some limiting radius ratio values;
            Structures of NaCl, ZnS, CsCl, CaF2; stoichiometric and nonstoichiometric defects, impurity defects, semi-conductors.
        </p>

        <p className={`${styles.aboutheading2}`}>  The gaseous state and Transport Phenomenon :</p>
     
        <p className={`${styles.aboutoption}`}>
            Equation of state for real gases, intermolecular interactions, and critical phenomena and liquefaction
            of gases; Maxwell’s distribution of speeds, intermolecular collisions, collisions on the wall and effusion;
            Thermal conductivity and viscosity of ideal gases.
        </p>

        <p className={`${styles.aboutheading2}`}>  Liquid State :</p>

        <p className={`${styles.aboutoption}`}>
            Kelvin equation; Surface tension and surface enercy, wetting and contact angle, interfacial tension
            and capillary action.
        </p>

        <p className={`${styles.aboutheading2}`}> Thermodynamics : </p>

        <p className={`${styles.aboutoption}`}>Work, heat and internal energy; first law of thermodynamics.</p>

        <p className={`${styles.aboutoption}`}>
            Second law of thermodynamics; entropy as a state function, entropy changes in various processes,
            entropy-reversibility and irreversibility, Free energy functions; Thermodynamic equation of state; Maxwell
            relations; Temperature, volume and pressure dependence of U, H, A, G, Cp and Cv, and ; J-T effect
            and inversion temperature; criteria for equilibrium, relation between equilibrium constant and
            thermodynamic quantities; Nernst heat theorem, introductory idea of third law of thermodynamics.
        </p>

        <p className={`${styles.aboutheading2}`}> Phase equilibria and solutions : </p>

        <p className={`${styles.aboutoption}`}>
            Clausius-Clapeyron equation; phase diagram for a pure substance; phase equilibria in binary
            systems, partially miscible liquids—upper and lower critical solution temperatures; partial molar quantities,
            their significance and determination; excess thermodynamic functions and their determination.
        </p>

        <p className={`${styles.aboutheading2}`}> Electrochemistry : </p>
         <ul>
            <li>Debye-Huckel theory of strong electrolytes and Debye-Huckel limiting Law for various equilibrium
                and transport properties.</li>
            <li>Galvanic cells, concentration cells; electrochemical series, measurement of e.m.f. of cells and its
                applications fuel cells and batteries.</li>  
            <li>Processes at electrodes; double layer at the interface; rate of charge transfer, current density;
                overpotential; electroanalytical <br/>techniques : amperometry, ion selective electrodes and their use.</li>      
         </ul>

        <p className={`${styles.aboutheading2}`}> Chemical kinetics : </p>

        <p className={`${styles.aboutoption}`}>
            Differential and integral rate equations for zeroth, first, second and fractional order reactions; Rate
            equations involving reverse, parallel, consecutive and chain reactions; Branching chain and explosions;
            effect of temperature and pressure on rate constant. Study of fast reactions by stop-flow and relaxation
            methods. Collisions and transition state theories.
        </p>

        <p className={`${styles.aboutheading2}`}> Photochemistry : </p>

        <p className={`${styles.aboutoption}`}>
            Absorption of light; decay of excited state by different routes; photochemical reactions between
            hydrogen and halogens and their quantum yields.
        </p>
            
        <p className={`${styles.aboutheading2}`}> Surface phenomena and catalysis : </p>

        <p className={`${styles.aboutoption}`}>
            Adsorption from gases and solutions on solid adsorbents; Langmuir and B.E.T. adsorption
            isotherms; determination of surface area, characteristics and mechanism of reaction on heterogeneous
            catalysts.
        </p>

        <p className={`${styles.aboutheading2}`}> Bio-inorganic chemistry : </p>
        <p className={`${styles.aboutoption}`}>
            Metal ions in biological systems and their role in ion-transport across the membranes (molecular
            mechanism), oxygen-uptake proteins, cytochromes and ferrodoxins.
        </p>

        <p className={`${styles.aboutheading2}`}> Coordination chemistry : </p>
          
          <ul>
            <li>Bonding in transition of metal complexes. Valence bond theory, crystal field theory and its
                modifications; applications of theories in the explanation of magnetism and elctronic spectra of metal
                complexes.
            </li>

            <li>Isomerism in coordination compounds; IUPAC nomenclature of coordination compounds;
                stereochemistry of complexes with 4 and 6 coordination numbers; chelate effect and polynuclear
                complexes; trans effect and its theories; kinetics of substitution reactions in square-planar
                complexes; thermodynamic and kinetic stability of complexes.
            </li>

            <li>EAN rule, Synthesis structure and reactivity of metal carbonyls; carboxylate anions, carbonyl
                hydrides and metal nitrosyl compounds.
            </li>

            <li>
                Complexes with aromatic systems, synthesis, structure and bonding in metal olefin complexes,
                alkyne complexes and cyclopentadienyl complexes; coordinative unsaturation, oxidative
                addition reactions, insertion reactions, fluxional molecules and their characterization; Compounds
                with metal—metal bonds and metal atom clusters.
            </li>
          </ul>
        <p className={`${styles.aboutheading2}`}> Main Group Chemistry: </p> 

        <p className={`${styles.aboutoption}`}>Boranes, borazines, phosphazenes and cyclic phosphazene, silicates and silicones, Interhalogen
             compounds; Sulphur—nitrogen compounds, noble gas compounds.
        </p>

        <p className={`${styles.aboutheading2}`}> General Chemistry of ‘f’ Block Element:</p>  

        <p className={`${styles.aboutoption}`}>Lanthanides and actinides: separation, oxidation states, magnetic and spectral properties;
           lanthanide contraction.</p>

      </div>
    </div>

{/*CHEMISTRY II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
       Chemistry - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      >
         <p className={`${styles.aboutheading2}`}>
           Delocalised covalent bonding :
         </p>

         <p className={`${styles.aboutoption}`}>Aromaticity, anti-aromaticity; annulenes, azulenes, tropolones, fulvenes, sydnones.</p>

         <ul>
            <li>Reaction mechanisms : General methods (both kinetic and non-kinetic) of study of
                mechanisms or organic reactions : isotopies, mathod cross-over experiment, intermediate trapping,
                stereochemistry; energy of activation; thermodynamic control and kinetic control of reactions.
            </li>
            <li>
                Reactive intermediates : Generation, geometry, stability and reactions of carboniumions
                and carbanions, free radicals, carbenes, benzynes and nitrenes.
            </li>
            <li>
                Substitution reactions :—SN 1, SN 2, and SN i, mechanisms ; neighbouring group
                participation; electrophilic and nucleophilic reactions of aromatic compounds including heterocyclic
                compounds—pyrrole, furan, thiophene and indole.
            </li>

            <li>
                Elimination reactions :—E1, E2 and E1cb mechanisms; orientation in E2 reactions—
                Saytzeff and Hoffmann; pyrolytic syn elimination—acetate pyrolysis, Chugaev and Cope
                eliminations.
            </li>
            <li>
                Electrophilic addition to <code>C=C</code> and <code>C&alpha;C</code>;
                nucleophilic addition to <code>C=O</code>, <code>C&alpha;N</code>,
                conjugated olefins and carbonyls.
            </li>
            <li>
                Reactions and Rearrangements :—(a) Pinacol-pinacolone, Hoffmann, Beckmann, Baeyer-
                Villiger, Favorskii, Fries, Claisen, Cope, Stevens and Wagner—Meerwein rearrangements. <br/>

                b) Aldol condensation, Claisen condensation, Dieckmann, Perkin, Knoevenagel, Witting,
                Clemmensen, Wolff-Kishner, Cannizzaro and von Richter reactions; Stobbe, benzoin and acyloin
                condensations; Fischer indole synthesis, Skraup synthesis, Bischler-Napieralski, Sandmeyer,
                Reimer-Tiemann and Reformatsky reactions.
            </li>
         </ul>

        <p className={`${styles.aboutoption}`}>
             <span className="fw-bold text-dark">Pericyclic reactions :</span>—Classification and examples; Woodward-Hoffmann rules—electrocyclic
            reactions, <br/>cycloaddition reactions [2+2 and 4+2] and sigmatropic shifts [1, 3; 3, 3 and 1, 5], FMO
            approach.
        </p>

        <ul>
            <li>Preparation and Properties of Polymers: Organic polymerspolyethylene, polystyrene,
                polyvinyl chloride, teflon, nylon, terylene, synthetic and natural rubber.</li>

            <li>Biopolymers: Structure of proteins, DNA and RNA.</li>    
        </ul>

        <p className={`${styles.aboutheading2}`}>
            Synthetic Uses of Reagents:
        </p>

        <p className={`${styles.aboutoption}`}>
            OsO<sub>4</sub>, HIO<sub>4</sub>, CrO<sub>3</sub>, Pb(OAc)<sub>4</sub>, SeO<sub>2</sub>, 
            NBS, B<sub>2</sub>H<sub>6</sub>, Na / liquid NH<sub>3</sub>, LiAlH<sub>4</sub>, 
            NaBH<sub>4</sub>, n-BuLi, MCPBA.
        </p>

        <p className={`${styles.aboutoption}`}>
           <span className="fw-bold text-dark"> Photochemistry : </span>—Photochemical reactions of simple organic compounds, excited and ground
            states, singlet and triplet states, Norrish-Type I and Type II reactions.
        </p>

        <p className={`${styles.aboutheading}`}>
             <span className="fw-bold text-dark">Spectroscopy : </span>  Principle and applications in structure elucidation 
        </p>

        <ul>
           
            <li>
                Rotational—Diatomic molecules; isotopic substitution and rotational constants.
            </li>
            <li>
                Vibrational—Diatomic molecules, linear triatomic molecules, specific frequencies of
                functional groups in polyatomic molecules.
            </li>
            <li>
                Electronic — Singlet and triplet states. <code>n→π*</code>  and <code>n→π*</code> transitions;
                application to conjugated double bonds and conjugated carbonyls, Woodward–Fieser rules; Charge transfer spectra.
            </li>
            <li>
                Nuclear Magnetic Resonance (1HNMR): Basic principle; chemical shift and spin-spin
                interaction and coupling constants.
            </li>
            <li>
                Mass Spectrometry :—Parent peak, base peak, metastable peak, McLafferty rearrangement.
            </li>
        </ul>
      </div>
    </div>
  </div>
</div>

{/* 17 COMMERCE AND ACCOUNTANCY */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        17</span> COMMERCE AND ACCOUNTANCY
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Commerce and Accountancy  - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >

        <p className={`${styles.aboutheading2} text-center`}>
           Accounting and Finance  <br/>
           Accounting, Taxation & Auditing
        </p>


        <p className={`${styles.aboutheading2}`}>
           Financing Accounting :
        </p>

        <p className={`${styles.aboutoption}`}>
            Accounting as a financial information system; Impact of behavioural sciences. Accounting Standards
            e.g., accounting for Depreciation, Inventories, Research and Development Costs, Long-term
            Construction Contracts, Revenue Recognition, Fixed Assets, Contingencies, Foreign Exchange
            Transactions, Investments and Government Grants, Cash Flow Statement, Earnings per Share. <br/>
        </p>

        <ul>
            <li>Accounting for Share Capital Transactions including Bonus Shares, Right Shares.</li>
            <li>Emplyees Stock Option and Buy-Back of Securities.</li>
            <li>Preparation and Presentation of Company Final Accounts.</li>
            <li>Amalgamations, Absorption and Reconstruction of Companies.</li>
        </ul>


        <p className={`${styles.aboutheading2} pt-2`}>
           Cost Accounting :
        </p>

        <p className={`${styles.aboutoption}`}>
            Nature and functions of cost accounting. Installation of Cost Accounting System. Cost Concepts
            related to Income Measurement, Profit Planning, Cost Control and Decision Making.       
        </p>

        <p className={`${styles.aboutoption}`}>Methods of Costing: Job Costing, Process Costing, Activity Based Costing.</p>
        <p className={`${styles.aboutoption}`}>Volume-cost-Profit Relationship as a tool of Profit Planning.</p>
        <p className={`${styles.aboutoption}`}>Incremental Analysis/Differential Costing as a Tool of Pricing Decisions, Product Decisions, Make or
            Buy Decisions, Shut-Down Decisions etc.
        </p>
        <p className={`${styles.aboutoption}`}>Techniques of Cost Control and Cost Reduction : Budgeting as a Tool of Planning and Control.
            Standard Costing and Variance Analysis.</p>
        <p className={`${styles.aboutoption}`}>Responsibility Accounting and Divisional Performance Measurement.</p>

        <p className={`${styles.aboutheading2} pt-2`}>Taxation  : </p>

        <p className={`${styles.aboutoption}`}>
            Income Tax: Definitions. Basis of charge; Incomes which do not form part of total income. Simple
            problems of computation of income (of individuals only) under various heads, i.e., salaries, income
            from house property, profits and gains from business or profession, capital gains, income from other
            sources, Income of other persons included in assessee’s total income.
        </p>

        <p className={`${styles.aboutoption}`}>Set-off and Carry forward of Loss.</p>
        <p className={`${styles.aboutoption}`}>Deductions from gross Total Income.</p>
        <p className={`${styles.aboutoption}`}>Salient Features/Provisions Related to VAT and Services Tax</p>
        
        <p className={`${styles.aboutheading2}`}>Auditing :</p>
        <p className={`${styles.aboutoption}`}>Company Audit: Audit related to Divisible Profits, Dividends, Special investigations, Tax audit.</p>
        <p className={`${styles.aboutoption}`}>Audit of banking, Insurance, Non-Profit Organization and Charitable
            societies/Trusts/Organizations.</p>

        <p className={`${styles.aboutheading2} text-center`}>
           Financial Management, Financial Institutions and Markets
        </p> 

        <p className={`${styles.aboutheading2} `}>
           Financial Management :
        </p>

       <p className={`${styles.aboutoption}`}> Finance Function : Nature, Scope and Objectives of Financial Management : Risk and Return
        relationship.</p>
       
       <p className={`${styles.aboutoption}`}>Tools of Financial Analysis: Ratio Analysis, Funds-Flow and Cash-Flow Statement.</p>
       <p className={`${styles.aboutoption}`}>Capital Budgeting Decisions: Process, Procedures and Appraisal Methods. Risk and Uncertainty
        Anlysis and Methods.</p>

        <p className={styles.aboutoption}>
        Cost of Capital : Concept, Computation of Specific Costs and Weighted Average Cost of Capital. 
        CAPM as a Tool of Determining Cost of Equity Capital.
        </p>

        <p className={`${styles.aboutoption}`}>
        Financing Decisions: Theories of Capital Structure — Net Income (NI) Approach.
        </p>

        <p className={`${styles.aboutoption}`}>
        Net Operating Income (NOI) Approach, MM Approach and Traditional Approach. Designing of Capital
        Structure: Types of Leverages (Operating, Financial and Combined), EBIT-EPS Analysis, and other
        Factors.
        </p>

        <p className={`${styles.aboutoption}`}>
        Dividend Decisions and Valuation of Firm : Walter’s Model, MM Thesis, Gordan’s Model, 
        Lintner’s Model. Factors Affecting Dividend Policy.
        </p>

        <p className={`${styles.aboutoption}`}>
        Working Capital Management: Planning of Working Capital. Determinants of Working Capital. 
        Components of Working Capital — Cash, Inventory and Receivables.
        </p>

        <p className={`${styles.aboutoption}`}>
        Corporate Restructuring with focus on Mergers and Acquisitions (Financial aspect only).
        </p>

        <p className={`${styles.aboutheading2} `}>Financial Markets and Institutions :</p>

        <p className={`${styles.aboutoption}`}>Indian Financial System: An Overview</p>
        <p className={`${styles.aboutoption}`}>Money Markets: Participants, Structure and Instruments. Commercial Banks. Reforms in Banking
           Sector. Monetary and Credit Policy of RBI. RBI as a Regulator.</p>
        <p className={`${styles.aboutoption}`}>Capital Market : Primary and Secondary Market. Financial Market Instruments and Innovative Debt
           Instruments; SEBI as a Regulator.</p>
        <p className={`${styles.aboutoption}`}> Financial Services : Mutual Funds, Venture Capital, Credit Rating Agencies, Insurance and IRDA.</p>   
        
      </div>
    </div>

{/* Commerce and Accountancy II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
      Commerce and Accountancy - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      >
        <p className={`${styles.aboutheading2} text-center`}>
            Organisation Theory and Behaviours, Human Resource Management and Industrial Relations
        </p>

        <p className={`${styles.aboutheading2} `}>
            Organisation Theory  :
        </p>

        <p className={`${styles.aboutoption}`}>
            Nature and Concept of Organisation; External Environment of Organisation—Technological, Social,
            Political, Ecomomical and Legal; Organizational Goals Primary and Secondary Goals, Single and
            Multiple Goals; Management by Objectives.
        </p>

        <p className={`${styles.aboutoption}`}>Evolution of Organisation theory : Classical Neo-classical and system approach.</p>

        <p className={`${styles.aboutoption}`}>Modern Concepts of Organisation Theory : Organisational Design, Organisational Structure and
           Organisational Culture
        </p>

        <p className={`${styles.aboutoption}`}>Organisational Design—Basic Challenges; Differentiation and Intergration Process; Centralization
           and Decentralization Process; Standardization/Formalization and Mutual Adjustment. Coordinating
           Formal and Informal Organizations. Mechanistic and Organic Structures
        </p>

        <p className={`${styles.aboutoption}`}> Designing Organizational structures—Authority and Control; Line and Staff Functions,
            Specialization and Coordination. Types of Organization Structure—Functional. Matrix Structure,
            Project Structure. Nature and Basis of Power, Sources of Power, Power Structure and Politics. Impact
            of Information Technology on Organizational Design and Structure.
        </p>   

        <p className={`${styles.aboutoption}`}>Managing Organizational Culture.</p>

        <p className={`${styles.aboutheading2} `}>
           Organisation Behaviour :
        </p>

        <p className={`${styles.aboutoption}`}>Meaning and Concept; Individual in organization: Personality, Theories, and Determinants;
            Pereception Meaning and Process.
        </p>
        <p className={`${styles.aboutoption}`}>
            Motivation : Concepts, Theories and Applications. Leadership—Theories and Styles. Quality of Work
            Life (QWL): Meaning and its impact on Performance, Ways of its Enhancement. Quality Circles (QC)—
            Meaning and their Importance. Management of Conflicts in Organizations. Transactional Analysis,
            Organizational Effectiveness, Management of Change.
        </p>

        <p className={`${styles.aboutheading2} text-center`}>Human Resources Management and Industrial Relations</p>
        <p className={`${styles.aboutheading2} `}> Human Resources Management (HRM) :</p>
        <p className={`${styles.aboutoption}`}>Meaning Nature and Scope of HRM, Human Resource Planning, Job Analysis, Job Description, Job
            Specification, Recruitment Process, Selection Process, Orientational and Placement, Training and
            Development Process, Performance Appraisal and 360° Feed Back, Salary and Wage Administration,
            Job Evaluation, Employee Welfare, Promotions, Transfers and Separations.
        </p>
        <p className={`${styles.aboutheading2}`}>Industrial Relations (IR) :</p>

        <p className={`${styles.aboutoption}`}>Meaning, Nature, Importance and Scope of IR, Formation of Trade Union, Trade Union Legislation,
           Trade Union Movement in India. Recognition of Trade Unions, Problems of Trade Unions in India.Impact of Liberalization on Trade Union Movement.
        </p>
        <p className={`${styles.aboutoption}`}>Nature of Industrial Disputes: Strikes and Lockouts, Causes of Disputes, Prevention and Settlement of Disputes.</p>
        
        <p>Worker’s Participation in Management: Philosophy, Rationale, Present Day Status and future Prospects.</p>

        <p>Adjudication and Collective Bargaining.</p>
        <p>Industrial Relations in Public Enterprises Absenteeism and Labour Turnover in Indian Industries
        and their Causes and Remedies.</p>
        <p>ILO and its Functions.</p>




      </div>
    </div>
  </div>
</div>

{/* 18. STATISTICS  */} 
 
<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        18</span> STATISTICS 
    </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
       Statistics - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
       
    
    <p className={`${styles.aboutheading2} `}> 1. Probability :</p>

    <p className={`${styles.aboutheading} `}>
        Sample space and events, probability measure and probability space, random variable as a measurable function.
    </p> 

    <p className={`${styles.aboutheading} `}>  
        distribution function of a random variable, discrete and continuous-type random variable, probability mass
        function, probability density function, vector-valued random variable, marginal and conditional
        distributions, stochastic independence of events and of random variables, expectation and moments of a
        random variable, conditional expectation, convergence of a sequence of random variable in distribution, in
        probability, in path mean and almost everywhere, their criteria and inter-relations, Chebyshev’s inequality
        and Khintchine’s weak law of large numbers, strong law of large numbers and Kolmogoroffs theorems,
        probability generating function, moment generating function, characteristic function, inversion theorem,
        Linderberg and Levy forms of central limit theorem, standard discrete and continuous probability
        distributions.
    </p> 

    <p className={`${styles.aboutheading2} `}>2. Statistical Inference:</p>

    <p className={`${styles.aboutheading} `}>
        Consistency, unbiasedness, efficiency, sufficiency, completeness, ancillary statistics, factorization theorem,
        exponential family of distribution and its properties, uniformly minimum variance unbiased (UMVU)
        estimation, Rao Blackwell and Lehmann-Scheffe theorems, Cramer-Rao inequality for single Parameter.
    </p>

    <p className={`${styles.aboutheading} `}>
        Estimation by methods of moments, maximum likelihood, least squares, minimum chisquare and modified
        minimum chisquare, properties of maximum likelihood and other estimators, asymptotic efficiency, prior
        and posterior distributions, loss function, risk function, and minimax estimator. Bayes estimators.
    </p>

    <p className={`${styles.aboutheading} `}>
        Non-randomised and randomised tests, critical function, MP tests, Neyman-Pearson lemma, UMP tests,
        monotone likelihood ratio: similar and unbiased tests, UMPU tests for single paramet likelihood ratio test
        and its asymptotic distribution. Confidence bounds and its relation with tests.
    </p>

    <p className={`${styles.aboutheading} `}>
        Kolmogorov’s test for goodness of fit and its consistency, sign test and its optimality. Wilcoxon signedranks
        test and its consistency, Kolmogorov-Smirnov two sample test, run test, Wilcoxon-Mann-Whitney test and
        median test, their consistency and asymptotic normality.
    </p>

    <p className={`${styles.aboutheading} `}>
        Wald’s SPRT and its properties, Oc and ASN functions for tests regarding parameters for Bernoulli, Poisson,
        normal and exponential distributions. Wald’s fundamental identity.
    </p>

    <p className={`${styles.aboutheading2} `}>
        3. Linear Inference and Multivariate Analysis :
    </p>

     <p className={`${styles.aboutheading} `}>
        Linear statistical models, theory of least squares and analysis of variance, Gauss-Markoff theory, normal
        equations, least squares estimates and their precision, test of significance and interval estimates based on
        least squares theory in oneway, two-way and three-way classified data, regression analysis, linear
        regression, curvilinear regression and orthogonal polynomials, multiple regression, multiple and partial
        correlations, estimation of variance and covariance components, multivariate normal distribution,
        Mahalanobis’s D2 and Hotelling’s T2 statistics and their applications and properties, discriminant analysis,
        canonical correlations, principal component analysis.
     </p>

    <p className={`${styles.aboutheading2} `}>
       4. Sampling Theory and Design of Experiments :
    </p>
 
    <p className={`${styles.aboutheading} `}> 
        An outline of fixed-population and super-population approaches, distinctive features of finite population
        sampling, propability sampling designs, simple random sampling with and without replacement, stratified
        random sampling, systematic sampling and its efficacy, cluster sampling, twostage and multi-stage
        sampling, ratio and regression methods of estimation involving one or more auxiliary variables, two-phase
        sampling, probability proportional to size sampling with and without replacement, the Hansen-Hurwitz and
        the HorvitzThompson estimators, non-negative variance estimation with reference to the Horvitz-Thompson
        estimator, non-sampling errors.
    </p>
 
    <p className={`${styles.aboutheading}`}>
        Fixed effects model (two-way classification) random and mixed effects models (two-way classification with
        equal observation per cell), CRD, RBD, LSD and their analyses, incomplete block designs, concepts of
        orthogonality and balance, BIBD, missing plot technique, factorial experiments and 24 and 32, confounding
        in factorial experiments, split-plot and simple lattice designs, transformation of data Duncan’s multiple
        range test.
    </p>

 </div>
</div>

{/* Statistics   II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
         Statistics - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", 
            textAlign: "justify", 
            }}
      > 
      
        <p className={`${styles.aboutheading2}`}>
           1. Industrial Statistics
        </p>
              
        <p className={`${styles.aboutheading} `}>  
            Process and product control, general theory of control charts, different types of control charts for variables
            and attributes, X, R, s, p, np and charts, cumulative sum chart. Single, double, multiple and sequential
            sampling plans for attributes, OC, ASN, AOQ and ATI curves, concepts of producer’s and consumer’s risks,
            AQL, LTPD and AOQL, Sampling plans for variables, Use of Dodge-Romin tables.
        </p>

        <p className={`${styles.aboutheading} `}> 
            Concept of reliability, failure rate and reliability functions, reliability of series and parallel systems and
            other simple configurations, renewal density and renewal function, Failure models: exponential, Weibull,
            normal, lognormal. Problems in life testing, censored and truncated experiments for exponential models.
        </p>

        <p className={`${styles.aboutheading2} `}>
          2. Optimization Techniques :
        </p>

        <p className={`${styles.aboutheading} `}>
            Different types of models in Operations Research, their construction and general methods of solution, simulation and Monte-Carlo methods formulation of Linear Programming (LP) problem, simple LP model
            and its graphical solution, the simplex procedure, the two-phase metbod and the M-technique with artificial
            variables, the duality theory of LP and its economic interpretation, sensitivity analysis, transpotation and
            assignment problems, rectangular games, two-person zerosum games, methods of solution (graphical and
            algebraic).
        </p>

        <p className={`${styles.aboutheading} `}>
            Replacement of failing or deteriorating items, group and individual replacement policies, concept of scientific
            inventory management and analytical structure of inventory problems, simple models with deterministic
            and stochastic demand with and without lead time, storage models with particular reference to dam type.
            Homogeneous discrete-time Markov chains, transition probability matrix, classification of states and ergodic
            theorems, homogeneous continuous-time Markov chains, Poisson process, elements of queuing theory,
            M/MI, M/M/K, G/M/l and M/G/1 queues. <br/>
            Solution of statistical problems on computers using wellknown statistical software packages like SPSS.
        </p>
 
        <p className={`${styles.aboutheading2} `}>
           3. Quantitative Economics and Official Statistics:
        </p>

        <p className={`${styles.aboutheading} `}>
            Determination of trend, seasonal and cyclical components, Box-Jenkins method, tests for stationary series,
            ARIMA models and determination of orders of autoregressive and moving average components, fore-casting.
            Commonly used index numbers - Laspeyre’s, Paasche’s and Fisher’s ideal index numbers, cham-base index
            number, uses and limitations of index numbers, index number of wholesale prices, consumer price,
            agricultural production and industrial production, test fot index numbers -proportionality, time-reversal,
            factor-reversal and circular.
        </p>

        <p className={`${styles.aboutheading} `}>
            General linear model, ordinary least square and generalized least squares methods of estimation, problem
            of multi-collinearity, consequences and solutions of multi-collinearity, autocorrelation and its
            consequences, heteroscedasticity of disturbances and its testing, test for independence of disturbances
            concept of structure and model for simultaneous equations, problem of identification-rank and order
            conditions of identifiability, two-stage least sauare method of estimation.
        </p>

        <p className={`${styles.aboutheading} `}>
            Present official statistical system in India relating to population, agriculture, industrial production, trade
            and prices, methods of collection of official statistics, their reliability and limitations, principal publications
            containing such statistics, various official agencies responsible for data collection and their main functions.
        </p>

        <p className={`${styles.aboutheading2} `}>
            4. Demography and Psychometry :
        </p>

        <p className={`${styles.aboutheading} `}>
            Demographic data from census, registration, NSS other surveys, their limitations. and uses, definition,
            construction and uses of vital rates and ratios, measures of fertility, reproduction rates, morbidity rate,
            standardized death rate, complete and abridged life tables, construction of life tables from vital statistics
            and census returns, uses of life tables, logistic and other population growth curves, fitting a logistic curve,
            population projection, stable population, quasi-stable population, techniques in estimation of demographic
            parameters, standard classification by cause of death, health surveys and use of hospital statistics.
        </p>

        <p className={`${styles.aboutheading} `}>
            Methods of standardisation of scales and tests, Z-scores, standard scores, T-scores, percentile scores,
            intelligence quotient and its measurement and uses, validity and reliability of test scores and its
            determination, use of factor analysis and path analysis in psychometry.
        </p>

      </div>
    </div>
  </div>
</div>

{/* 19.  ANIMAL HUSBANDRY AND VETERINARY SCIENCE */}

<div className="container pt-5">
     <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        19 </span> ANIMAL HUSBANDRY AND VETERINARY SCIENCE
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     

      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
        <p className={`${styles.aboutheading2}`}>1. Animal Nutrition:</p>
        <p className={`${styles.aboutoption}`}>
            Partitioning of food energy within the animal. Direct and indirect calorimetry. Carbon—nitrogen
            balance and comparative slaughter methods. Systems for expressing energy value of foods in
            ruminants, pigs and poultry. Energy requirements for maintenance, growth, pregnancy, lactation,
            egg, wool, and meat production.
        </p>

        <p className={`${styles.aboutoption}`}>
            Latest advances in protein nutrition. Energy protein inter-relationships. Evaluation of protein
            quality. Use of NPN compounds in ruminant diets. Protein requirements for maintenance, growth,
            pregnancy, lactation, egg, wool and meat production. 
        </p>

        <p className={`${styles.aboutoption}`}>
            Major and trace minerals—Their sources, physiological functions and deficiency symptoms. Toxic
            minerals. Mineral interactions. Role of fatsoluble and water—soluble vitamins in the body, their
            sources and deficiency symptoms.
        </p>

        <p className={`${styles.aboutoption}`}>
            Feed additives—methane inhibitors, probiotics, enzymes, antibiotics, hormones, oligosaccharides,
            antioxidants, emulsifiers, mould inhibitors, buffers etc. Use and abuse of growth promoters like
            harmones and antibiotics—latest concepts
        </p>

        <p className={`${styles.aboutoption}`}>
            Conservation of fodders. Storage of feeds and feed ingredients. Recent advances in feed technology
            and feed processing. Anti-nutritional and toxic factors present in livestock feeds. Feed analysis and
            quality control. Digestibility trials—direct, indirect and indicator methods. Predicting feed intake in
            grazing animals.
        </p>

        <p className={`${styles.aboutoption}`}>
            Advances in ruminant nutrition. Nutrient requirements. Balanced rations. Feeding of calves,
            pregnant, work animals and breeding bulls. Strategies for feeding milch animals during different
            stages of lactation cycle. Effect of feeding on milk composition. Feeding of goats for meat and milk
            production. Feeding of sheep for meat and wool production.
        </p>

        <p className={`${styles.aboutoption}`}>
            Swine Nutrition. Nutrient requirements. Creep, starter, grower and finisher rations. Feeding of pigs
            for lean meat production. Low cost rations for swine.
        </p>

        <p className={`${styles.aboutoption}`}>
            Poultry nutrition. Special features of poultry nutrition. Nutrient requirements for meat and egg
            production. Formulation of rations for different classes of layers and broilers.
        </p>

        <p className={`${styles.aboutheading2}`}>2. Animal Physiology:</p>

        <p className={`${styles.aboutoption}`}>
            Physiology of blood and its circulation, respiration; excretion. Endocrine glands in health and disease.
        </p>

        <p className={`${styles.aboutoption}`}>
            Blood constituents.—Properties and functions-blood cell formation—Haemoglobin synthesis and
            chemistry-plasma proteins production, classification and properties, coagulation of blood;
            Haemorrhagic disorders—anti-coagulants—blood groups—Blood volume—Plasma expanders-Buffer
            systems in blood. Biochemical tests and their significance in disease diagnosis
        </p>

        <p className={`${styles.aboutoption}`}>
            Circulation.—Physiology of heart, cardiac cycle, heart sounds, heart beat, electrocardiograms. Work
            and efficiency of heart—effect of ions on heart function-metabolism of cardiac muscle, nervous and
            chemical regulation of heart, effect of temperature and stress on heart, blood pressuer and
            hypertension, osmotic regulation, arterial pulse, vasomotor regulation of circulation, shock.
            Coronary and pulmonary circulation, Blood-Brain barrier Cerebrospinal fluid-circulation in birds.
        </p>

        <p className={`${styles.aboutoption}`}>
            Respiration.—Mechanism of respiration, Transport and exchange of gases-neural control of
            respiration-Chemo-receptors-hypoxia-respiration in birds.
        </p>

        <p className={`${styles.aboutoption}`}>
            Excretion.—Structure and function of kidney-formation of urine-methods of studying renal function
            renal regulation of acid-base balance: physiological constituents of urine-renal failure-passive
            venous congestion-Urinary secretion in chicken-Sweat glands and their function. Bio-chemical test
            for urinary dysfunction.
        </p>

        <p className={`${styles.aboutoption}`}>
            Endocrine glands.—Functional disorders—their symptoms and diagnosis. Synthesis of hormones,
            mechanism and control of secretion—hormonal receptors-classification and function.
        </p>

        <p className={`${styles.aboutoption}`}>
            Growth and Animal Production.—Prenatal and postnatal growth, maturation, growth curves,
            measures of growth, factors affecting growth, conformation, body composition, meat quality.
        </p>

        <p className={`${styles.aboutoption}`}>
            Physiology of Milk Production, Reproduction and Digestion.—Current status of hormonal control of
            mammary development, milk secretion and milk ejection. Male and Female reproductive organs,
            their components and functions. Digestive organs and their functions.
        </p>

        <p className={`${styles.aboutoption}`}> 
            Environmental Physiology.—Physiological relations and their regulation; mechanisms of adaptation,
            environmental factors and regulatory mechanisms involved in animal behaviour, climatology—
            various parameters and their importance. Animal ecology. Physiology of behaviour. Effect of stress
            on health and production.
        </p>

        <p className={`${styles.aboutheading2}`}>3. Animal Reproduction:</p>

        <p className={`${styles.aboutoption}`}>
            Semen quality.—Preservation and Artificial Insemination—Components of semen, composition of
            spermatozoa, chemical and physical properties of ejaculated semen, factors affecting semen in vivo and in
            vitro. Factors affecting semen production and quality, preservation, composition of diluents, sperm
            concentration, transport of diluted semen. Deep freezing techniques in cows, sheep, goats, swine and
            poultry. Detection of oestrus and time of insemination for better conception. Anoestrus and repeat breeding.
        </p>

        <p className={`${styles.aboutheading2}`}>4. Livestock Production and Management:</p>

        <p className={`${styles.aboutoption}`}>
            Commercial Dairy Farming.—Comparison of dairy farming in India with advanced countries.
            Dairying under mixed farming and as specialized farming, economic dairy farming. Starting of a
            dairy farm, Capital and land requirement, organization of the dairy farm. Opportunities in dairy
            farming, factors determining the efficiency of dairy animal. Heard recording, budgeting cost of milk
            production, pricing policy; Personnel Management. Developing Practical and Economic rations for
            dairy cattle; supply of greens throughout the year, feed and fodder requirements of Dairy Farm.
            Feeding regimes for young stock and bulls, heifers and breeding animals; new trends in feeding
            young and adult stock; Feeding records.
        </p>

        <p className={`${styles.aboutoption}`}>
            Commercial meat, egg and wool production.—Development of practical and economic rations for
            sheep, goats, pigs, rabbits and poultry. Supply of greens, fodder, feeding regimes for young and
            mature stock. New trends in enhancing production and management. Capital and land requirements
            and socio-economic concept.
        </p>

        <p className={`${styles.aboutoption}`}>
            Feeding and management of animals under drought, flood and other natural calamities.
        </p> 

        <p className={`${styles.aboutheading2}`}>5. Genetics and Animal Breeding:</p>

        <p className={`${styles.aboutoption}`}>
            History of animal genetics. Mitosis and Meiosis: Mendelian inheritance; deviations to Mendelian
            genetics; Expression of genes; Linkage and crossing over; Sex determination, sex influenced and sex
            limited characters; Blood groups and polymorphism; Chromosome aberrations; Cytoplasmic
            inheritance, Gene and its structure; DNA as a genetic material; Genetic code and protein synthesis;
            Recombinant DNA technology. Mutations, types of mutations, methods for detecting mutations and
            mutation rate, Transgenesis.
        </p>

        <p className={`${styles.aboutoption}`}>
            Population Genetics applied to Animal Breeding—Quantitative Vs. Qualitative traits; Hardy Weinberg
            Law; Population Vs. Individual; Gene and genotypic frequency; Forces changing gene frequency;
            Random drift and small populations; Theory of path coefficient; Inbreeding, methods of estimating
            inbreeding coefficient, systems of inbreeding; Effective population size; Breeding value, estimation
            of breeding value, dominance and epistatic deviation; Partitioning of variation; Genotype X
            environment correlation and genotype X environment interaction; role of multiple measurements;
            Resemblance between relatives.
        </p>

        <p className={`${styles.aboutoption}`}>
            Breeding Systems.—Breeds of livestsock and Poultry. Heritability, repeatability and genetic and
            phenotypic correlations, their methods of estimation and precision of estimates; Aids to selection
            and their relative merits; Individual, pedigree, family and within family selection; Pregnency testing;
            Methods of selection; Construction of selection indices and their uses; Comparative evaluation of
            genetic gains through various selection methods; Indirect selection and correlated response;
            Inbreeding, out breeding, upgrading, cross-breeding and synthesis of breeds; Crossing of inbred
            lines for commercial production; Selection for general and specific combining ability; Breeding for
            threshold characters. Sire index.
        </p>

        <p className={`${styles.aboutheading2}`}>6. Extension:</p>

        <p className={`${styles.aboutoption}`}>
            Basic philosophy, objectives, concept and principles of extension. Different Methods adopted to
            educate farmers under rural conditions. Generation of technology, its transfer and feedback. Problems and
            constraints in transfer of technology. Animal husbandry programmes for rural development.
        </p>

      </div>
    </div>

    {/* ANIMAL HUSBANDRY AND VETERINARY SCIENCE Paper II*/}

     <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", 
            textAlign: "justify", 
            }}
      >
        <p className={`${styles.aboutheading2}`}>1. Anatomy, Pharmacology and Hygiene:</p>
        <p className={`${styles.aboutoption}`}>
            <b>Histology and Histological Techniques :</b> Paraffin embedding technique of tissue processing and
            H.E. staining—Freezing microtomy—Microscopy Bright field microscope and electron microscope.
            Cytology-structure of cell organells and inclusions; cell division-cell types—Tissues and their
            classification-embryonic and adult tissues—Comparative histology of organs—Vascular, Nervous,
            digestive, respiratory, musculo-skeletal and urogenital systems—Endocrine glands—Integuments—
            sense organs.
        </p>

        <p className={`${styles.aboutoption}`}>
            <b>Embryology.</b>—Embryology of vertebrates with special reference to aves and domestic mammals
            gametogenesis-fertilization-germ layers-foetal membranes and placentation-types of placenta in
            domestic mammals-Teratology-twins and twinning-organogenesis-germ layer derivativesendodermal,
            mesodermal and ectodermal derivatives.
        </p>

        <p className={`${styles.aboutoption}`}>
            <b>Bovine Anatomy.</b>—Regional Anatomy : Paranasal sinuses of OX— surface anatomy of salivary
            glands. Regional anatomy of infraorbital, maxillary, mandi-buloalveolar, mental and cornnal nerve
            block. Regional anatomy of paravertebral nerves, pudental nerve, median, ulnar and radial
            nervestibial, fibular and digital nerves—Cranial nerves-structures involved in epidural anaesthesiasuperficial
            lymph nodes-surface anatomy of visceral organs of thoracic, abdominal and pelvic
            cavities-comparative-features of locomotor apparatus and their application in the biomechanics of
            mammalian body.
        </p>

        <p className={`${styles.aboutoption}`}>
            Anatomy of Fowl.—Musculo-skeletal system-functional anatomy in relation to respiration and
            flying, digestion and egg production.
        </p>

        <p className={`${styles.aboutoption}`}>
            pharmacology and therapeutics drugs.—Cellular level of pharmacodynamics and pharmacokinetics. Drugs acting on fluids and electrolyte balance. Drugs acting on Autonomic
            nervous system. Modern concepts of anaesthesia and dissociative anaesthetics. Autocoids.
            Antimicrobials and principles of chemotherapy in microbial infections. Use of hormones in
            therapeutics—chemotherapy of parasitic infections. Drug and economic concerns in the Edible
            tissues of animals—chemotherapy of Neoplastic diseases. Toxicity due to “insecticides, plants,
            metals, non-metals, zootoxins and mycotoxins”.
        </p>

        <p className={`${styles.aboutoption}`}>
            Veterinary Hygiene with reference to water, air and habitation.—Assessment of pollution of
            water, air and soil—Importance of climate in animal health—effect of environment on animal
            function and performance relationship between industrialisation and animal agriculture—animal
            housing requirements for specific categories of domestic animals viz. pregnant cows and sows,
            milking cows, broiler birds—stress, strain and productivity in relation to animal habitation.
        </p> 

        <p className={`${styles.aboutheading2}`}>2. Animal Diseases :</p>

        <p className={`${styles.aboutoption}`}>Etiology, epidemiology pathogenesis, symptoms, post-moretem lesions, diagnosis, and control of infectious diseases of cattle, sheep and goat, horses, pigs and poultry.</p>
        <p className={`${styles.aboutoption}`}>Etiology, epidemiology, symptoms, diagnosis, treatment of production diseases of cattle, horse, pig and poultry.</p>
        <p className={`${styles.aboutoption}`}>Deficiency diseases of domestic animals and birds.</p>
        <p className={`${styles.aboutoption}`}>Diagnosis and treatment of non-specific conditions like impaction, Bloat, Diarrhoea, Indigestion,dehydration, stroke, poisioning.</p>
        <p className={`${styles.aboutoption}`}>Diagnosis and treatment of neurological disorders.</p>
        <p className={`${styles.aboutoption}`}>Principles and methods of immunisation of animals against specific diseases—hard immunity—disease free zones—‘zero’ disease concept—chemoprophylaxis.</p>
        <p className={`${styles.aboutoption}`}>Anaesthesia.—local, regional and general-prenesthetic medication. Symptoms and surgical interference in fractures and dislocation. Hernia, choking abomassal displacement—Caesarian operations. Rumenotomy—Castrations.</p>
        <p className={`${styles.aboutoption}`}>Disease investigation techniques.—Materials for laboratory investigation—Establishment. Animal Health Centres—Disease free zone.  </p>      
      
        <p className={`${styles.aboutheading2}`}>3. Veterinary Public Health :</p>

        <p className={`${styles.aboutoption}`}>
            Zoonoses.—Classification, definition, role of animals and birds in prevalence and transmission of
            zoonotic diseases—occupational zoonotic diseases.
        </p>

        <p className={`${styles.aboutoption}`}>
            Epidemiology.—Principle, definition of epidemiological terms, application of epidemiological
            measures in the study of diseases and disease control. Epidemiological features of air, water and
            food borne infections. OIE regulation, WTO, sanitary and phytosanitary measures.
        </p>
        <p className={`${styles.aboutoption}`}>
            Veterinary Jurisprudence.—Rules and Regulations for improvement of animal quality and
            prevention of animal diseases—State and Central Rules for prevention of animal and animal product
            borne diseases—S.P. C.A.—Veterolegal cases—Certificates—Materials and Methods of collection of
            samples for veterolegal investigation.
       </p>

       <p className={`${styles.aboutheading2}`}>4. Milk and Milk Products Technology :</p>

       <p className={`${styles.aboutoption}`}>
            Market Milk.—Quality, testing and grading of raw milk. Processing, packaging, storing, distribution,
            marketing defects and their control. Preparation of the following milks : Pasteurized, standardized,toned, double toned, sterilized, homogenized, reconstituted, recombined and flavoured milks.
            Preparation of cultured milks, cultures and their management, yoghurt, Dahi, Lassi and Srikhand.
            Preparation of flavoured and sterilized milks. Legal standards. Sanitation requirement for clean and
            safe milk and for the milk plant equipment.
       </p>

       <p className={`${styles.aboutoption}`}>
            Milk Products Technology.—Selection of raw materials, processing, storing, distributing and
            marketing milk products such as Cream, Butter, Ghee, Khoa, Channa, Cheese, condensed,
            evaporated, dried milk and baby food, lce cream and Kulfi; by-products, whey products, butter milk,
            lactose and casein. Testing, grading, judging milk products—BIS and Agmark specifications, legal
            standards, quality control nutritive properties. Packaging processing and operational control.
            Costing of dairy products.
        </p>

        <p className={`${styles.aboutheading2}`}>Meat Hygiene and Technology :</p>
        <p className={`${styles.aboutheading2}`}>Meat Hygiene</p>
        <p className={`${styles.aboutoption}`}>
            Ante mortem care and management of food animals, stunning, slaughter and dressing operations;
            abattoir requirements and designs; Meat inspection procedures and judgement of carcass meat
            cuts—grading of carcass meat cuts—duties and functions of Veterinarians in wholesome meat
            production.
        </p>

        <p className={`${styles.aboutoption}`}>
            Hygienic methods of handling production of meat.—Spoilage of meat and control measures—
            Post- slaughter physicochemical changes in meat and factors that influence them—Quality
            improvement methods—Adulteration of meat and detection—Regulatory provisions in Meat trade
            and Industry.
        </p>

        <p className={`${styles.aboutheading2}`}>Meat Technology</p> 

        <p className={`${styles.aboutoption}`}>
            Physical and chemical characteristics of meat.—Meat emulsions—Methods of preservation of
            meat—Curing, canning, irradiation, packaging of meat and meat products, processing and
            formulations.
        </p>

        <p className={`${styles.aboutoption}`}>
            By-products.—Slaughter house by-products and their utilisation—Edible and inedible by
            products—Social and economic implications of proper utilisation of slaughter house by-products—
            Organ products for food and pharmaceuticals.
        </p>  

        <p className={`${styles.aboutoption}`}>
            Poultry Products Technology.—Chemical composition and nutritive value of poultry meat, preslaughter
            care and management. Slaughtering techniques, inspection, preservation of poultry meat
            and products. Legal and BIS standards.
        </p> 

        <p className={`${styles.aboutoption}`}>
            Structure composition and nutritive value of eggs Microbial spoilage. Preservation and maintenance.
            Marketing of poultry meat, eggs and products.
        </p> 

        <p className={`${styles.aboutoption}`}> 
            Rabbit/Fur Animal farming.—Rabbit meat production. Disposal and utilization of fur and wool and
            recycling of waste by products. Grading of wool. 
        </p> 


      </div>
    </div>
  </div>
</div>

{/* 20. MEDICAL SCIENCE  */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        20 </span> MEDICAL SCIENCE 
    </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Medical Science - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
       
    
    <p className={`${styles.aboutheading2} `}> 1. Human Anatomy :</p>

    <p className={`${styles.aboutheading} `}>
        Applied anatomy including blood and nerve supply of upper and lower limbs and joints of shoulder, hip and knee.
    </p> 

    <p className={`${styles.aboutheading} `}>  
        Gross anatomy, blood supply and lymphatic drainage of tongue, thyroid, mammary gland, stomach, liver,
        prostate, gonads and uterus.
    </p> 

    <p className={`${styles.aboutheading} `}>
        Applied anatomy of diaphragm, perineum and inguinal region. <br/>
        Clinical anatomy of kidney, urinary bladder, uterine tubes, vas deferens.
    </p>

    <p className={`${styles.aboutheading} `}>
       <span className=''style={{fontWeight:"bold" , color:"#c30505"}}> Embryology : </span> Placenta and placental barrier. Development of heart, gut, kidney. uterus, ovary, testis and
        their common congenital abnormalities.
    </p>

    <p className={`${styles.aboutheading} `}>
       <span className=''style={{fontWeight:"bold" , }}> Central and Peripheral Autonomic Nervous System : </span>Gross and clinical anatomy of ventricles of brain,
        circulation of cerebrospinal fluid; Neural pathways and lesions of cutaneous sensations, hearing and
        vision; Cranial nerves distribution and clinical significance; Components of autonomic nervous system.
    </p>

    <p className={`${styles.aboutheading2} `}>2. Human Physiology :</p>

    <p className={`${styles.aboutheading} `}>
        Conduction and transmission of impulse, mechanism of contraction, neuromuscular transmission, reflexes,
        control of equilibrium, posture and muscle tone, descending pathways, functions of cerebellum, basal
        ganglia, Physiology of sleep and consciousness.     
    </p>

    <p className={`${styles.aboutheading} `}>
        <span className=''style={{fontWeight:"bold" , color:"#c30505"}}> Endocrine System : </span>Mechanism of action of hormones; formation, secretion, transport, metabolism,
        function and regulation of secretion of pancreas and pituitary gland.
    </p>

    <p className={`${styles.aboutheading} `}>
       <span className=''style={{fontWeight:"bold" , color:"#c30505"}}> Physiology of Reproductive System :</span> Pregnancy menstrual cycle, lactation, pregnancy.
    </p>

    <p className={`${styles.aboutheading} `}>
       <span className=''style={{fontWeight:"bold" , color:"#c30505"}}> Blood : </span>Development, regulation and fate of blood cells. <br/>
        Cardio-vascular,cardiac output, blood pressure, regulation of cardiovascular functions.
    </p>
 
    

    <p className={`${styles.aboutheading2} `}> 3. Biochemistry :</p>

    <p className={`${styles.aboutheading} `}>
        Organ function tests—liver, kidney, thyroid Protein synthesis. <br/>
        Vitamins and minerals.<br/>
        Restriction fragment length.<br/>
        polymorphism (RFLP).<br/>
        Polymerase chain reaction (PCR).<br/>
        Radio-immunoassays (RIA).

    </p>

   
    <p className={`${styles.aboutheading2} `}>4. Pathology :</p>

    <p className={`${styles.aboutheading} `}> 
        Inflammation and repair, disturbances of growth and cancer, Pathogenesis and histopathology of rheumatic
        and ischaemic heart disease and diabetes mellitus. Differentiation between benign, malignant, primary and
        metastatic malignancies, Pathogenesis and histopathology of bronchogenic carcinoma, carcinoma breast,
        oral cancer, cancer cervix, leukemia, Etiology, pathogenesis and histopathology of—cirrhosis liver,
        glomerulonephritis, tuberculosis, acute osteomyelitis.
    </p>
 
    <p className={`${styles.aboutheading2}`}>5. Microbiology :</p>

    <p className={`${styles.aboutheading2}`}>Humoral and cell mediated immunity.</p>

    <p className={`${styles.aboutheading} `}>
        Diseases caused by and laboratory diagnosis of —
    </p>
       
        <ul className='list-unstyled'>
          <li>* Meningococcus, Saimonella</li>
          <li>* Shigella, Herpes, Dengue, Polio</li>
          <li>* HIV/AIDS, Malaria, E. Histolytica, Giardia</li>
          <li>* Candida, Cryptococcus, Aspergillus</li>
        </ul>


    <p className={`${styles.aboutheading2}`}>6. Pharmacology : </p>
       
    <p className={`${styles.aboutheading}`}> 
       Mechanism of action and side effects of the following drugs :
    </p>
         <ul className='list-unstyled'>
          <li>* Antipyretics and analgesics, Antibiotics,</li>
          <li>* Antimalaria, Antikala-azar, Antidiabetics,</li>
          <li>* Antihypertensive, Antidiuretics, General and cardiac vasodilators, Antiviral, Antiparasitic, Antifungal, Immunosuppressants,</li>
          <li>* Anticancer.</li>
        </ul>

    <p className={`${styles.aboutheading2}`}> 
        7. Forensic Medicine and Toxicology
    </p> 

    <p className={`${styles.aboutheading}`}> 
        Forensic examination of injuries and wounds; Examination of blood and seminal stains; Poisoning, sedative
        overdose, hanging, drowning, burns, DNA and finger print study.
    </p>

 </div>
</div>

{/* Medical Science  II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
         Medical Science  - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", 
            textAlign: "justify", 
            }}
      > 
      
        <p className={`${styles.aboutheading2}`}>1. General Medicine </p>
              
        <p className={`${styles.aboutheading} `}>  
            Etiology, clinical features, diagnosis and principles of management (including prevention) of—Typhoid,
            Rabies, AIDS, Dengue, Kala-azar, Japanese Encephalitis.
        </p>

        <p className={`${styles.aboutheading} `}> 
           Etiology, clinical features, diagnosis and principles of management of : <br/>
           Ischaemic heart disease, pulmonary embolism.<br/>
           Bronchial asthma.<br/>
           Pleural effusion, tuberculosis, Malabsorption syndromes; acid peptic diseases, Viral hepatitis and cirrhosis of liver.<br/>

           Glomerulonephritis and pyelonephritis, renal failure, nephrotic syndrome, renovascular hypertension,
           complications of diabetes mellitus, coagulation disorders, leukaemia, Hypo and hyper thyrodism, meningitis
           and encephalitis<br/>

           Imaging in medical problems, ultrasound, echo- cardiogram, CT scan, MRI. <br/>
           Anxiety and Depressive Psychosis and schizophrenia and ECT.
        </p>

        <p className={`${styles.aboutheading2} `}> 2. Paediatrics</p>

        <p className={`${styles.aboutheading} `}>
            Immunization, Baby friendly hospital, congenital cyanotic heart disease, respiratory distress syndrome,
            broncho— pneumonias, kernicterus. IMNCI classification and management, PEM grading and management.
            ARI and Diarrhea of under five and their management.
        </p>

        <p className={`${styles.aboutheading2} `}>3. Dermatology</p>

        <p className={`${styles.aboutheading} `}>
            Psoriasis, Allergic dermatitis, scabies, eczema, vitiligo, Stevan Johnson’s syndrome, Lichen Planus.
        </p>

        <p className={`${styles.aboutheading2} `}>4. General Surgery</p>
 
        <p className={`${styles.aboutheading} `}>
            Clinical features, causes, diagnosis and principles of management of cleft palate, harelip. <br/>
            Laryngeal tumour, oral and esophageal tumours. <br/>
            Peripheral arterial diseases, varicose veins, coarctation of aorta.<br/>
        </p>

        <p className={`${styles.aboutheading} `}>
            Tumours of Thyroid, Adrenal, Glands.<br/>
            Abscess cancer, fibroadenoma and adenosis of breast.<br/>
            Bleeding peptic ulcer, tuberculosis of bowel, ulcerative colitis, cancer stomach.<br/>
            Renal mass, cancer prostatie.<br/>
            Haemothorax, stones of Gall bladder, Kidney, Ureter and Urinary Bladder.<br/>
            Management of surgical conditions of Rectum, Anus and Anal canal, Gall bladder and Bile ducts.<br/>
            Splenomegaly, cholecystitis, portal hypertension, liver abscess, peritonitis, carcinoma head of pancreas.<br/>
            Fractures of spine, Colles’ fracture and bone tumors.<br/>
            Endoscopy.<br/>
            Laprascopic Surgery.<br/>

        </p>

        <p className={`${styles.aboutheading2} `}>6. Community Medicine (Preventive and Social Medicine)</p>

        <p className={`${styles.aboutheading}`}>
           Principles, methods approach and measurements of Epidemiology. <br/>
           Nutrition, nutritional diseases/diorders and Nutrition Programmes.<br/>
           Health information Collection, Analysis and Presentation.<br/>
        </p>

        <p className={`${styles.aboutheading}`}>
            Objectives, components and critical analysis of National programmes for control/eradication of :<br/>
            Malaria, Kala-azar, Filaria and Tuberculosis,<br/>
            HIV/AIDS, STDs and Dengue.<br/>
        </p>

        <p className={`${styles.aboutheading}`}>
            Critical appraisal of Health care delivery system.<br/>
            Health management and administration; Techniques, Tools, Programme Implementation and Evaluation.<br/>
            Objectives, Components, Goals and Status of Reproductive and Child Health, National Rural Health Mission
            and Millennium Development Goals.<br/>
            Management of hospital and industrial waste.
        </p>

     </div>
    </div>
  </div>
</div>

{/* 21. PHILOSOPHY  */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        21 </span> PHILOSOPHY 
    </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
       Philosophy - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
       
    
    <p className={`${styles.aboutheading2} `}> History and Problems of Philosophy</p>

    <p className={`${styles.aboutheading} `}>
      1. Plato and Aristotle : Ideas; Substance; Form and Matter; Causation; Actuality and Potentiality.
    </p> 

    <p className={`${styles.aboutheading} `}>  
      2. Rationalism (Descartes, Spinoza, Leibniz); Cartesian Method and Certain Knowledge; Substance;
        God; Mind-Body Dualism; Determinism and Freedom.
    </p> 

    <p className={`${styles.aboutheading} `}>
      3. Empiricism (Locke, Berkeley, Hume) : Theory of Knowledge; Substance and Qualities; Self and God;
        Scepticism.
    </p>

    <p className={`${styles.aboutheading} `}>
      4. Kant: Possibility of Synthetic a priori Judgments; Space and Time; Categories; Ideas of Reason;
        Antinomies; Critique of Proofs for the Existence of God.
    </p>

    <p className={`${styles.aboutheading} `}>
       5. Hegel : Dialectical Method; Absolute Idealism.
    </p>

    <p className={`${styles.aboutheading} `}>
        6. Moore, Russell and Early Wittgenstein : Defence of Commonsense; Refutation of Idealism; Logical
        Atomism; Logical Constructions; Incomplete Symbols; Picture Theory of Meaning; Sying and Showing.   
    </p>

    <p className={`${styles.aboutheading} `}>
        7. Logical Positivism : Verification Theory of Meaning; Rejection of Metaphysics; Linguistic Theory of
        Necessary Propositions.
    </p>

    <p className={`${styles.aboutheading} `}>
       8. Later Wittgenstein : Meaning and Use; Language-games; Critique of Private Language.
    </p>

    <p className={`${styles.aboutheading} `}>
       9. Phenomenology (Husserl): Method; Theory of Essences; Avoidance of Psychologism.
    </p>
 
    <p className={`${styles.aboutheading} `}> 
       10. Existentialism (Kierkegaard, Sarte, Heidegger): Existence and Essence; Choice, Responsibility and
        Authentic Existence; Being-in-the-world and Temporality.
    </p>
 
    <p className={`${styles.aboutheading}`}>
        11. Quine and Strawson : Critique of Empiricism; Theory of Basic Particulars and Persons.
    </p>

    <p className={`${styles.aboutheading}`}>
        12. Carvaka : Theory of Knowlegde; Rejection of Transcendent Entities.
    </p>

    <p className={`${styles.aboutheading} `}>
        13. Jainism : Theory of Reality; Saptabhanginaya; Bondage and Liberation.
    </p>
    
    <p className={`${styles.aboutheading}`}>
        14. Schools of Buddhism : Prat Ityasamutpada; Ksanikavada, Nairatmyavada.
    </p>
       
    <p className={`${styles.aboutheading}`}> 
        15. Nyaya—Vaiesesika : Theory of Categories; Theory of Appearance; Theory of Pramana; Self, Liberation;
        God; Proofs for the Existence of God; Theory of Causation; Atomistic Theory of Creation.
    </p>
         
    <p className={`${styles.aboutheading}`}> 
       16. Samkhya; Prakrit; Purusa; Causation; Liberation.
    </p> 

    <p className={`${styles.aboutheading}`}> 
        17. Yoga; Citta; Cittavrtti; Klesas; Samadhi; Kaivalya
    </p>

    <p className={`${styles.aboutheading}`}> 
        18. Mimamsa: Theory of Knowlegde.
    </p>

    <p className={`${styles.aboutheading}`}>
        19. Schools of Vedanta : Brahman; Isvara; Atman; Jiva; Jagat; Maya; Avida; Adhyasa; Moksa;
        Aprthaksiddhi; Pancavidhabheda
    </p>

    <p className={`${styles.aboutheading}`}>
        20. Aurobindo: Evolution, Involution; Integral Yoga.
    </p>

 </div>
</div>

{/* Philosophy  II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
         Philosophy  - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", 
            textAlign: "justify", 
            }}
      > 
      
        <p className={`${styles.aboutheading2}`}>Socio-Political Philosophy</p>
              
        <p className={`${styles.aboutheading} `}>  
           1. Social and Political ldeals : Equality, Justice, Liberty.
        </p>

        <p className={`${styles.aboutheading} `}> 
           2. Sovereignty : Austin, Bodin, Laski, Kautilya.
        </p>

        <p className={`${styles.aboutheading} `}>
           3. Individual and State : Rights; Duties and Accountability.
        </p>

        <p className={`${styles.aboutheading} `}>
            4. Forms of Government : Monarchy; Theocracy and Democracy.
        </p>

        <p className={`${styles.aboutheading} `}>
            5. Political Ideologies: Anarchism; Marxism and Socialism.
        </p>
 
        <p className={`${styles.aboutheading} `}>
            6. Humanism; Secularism; Multi-culturalism.
        </p>

        <p className={`${styles.aboutheading} `}>
           7. Crime and Punishment : Corruption, Mass Violence, Genocide, Capital Punishment.
        </p>

        <p className={`${styles.aboutheading} `}>
           8. Development and Social Progress.
        </p>

        <p className={`${styles.aboutheading}`}>
           9. Gender Discrimination : Female Foeticide, Land and Property Rights; Empowerment.
        </p>

        <p className={`${styles.aboutheading}`}>
          10. Caste Discrimination : Gandhi and Ambedkar.
        </p>

        <p className={`${styles.aboutheading2}`}>Philosophy of Religion</p>

        <p className={`${styles.aboutheading}`}>1. Notions of God : Attributes; Relation to Man and the World. (Indian and Western). </p>
        <p className={`${styles.aboutheading}`}>2. Proofs for the Existence of God and their Critique (Indian and Western).</p>
        <p className={`${styles.aboutheading}`}>3. Problem of Evil. </p>
        <p className={`${styles.aboutheading}`}>4. Soul : Immortality; Rebirth and Liberation.</p>
        <p className={`${styles.aboutheading}`}>5. Reason, Revelation and Faith.</p>
        <p className={`${styles.aboutheading}`}>6. Religious Experience : Nature and Object (Indian and Western).</p>
        <p className={`${styles.aboutheading}`}>7. Religion without God.</p>
        <p className={`${styles.aboutheading}`}>8. Religion and Morality.</p>
        <p className={`${styles.aboutheading}`}>9. Religious Pluralism and the Problem of Absolute Truth</p>
        <p className={`${styles.aboutheading}`}>10. Nature of Religious Language : Analogical and Symbolic; Cognitivist and Non-cognitive.</p>

      </div>
    </div>
  </div>
</div>

{/* 22. MECHANICAL ENGINEERING */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        22 </span> MECHANICAL ENGINEERING 
    </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Mechanical Engineering - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
       
    
    <p className={`${styles.aboutheading2} `}> 1. Mechanics :</p>

    <p className={`${styles.aboutheading2} `}> 1.1 Mechanics of Rigid Bodies :</p>

    <p className={`${styles.aboutheading} `}>
        Equations of equilibrium in space and its application; first and second moments of area; simple problems
        on friction; kinematics of particles for plane motion; elementary particle dynamics.
    </p>  

    <p className={`${styles.aboutheading2} `}>1.2 Mechanics of Deformable Bodies :</p>
 
    <p className={`${styles.aboutheading} `}>  
        Generalized Hooke’s law and its application; design problems on axial stress, shear stress and bearing
        stress; material properties for dynamic loading; bending shear and stresses in beams; determination of
        principle stresses and strains-analytical and graphical; compound and combined stresses; bi-axial stressesthin
        walled pressure vessel; material behaviour and design factors for dynamic load; design of circular shafts
        for bending and torsional load only; deflection of beam for statically determinate problems; theories of
        failure.
    </p>

    <p className={`${styles.aboutheading2} `}> 2.Engineering Materials :</p>

    <p className={`${styles.aboutheading} `}>
            Basic concepts on structure of solids, common ferrous and non-ferrous materials and their applications;
            heat-treatment of steels; non-metalsplastics, cermics, composite materials and nano-materials.
    </p>

   
    <p className={`${styles.aboutheading2} `}>3.Theory of Machines :</p>

    <p className={`${styles.aboutheading} `}> 
        Kinematic and dynamic analysis of plane mechanisms. Cams, Gears and empicyclie gear trains, flywheels,
        governors, balancing of rigid rotors, balancing of single and multicy- linder engines, linear vibration analysis
        of mechanical systems (single degree of freedom), Critical speeds and whirling of shafts
    </p>
 
    <p className={`${styles.aboutheading2}`}>4. Manufacturing Science :</p>

    <p className={`${styles.aboutheading2}`}>4.1 Manufacturing Process:</p>

    <p className={`${styles.aboutheading} `}>
        Machine tool engineering - Merhant’s force analysis: Taylor’s tool life equation; conventional machining; NC
        and CNC machining process; jigs and fixtures.
    </p>

    <p className={`${styles.aboutheading} `}>
        Non-conventional machining-EDM, ECM, ultrasonic, water jet machining etc.; application of lasers and
        plasmas; energy rate calculations.
    </p>

    <p className={`${styles.aboutheading} `}>
        Forming and welding processes-standard processes. <br/>
        Metrology-concept of fits and tolerances; tools and guages; comparators; inspection of length; position;
        profile and surface finish.
    </p>

    <p className={`${styles.aboutheading2}`}>4.2 Manufacturing Management : </p>
       
    <p className={`${styles.aboutheading}`}> 
        System design: factory location—simple OR models; plant layout-methods based; applications of engineering
        economic analysis and break-even analysis for product selection, process selection and capacity planning;
        predetermined time standards.
    </p>

    <p className={`${styles.aboutheading}`}> 
        System planning; forecasting methods based on regression and decomposition, design and blancing of multi
        model and stochastic assembly lines; inventory management-probablistic inventory models for order time
        and order quanitity determination; JIT systems; strategic sourcing; managing inter plant logistics.
    </p> 

    <p className={`${styles.aboutheading}`}> 
        System operations and control: Scheduling algorithms for job shops; applications of statistical methods for
        product and process quality control applications of control charts for mean, range, percent defective,
        number of defectives and defects per unit; quality cost systems; management of resources, organizations
        and risks in projects. <br/>

        System improvement: Implementation of systems, such as total quality management, developing and
        managing flexible, lean and agile Organizations.
    </p>

 </div>
</div>

{/* Mathematics  II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Mechanical Engineering  - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", 
            textAlign: "justify", 
            }}
      > 
      
        <p className={`${styles.aboutheading2}`}>1. Thermodynamics, Gas Dynamics Turbine : </p>
              
        <p className={`${styles.aboutheading} `}>  
            1.1 Basic concept of First-law and Second law of Thermodynamics; concept of entropy and reversibility;
            availability and unavailability and irreversibility.
        </p>

        <p className={`${styles.aboutheading} `}> 
            1.2 Classification and properties of fluids; incompressible and compressible fluids flows; effect of Mach
            number and compressibility; continuity momentum and energy equations; normal and oblique shocks; one
            dimensional isentropic flow; flow or fluids in duct with frictions that transfer.
        </p>

        <p className={`${styles.aboutheading} `}>
            1.3 Flow through fans, blowers and compressors; axial and centrifugal flow configuration; design of fans
            and compressors; single problems compresses and turbine cascade; open and closed cycle gas turbines;
            work done in the gas turbine; reheat and regenerators.
        </p>
        
        <p className={`${styles.aboutheading2} `}> 2. Heat Transfer :</p>

        <p className={`${styles.aboutheading} `}>
            2.1 Conduction heat transfer—general conduction equation-Laplace, Poisson and Fourier equations;
            Fourier law of conduction; one dimensional steady state heat conduction applied to simple wall, solid and
            hollow cylinder and spheres.
        </p>

        <p className={`${styles.aboutheading} `}>
            2.2 Convection heat transfer—Newton’s law of convection; free and forces convection; heat transfer during
            laminar and turbulent flow of an incompressible fluid over a flat plate; concepts of Nusselt number,
            hydrodynamic and thermal boundary layer their thickness; Prandtl number; analogy between heat and
            momentum transfer—Reynolds, Colbum, Prandtl analogies; heat transfer during laminar and turbulent flow
            through horizontal tubes; free convection from horizontal and vertical plates.
        </p>

        <p className={`${styles.aboutheading} `}>
            2.3 Black body radiation—basic radiation laws such as Stefan-boltzman, Planck distribution, Wein’s
            displacement etc.
        </p>

        <p className={`${styles.aboutheading} `}>
            2.4 Basic heat exchanger analysis; classification of heat exchangers.
        </p>

        <p className={`${styles.aboutheading2} `}>3. Engines :</p>

        <p className={`${styles.aboutheading}`}>
            3.1 Classification, themodynamic cycles of operation; determination of break power, indicated power,
            mechanical efficiency, heat balance sheet, interpretation of performance characteristics, petrol, gas and
            diesel engines.
        </p>

        <p className={`${styles.aboutheading}`}>
            3.2 Combustion in SI and CI engines, normal and abnormal combustion; effect of working parameters on
            knocking, reduction of knocking; Forms of combustion chamber for SI and CI engines; rating of fuels;
            additives; emission.
        </p>

        <p className={`${styles.aboutheading}`}>
            3.3 Different systems of IC engines-fuels; lubricating; cooling and transmission systems. Alternate fuels in
            IC engines.
        </p>

        <p className={`${styles.aboutheading2} `}>4. Steam Engineering :</p>
            
        <p className={`${styles.aboutheading} `}>
            4.1 Steam generation—modified Ranking cycle analysis; Modern steam boilers; steam at critical and
            supercritical pressures; draught equipment; natural and artificial draught; boiler fuels solid, liquid and
            gaseous fuels. Steam turbines—Principle; types; compounding; impulse and reaction turbines; axial thrust.
        </p>

          
        <p className={`${styles.aboutheading2} `}>(5) Partial Differential Equations :</p>

        <p className={`${styles.aboutheading} `}>
            Family of surfaces in three dimensions and formulation of partial differential equations; Solution of
            quasilinear partial differential equations of the first order, Cauchy’s method of characteristics; Linear partial
            differential equations of the second order with constant coefficients, canonical form; Equation of a vibrating
        </p> 

        <p className={`${styles.aboutheading} `}>
            4.2 Steam nozzles—flow of steam in convergent and divergent nozzle pressure at throat for maximum
            discharge with different initial steam conditions such as wet, saturated and superheated, effect of variation
            of back pressure; supersaturated flow of steam in nozzles, Wilson line.
        </p>

        <p className={`${styles.aboutheading} `}>
            4.3 Rankine cycle with internal and external irreversibility; reheat factor; reheating and regeneration,
            methods of governing; back pressure and pass out turbines.
        </p>

        <p className={`${styles.aboutheading} `}>
            4.4 Steam power plants—combined cycle power generation; heat recovery steam generators (HRSG) fired
            and unfired, co-generation plants.
        </p>

        <p className={`${styles.aboutheading2} `}> 5. Refrigeration and Air-conditioning :</p> 

        <p className={`${styles.aboutheading} `}>
            5.1 Vapour compression refrigeration cycle—cycle on p-H & T-s diagrams; ecofriendly refrigerants—R 134a.
            123; Systems like evaporators, condensers, compressor, expansion devices. Simple vapour absorption systems.
        </p>

        <p className={`${styles.aboutheading} `}>
            5.2 Psychrometry—properties; processes; charts; sensible heating and cooling; humidification and
            dehumidification effective temperature; air-conditioning load calculation; simple duct design.
        </p>
     </div>
    </div>
  </div>
</div>

{/* 23 CIVIL ENGINEERING */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        23 </span> CIVIL ENGINEERING
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
          Civil  - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
        <p className={`${styles.aboutheading2}`}>
           Engineering Mechanics, Strength of Materials and Structural Analysis.
        </p>

        <p className={`${styles.aboutheading2}`}>Engineering Mechanics :</p>

        <p className={`${styles.aboutoption}`}>
            Units and Dimensions, SI Units, Vectors, Concept of Force, Concept of particle and rigid body.
            Concurrent, Non- Concurrent and parallel forces in a plane, moment of force free body diagram,
            conditions of equilibrium, Principle of virtual work, equivalent force system.
        </p>

        <ul>
            <li>First and Second Moment of area, Mass moment of Inertia.</li>
            <li>Kinematics and Kinetics:</li>
            <li>Kinematics in cartesian Co-ordinates, motion under uniform and non-uniform acceleration, motion
                under gravity. Kinetics of particle : Momentum and Energy principles, collision of elastic bodies,
                rotation of rigid bodies.
            </li>
        </ul>

        <p className={`${styles.aboutheading2}`}>Strength of Materials :</p>

        <p className={`${styles.aboutoption}`}>
            Simple Stress and Strain, Elastic constants, axially loaded compression members, Shear force and
            bending moment, theory of simple bending, Shear Stress distribution across cross sections, Beams
            of uniform strength.        
        </p>

        <p className={`${styles.aboutoption}`}>
            Deflection of beams: Mecaulay’s method, Mohr’s Moment area method, Conjugate beam method,
            unit load method. Torsion of Shafts, Elastic stability of columns, Euler’s, Rankine’s and Secant
            formulae.
        </p>

        <p className={`${styles.aboutheading2}`}>
           Structural Analysis :
        </p>

        <p className={`${styles.aboutoption}`}>
            Castiglianio’s theorems I and II, unit load method, of consistent deformation applied to beams and
            pin jointed trusses. Slope-deflection, moment distribution.
        </p>

        <p className={`${styles.aboutoption}`}> 
            Rolling loads and Influences lines : Influences lines for Shear Force and Bending moment at a
            section of a beam. Criteria for maximum shear force and bending Moment in beams traversed by a
            system of moving loads. Influences lines for simply supported plane pin jointed trusses.
        </p>
     
        <p className={`${styles.aboutoption}`}>
            Arches : Three hinged, two hinged and fixed arches, rib shortening and temperature effects.
        </p>

        <p className={`${styles.aboutoption}`}>Matrix mehods of analysis : Force method and displacement method of analysis of indeterminate
            beams and rigid frames.</p>

        <p lassName={`${styles.aboutoption}`}>Plastic Analysis of beams and frames : Theory of plastic bending, plastic analysis, statical method,
            Mechanism method. <br/>
            Unsymmetrical bending : Moment of inertia, product of inertia, position of Neutral Axis and Principal
            axes, calculation of bending stresses.</p>    

        <p className={`${styles.aboutheading2}`}> Design of Structures : Steel, concrete and masonry structures.</p>

        <p className={`${styles.aboutheading2}`}>Structural Steel Design :</p>
        
        <p className={`${styles.aboutoption}`}>
            Structural steel : Factors of safety and load factors. Riveted, bolted and welded joints and
            connections. Design of tension and compression members, beams of built up section, riveted and
            welded plate girders, gantry girders, stancheons with battens and lacings.
        </p>

        <p className={`${styles.aboutheading2}`}> Design of Concrete and Masonry Structures : </p>

        <p className={`${styles.aboutoption}`}>
            Concept of mix design. Reinforced Concrete : Working Stress and Limit State method of design—
            Recommendations of I. S. codes. design of one way and two way slabs, stair-case slabs, simple and
            continuous beams of rectangular, T and L sections. compression members under direct load with or
            without eccentricity.<br/>
            Cantilever and Counter fort type retaining walls.
        </p>

        <p className={`${styles.aboutoption}`}>Water tanks : Design requirements for Rectangular and circular tanks resting on ground.</p>
        <p className={`${styles.aboutoption}`}>
            Prestressed Concrete : Methods and systems of prestressing, anchorages, Analysis and design of
            sections for flexure based on working stress, loss of prestress.
        </p>
        <p className={`${styles.aboutoption}`}>Design of brick masonry as per I. S. Codes</p>

        <p className={`${styles.aboutheading2}`}> Fluid Mechanics, open channel flow and Hydraulic Machines : </p>
    
        <p className={`${styles.aboutheading2}`}>Fluid Mechanics :</p>
        
        <p className={`${styles.aboutoption}`}>
            Fluid properties and their role in fluid motion, fluid statics including forces acting on plane and
            curve surfaces. <br/>
        </p>

        <p className={`${styles.aboutoption}`}>
            Kinematics and Dynamics of Fluid flow : Velocity and accelerations, stream lines, equation of
            continuity, irrotational and rotational flow, velocity potential and stream functions.
        </p>

        <p className={`${styles.aboutoption}`}>
            Continuity, momentum, energy equation, Navier Stokes equation, Euler’s equation of motion,
            application to fluid flow problems, pipe flow, sluice gates, weirs.
        </p>

        <p className={`${styles.aboutheading2}`}>Dimensional Analysis and Similitude: Buckingham’s Pi-theorem, dimensionless parameters.</p>

        <p className={`${styles.aboutheading2}`}>Laminar Flow :</p>

        <p className={`${styles.aboutoption}`}>Laminar flow between parallel, stationary and moving plates, flow through tube.</p>
      
        <p className={`${styles.aboutheading2}`}>Open channel flow :</p>

        <p className={`${styles.aboutoption}`}>
            Uniform and non-uniform flows, momentum and energy correction factors, specific energy and
            specific force, critical depth, rapidly varied flow, hydraulic jump, gradually varied flow, classification
            of surface profiles, control section, step method of integration of varied flow equation.
        </p>

        <p className={`${styles.aboutheading2}`}>Hydraulic Machines and Hydropower :</p>

        <p className={`${styles.aboutoption}`}>
            Hydraulic turbines, types classification, Choice of turbines performance parameters, controls,
            characteristics, specific speed.<br/>
            Principles of hydropower development.
        </p>

        <p className={`${styles.aboutheading2}`}>Geotechnical Engineering :</p>

        <p className={`${styles.aboutoption}`}> 
            Soil Type and Structure—gradation and particle size distribution—consistency limits.
            Water in soil—capillary and structural—effective stress and pore water pressure—permeability
            concept—filed and laboratory determination of permeability—Seepage pressure—quick sand
            conditions—Shear strength determination—Mohr Coulomb concept.
        </p>

        <p className={`${styles.aboutoption}`}>Compaction of soil—Laboratory and filed test.</p>

        <p className={`${styles.aboutoption}`}>Compressibility and consolidation concept— consolidation theory—consolidation settlement
            analysis.</p>

        <p className={`${styles.aboutoption}`}>Earth pressure theory and analysis for retaining walls, Application for sheet piles and Braced
            excavation.</p> 

        <p className={`${styles.aboutoption}`}>Bearing capacity of soil—approaches for analysis- Filed tests—settlement analysis—stability of slope
            of earth walk.</p>

        <p className={`${styles.aboutoption}`}> Subsuface exploration of soils—methods</p> 

        <p className={`${styles.aboutoption}`}>Foundation—Type and selection criteria for foundation of structures—Design criteria for
            foundation—Analysis of distribution of stress for footings and pile—pile group action—pile load test</p>     

        <p className={`${styles.aboutoption}`}>Ground improvement techniques.</p>
       
      </div>
    </div>

{/*Civil II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
       Civil  - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      >
        <p className={`${styles.aboutheading2}`}>
           Construction Technology, Equipment, Planning and Management
        </p>

        <p className={`${styles.aboutheading2}`}>Construction Technology</p>

        <p className={`${styles.aboutoption}`}>Engineering Materials :</p>

        <p className={`${styles.aboutoption}`}>
            Physical properties of construction materials with respect to their use in construction—Stones,
            Bricks and Tiles; Lime, Cement, different types of Mortars and Concrete.
        </p>

        <p className={`${styles.aboutoption}`}>Specific use of ferro cement, fibre reinforced C. C., High stength concrete.</p>

        <p className={`${styles.aboutoption}`}>Timber; Properties defects—common preservation treatments.</p>

        <p className={`${styles.aboutoption}`}>Use and selection of materials for specific use like Low Cost Housing, Mass Housing, High Rise Buildings.</p> 
         
        <p className={`${styles.aboutheading2}`}>Construction :</p> 
         
         
         <ul>
            <li>Masonry principles using Brick, stone, Blocks—construction detailing and strength characteristics.</li>
            <li>Types of plastering, pointing, flooring, roofing and construction features.</li>
            <li>Common repairs in buildings.</li>
            <li>Principle of functional planning of building for residents and specific use—Building code provisions.</li>
            <li>Basic principles of detailed and approximate estimating—specification writing and rate analysisprinciples
                of valuation of real property.
            </li>
            <li>
                Machinery for earthwork, concreting and their specific uses—Factors affecting selection of
                equipments—operating cost of equipments.
            </li>
         </ul>

        <p className={`${styles.aboutheading2}`}>
             CONSTRUCTION PLANNING AND MANAGEMENT :
        </p>

        <ul>
            <li>Construction activity—schedules—organization for construction industry—Quality assurance
                principles.</li>
            <li>Use Basic principle of network—analysis in form of CPM and PERT—their use in construction
                monitoring, Cost optimization and resource allocation.</li> 
            <li>Basic principles of Economic analysis and methods.</li>   
            <li>Project profitability—Basic principles of Boot approach to financial planning-simple toll fixation
                criterions.</li>    
        </ul>

        <p className={`${styles.aboutheading2}`}>
           Surveying and Transportation Engineering :
        </p>

        <p className={`${styles.aboutoption}`}>
            <span className="fw-bold text-dark">Surveying :</span> Common methods and instruments for distance and angle measurement for CE work—
            their use in plane table, traverse survey, levelling work, triangulation, contouring and topographical
            map.
        </p>

        <p className={`${styles.aboutoption}`}>Basic principles of photogrammetry and remote sensing.</p>

        <p className={`${styles.aboutoption}`}>
           <span className="fw-bold text-dark"> Railways Engineering : </span> Permanent way—components, types and their function-Functions and
            Design constituents of turn and crossing— Necessity of geometric design of track—Design of station
            and yards.
        </p>

        <p className={`${styles.aboutoption}`}>
           <span className="fw-bold text-dark"> Highway Engineering : </span> Principles of Highway alignments—classification and geometrical design elements and standards for Roads.
        </p>

        <ul>
            <li>Pavement structure for flexible and rigid pavements—Design principles and methodology of pavements.</li>

            <li>Typical construction methods and standards of materials for stabilized soil, WBM, Bituminous works and CC roads.</li>

            <li>Surface and sub-surface drainge arrangements for roads—culvert structures.</li>

            <li>Pavement distresses and strengthening by overlays.</li>

            <li>Traffic surveys and their application in traffic planning—Typical design features for channelized,
                intersection rotary etc.—signal designs—standard Traffic signs and markings.</li>
        </ul>

       <p className={`${styles.aboutheading2}`}> Hydrology, Water Resources and Engineering :</p>

       <p className={`${styles.aboutoption}`}>
            <span className="fw-bold text-dark">Hydrology : </span> <br/>
            Hydrological cycle, precipitation, evaporation, transpiration, infiltration, overland flow, hydrograph,
            flood frequency analyses, flood routing through a reservoir, channel flow routing—Muskingam
            method.
        </p>

        <p className={`${styles.aboutoption}`}>
            <span className="fw-bold text-dark">Ground Water flow : </span> <br/>
            Specific yield, storage coefficient, coefficient of permeability, confined and unconfined aquifers,
            aquifers, aquitards, radial flow into a well under confined and unconfined conditions.
        </p>

        <p className={`${styles.aboutoption}`}>
           <span className="fw-bold text-dark"> Water Resources Engineering : </span> <br/>
            Ground and surface water resources, single and multipurpose projects, storage capacity of
            reservoirs, reservoir losses, reservoir sedimentation.
        </p>

        <p className={`${styles.aboutheading2}`}>
            Irrigation Engineering :
        </p>
        <ul>
            <li>
                Water requirements of crops : consumptive use, duty and delta, irrigation methods and their efficiencies.
            </li>

            <li>
                Canals : Distribution systems for cannal irrigation, canal capacity, canal losses, alignment
                of main and distributory canals, most efficient section, lined canals, their design, regime theory,
                critical shear stress, bed load.
            </li>

            <li>
                Water logging : causes and control, salinity.
            </li>
            
            <li>
                Canal structures : Design of head regulators, canal falls, aqueducts, metering flumes and canal outlets.
            </li>

            <li>
                Diversion head work : Principles and design of weirs on permeable and impermeable
                foundation, Khosla’s theory, energy dissipation.
            </li>

            <li>
                Storage works : Types of dams, design, principles of rigid gravity stability analysis.
            </li>

            <li>Spillways : Spillway types, energy dissipation.</li>

            <li>River training : Objectives of river training, methods of river training</li>
        </ul>

        <p className={`${styles.aboutheading2}`}>
            Environmental Engineering
        </p>

        <p className={`${styles.aboutoption}`}><span className="fw-bold text-dark"> Water Supply : </span>
            Predicting demand for water, impurities of water and their significance, physical, chemical and
            bacteriological analysis, waterborne diseases, standards for potable water.
        </p>

        <p className={`${styles.aboutoption}`}><span className="fw-bold text-dark"> Intake of Water :  </span>
            Water treatment: principles of coagulation, flocculation and sedimentation; slow-, rapid-, pressure,
            filters; chlorination, softening, removal of taste, odour and salinity.
        </p> 

        <p className={`${styles.aboutoption}`}><span className="fw-bold text-dark"> Sewerage Systems  :  </span>
            Domestic and industrial wastes, store sewage—separate and combined systems, flow through
            sewers, design of sewers.
        </p>

        <p className={`${styles.aboutoption}`}><span className="fw-bold text-dark"> Sewage Characterisation   :  </span>
            BOD, COD, solids, dissolved oxygen, nitrogen and TOC. Standards of disposal in normal water
            course and on land.
        </p>

        <p className={`${styles.aboutoption}`}><span className="fw-bold text-dark"> Sewage Treatment   :  </span>
            Working principles, units, chambers, sedimentation tank, trickling filters, oxidation ponds, activated
            sludge process, septic tank, disposal of sludge, recycling of waste water..
        </p> 

        <p className={`${styles.aboutoption}`}><span className="fw-bold text-dark"> Solid waste :  </span>
            Collection and disposal in rural and urban contexts, management of long-term ill-effects.
        </p>

        <p className={`${styles.aboutoption}`}><span className="fw-bold text-dark"> Environmental pollution :</span>
            Sustainable development. Radioactive wastes and disposal. Environmental impact assessment for
            thermal power plants, mines, river valley projects. Air pollution. Pollution control acts.
        </p>
        
      </div>
    </div>
  </div>
</div>
                    
{/* 24 ELECTRICAL ENGINEERING */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        24 </span> ELECTRICAL ENGINEERING
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Electrical Engineering - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >

        <p className={`${styles.aboutheading2}`}>
          Circuits—Theory :
        </p>

        <p>
            Circuit components; network graphs; KCL, KVL; Circuit analysis methods : nodal analysis, mesh
            analysis; basic network theorems and applications; transient analysis : RL, RC and RLC circuits; sinusoidal
            steady state analysis; resonant circuits; coupled circuits; balanced 3-phase circuits. Two-port networks.
        </p>


        <p className={`${styles.aboutheading2} pt-2`}>
          Signals and Systems :
        </p>

        <p className={`${styles.aboutoption}`}>
            Representation of continuous-time and discrete-time signals and systems; LTI systems; convolution;
            impulse response; time-domain analysis of LTI systems based on convolution and differential/difference
            equations. Fourier transform, Laplace transform, Z-transform, Transfer function. Sampling and recovery of
            signals DFT, FFT Processing of analog signals through discrete-time systems.       
        </p>

        <p className={`${styles.aboutheading2} pt-2`}>E.M. Theory :</p>

        <p className={`${styles.aboutoption}`}>
            Maxwell’s equations, wave propagation in bounded media. Boundary conditions, reflection and
            refraction of plane waves. Transmission lines : travelling and standing waves, impedance matching, Smith
            chart.
        </p>

       <p className={`${styles.aboutheading2} pt-2`}>Analog Electronics : </p> 

         <p className={`${styles.aboutoption}`}>
            Characteristics and equivalent circuits (large and small-signal) of Diode, BJT, JFET and MOSFET.
            Diode circuits : Clipping, clamping, rectifier. Biasing and bias stability. FET amplifiers. Current mirror;
        </p>

        <p className={`${styles.aboutoption}`}>
            Amplifiers : single and multi-stage, differential, operational feedback and power. Analysis of
            amplifiers; frequency-response of amplifiers. OPAMP circuits. Filters; sinusoidal oscillators : criterion for
            oscillation; single-transistor and OPAMP configurations. Function generators and wave-shaping circuits.
            Linear and switching power supplies.
        </p>

        <p className={`${styles.aboutheading2} pt-2`}>Digital Electronics : </p>
        <p className={`${styles.aboutoption}`}>
            Boolean algebra; minimisation of Boolean functions; logic gates; digital IC families (DTL, TTL, ECL,
            MOS, CMOS). Combinational circuits : arithmetic circuits, code converters, multiplexers and decoders.
            Sequential circuits: latches and flip-flops, counters and shift-registers. Comparators, timers, multivibrators.
            Sample and hold circuits, ADCs and DACs. Semiconductor memories. Logic implementation using
            programmable devices (ROM, PLA, FPGA).
        </p>
        <p className={`${styles.aboutheading2} pt-2`}>Energy Conversion : </p>

        <p className={`${styles.aboutoption}`}>
            Principles of electromechanical energy conversion : Torque and emf in rotating machines. DC
            machines : characteristics and performance analysis; starting and speed control of motors. Transformers :
            principles of operation and analysis; regulation, efficiency; 3-phase transformers. 3-phase induction
            machines and synchronous machines : characteristics and performance analysis; speed control.
        </p>
        <p className={`${styles.aboutheading2} pt-2`}>Power Electronics and Electric Drives :</p>

        <p className={`${styles.aboutoption}`}>
            Semi-conductor power devices : diode, transistor, thyristor, triac, GTO and MOSFET-static
            characteristics and principles of operation; triggering circuits; phase control rectifiers; bridge converters :
            fully-controlled and half-controlled; principles of thyristor choppers and inverters; DC-DC converters;
            Switch mode inverter; basic concepts of speed control of dc and ac motor drives applications of variablespeed
            drives.
        </p>
        <p className={`${styles.aboutheading2} pt-2`}>Analog Communication :</p>
        <p className={`${styles.aboutoption}`}>
            Random variables : continuous, discrete; probability, probability functions. Statistical averages;
            probability models; Random signals and noise : white noise, noise equivalent bandwidth; signal
            transmission with noise; signal to noise ratio. Linear CW modulation : Amplitude modulation : DSB, DSBSC
            and SSB. Modulators and Demodulators; Phase and Frequency modulation : PM & FM signals; narrows
            band FM; generation & detection of FM and PM, Deemphasis, Preemphasis. CW modulation system :
            Superhetrodyne receivers, AM receivers, communication receivers, FM receivers, phase locked loop, SSB
            receiver Signal to noise ratio calculation or AM and FM receivers.
        </p>
                
      </div>
    </div>

{/*  Electrical Engineering II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
     Electrical Engineering  - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      >
        <p className={`${styles.aboutheading2} `}>
            Control Systems :
        </p>
       <p className={`${styles.aboutoption}`}>
            Elements of control systems; block-diagram representations; open-loop & closed-loop systems;
            principles and applications of feed-back. Control system components. LTI systems : time-domain and
            transform-domain analysis. Stability : Routh Hurwitz criterion, root-loci, Bode-plots and polor plots,
            Nyquist’s criterion; Design of lead-lad compensators. Proportional, PI, PID controllers. State-variable
            representation and analysis of control systems.
        </p> 

        <p className={`${styles.aboutheading2} `}>
            Microprocessors and Microcomputers :
        </p>

        <p className={`${styles.aboutoption}`}>
            PC organisation; CPU, instruction set, register settiming diagram, programming, interrupts, memory
            interfacing, I/O interfacing, programmable peripheral devices.
        </p>

        <p className={`${styles.aboutheading2} `}>
            Measurement and Instrumentation :
        </p>

        <p className={`${styles.aboutoption}`}>
            Error analysis; measurement of current voltage, power, energy, power-factor, resistance, inductance,
            capacitance and frequency; bridge measurements. Signal conditioning circuit; Electronic measuring
            instruments : multimeter, CRO, digital voltmeter, frequency counter, Q-meter, spectrum-analyser,
            distoration-meter. Transducers : thermocouple, thermistor, LVDT, strain-guage, piezo-electric crystal.
        </p>

       <p className={`${styles.aboutheading2} `}>
          Power Systems: Analysis and Control :
        </p>

        <p className={`${styles.aboutoption}`}>
            Steady-state performance of overhead transmission lines and cables; principles of active and reactive
            power transfer and distribution; per-unit quantities; bus admittance and impedance matrices; load flow;
            voltage control and power factor correction; economic operation; symmetrical components, analysis of
            symmetrical and unsymmetrical faults. Concepts of system stability : swing curves and equal area criterion.
            Static VAR system. Basic concepts of HVDC transmission.
        </p>

        <p className={`${styles.aboutheading2} `}>
            Power System Protection :
        </p>

        <p className={`${styles.aboutoption}`}>
            Principles of overcurrent, differential and distance protection. Concept of solid state relays. Circuit
            brakers. Computer aided protection : introduction; line, bus, generator, transformer protection; numeric
            relays and application of DSP to protection.
        </p>

        <p className={`${styles.aboutheading2} `}>Digital Communication :</p>

        <p className={`${styles.aboutoption}`}>
            Pulse code modulation (PCM), defferential pulse code modulation (DPCM), delta modulation (DM),
            Digital modulation and demodulation schemes : amplitude, phase and frequency keying schemes (ASK,
            PSK, FSK). Error control coding : error detection and correction, linear block codes, convolation codes.
            Information measure and source coding. Data networks, 7-layer architecture.
       </p>

        </div>
    </div>
  </div>
</div>

{/* 25. MANAGEMENT  */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        25</span> MANAGEMENT 
    </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Management - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
       
    <p className={`${styles.aboutheading} `}>
        The candidate should make a study of the concept of development of Management as science and art drawing
        upon the contributions of leading thinkers of management and apply the concepts to the real life of government
        and business decision-making keeping in view the changes in the strategic and operative environment.
    </p>

    <p className={`${styles.aboutheading2} `}>PAPER I</p>

    <p className={`${styles.aboutheading2} `}>1. Managerial Function and Process :</p>

    <p className={`${styles.aboutheading} `}>
        Concept and foundations of management, Evolution of Management Thoughts; Managerial Functions—
        Planning, Organizing, Controlling; Decision-making; Role of Manager, Managerial skills; Entrepreneurship;
        Management of innovation; Managing in a global environment, Flexible Systems Management; Social
        responsibility and managerial ethics; Process and customer orientation; Managerial processes on direct and
        indirect value chain.
    </p>    

   <p className={`${styles.aboutheading2} `}> 2. Organisational Behaviour and Design :</p>

   <p className={`${styles.aboutheading} `}>
        Conceptual model of organization behaviour; The individual processes—personality, values and attitude,
        perception, motivation, learning and reinforcement, work stress and stress management; The dynamics of
        Organization behaviour—power and politics, conflict and negotiation, leadership process and styles,
        communication; The Organizational Processes—decision-making, job design; Classical, Neoclassical and
        Contingency approaches to organizational design; Organizational theory and design—Organizational
        culture, managing cultural diversity, learning Organization; Organizational change and development;
        Knowledge Based Enterprise—systems and processes; Networked and virtual organizations.
   </p>

  <p className={`${styles.aboutheading2} `}> 3. Human Resource Management :</p>

  <p className={`${styles.aboutheading} `}> 
        HR challenges; HRM functions; The future challenges of HRM; Strategic Management of human resources;
        Human resource planning; Job analysis; Job evaluation, Recruitment and selection; Training and
        development; Promotion and transfer; Performance management; Compensation management and
        bnenefits; Employee morale and productivity; Management of Organizational climate and Industrial
        relations; Human resources accounting and audit; Human resource information system; International
        human resource management.
  </p>
 
    <p className={`${styles.aboutheading2}`}>4. Accounting for Managers :</p>

    <p className={`${styles.aboutheading} `}>
        Financial accounting—concept, importance and scope, generally accepted accounting principles,
        preparation of financial statements with special reference to analysis of a balance sheet and measurment of
        business income, inventory valuation and depreciation, financial statement analysis, fund flow analysis, the
        statement of cash flows; Management accounting concept, need, imporance and scope; Cost accounting— records and processes, cost ledger and control accounts, reconciliation and integration bwtween financial
        and cost accounts; Overhead cost and control, Job and process costing, Budget and budgetary control,
        Performance budgeting, Zero-base budgeting, relevant costing and costing for decision-making, standard
        costing and variance analysis, marginal costing and absorption costing.
    </p>

    <p className={`${styles.aboutheading2}`}>5. Financial Management : </p>
       
    <p className={`${styles.aboutheading}`}> 
        Goal of Finance Function. Concepts of value and return. Valuation of bonds and Shares; Management of
        working capital : Estimation and Financing; Management of cash, receivables, inventory and current
        liabilities; Cost of capital ; Capital budgeting; Financial and operating leverage; Design of capital structure:
        theories and practices; Shareholder value creation: dividend policy, corporate financial policy and strategy,
        management of corporate distress and restructuring strategy; Capital and money markets: institutions and
        instruments; Leasing hire purchase and venture capital; Regulation of capital market; Risk and return:
        portfolio theory; CAPM; APT; Financial derivatives: option, futures, swap; Recent reforms in financial sector.
    </p>

    <p className={`${styles.aboutheading2}`}> 6. Marketing Management : </p>

    <p className={`${styles.aboutheading}`}> 
        Concept, evolution and scope; Marketing strategy formulation and components of marketing plan;
        Segmenting and targeting the market; Positioning and differentiating the market offering; Analyzing
        competition; Analyzing consumer markets; Industrial buyer behaviour; Market research; Product strategy;
        Pricing strategies; Designing and managing Marketing channels; Integrated marketing communications;
        Building customer staisfaction, Value and retention; Services and non-profit marketing; Ethics in
        marketing; Consumer protection; Internet marketing; Retail management; Customer relationship
        management; Concept of holistic marketing.
    </p>  

 </div>
</div>

{/* Management  II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
       Management  - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", 
            textAlign: "justify", 
            }}
      > 
      
        <p className={`${styles.aboutheading2}`}>1. Quantitative Techniques in Decision-making :  </p>
              
        <p className={`${styles.aboutheading} `}>  
            Descriptive statistics—tabular, graphical and numerical methods, introduction to probability, discrete and
            continuous probability distributions, inferential statistics-sampling distributions, central limit theorem,
            hypothesis testing for differences between means and proportions, inference about population variances,
            Chisquare and ANOVA, simple correlation and regression, time series and forecasting, decision theory, index
            numbers; Linear programming—problem formulation, simplex method and graphical solution, sensitivity
            analysis.
        </p>
        
        <p className={`${styles.aboutheading2} `}> 2. Production and Operations Management :</p>

        <p className={`${styles.aboutheading} `}>
            Fundamentals of operations management; Organizing for production; Aggregate production planning,
            capacity planning, plant design: process planning, plant size and scale of operations, Management of
            facilities; Line balancing; Equipment replacement and maintenance; Production control; Supply, chain
            management—vendor evaluation and audit; Quality management; Statistical process control, Six Sigma;
            Flexibility and agility in manufacturing systems; World class manufaturing; Project management concepts,
            R&D management, Management of service operations; Role and importance of materials management, value
            analysis, make or buy decision; Inventory control, MRP; Waste management.
        </p>

        <p className={`${styles.aboutheading2} `}>3. Management Information System :</p>

        <p className={`${styles.aboutheading}`}>
            Conceptual foundations of information systems; Information theory; Information resource management;
            Types of information Systems; Systems Development—Overview of Systems and Design; System
            Development management life-cycle, Designing online and distributed environments; Implementation and
            control of project; Trends in information technology; Managing data resources—Organising data. DSS
            and RDBMS; Enterprise Resource Planning (ERP), Expert systems, e-Business architecture, e-Governance;
            Information systems planning, Flexibility in information systems; User involvement; Evaluation of information systems.
        </p>

        <p className={`${styles.aboutheading2} `}> 4. Government Business Interface :</p>
            
        <p className={`${styles.aboutheading} `}>
            State participation in business, Interaction between Government, Business and different Chambers of
            Commerce and Industry in India; Government’s ploicy with regard to Small Scale Industries; Government
            clearances for establishing a new enterprise; Public Distribution System; Government control over price and
            distribution; Consumer Protection Act (CPA) and The Role of Voluntary Organizations in protecting
            consumers’ rights; New Industrial Policy of the Government : liberalization, deregulation and privatisation;
            Indian planning system; Government policy concerning development of Backward areas/regions; The
            Responsibilities of the business as well as the Government to protect the environment; Corporate
            Governance; Cyber Laws.
        </p>

          
        <p className={`${styles.aboutheading2} `}>5. Strategic Cost Management :</p>

        <p className={`${styles.aboutheading} `}>
            Business policy as a field of study; Nature and scope of strategic management, Strategic intent, vision,
            objectives and policies; Process of strategic planning and implementa-tion; Environmental analysis and
            internal analysis; SWOT analysis; Tools and techniques for strategic analysis—Impact matrix: The
            experience curve, BCG matrix, GEC mode, Industry analysis, Concept of value chain; Strategic profile of a
            firm; Framework for analysing competition; Competitive advantage of a firm; Generic competitive strategies;
            Growth strategies—expansion, integration and diversification; Concept of core competence, Strategic
            flexibility; Reinventing strategy; Strategy and structure; chief Executive and Board; turnaround
            management; Management of strategic change; Strategic alliances, Mergers and Acquisitions; Strategy and
            corporate evolution in the Indian context.
            
        </p> 

        <p className={`${styles.aboutheading2} `}> 6. International Business : </p> 

        <p className={`${styles.aboutheading} `}>
            International Business Environment : Changing composition of trade in goods and services; India’s Foreign
            Trade: Policy and trends; Financing of International trade; Regional Economic Cooperation; FTAs;
            Internationalisation of service firms; International production; Operation Management in International
            companies; International Taxation; Global competitiveness and technological developments; Global EBusiness;
            Designing global organisational structure and control; Multicultural management; Global
            business strategy; Global marketing strategies; Export Management; Export-Import procedures; Joint
            Ventures; Foreign Investment: Foreign direct investment and foreign portfolio investment; Cross-border
            Mergers and Acquisitions; Foreign Exchange Risk Exposure Management; World Financial Markets and
            International Banking; External Debt Management; Country Risk Analysis.
        </p>
   
        </div>
    </div>
  </div>
</div>


{/*Literature */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
          Literature  
    </h2>
    <div className="row justify-content-center">
        <div className="col-lg-10">
            <h3 className="fw-bold text-white text-center rounded-top-4"
                style={{
                    background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
                    fontSize: "1.3rem",
                    letterSpacing: "0.05em",
                    padding: "12px",
                    }}>
                Literature of the following languages :
            </h3>
            <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
                    style={{
                    background: "rgba(255,255,255,0.98)",
                    lineHeight: "1.9em",
                    fontSize: "1rem",
                    color: "#333",
                    textAlign: "justify",
                    }}
            >
                <p className={`${styles.aboutheading2} `}>
                    NOTE (i). — A candidate may be required to answer some or all the Questions in the language
                    concerned.
                </p>

                <p className={`${styles.aboutheading2} `}>
                    NOTE (ii). — In regard to the languages included in the Eighth Schedule to Constitution, the scripts
                    will be the same as indicated in Section II (B) of Appendix I relating to the Main Examination.
                </p>

                <p className={`${styles.aboutheading2} `}>NOTE (iii). — Candidates should note that the questions not required to be answered in a specific
                    language will have to be answered in the language medium indicated by them for answering papers
                    on Essay, General Studies and Optional Subjects.
                </p> 

            </div>
        </div>
    </div>
</div>

{/* 26. Tamil Language */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        26</span> TAMIL 
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Tamil - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
        
    <p className={`${styles.aboutheading2} text-center `}>
       Answers must be written in Tamil   
    </p>

    <p className={`${styles.aboutheading2} text-center`}>
        Section A
    </p>
    
    <p className={`${styles.aboutheading2} `}>Part 1: History of Tamil Language</p>

    <p className={`${styles.aboutheading} `}>
        Major Indian Language Families—The place of Tamil among Indian Languages in general and
        Dravidian in particular—Enumeration and Distribution of Dravidian languages.
        The language of Sangam Literature—The language of medieval Tamil : Pallava Period only—Historical study
        of Nouns, Verbs, Adjectives, Adverbs—Tense markers and case markers in Tamil.
        Borrowing of words from other languages into Tamil—Regional and social dialects—difference between
        literary and spoken Tamil.
    </p>    

   <p className={`${styles.aboutheading2} `}> Part 2 : History of Tamil Literature </p>

   <p className={`${styles.aboutheading} `}>
        Tolkappiyam-Sangam Literature—The division of Akam and Puram—The secular characteristics of Sangam
        Literature—The development of Ethical literature—Silappadikaram and Manimekalai.
   </p>

  <p className={`${styles.aboutheading2} `}> Part 3 : Devotional Literature (Alwars and Nayanamars)</p>

  <p className={`${styles.aboutheading} `}> 
        The bridal mysticism in Alwar hymns—Minor literary forms (Tutu, Ula, Parani, Kuravanji).
        Social factors for the development of Modern Tamil Literature; Novel, Short Story and New Poetry—The
        impact of various political ideologies on modern writings.
  </p>
 
    <p className={`${styles.aboutheading2} text-center`}>Section B</p>

    <p className={`${styles.aboutheading2} `}> Part 1 : Recent trends in Tamil Studies</p>

    <p className={`${styles.aboutheading} `}>
        Approaches to criticism : Social, psychological, historical and moralistic—the use of criticism—the various
        techniques in literature; Ullurai, Iraicchi, Thonmam (Myth) Otturuvagam (allegory), Angadam (Satire),
        Meyappadu, Padimam (image), Kuriyeedu (Symbol), Irunmai (Ambiguity)—The concept of comparative
        literature-the principle of comparative literature.
    </p>

    <p className={`${styles.aboutheading2}`}> 
       Part 2 : Folk literature in Tamil
    </p>

    <p className={`${styles.aboutheading}`}> 
        Ballads, Songs, proverbs and riddles—Sociological study of Tamil folklore. Uses of translation—Translation
        of Tamil works into other languages-Development of journalism in Tamil.
    </p>

    <p className={`${styles.aboutheading2}`}> 
       Part 3 : Cultural Heritage of the Tamils
    </p>

    <p className={`${styles.aboutheading}`}> 
        Concept of Love and War—Concept of Aram-the ethical codes adopted by the ancient Tamils in their
        warfare-customs beliefs, rituals, modes of worship in the five Thinais.</p>

    <p className={`${styles.aboutheading}`}> The Cultural changes as revealed in post sangam literature—cultural fusion in the medieval period (Janism
        and Buddhism). The development of arts and architecture through the ages (Pallavas, later Cholas, and
        Nayaks). The impact of various political, social, religious and cultural movements on Tamil Society. The
        role of mass media in the cultural change of contemporary Tamil society.
    </p>
     


 </div>
</div>

{/* Tamil II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
       Tamil - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", 
            textAlign: "justify", 
            }}
      > 
      
        <p className={`${styles.aboutheading2} text-center`}>
            Answer must be written in Tamil   
        </p>
        
        <p className={`${styles.aboutheading} `}>  The paper will require first-hand reading of the text prescribed and will be designed to test the critical ability of the candidate.</p>

        <p className={`${styles.aboutheading2} text-center`}>Section A</p>
        
        <p className={`${styles.aboutheading2} `}>  Part 1 : Ancient Literature</p>

            <ul className="list-unstyled">

                <li>(1) Kuruntokai (1—25 poems)</li>
                <li>(2) Purananuru (182—200 poems)</li>
                <li>(3) TirukkuralPorutpal :ArasiyalumAmaichiyalum(from Iraimatchi to Avaianjamai).</li>
             </ul> 

        <p className={`${styles.aboutheading2} `}>Part 2 : Epic Literature  </p>

             <ul className="list-unstyled">
                <li>(1) Silappadikaram : Madhurai Kandam only. </li>
                <li>(2) Kambaramayanam : Kumbakarunan Vadhai Padalam.</li>
             </ul>

        <p className={`${styles.aboutheading2} `}>Part 3 : Devotional Literature</p>

            <ul className="list-unstyled">
               <li>(1) Tiruvasagam : Neetthal Vinnappam</li>
               <li>(2) Tiruppavai  : (Full Text).</li>
            </ul>

        <p className={`${styles.aboutheading2} text-center`}>Section B</p>

        <p className={`${styles.aboutheading2} `}>
             Modern Literature
        </p>

        <p className={`${styles.aboutheading2} `}>Part 1 : Poetry</p>

            <ul className="list-unstyled">  
                <li>(1) Bharathiar : Kannan Pattu</li>
                <li>(2) Bharathidasan : Kudumba Vilakku</li>
                <li>(3) Naa. Kamarasan : Karappu Malarkal</li>   
            </ul>

        <p className={`${styles.aboutheading2} `}>Prose</p>

            <ul className="list-unstyled">
                <li>(1) Mu. Varadharajanar : Aramum Arasiyalum</li>
                <li>(2) C. N. Annadurai : Ye! Thazhntha Tamilagame.</li>
            </ul>

        <p className={`${styles.aboutheading2} `}>Part 2 : Novel, Short Story and Drama</p> 

           <ul className="list-unstyled">
                <li>(1) Akilon ; Chittairappavai</li>
                <li>(2) Jayakanthan : Gurupeedam</li>
                <li>(3) Cho : Yaurkkum Vetkamillai</li>
            </ul>  

        <p className={`${styles.aboutheading2} `}> Part 3 : Folk Literature </p> 

            <ul className="list-unstyled">
                <li>(1) Muthuppattan kathai Edited by Na. Vanamamalai, (Publication : Madurai Kamaraj University).</li>
                <li>(2) Malaiyaruvi, Edited by Ki. Va Jagannathan (Publication : Saraswathi Mahal, Thanjavur).</li>
            </ul>

        </div>
    </div>
  </div>
</div>

{/* 27. English Language */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        27 </span> English
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        English - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
        <p>
            The syllabus consists of two papers, designed to test a first-hand and critical reading of texts prescribed
            from the following periods in English Literature : Paper 1 : 1600-1900 and Paper 2 : 1900–1990.
            There will be two compulsory questions in each paper : (a) A short-notes question related to the topics for
            general study, and (b) A critical analysis of UNSEEN passages both in prose and verse.
        </p>


        <p className={`${styles.aboutheading2} text-center`}>
         [Answers must be written in English]
        </p>

        <p className={`${styles.aboutheading2} `}>Texts for detailed study are listed below. Candidates will also be required to show adequate knowledge
        of the following topics and movements :</p>

        <p>
            The Renaissance; Elizabethan and Jacobean Drama; Metaphysical Poetry; The Epic and the Mock-epic; Neoclassicism;
            Satire; The Romantic Movement; The Rise of the Novel; The Victorian Age.
       </p>

    <p className={`${styles.aboutheading2} text-center`}>
        Section A
    </p>

    <p className={`${styles.aboutheading2} `}>
        1. William Shakespeare : King Lear and The Tempest.
    </p>

    <p className={`${styles.aboutheading2} `}>2. John Donne. The following poems :</p>  
        <ul>
            <li>–Canonization;</li>
            <li>–Death be not proud;</li>
            <li>–The Good Morrow;</li>
            <li>–On his Mistress going to bed;</li>
            <li>–The Relic;</li>
            
        </ul>
    <p className={`${styles.aboutheading2} `}>3. John Milton : Paradise Lost, I, II, IV, IX.</p>

    <p className={`${styles.aboutheading2} `}>4. Alexander Pope. The Rape of the Lock.</p>

    <p  className={`${styles.aboutheading2}`}>5. William Wordsworth. The following poems :</p>
       <ul>
            <li> – Ode on Intimations of Immortality.</li>
            <li>– Tintern Abbey.</li>
            <li>- Three years she grew.</li>
            <li>– She dwelt among untrodden ways.</li>
            <li>– Michael.</li>
            <li>– Resolution and Independence.</li>
            <li>– The World is too much with us.</li>
            <li>– Milton, thou shouldst be living at this hour.</li>
            <li>- Upon Westminster Bridge.</li>
       </ul>
    <p  className={`${styles.aboutheading2}`}>6. Alfred Tennyson : In Memoriam.</p>

    <p  className={`${styles.aboutheading2}`}>7. Henrik Ibsen : A Doll’s House.</p>

    <p className={`${styles.aboutheading2} text-center`}> Section B </p>

    <p className={`${styles.aboutheading} `}>1. Jonathan Swift, Gulliver’s Travels.</p>
    <p className={`${styles.aboutheading} `}>2. Jane Austen. Pride and Prejudice.</p>
    <p className={`${styles.aboutheading} `}>3. Henry Fielding. Tom Jones.</p>
    <p className={`${styles.aboutheading} `}>4. Charles Dickens. Hard Times.</p>
    <p className={`${styles.aboutheading} `}>5. George Eliot. The Mill on the Floss.</p>
    <p className={`${styles.aboutheading} `}>6. Thomas Hardy. Tess of the d’Urbervilles.</p>
    <p className={`${styles.aboutheading} `}>7. Mark Twain. The Adventures of Huckleberry Finn.</p>

        
      </div>
    </div>

{/*  English II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
     English - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      >

        <p className={`${styles.aboutheading2} text-center `}>
            [Answers must be written in English]
        </p>

        <p className={`${styles.aboutheading2}`}> Texts for detailed study are listed below. Candidates will also be required to show adequate knowledge
            of the following topics and movements :</p>

        <p className={`${styles.aboutheading}`}>
            Modernism; Poets of the Thirties; The stream-of-consciousness Novel; Absurd Drama; Colonialism and Post-
            Colonialism; Indian Writing in English; Marxist, Psychoanalytical and Feminist approaches to literature;
            Post-Modernism.
        </p>

        <p className={`${styles.aboutheading2} text-center `}>  Section A</p>

        <p className={`${styles.aboutheading2}`}>
            1. William Butler Yeats. The following poems :
        </p>
          
            <ul>
                <li>Easter 1916.</li>
                <li>The Second Coming.</li>
                <li>A Prayer for my daughter.</li>
                <li>Sailing to Byzantium.</li>
                <li>The Tower. </li>
                <li>Among School Children.</li>
                <li>Leda and the Swan.</li>
                <li>Meru.</li>
                <li>Lapis Lazuli.</li>
                <li>The Second Coming.</li>
                <li>Byzantium.</li>
            </ul>

        <p className={`${styles.aboutheading2}`}>
            2. T.S. Eliot. The following poems :
        </p>
         
          <ul>
            <li>The Love Song of J. Alfred Prufrock.</li>
            <li>Journey of the Magi.</li>
            <li>Burnt Norton</li>
          </ul>

        <p className={`${styles.aboutheading2}`}>
            3. W.H. Auden. The following poems :
        </p>
         
          <ul>
            <li>Partition</li>
            <li>Musee des Beaux Arts</li>
            <li>In Memory of W.B. Yeats</li>
            <li>Lay your sleeping head, my love</li>
            <li>The Unknown Citizen</li>
            <li>Mundus Et Infans</li>
            <li>The Shield of Achilles</li>
            <li>September 1, 1939</li>
            <li>Petition</li>
          </ul>

        <p className={`${styles.aboutheading2}`}>
           4.  John Osborne : Look Back in Anger.
        </p>

        <p className={`${styles.aboutheading2}`}>
           5.  Samuel Beckett. Waiting for Godot.
        </p>

        <p className={`${styles.aboutheading2}`}>
           6.  Philip Larkin. The following poems :
        </p>

            <ul>
                <li>Next</li>
                <li>Please</li>
                <li>Deceptions  </li>
                <li>Afternoons</li>
                <li>Days</li>
                <li>Mr. Bleaney</li>
            </ul>

        <p className={`${styles.aboutheading2}`}>
           7.  A.K. Ramanujan. The following poems :
        </p>

            <ul>
                <li>Looking for a Cousin on a Swing</li>
                <li>A River</li>
                <li>Of Mothers, among other Things</li>
                <li>Love Poem for a Wife 1</li>
                <li>Small-Scale Reflections on a Great House</li> 
                <li>Obituary</li>
            </ul>
        
        <p>
            (All these poems are available in the anthology Ten Twentieth Century Indian Poets, edited by
            R. Parthasarthy, published by Oxford University Press, New Delhi).
        </p>

        <p className={`${styles.aboutheading2} text-center`}>Section B</p>

             <ul className='list-unstyled'>
                <li>1. Joseph Conrad. Lord Jim.</li>
                <li>2. James Joyce. Portrait of the Artist as a Young Man.</li>
                <li>3. D.H. Lawrence. Sons and Lovers.</li>
                <li>4. E.M. Forster. A Passage to India.</li>
                <li>5. Virginia Woolf. Mrs. Dalloway.</li> 
                <li>6. Raja Rao. Kanthapura.</li>
                <li>7. V.S. Naipaul. A House for Mr. Biswas.</li>
            </ul>

        </div>
    </div>

  </div>
</div>


{/* 28. ASSAMESE Language */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        28</span> ASSAMESE
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Assamese  - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >

        <p className={`${styles.aboutheading2} text-center`}>
         [Answers must be written in Assamese]
        </p>

        <p className={`${styles.aboutheading2} text-center`}>
          Section A
        </p>

        <p className={`${styles.aboutheading2} `}>
         Language :
        </p>

        <ul>
            <li>History of the origin and development of the Assamese Language —its position among the Indo-
                Aryan language—periods in its history.</li>
            <li>Development of Assamese prose.</li>    
            <li>Vowels and consonants of the Assamese Language—Rules of phonetic changes with stress on
                Assamese coming down from <br/>Old Indo-Aryan.</li>
            <li>Assamese vocabulary—and its sources.</li>
            <li>Morphology of the language—conjugation—enclitic definitives and pleonastic suffixes.</li>
            <li>Dilectical divergences—the Standard colloquial and the Kamrupi dialect in particular.</li>  
            <li>Assamese script—its evolution through the ages till 19th century A.D.</li>  
        </ul>

        <p className={`${styles.aboutheading2} text-center`}>Section B</p>

        <p className={`${styles.aboutheading2}`}>Literary Criticism and Literary History</p>
        <ul>
            <li>Principles of literary criticism up to New criticism.</li>
            <li>Different literary genres.</li>
            <li>Development of literary forms in Assamese.</li>
            <li>Development of literary criticism in Assamese.</li>
            <li>Periods of the literary history of Assam from the earliest beginnings, i.e. from the period of the
                charyyageeta with their socio-cultural background : the proto Assamese Pre-Sankaradeva—
                Sankaradeva—Post-Sankaradeva—Modern period (from the coming of the Britishers)—Post-
                Independence period. Special emphasis is to be given on the Vaisnavite period, the gonaki and the
                post-independence periods.
            </li>
        </ul>
        
       
                        
      </div>
    </div>

{/*  ASSAMESE II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
     ASSAMESE - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      >
        <p className={`${styles.aboutheading2} text-center`}>This paper will require first-hand reading of the texts prescribed and will be designed to test the candidate’s critical ability.</p>

        <p className={`${styles.aboutheading2} text-center `}>
            [Answers must be written in Assamese]
        </p>

        <p className={`${styles.aboutheading2} text-center `}>  Section A</p>

        <p>Râmâyana (Ayodhyâ Kânda  —  by Madhava Kandali only)</p>
        <p>Pârijât-Harana           —  by Sankaradeva.</p>
        <p>Râsakrîdâ                —  by Sankaradeva (From Kirtana Ghosa)</p>
        <p>Bârgeet                  —  by Madhavadeva.</p>
        <p>Râjasûya                 —  by Madhavadeva.</p>
        <p>Kathâ-Bhâgavata(Books I and II) —by Baikurthanath Bhattacharyya.</p>
        <p>Gurucarit-Kathâ (Sankaradeva’s Part only) —ed. by Maheswar Neog.</p>

        <p className={`${styles.aboutheading2} text-center `}>  Section B</p>

        <ul>
            <li>Mor Jeevan Soñwaran —by Lakshminath Bezbaroa.</li>
            <li>Kripâbar BorbaruârKakatar Topola —by Lakshminath Bezbaroa.</li>
            <li>Pratimâ —by Chandra KumarAgarwalla.</li>
            <li>Gâonburhâ —by Padmanath GohainBarua.</li>
            <li>Manomatî —by Rajanikanta Bordoloi.</li>
            <li>Purani Asamîyâ Sâhitya —by Banikanta Kakati.</li>
            <li>Kârengar Ligirî —by Jyotiprasad Agarwalla</li>
            <li>Jeevanar Bâtat —by Bina Barva(BirinchiKumar Barua)</li>
            <li>Mrityunjoy —by Birendrakumar Bhattacharyya</li>
            <li>Samrât —by Navakanta Barua</li>
        </ul>
        
        </div>
    </div>
  </div>
</div>

{/* 29. BENGALI Language */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        29</span> BENGALI
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Bengali - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >

        <p className={`${styles.aboutheading2} text-center`}> 
            History of Language and Literature.
        </p> 

        <p className={`${styles.aboutheading2} text-center`}>
         [Answers must be written in Bengali]
        </p>

        <p className={`${styles.aboutheading2} text-center`}>
          Section A
        </p>

        <p className={`${styles.aboutheading2} `}>
         Language :
        </p>

        <ul>
            <li>The chronological track from Proto Indo-European to Bangla (Family tree with branches and
                approximate dates).</li>
            <li>Historical stages of Bangla (Old, Middle, New) and their linguistic features.</li>    
            <li>Dialects of Bangla and their distinguishing characteristics.</li>
            <li>Elements of Bangla Vocabulary.</li>
            <li>Forms of Bangla Literary Prose—Sadhu and Chalit.</li>  
        </ul>

        <p>Processes of language change relevant for Bangla : </p>
        <p>
            Apinihiti (Anaptyxis), Abhishruti (umlaut), Murdhanyibhavan (cerebralization), Nasikyibhavan
            (Nasalization), Samibhavan (Assimilation), Sadrishya (Analogy), Svaragama (Vowel insertion) —Adi
            Svaragama, Madhya Svaragama or Svarabhakti, Antya Svaragama, Svarasangati (Vowel harmony),
            y—shruti and w—shruti.
        </p>

        <p>Problems of standardization and reform of alphabet and spelling, and those of transliteration and
            Romanization.</p>
        <p>Phonology, Morphology and Syntax of Modern Bangla. <br/>
          (Sounds of Modern Bangla, Conjuncts; word formations, compounds; basic sentence patterns.)</p>    

        <p className={`${styles.aboutheading2} text-center`}>Section B</p>

        <p className={`${styles.aboutheading2}`}>History of Bangla Literature.</p>

        <ul>
            <li>Periodization of Bangla Literature : Old Bangla and Middle Bangla.</li>
            <li>Points of difference between modern and pre-modern Bangla Literature.</li>
            <li>Roots and reasons behind the emergence of modernity in Bangla Literature.</li>
            <li>Evolution of various Middle Bangla forms ; Mangal Kavyas, Vaishnava lyrics, Adapted narratives
                (Ramayana, Mahabharata, Bhagavata) and religious biographies.</li>

            <li>Secular forms in middle Bangla literature.</li>
            <li>Narrative and lyric trends in the nineteenth century Bangla poetry.</li>
            <li>Development of prose.</li>
            <li>Bangla dramatic literature (nineteenth century, Tagore, Post-1944 Bangla drama).</li>
            <li>Tagore and post-Tagoreans.</li>
            <li>Fiction, major authors : <br/>
            ( Bankimchandra, Tagore, Saratchandra, Bibhutibhusan, Tarasankar, Manik ).</li>
            <li>Women and Bangla literature : creators and created.</li>
        </ul>
                        
      </div>
    </div>

{/*  Bengali II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
     Bengali - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      >
        <p className={`${styles.aboutheading2} text-center`}>Prescribed texts for close study</p>

        <p className={`${styles.aboutheading2} text-center `}>
            [Answers must be written in Bengali]
        </p>

        <p className={`${styles.aboutheading2} text-center `}>  Section A</p>

        <ul>
            <li>Vaishnava Padavali (Calcutta University) </li>
            <li>Poems of Vidyapati, Chandidas, Jnanadas, Govindadas and Balaramdas.</li>
            <li>Chandimangal Kalketu episode by Mukunda (Sahitya Akademi).</li>
            <li>Chaitanya Charitamrita, Madhya Lila by Krishnadas Kaviraj (Sahitya Akademi).</li>
            <li>Meghnadbadh Kavya by Madhusudan Dutta.</li>
            <li>Kapalkundala by Bankimchandra Chatterjee.</li>
            <li>Samya and Bangadesher Krishak by Bankimchandra Chatterjee.</li>
        </ul>

        
        <p className={`${styles.aboutheading2} text-center `}>  Section B</p>

        <ul>
            <li>Raktakarabi by Rabindranath Tagore.</li>
            <li>Nabajatak by Rabindranath Tagore.</li>
            <li>Grihadaha by Saratchandra Chatterjee.</li>
            <li>Prabandha Samgraha, Vol. 1, by Pramatha Choudhuri.</li>
            <li>Aranyak by Bibhutibhusan Banerjee.</li>
            <li>Short stories by Manik Bandyopadhyay : <br/> Atashi Mami, Pragaitihasik, Holud-Pora, Sarisrip, Haraner Natjamai, Chhoto-Bokulpurer Jatri, Kustharogir Bou, Jakey Ghush Ditey Hoy.</li>  
            <li>Shrestha Kavita by Jibanananda Das.</li>
            <li>Jagori by Satinath Bhaduri.</li>
            <li>Ebam Indrajit by Badal Sircar.</li>
        </ul>

        


        </div>
    </div>

    
  </div>
</div>

{/* 30. BODO Language */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        30</span> BODO
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        BODO - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >

        <p className={`${styles.aboutheading2} text-center`}> 
            History of Language and Literature.
        </p> 

        <p className={`${styles.aboutheading2} text-center`}>
         [Answers must be written in Bodo]
        </p>

        <p className={`${styles.aboutheading2} text-center`}>
          Section A
        </p>

        <p className={`${styles.aboutheading2} `}>
        History of Bodo Language :
        </p>

        <p>Homeland, language family, its present status and its mutual contact with Assamese.</p>
        <ul>
           <li>phonemes : Vowel and Consonant Phonemes.</li>
           <li>Tones.</li>
        </ul>

        <p>Morphology : Gender, Case and Case endings, Plural suffix, Definitives, Verbal suffix. </p>
        <p> Vocabulary and its sources.</p>
        <p>Syntax : Types of sentences, Word Order.</p>
        <p>History of scripts used in writing Bodo Language since inception</p>

        <p className={`${styles.aboutheading2} text-center`}> Section B </p>

        <p className={`${styles.aboutheading2}`}>History of Bodo Literature:</p>

        <ul>
            <li>General introduction of Bodo folk Literature.</li>
            <li>Contribution of the Missionaries.</li>
            <li>Periodization of Bodo Literature.</li>
            <li>Critical analysis of different genre (Poetry, Novel, Short Story and Drama).</li>
            <li>Translation Literature.</li>
        </ul>


           
      </div>
    </div>

{/*  BODO II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
     BODO - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      >
        <p className={`${styles.aboutheading2} text-center`}>The paper will require first-hand reading of the texts prescribed and will be designed to test the
            critical ability of the candidates.</p>

        <p className={`${styles.aboutheading2} text-center `}>
            [Answers must be written in Bodo]
        </p>

        <p className={`${styles.aboutheading2} text-center `}>  Section A</p>

        <p><span style={{fontWeight:"bold"}}> Khonthai-Methai </span> : (Edited by Madaram Brahma & Rupnath Brahma) </p>
        <p><span style={{fontWeight:"bold"}}>Hathorkhi-Hala </span>   : (Edited by Pramod Chandra Brahma)</p>
        <p><span style={{fontWeight:"bold"}}>Boroni Gudi Sibsa Arw Aroz :</span> Madaram Brahma</p>
        <p><span style={{fontWeight:"bold"}}>Raja Nilambar :</span> Dwarendra Nath Basumatary</p>
        <p> Bibar (prose section)(Edited by Satish Chandra Basumatary).</p>
       

        <p className={`${styles.aboutheading2} text-center `}>  Section B</p>

        <ul>
            <li>Bibi Bithai (Aida Nwi) : Bihuram Boro</li>
            <li>Radab : Samar Brahma Chaudhury</li>
            <li>Okhrang Gongse Nangou : Brajendra Kumar Brahma</li>
            <li>Baisagu Arw Harimu : Laksheswar Brahma</li>
            <li>Gwdan Boro : Manoranjan Lahary</li>
            <li>Jujaini Or : Chittaranjan Muchahar</li>
            <li>Mwihoor : Dharanidhar Wary</li>
            <li>Hor Badi Khwmsi : Kamal Kumar Brahma</li>
            <li>Jaolia Dewan : Mangal Singh Hozowary</li>
            <li>Hagra Guduni Mwi : Nilkamal Brahma</li>
        </ul>
        </div>
    </div>

  </div>
</div>

{/* 31. DOGRI Language */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        31</span> DOGRI
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        DOGRI - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >

        <p className={`${styles.aboutheading2} text-center`}> 
            HISTORY OF DOGRI LANGUAGE AND LITERATURE
        </p> 

        <p className={`${styles.aboutheading2} text-center`}>
         [Answers must be written in Dogri]
        </p>

        <p className={`${styles.aboutheading2} text-center`}>
          Section A
        </p>

        <p className={`${styles.aboutheading2} `}>
        History of Dogri Language :
        </p>

        <p>Dogri language: Origin and development through different stages.</p>
        <p>Linguistic boundaries of Dogri and its dialects.</p>
        <p>Characteristic features of Dogri Language.</p>
        <p> <span className='' style={{fontWeight:"bold"}}>Structure of Dogri Langauge:</span></p>
        <ul>
            <li>Sound Structure:</li>
            <li>
                Segmental : Vowels and Consonants <br/>
                Non-segmental : Length, Stress, Nasalization, Tone and Junture.
            </li>
        </ul>

        <p> <span className='' style={{fontWeight:"bold"}}> Morphology of Dogri :  </span></p>
        <ul>
            <li>Inflection Categories: Gender, Number, Case, Person, Tense and Voice.</li>
            <li>Word Formation; use of prefixes, infixes and suffixes.</li>
            <li>Vocabulary: tatsam, tadbhav, foreign and regional.</li>
        </ul>
        <p>Sentence Structure; Major Sentence-types and their constituents, agreement and concord in Dogri
            syntax.</p>
        <p>Dogri Language and Scripts: Dogre/Dogra Akkhar, Devanagari and Persia.</p>    

        <p className={`${styles.aboutheading2} text-center`}> Section B </p>

        <p className={`${styles.aboutheading2}`}>History of Bodo Literature:</p>
        <ul>
            <li>A brief account of Pre-independence Dogri Literature: Poetry & Prose.</li>
            <li>Development of modern Dogri Poetry and main trends in Dogri Poetry.</li>
            <li>Development of Dogri short-story, main trends and prominent short-story writers.</li>
            <li>Development of Dogri Novel, main trends and contribution of Dogri Novelists.</li>
            <li>Development of Dogri Drama and contribution of prominent playwrights.</li>
            <li>Development of Dogri Prose; Essays, Memoirs and travelogues.</li>
            <li>An introduction to Dogri Folk Literature—Folk songs, Folk tales 7 Ballads.</li>
        </ul>
  
      </div>
    </div>

{/*  Dogri II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
     Dogri - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      >
        <p className={`${styles.aboutheading2} text-center`}>TEXTUAL CRITICISM OF DOGRI LITERATURE</p>

        <p className={`${styles.aboutheading2} text-center `}>
            [Answers must be written in Dogri]
        </p>

        <p className={`${styles.aboutheading2} text-center `}>  Section A</p>

        <p className={`${styles.aboutheading2}`}>Poetry</p>

        <p className={`${styles.aboutheading2}`}>
            1. Azadi Paihle Di Dogri Kavita
        </p>

        <p>The following poets: <br/>
           Devi Ditta, Lakkhu, Ganga Ram, Ramdhan, Hardutt, Pahari Gandhi Baba Kanshi Ram & Permanand Almas
        </p>
      
         <p className={`${styles.aboutheading2}`}>
            2. Modern Dogri Poetry
        </p>

        <p>
            Azadi Bad Di Dogri Kavita
        </p>

        <p>The following poets : <br/>
            Kishan Smailpuri, Tara Smailpuri, Mohan Lal Sapolia, Yash Sharma, K.S. Madhukar, Padma Sachdev, Yash Sharma, K.S. Madhukar, Padma Sachdev,
            Jitendra Udhampuri, Charan Singh and Prakash Premi
        </p>

        <p className={`${styles.aboutheading2}`}>3. Sheeraza Dogri Number 102, Ghazal Ank</p>

        <p>The following poets : <br/>
           Ram Lal Sharma, Ved Pal Deep, N.D. Jamwal, Shiv Ram Deep, Ashwini Magotra and Virendra Kesar

        </p>

        <p className={`${styles.aboutheading2}`}>4. Sheeraza Dogri Number 147, Ghazal Ank</p>

        <p>The following poets : <br/>
          R.N. Shastri, Jitendra Udhampuri, Champa Sharma and Darshan Darshi.
        </p>

        <p>5. Ramayan (Epic) by Shambhu Nath Sharma (up to Ayodhya Kand)</p>
        <p>6. Veer Gulab (Khand Kavya) by Dinoo Bhai Pant.</p>


        <p className={`${styles.aboutheading2} text-center `}>  Section B</p>

        <p className={`${styles.aboutheading2}`}>Prose</p>

        <p className={`${styles.aboutheading2}`}>
            1.  Ajakani Dogri Kahani
        </p>

        <p>The following Short Story Writers : <br/>
          Madan Mohan Sharma, Narendra Khajuri and B.P. Sathe
        </p>

        <p className={`${styles.aboutheading2}`}>
         2.  Ajakani Dogri Kahani Part-II
        </p>

        <p>The following Short Story Writers : <br/>
         Ved Rahi, Narsingh Dev Jamwal, Om Goswami, Chahttrapal, Lalit Magotra, Chaman Arora and Ratan Kesar.
        </p>

        <p className={`${styles.aboutheading2}`}>
           3.  Khatha Kunj Bhag II
        </p>

        <p>The following Short Story Writers : <br/>
         Om Vidyarthi, Champa Sharma and Krishan Sharma.
        </p>

        <p>4. Meel Patthar (collection of short stories) by Bandhu Sharma.</p>
        <p>5. Kaiddi (Novel) by Desh Bandhu Dogra Nutan.</p>
        <p>6. Nanga Rukkh (Novel) by O.P. Sharma Sarathi.</p>
        <p>7. Nayaan (Drama) by Mohan Singh.</p>

        <p className={`${styles.aboutheading2}`}>
           8. Satrang (A collection of one act plays).
        </p>

        <p>The following play wrights : <br/>
          Vishwa Nath Khajuria, Ram Nath Shastri, Jitendra Sharma, Lalit Magotra and Madan Mohan Sharma.
        </p>

        <p className={`${styles.aboutheading2}`}>
           9.  Dogri Lalit Nibandh.
        </p>

        <p>The following authors: <br/>
            Vishwa Nath Khajuria, Narayan Mishra, Balkrishan Shastri, Shiv Nath, Shyam Lal Sharma, Lakshmi
            Narayan, D.C. Prashant, Ved Ghai, Kunwar Viyogi.
        </p>
        
        </div>
    </div>

  </div>
</div>


{/* 32. GUJARATI Language */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        32</span> Gujarati 
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Gujarati - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
        
    <p className={`${styles.aboutheading2} text-center`}>
         [Answers must be written in Gujarati]
    </p>


    <p className={`${styles.aboutheading2} text-center`}>
        Section A
    </p>

    <p className={`${styles.aboutheading2} `}>
      Gujarati Language : Form and History
    </p>
        <ul className='list-unstyled'>
            <li>1. History of Gujarati Language with special reference to New Indo-Aryan i.e. last one thousand
            years.</li>
            <li>2. Significant features of the Gujarati language : phonology, morphology and syntax.</li>
            <li>3. Major dialects : Surti, pattani, charotari and Saurashtri.</li>
        </ul>
    <p className={`${styles.aboutheading2} `}>
      Gujarati Language : Form and History
    </p>
    <p className={`${styles.aboutheading2} `}>
        Medieval :
    </p>
        <ul className='list-unstyled'>
            <li>4. Jaina tradition</li>
            <li>5. Bhakti tradition : Sagun and Nirgun (Jnanmargi)</li>
            <li>6. Non-sectarian tradition (Laukik parampara)</li>
        </ul>
    


    <p className={`${styles.aboutheading2} `}>Modern :</p>

        <ul className='list-unstyled'>
            <li>7. Sudharak yug</li>
            <li>8. Pandit yug</li>
            <li>9. Gandhi yug</li>
            <li>10. Anu-Gandhi yug</li>
            <li>11. Adhunik yug</li>
        </ul>

    <p className={`${styles.aboutheading2} text-center`}> Section B </p>

    <p className={`${styles.aboutheading2} `}>Literary Forms :</p>
    <p className={`${styles.aboutheading} `}>
        (Salient features, history and development of the following literary forms :)
    </p>

    <p className={`${styles.aboutheading2} `}>(a) Medieval</p>
  
    <ul className='list-unstyled'>
      <li>1. Narratives : Rasa, Akhyan and Padyavarta</li> 
      <li>2. Lyrical: Pada</li>
    </ul>

    <p className={`${styles.aboutheading2} `}>(b) Folk</p>

    <ul className='list-unstyled'>
        <li>3. Bhavai</li>
    </ul>

    <p className={`${styles.aboutheading2} `}> (c) Modern</p>

    <ul className='list-unstyled'>
        <li>4. Fiction : Novel and Short Story</li>
        <li>5. Drama</li>
        <li>6. Literary Essay</li>
        <li>7. Lyrical Poetry</li>
    </ul>

    <p className={`${styles.aboutheading2} `}> (d) Criticism</p>

      <ul className='list-unstyled'>
        <li>8. History of theoretical Gujarati criticism</li>
        <li>9. Recent research in folk tradition.</li>
      </ul>     
        
      </div>
    </div>

{/*  Gujarati II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
     Gujarati - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      >

        <p className={`${styles.aboutheading2} text-center `}>
            [Answers must be written in Gujarati]
        </p>

        <p className={`${styles.aboutheading2}`}> The paper will require first-hand reading of the texts prescribed and will be designed to test the critical
        ability of the candidate.</p>

        <p className={`${styles.aboutheading2} text-center `}>  Section A</p>

        <p className={`${styles.aboutheading2}`}>
           1. Medieval
        </p>
          
            <ul className='list-unstyled'>
                <li>(i) Vasantvilas phagu — AJNATKRUT</li>
                <li>(ii) Kadambari — BHALAN</li>
                <li>(iii) Sudamacharitra — PREMANAND</li>
                <li>(iv) Chandrachandravatini varta — SHAMAL</li>
                <li>(v) Akhegeeta — AKHO</li>
                
            </ul>

        <p className={`${styles.aboutheading2}`}>
            2. Sudharakyug & Pandityug
        </p>
         
          <ul className='list-unstyled'>
            <li>(vi) Mari Hakikat — NARMADASHA.</li>
            <li>(vii) Farbasveerah — DALPATRAM</li>
            <li>(viii) Saraswatichandra-Part 1 — GOVARDHANRAM TRIPATHI</li>
            <li>(ix) Purvalap — ‘KANT’ (MANISHANKAR RATNAJI BHATT)</li>
            <li>(x) Raino Parvat — RAMANBHAI NEELKANTH</li>
          </ul>

        <p className={`${styles.aboutheading2} text-center`}>Section B</p>

        <p className={`${styles.aboutheading2}`}> 1. Gandhiyug & Anu Gandhiyug</p>

            <ul className='list-unstyled'>
                <li>(i) Hind Swaraj — MOHANDAS KARAMCHAND GANDHI.</li>
                <li>(ii) Patanni Prabhuta — KANHAIYALAL MUNSHI.</li>
                <li>(iii) Kavyani Shakti — RAMNARAYAN VISHWANATH PATHAK.</li>
                <li>(iv) Saurashtrani Rasdhar-Part 1 —  ZAVERCHAND MEGHANI</li>
                <li>(v) Manvini Bhavai — PANNALAL PATEL</li> 
                <li>(vi) Dhvani — RAJENDRA SHAH</li>
            </ul>

        <p className={`${styles.aboutheading2}`}> 2.Adhunik yug</p>
            
            <ul className='list-unstyled'>
                <li>(vii) Saptapadi—UMASHANKAR JOSHI</li>
                <li>(viii) Janantike—SURESH JOSHI</li>
                <li>(ix) Ashwatthama—SITANSHU YASHASCHANDRA.</li>
            </ul>
                
        </div>
    </div>

  </div>
</div>

{/* 33. HINDI Language */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        33</span> HINDI 
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Hindi - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
        
    <p className={`${styles.aboutheading2} text-center`}>
         [Answers must be written in Hindi]
    </p>


    <p className={`${styles.aboutheading2} text-center`}>
        Section A
    </p>

    <p className={`${styles.aboutheading2} `}>
      1. History of Hindi Language and Nagari Lipi
    </p>
        <ul className='list-unstyled'>
            <li>I. Grammatical and applied forms of Apbhransh, Awahatta & Arambhik Hindi.</li>
            <li>II. Development of Braj and Awadhi as Literary language during medieval period.</li>
            <li>III. Early form of Khari-boli in Siddha-Nath Sahitya, Khusero, Sant Sahitaya, Rahim etc. and Dakhni Hindi.</li>
            <li>IV. Development of Khari-boli and Nagari Lipi during 19th Century.</li>
            <li>V. Standardisation of Hindi Bhasha & Nagari Lipi.</li>
            <li>VI. Development of Hindi as a National Language during freedom movement.</li>
            <li>VII. The development of Hindi as a National Language of Union of India.</li>
            <li>VIII. Scientific & Technical Development of Hindi Language.</li>
            <li>IX. Prominent dialects of Hindi and their inter-relationship.</li>
            <li>X. Salient features of Nagari Lipi and the efforts for its reform & Standard form of Hindi.</li>
            <li>XI. Grammatical structure of Standard Hindi.</li>
        </ul>

    <p className={`${styles.aboutheading2} text-center`}> Section B </p>

    <p className={`${styles.aboutheading2} `}>2. History of Hindi Literature</p>
    <p className={`${styles.aboutheading} `}>
        I. The relevance and importance of Hindi literature and tradition of writing History of Hindi Literature.
    </p>
    <p className={`${styles.aboutheading} `}>
        II. Literary trends of the following four periods of history of Hindi Literature.
    </p>

    <p className={`${styles.aboutheading} `}>
       A : Adikal—Sidh, Nath and Raso Sahitya. <br/>
       Prominent poets—Chandvardai, Khusaro, Hemchandra, Vidyapati.
    </p>

    <p className={`${styles.aboutheading} `}>
      B : Bhaktikal—Sant Kavyadhara, Sufi Kavyadhara, Krishna Bhaktidhara and Ram Bhaktidhara. <br/>
      Prominent Poets—Kabir, Jayasi, Sur & Tulsi.
    </p>

    <p className={`${styles.aboutheading} `}>
      C : Ritikal—Ritikavya, Ritibaddhkavya & Riti Mukta Kavya. Prominent Poets—Keshav, Bihari,
      Padmakar and Ghananand.
    </p>

    <p className={`${styles.aboutheading} `}>
       D: Adhunik Kal —
    </p>

     <ul className='list-unstyled'>
        <li>a. Renaissance, the development of Prose, Bharatendu Mandal.</li>
        <li>b. Prominent Writers—Bharatendu, Bal Krishna Bhatt & Pratap Narain Mishra.</li>
        <li>c. Prominent trends of modern Hindi Poetry: Chhayavad, Pragativad, Prayogvad, Nai Kavita,
          <br/>  Navgeet and Contemporary poetry and Janvadi Kavita. <br/>

            Prominent Poets—Maithili Sharan Gupta, Prasad, Nirala, Mahadevi, Dinkar, Agyeya,
            Muktibodh, Nagarjun.
        </li>
     </ul>

    <p className={`${styles.aboutheading2} `}> 3. Katha Sahitya </p>

       <ul className='list-unstyled'>
          <li>A : Upanyas & Realism</li>
          <li>B : The origin and development of Hindi Novels.</li>
          <li>C : ProminentNovelists—Premchand, Jain-endra, Yashpal, Renu and Bhism Sahani.</li>
          <li>D : The origin and development of Hindi short story.</li>
          <li>E : Prominent Short Story Writers—Premchand, Prasad, Agyeya, Mohan Rakesh & Krishna Sobti.</li>
       </ul>

   <p className={`${styles.aboutheading2} `}> 4. Drama & Theatre</p>

    <ul className='list-unstyled'>
        <li>A : The Origin & Development of Hindi Drama.</li>
        <li>B : Prominent Dramatists—Bharatendu, Prasad, Jagdish Chandra Mathur, Ram Kumar Verma, Mohan Rakesh.</li>
        <li>C : The development of Hindi Theatre.</li>
    </ul>

    <p className={`${styles.aboutheading2} `}> 5. Criticism</p>
      
      <ul className='list-unstyled'>
        <li>A : The origin and development of Hindi criticism : Saiddhantik, Vyavharik, Pragativadi.
                Manovishleshanvadi & Nai Alochana.
        </li>

        <li>B : Prominent critics—Ramchandra Shukla, Hajari Prasad Dwivedi, Ram Vilas Sharma & Nagendra.</li>
      </ul>

    <p className={`${styles.aboutheading} `}><span className='' style={{fontWeight:"bold"}}> 6. The other form of Hindi prose — </span> Lalit Nibandh,Rekhachitra, Sansmaran, Yatra-vrittant.</p>
  
  
      </div>
    </div>

{/*  Gujarati II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
     Hindi - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      >

        <p className={`${styles.aboutheading2} text-center `}>
            [Answers must be written in Hindi]
        </p>

        <p className={`${styles.aboutheading} text-center`}> The paper will require first-hand reading of the prescribed texts and will test the critical ability of the candidates.</p>

        <p className={`${styles.aboutheading2} text-center `}>Section A</p>

         <ul className='list-unstyled'>
          <li><span className="" style={{ fontWeight: "bold" }}>1. Kabir   : </span>   Kabir Granthawali, Ed. Shyam Sundar Das (First hundred Sakhis)</li>
          <li><span className="" style={{ fontWeight: "bold" }}>2. Soordas : </span>   Bhramar Geetsar, Ed. Ramchandra Shukla (First hundred Padas)</li>
          <li><span className="" style={{ fontWeight: "bold" }}>3. Tulsidas : </span> Ramcharit Manas (Sundar Kand) Kavitawali (Uttarkand)</li>
          <li><span className="" style={{ fontWeight: "bold" }}>4. Jayasi : </span>Padmawat Ed. Shyam Sundar Das (Sinhal Dwip Khand & Nagmativiyog Khand)</li>
          <li><span className="" style={{ fontWeight: "bold" }}>5. Bihari :</span> Bihari Ratnakar Ed. Jagnnath Prasad Ratnakar (First 100 Dohas)</li>
          <li><span className="" style={{ fontWeight: "bold" }}>6. Maithili Sharan : </span> Bharat Bharati Gupta</li>
          <li><span className="" style={{ fontWeight: "bold" }}>7. Prasad : </span> Kamayani (Chinta and Shraddha Sarg)</li>
          <li><span className="" style={{ fontWeight: "bold" }}>8. Nirala : </span>Rag-Virag, Ed. Ram Vilas Sharma (Ram Ki Shakti Pooja & Kukurmutta)</li>
          <li><span className="" style={{ fontWeight: "bold" }}>9. Dinkar : </span> Kurukshetra</li>
          <li><span className="" style={{ fontWeight: "bold" }}>10. Agyeya : </span> Angan Ke Par Dwar (Asadhya Veena)</li>
          <li><span className="" style={{ fontWeight: "bold" }}>11. Muktiboth : </span> Brahm Rakhashas</li>
          <li><span className="" style={{ fontWeight: "bold" }}>12. Nagarjun : </span> Badal Ko Ghirte Dekha Hai, Akal Ke Bad, Harijan Gatha.</li>
        </ul>

        <p className={`${styles.aboutheading2} text-center`}>Section B</p>

        <ul className='list-unstyled'>
            <li><span className="" style={{ fontWeight: "bold" }}>1. Bharatendu   : </span>Bharat Durdasha </li>
            <li><span className="" style={{ fontWeight: "bold" }}>2. Mohan Rakesh : </span>Ashadh Ka Ek Din</li>
            <li><span className="" style={{ fontWeight: "bold" }}>3. Ramchandra   : </span>Chintamani (Part I) (KavitaKya Shukla Hai, ShraddhaAurBhakti)</li>
            <li><span className="" style={{ fontWeight: "bold" }}>4. Dr. Satyendra: </span> Nibandh Nilaya—Bal Krishna Bhatt, Premchand, Gulab Rai, Hajari Prasad Dwivedi, Ram Vilas Sharma, Agyeya, Kuber Nath Rai.</li>
            <li><span className="" style={{ fontWeight: "bold" }}>5. Premchand : </span>Godan, Premchand ki Sarvashreshtha Kahaniyan, Ed. Amrit Rai/Manjusha—Prem Chand ki Sarvashreshtha Kahaniyan. Ed. Amrit Rai. </li>
            <li><span className="" style={{ fontWeight: "bold" }}>6.Prasad :</span>Skandgupta</li>
            <li><span className="" style={{ fontWeight: "bold" }}>7.Yashpal :</span>Divya</li>
            <li><span className="" style={{ fontWeight: "bold" }}>8.Phaniswar Nath :</span>Maila Anchal Renu</li>
            <li><span className="" style={{ fontWeight: "bold" }}>9.Mannu Bhandari :</span>Mahabhoj</li>
            <li><span className="" style={{ fontWeight: "bold" }}>10.Rajendra Yadav : </span>Ek Dunia Samanantar (All Stories)</li>
        </ul>     
        </div>
    </div>

  </div>
</div>

{/* 34. KANNADA Language */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        34</span> KANNADA 
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Kannada - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
        
    <p className={`${styles.aboutheading2} text-center`}>
         [Answers must be written in Kannada    ]
    </p>


    <p className={`${styles.aboutheading2} text-center`}>
        Section A
    </p>

    <p className={`${styles.aboutheading2} `}>
      A. History of Kannada Language
    </p>
        <ul className='list-unstyled'>
            <li>
                What is Language ? General characteristics of Language. Dravidian Family of Languages and its specific
                features. Antiquity of Kannada Language. Different phases of its Development.
            </li>

            <li>
                Dialects of Kannada Language : Regional and Social. Various aspects of developments of Kannada
                Language: phonological and Semantic changes. Language borrowing.
            </li>
        </ul>

    <p className={`${styles.aboutheading2} `}>
      B. History of Kannada Literature
    </p>

    <p className={`${styles.aboutheading} `}>
        Ancient Kannada literature : Influence and Trends, Poets for study : Specified poets from Pampa to
        Ratnakara Varni are to be studied in the light of contents, form and expression : Pampa, Janna,
        Nagachandra.
    </p>

    <p className={`${styles.aboutheading} `}>
        Medieval Kannada literature : Influence and Trends.
    </p>

    <p className={`${styles.aboutheading} `}>
        Vachana Literature : Basavanna, Akka Mahadevi.
    </p>

    <p className={`${styles.aboutheading} `}>
        Medieval Poets : Harihara, Raghavanka, Kumara-Vyasa.
    </p>

    <p className={`${styles.aboutheading} `}>
      Dasa literature : Purandara and Kanaka.
    </p>

    <p className={`${styles.aboutheading} `}>
        Sangataya : Ratnakarvarni
    </p>

    <p className={`${styles.aboutheading2} `}>
      C. Modern Kannada literature 
    </p>

     <p className={`${styles.aboutheading} `}>
        Influence, trends and ideologies, Navodaya, Pragatishila, Navya, Dalita and Bandaya.
    </p>

    <p className={`${styles.aboutheading2} text-center`}>
        Section B
    </p>

    <p className={`${styles.aboutheading2} `}>
      A. Poetics and Literary Criticism 
    </p>

     <p className={`${styles.aboutheading} `}>
        Definition and concepts of poetry; Word, Meaning, Alankara, Reeti, Rasa, Dhwani, Auchitya.
    </p>

    <p className={`${styles.aboutheading} `}>
        Interpretations of Rasa Sutra. Modern Trends of literary criticism : Formalist, Historical, Marxist,
        Feminist, Post-colonial criticism.
    </p>

    <p className={`${styles.aboutheading2} `}>
      B. Cultural History of Karnataka
    </p>

    <p className={`${styles.aboutheading} `}>
        Contribution of Dynasties to the culture of Karnataka: Chalukyas of Badami and Kalyani,
        Rashtrakutas, Hoysalas, Vijayanagara rulers, in literary context.
    </p>

    <p className={`${styles.aboutheading} `}>
        Major religions of Karnataka and their cultural contribution.
    </p>

    <p className={`${styles.aboutheading} `}>
        Arts of Karnataka ; Sculpture, Architecture, Painting, Music, Dance—in the literary context.
        Unification of Karnataka and its impact of Kannada literature.
    </p>

      </div>
    </div>

{/*  KANNADA II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
     KANNADA - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      >

        <p className={`${styles.aboutheading2} text-center `}>
            [Answers must be written in Kannada]
        </p>

        <p className={`${styles.aboutheading} text-center`}> The Paper will require first-hand reading of the Texts prescribed and will be designed to test the critical ability of the candidates.</p>

        <p className={`${styles.aboutheading2} text-center `}>Section A</p>

        <p className={`${styles.aboutheading2}`}> A. Old Kannada Literature</p>

        <p className={`${styles.aboutheading}`}>1. Vikramaarjuna Vijaya of Pampa (Cantos 12 & 13), (Mysore University Pub.)</p>
        <p className={`${styles.aboutheading}`}>2. Vaddaraadhane (Sukumaraswamyia Kathe, Vidyutchorana Kathe)</p>

        <p className={`${styles.aboutheading2}`}> B. Medieval Kannada Literature</p>

        <p className={`${styles.aboutheading}`}>1. Vachana, Kammata, Ed. K. Marulasiddappa K.R. Nagaraj (Bangalore University Pub.)</p>
        <p className={`${styles.aboutheading}`}>2. Janapriya Kanakasamputa, Ed. D. Javare Gowda (Kannada and Culture Directorate, Bangalore)</p>
        <p className={`${styles.aboutheading}`}>3. Nambiyannana Ragale, Ed., T.N. Sreekantaiah (Ta. Vem. Smaraka Grantha Male, Mysore)</p>  
        <p className={`${styles.aboutheading}`}>4. Kumaravyasa Bharata : Karna Parva (Mysore University)</p>
        <p className={`${styles.aboutheading}`}>5. Bharatesha Vaibhava Sangraha Ed Ta. Su. Shama Rao (Mysore University)</p> 
        
        <p className={`${styles.aboutheading2} text-center `}>Section B</p>
        <p className={`${styles.aboutheading2}`}>A. Modern Kannada Literature</p> 

        <ul className='list-unstyled'>
            <li><span className="" style={{ fontWeight: "bold" }}>1. Poetry   : </span> Hosagannada Kavite, Ed. G.H. Nayak (Kannada Saahitya Parishattu,Bangalore)</li>
            <li><span className="" style={{ fontWeight: "bold" }}>2. Novel    : </span>Bettada Jeeva—Shivarama Karanta Madhavi—Anupama NiranjanaOdalaala-Deva-nuru Mahadeva</li>
            <li><span className="" style={{ fontWeight: "bold" }}>3. Short Story    : </span>Kannada Sanna Kathegalu, Ed. G.H. Nayak (Sahitya Academy, New Delhi)</li>
            <li><span className="" style={{ fontWeight: "bold" }}>4. Drama    : </span>Shudra Tapaswi—Kuvempu. Tughalak—Girish Karnad.</li>
            <li><span className="" style={{ fontWeight: "bold" }}>5. Vichara Sahitya    : </span>Devaru—A.N. Moorty Rao (Pub: D.V.K.Moorty, Mysore.)</li>
        </ul>

        <p className={`${styles.aboutheading2}`}> B. Folk Literature :</p>
            <ul className='list-unstyled'>
                <li><span className="" style={{ fontWeight: "bold" }}>1. Janapada Swaroopa — </span> Dr. H.M. Nayak. (Ta. Vem. Smaraka Grantha Male, Mysore.) </li>
                <li><span className="" style={{ fontWeight: "bold" }}>2. Janpada Geetaanjali — </span>Ed. D. Javare Gowda.(Pub : Sahitya Academy, New Delhi).</li>
                <li><span className="" style={{ fontWeight: "bold" }}>3. Kannada Janapada Kathegalu — Ed. J.S. Paramashiviaah (Mysore University).</span></li>
                <li>4. Beedi Makkalu Beledo. Ed. Kalegowda Nagavara (Pub : Bangalore University).</li>
                <li>5. 5. Savirada Ogatugalu—Ed. S.G. Imrapura.</li>
            </ul>

        </div>
    </div>

  </div>
</div>

{/* 35. KASHMIRI Language */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        35</span> KASHMIRI 
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Kashmiri - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
        
    <p className={`${styles.aboutheading2} text-center`}>
         [Answers must be written in Kashmiri ]
    </p>


    <p className={`${styles.aboutheading2} text-center`}>
        Section A
    </p>

    <p className={`${styles.aboutheading} `}>
        1. Genealogical relationship of the Kashmiri language: various theories.
    </p>

    <p className={`${styles.aboutheading} `}>
        2. Areas of occurence and dialects (geographical/social)
    </p>

    <p className={`${styles.aboutheading2} `}>
        3. Phonology and grammar:
    </p>
    <p className={`${styles.aboutheading} `}>
        i. Vowel and consonant system;
    </p>
    <p className={`${styles.aboutheading} `}>
        ii. Nouns and pronouns with various case inflections;
    </p>
    <p className={`${styles.aboutheading} `}>
        iii. Verbs: various types and tenses.
    </p>

    <p className={`${styles.aboutheading2} `}>
        4. Syntactic structure:
    </p>
    <ul className='list-unstyled'>
        <li>i. Simple, active and declarative statements;</li>
        <li>ii. Coordination;</li>
        <li>iii. Relativisation.</li>
    </ul>

    <p className={`${styles.aboutheading2} text-center`}>
        Section B
    </p>

    <p className={`${styles.aboutheading} `}>
        1. Kashmiri literature in the 14th century (Socio-cultural and intellectual background with special
        reference to Lal Dyad and Sheikhul Alam).
    </p>

    <p className={`${styles.aboutheading} `}>
        2. Nineteenth century Kashmiri literature (development of various genres : vatsun; ghazal and mathnavi).
    </p>

    <p className={`${styles.aboutheading} `}>
        3. Kashmiri literature in the first half of the twentieth century (with special reference to Mahjoor and
        Azad; various literary influences).
    </p>

    <p className={`${styles.aboutheading} `}>
        4. Modern Kashmiri literature (with special reference to the development of the short story, drama,
        novel and nazm).
    </p>

 </div>
</div>

{/*  KANNADA II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
     Kashmiri - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      >

        <p className={`${styles.aboutheading2} text-center `}>
            [Answers must be written in Kashmiri]
        </p>

        <p className={`${styles.aboutheading2} text-center `}>Section A</p>

        <p className={`${styles.aboutheading2}`}>1. Intensive study of Kashmiri poetry up to the nineteenth century :</p>

        <p className={`${styles.aboutheading}`}>(i) Lal Dyad,</p>
        <p className={`${styles.aboutheading}`}>(ii) Sheikhul Aalam</p>
        <p className={`${styles.aboutheading}`}>(iii) Habba Khatoon</p>

        <p className={`${styles.aboutheading2}`}>2. Kashmiri poetry : 19th Century</p>

        <p className={`${styles.aboutheading}`}>(i) Mahmood Gami (Vatsans),</p>
        <p className={`${styles.aboutheading}`}>(ii) Maqbool shah (Gulrez)</p>
        <p className={`${styles.aboutheading}`}>(iii) Rasool Mir (Ghazals)</p>
        <p className={`${styles.aboutheading}`}>(iv) Abdul Ahad Nadim (N’at)</p>
        <p className={`${styles.aboutheading}`}>(v) Krishanjoo Razdan (Shiv Lagun)</p>
        <p className={`${styles.aboutheading}`}>(vi) Sufi Poets (Test in Sanglaab, published by the Deptt. of Kashmiri, University of Kashmir)</p>

        <p className={`${styles.aboutheading2}`}>3. Twentieth Century Kashmiri poetry (text in Azich Kashir Shairi, published by the Deptt. of Kashmiri,
            University of Kashmir).
        </p>

        <p className={`${styles.aboutheading2}`}>4. Literary criticism and research work : development and various trends.</p>
        
        <p className={`${styles.aboutheading2} text-center `}>Section B</p>

        <p className={`${styles.aboutheading2}`}>1. An analytical study of the short story in Kashmiri.</p>

        <p className={`${styles.aboutheading}`}>(i)   Afsana Majmu’a, published by the Deptt. of Kashmiri, University of Kashmir.</p>
        <p className={`${styles.aboutheading}`}>(ii)  Kashur Afsana Az, published by the Sahitya Akademi.</p>
        <p className={`${styles.aboutheading}`}>(iii) Hamasar Kashur Afsana, published by the Sahitya Akademi. <br/>
            The following short story writers only : Akhtar Mohi-ud Din, Kamil, Hari Krishan Kaul, Hraday Kaul
            Bharti, Bansi Nirdosh, Gulshan Majid.
        </p>

        <p className={`${styles.aboutheading2}`}>2. Novel in Kashmiri :</p>
        <p className={`${styles.aboutheading}`}>(i) Mujrim by G. N. Gowhar</p>
        <p className={`${styles.aboutheading}`}>(ii) Marun—Ivan Ilyichun, (Kashmiri version of Tolstoy’s) The Death of Ivan Ilyich (published by Kashmiri Deptt.)</p>

        <p className={`${styles.aboutheading2}`}>3. Drama in Kashmiri :</p>
        <p className={`${styles.aboutheading}`}>(i) Natuk Kariv Band by Hari Krishan Kaul</p>
        <p className={`${styles.aboutheading}`}>(ii) Qk Angy Natuk, ed. Motilal Keemu, published by the Sahitya Akademi.</p>
        <p className={`${styles.aboutheading}`}>(iii) Razi Oedipus, tr. Naji Munawar, published by the Sahitya Akademi.</p>

        <p className={`${styles.aboutheading2}`}>4. Kashmiri Folk Literature :</p>

        <p className={`${styles.aboutheading}`}>(i) Kashur Luki Theatre by Mohammad Subhan Bhagat,published by the Deptt. of Kashmiri, University of Kashmir.</p>
        <p className={`${styles.aboutheading}`}>(ii) Kashiry Luki Beeth (all volumes) published by the J&K Cultural Akademy.</p>

        </div>
    </div>

  </div>
</div>

{/* 36. KONKANI Language */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        36</span> KONKANI 
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Konkani - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
        
    <p className={`${styles.aboutheading2} text-center`}>
         [Answers must be written in Konkani]
    </p>


    <p className={`${styles.aboutheading2} text-center`}>
        Section A
    </p>

    <p className={`${styles.aboutheading2} `}>
        History of the Konkani Language :
    </p>

    <p className={`${styles.aboutheading} `}>
       (i) Origin and development of the language and influences on it.
    </p>

    <p className={`${styles.aboutheading} `}>
      (ii) Major variants of Konkani and their linguistic features.
    </p>

    <p className={`${styles.aboutheading} `}>
      (iii) Grammatical and lexicographic work in Konkani, including a study of cases, adverbs,indeclinables and voices.
    </p>

    <p className={`${styles.aboutheading} `}>
        (iv) Old Standard Konkani, New Standard and Standardisation problems.
    </p>

     <p className={`${styles.aboutheading2} text-center`}>
        Section B
    </p>
    

    <p className={`${styles.aboutheading2} `}>
        History of Konkani Literature
    </p>
    <p>
        Candidates would be expected to be well-acquainted with Konkani literature and its social and
        cultural background and consider the problems and issues arising out of them.
    </p>

    <ul className='list-unstyled'>
        <li>
            (i) History of Konkani literature from its probable source to the present times, with emphasis on its
            major works, writers and movements.</li>
        <li>(ii) Social and cultural background of the making of Konkani literature from time to time.</li>
        <li>(iii) Indian and Western influences on Konkani literature, from the earliest to modern times.</li>
        <li>(iv) Modern literary trends in the various genres and regions including a study of Konkani folklore.</li>
    </ul>

   

 </div>
</div>

{/*  Konkani II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
     Konkani - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      >

        <p className={`${styles.aboutheading2} text-center `}>
            [Answers must be written in Konkani]
        </p>
        <p className={`${styles.aboutheading2} text-center `}>
          Textual Criticism of Konkani Literature
        </p>

        <p>
            The paper will be designed to test the candidate’s critical and analytical abilities. Candidates would be
            expected to be well-acquainted with Konkani Literature and required to have first-hand reading of the
            following texts :
        </p>

        <p className={`${styles.aboutheading2} text-center `}>Section A : Prose</p>

        <p className={`${styles.aboutheading}`}>
            1. <br/>(a) Konkani Mansagangotri (excluding poetry) ed. by Prof : Olivinho Gomes. <br/>
               (b) Old Konkani language and literature—the Portuguese Role
        </p>
        <p className={`${styles.aboutheading}`}>
            2. <br/>(a) Otmo Denvcharak — a novel by A. V. da Cruz. <br/>
                (b) Vadoll ani Varem — a novel by Antonio Pereira. <br/>
                (c) Devache Kurpen — a novel by V.J.P. Saldanha.
        </p>

        <p className={`${styles.aboutheading}`}>
            3.  <br/>(a) Vajralikhani — Shenoy goem-bab-An anthology-ed. by Shantaram Varde Valavalikar. <br/>
                (b) Konkani Lalit Niband — Essays-ed. by Shyam Verenkar. <br/>
                (c) Teen Dasakam—An anthology—ed. by Chandrakant Keni.
        </p>

        <p className={`${styles.aboutheading}`}>
            4.<br/> (a) Demand—Drama-by Pundalik Naik.<br/>
                (b) Kadambini: A Miscellany of Modern Prose—ed. by Prof. O.J.F. Gomes and Smt. P.S. Tadkodkar.<br/>
                (c) Ratha Tujeo Ghudieo—by Smt. Jayanti Naik.
        </p>

        <p className={`${styles.aboutheading2} text-center `}>Section B : Poetry</p>

        <p className={`${styles.aboutheading}`}>
            1. <br/>(a) Ev ani Mori : Poetry by Eduardo Bruno de Souza. <br/>
                    (b) Abravanchem Yadnyadan—by Luis Mascarenhas
        </p>
        <p className={`${styles.aboutheading}`}>
            2. <br/>(a) Godde Ramayan—ed. by R.K. Rao.<br/>
                    (b) Ratnahar I and II—collection of poems—ed. R. V. Pandit. <br/>
        </p>

        <p className={`${styles.aboutheading}`}>
            3.  <br/>(a) Zayo Zuyo—poems- Manohar L. Sardessai. <br/>
                     (b) Kanadi Mati Konkani Kavi—Anthology ofPoems—ed. Pratap Naik. <br/>
        </p>

        <p className={`${styles.aboutheading}`}>
            4.<br/> (a) Adrushatache Kalle—Poems by Pandurang Bhangui.<br/>
                    (b) Yaman—Poems by Madhav Borkar.<br/>
        </p>


        </div>
    </div>

  </div>
</div>

{/* 37. MAITHILI Language */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        37</span> MAITHILI 
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Maithili  - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
    <p className={`${styles.aboutheading2} text-center`}>
        HISTORY OF MAITHILI LANGUAGE AND ITS LITERATURE
    </p>
        
    <p className={`${styles.aboutheading2} text-center`}>
         [Answers must be written in Maithili]
    </p>


    <p className={`${styles.aboutheading2} text-center`}>
        Section A
    </p>

    <p className={`${styles.aboutheading2} `}>
        History of Maithili Language
    </p>

    <p className={`${styles.aboutheading} `}>
        1. Place of Maithili in Indo-European Language family.
    </p>

    <p className={`${styles.aboutheading} `}>
        2. Origin and development of Maithili language. (Sanskrit, Prakrit, Avhatt, Maithili)
    </p>

    <p className={`${styles.aboutheading} `}>
        3. Periodic division of Maithili Language. (Beginning, Middle era, Modern era).
    </p>

    <p className={`${styles.aboutheading} `}>
       4. Maithili and its different dialects.
    </p>

   <p className={`${styles.aboutheading} `}>
       5. Relationship between Maithili and other Eastern languages (Bengali, Asamese, Oriya)
    </p>

    <p className={`${styles.aboutheading} `}>
      6. Origin and Development of Tirhuta Script.
    </p>

    <p className={`${styles.aboutheading} `}>
        7. Pronouns and Verbs in Maithili Language.
    </p>

     <p className={`${styles.aboutheading2} text-center`}>
        Section B
    </p>
    

    <p className={`${styles.aboutheading2} `}>
        History of Maithili Literature
    </p>

    <ul className='list-unstyled'>
       <li> 1. Background of Maithili Literature (Religious, Economic, Social, Cultural).</li>
       <li> 2. Periodic division of Maithili literature.</li>
       <li> 3. Pre-Vidyapati Literature.</li>
       <li> 4. Vidyapati and his tradition.</li>
       <li> 5. Medieval Maithili Drama (Kirtaniya Natak, Ankia Nat, Maithili dramas written in Nepal).</li>
       <li> 6. Maithili Folk Literature (Folk Tales, Folk Drama, Folk Stories, Folk Songs).</li>
    </ul>

   <p className={`${styles.aboutheading} `}> 7. Development of different literary forms in modern era :</p>

    <ul className='list-unstyled'>
        <li>(a) Prabandh-kavya</li>
        <li>(b) Muktak-kavya</li>
        <li>(c) Novel</li>
        <li>(d) Short Story</li>
        <li>(e) Drama</li>
        <li>(f) Essay</li>
        <li>(g) Criticism </li>
        <li>(h) Memoirs </li>
        <li>(i) Translation </li>
    </ul>

    <p className={`${styles.aboutheading} `}> 8. Development of Maithili Magazines and Journals.</p>

 </div>
</div>

{/* Maithili II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
     Maithili - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      > 
      <p className={`${styles.aboutheading2} text-center `}>
            [Answers must be written in Konkani]
        </p>

        <p className={`${styles.aboutheading} text-center`}>
            The paper will require first-hand reading of the prescribed texts and will test the critical ability of
            the candidates.
        </p>

        <p className={`${styles.aboutheading2} text-center `}>Section A </p>

        <p className={`${styles.aboutheading2}`}>Poetry</p>

        <p className={`${styles.aboutheading}`}>
            1. Vidyapati Geet-Shati—Publisher : Sahitya Akademi, New Delhi (Lyrics— 1 to 50)
        </p>
        <p className={`${styles.aboutheading}`}>
            2. Govind Das Bhajanavali—Publisher : Maithili Acadamy, Patna (Lyrics— 1 to 25)
        </p>

        <p className={`${styles.aboutheading}`}>
            3. Krishnajanm—Manbodh
        </p>

        <p className={`${styles.aboutheading}`}>
            4.Mithilabhasha Ramayana—Chanda Jha (only Sunder-Kand)
        </p>

        <p className={`${styles.aboutheading}`}>
            5. Rameshwar Charit Mithila Ramayan—Lal Das (only Bal-kand)
        </p>
        <p className={`${styles.aboutheading}`}>
            6. Keechak-Vadh—Tantra Nath Jha.
        </p>

        <p className={`${styles.aboutheading}`}>
            7. Datta-Vati—Surendra Jah ‘Suman’ (only 1st and 2nd Cantos).
        </p>

        <p className={`${styles.aboutheading}`}>
            8. Chitra-Yatri
        </p>
        <p className={`${styles.aboutheading}`}>
            9. Samakaleen Maithili Kavita—Publisher: Sahitaya Akademi, New Delhi.
        </p>

        <p className={`${styles.aboutheading2} text-center `}>Section B </p>

        <p className={`${styles.aboutheading}`}>
           10. Varna Ratnakar—Jyotirishwar (only 2nd Kallol)
        </p>
        <p className={`${styles.aboutheading}`}>
           11. Khattar Kakak Tarang—Hari Mohan Jha
        </p>

        <p className={`${styles.aboutheading}`}>
           12. Lorik—Vijaya Manipadma
        </p>

        <p className={`${styles.aboutheading}`}>
            13. Prithvi Putra—Lalit
        </p>

        <p className={`${styles.aboutheading}`}>
           14. Bhaphait Chahak Jinagi—Sudhanshu ‘Shekhar’ Choudhary
        </p>
        <p className={`${styles.aboutheading}`}>
            15. Kriti Rajkamlak—Publisher: Maithili Acadamy, Patna (First Ten Stories only)
        </p>

        <p className={`${styles.aboutheading}`}>
            16. Katha–Sangrah–Publisher: Maithili Acadamy, Patna.
        </p>

        </div>
    </div>
  </div>
</div>

{/* 38. MALAYALAM Language */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        38</span> MALAYALAM 
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Malayalam - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
        
    <p className={`${styles.aboutheading2} text-center`}>
         [Answers must be written in Malayalam]
    </p>

    <p className={`${styles.aboutheading2} text-center`}>
        Section A
    </p>

    <p className={`${styles.aboutheading2} `}>
        (1) Early phase of Malayalam Language :
    </p>

    <p className={`${styles.aboutheading} `}>1.1 Various theories : Origin from proto Dravidian, Tamil, Sanskrit.</p>
    <p className={`${styles.aboutheading} `}>1.2 Relation between Tamil and Malayalam : Six nayas of A. R. Rajarajavarma.</p>
    <p className={`${styles.aboutheading} `}>1.3 Pattu School—Definition, Ramacharitam, later pattu works—Niranam works and Krishnagatha.</p>

    <p className={`${styles.aboutheading2} `}>
        (2) Linguistic features of :
    </p>

    <p className={`${styles.aboutheading} `}>2.1 Manipravalam—definition. Language of early manipravala works—Champu, Sandesakavya, Chandrotsava, minor works. Later manipravala works—medieval Champu and Attakkatha.</p>
    <p className={`${styles.aboutheading} `}>2.2 Folklore—Southern and Northern ballads, Mappila songs.</p>
    <p className={`${styles.aboutheading} `}>2.3 Early Malayalam Prose—Bhashakautaliyam, Brahmandapuranam, Attaprakaram, Kramadipika and Nambiantamil.</p>

    <p className={`${styles.aboutheading2} `}>
        (3) Standardisation of Malayalam :
    </p>

    <p className={`${styles.aboutheading} `}>3.1 Peculiarities of the language of Pana, Kilippattu and Tullal.</p>
    <p className={`${styles.aboutheading} `}>3.2 Contributions of indigenous and European missionaries to Malayalam.</p>
    <p className={`${styles.aboutheading} `}>3.3 Characteristics of contemporary Malayalam; Malayalam as administrative language. Language of scientific and technical literature—media language.</p>

    <p className={`${styles.aboutheading2} text-center`}>
        Section B
    </p>

    <p className={`${styles.aboutheading2} text-center`}>
        LITERARY HISTORY
    </p>

    <p className={`${styles.aboutheading2} `}>(4) Ancient and Medieval Literature :</p>

    <p className={`${styles.aboutheading} `}>4.1 Pattu—Ramacharitam, Niranam Works and Krishnagatha.</p>
    <p className={`${styles.aboutheading} `}>4.2 Manipravalam—early and medieval manipravala works including attakkatha and champu.</p>
    <p className={`${styles.aboutheading} `}>4.3 Folk Literature.</p>
    <p className={`${styles.aboutheading} `}>4.4 Kilippattu, Tullal and Mahakavya.</p>

    <p className={`${styles.aboutheading2} `}>(5) Modern Literature—Poetry :</p>

    <p className={`${styles.aboutheading}`}>5.1 Venmani poets and contemporaries.</p>
    <p className={`${styles.aboutheading}`}>5.2 The advent of Romanticism—Poetry of Kavitraya i.e., Asan, Ulloor and Vallathol.</p>
    <p className={`${styles.aboutheading}`}>5.3 Poetry after Kavitraya.</p>
    <p className={`${styles.aboutheading}`}>5.4 Modernism in Malayalam Poetry.</p>

    <p className={`${styles.aboutheading2} `}>(6) Modern Literature—Prose :</p>

    <p className={`${styles.aboutheading}`}>6.1 Drama.</p>
    <p className={`${styles.aboutheading}`}>6.2 Novel.</p>
    <p className={`${styles.aboutheading}`}>6.3 Short story.</p>
    <p className={`${styles.aboutheading}`}>6.4 Biography, travelogue, essay and criticism.</p>

 </div>
</div>

{/* Malayalam) II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
     Malayalam - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      > 
      <p className={`${styles.aboutheading2} text-center `}>
            [Answers must be written in Malayalam]
        </p>

        <p className={`${styles.aboutheading} text-center`}>
            This paper will require first hand reading of the texts prescribed and is designed to test the candidate’s critical ability.
        </p>

        <p className={`${styles.aboutheading2} text-center `}>Section A </p>

        <p className={`${styles.aboutheading2}`}>Unit 1</p>

            <p className={`${styles.aboutheading}`}>
                1.1 Ramacharitam—Patalam 
            </p>
            <p className={`${styles.aboutheading}`}>
                1.2 Kannassaramayanam—Balakandam first 25 stanzas.
            </p>

            <p className={`${styles.aboutheading}`}>
                1.3 Unnunilisandesam—Purvabhagam 25 slokas including Prastavana.
            </p>

            <p className={`${styles.aboutheading}`}>
                1.4 Mahabharatham Kilippattu—Bhishmaparvam.
            </p>

        <p className={`${styles.aboutheading2}`}>Unit 2</p>

            <p className={`${styles.aboutheading}`}>
                2.1 Kumaran Asan—Chintavisthayaya Sita.
            </p>
            <p className={`${styles.aboutheading}`}>
                2.2 Vailoppilli—Kutiyozhikkal.
            </p>
            <p className={`${styles.aboutheading}`}>
                2.3 G. Sankara Kurup—Perunthachan.
            </p>
            <p className={`${styles.aboutheading}`}>
                2.4 N. V. Krishna Variar—Tivandiyile pattu.
            </p>

        <p className={`${styles.aboutheading2}`}>Unit 3</p>

            <p className={`${styles.aboutheading}`}>
                3.1 O. N. V.—Bhumikkoru Charamagitam.
            </p>
            <p className={`${styles.aboutheading}`}>
                3.2 Ayyappa Panicker—Kurukshetram.
            </p>
            <p className={`${styles.aboutheading}`}>
                3.3 Akkittam—Pandatha Messanthi.
            </p>
            <p className={`${styles.aboutheading}`}>
                3.4 Attur Ravivarma—Megharupan.
            </p>

        <p className={`${styles.aboutheading2} text-center`}>Section B</p>

        <p className={`${styles.aboutheading2}`}>Unit 4</p>

            <p className={`${styles.aboutheading}`}>
                4.1 O. Chanthu Menon—Indulekha.
            </p>
            <p className={`${styles.aboutheading}`}>
                4.2 Thakazhy—Chemmin.
            </p>
            <p className={`${styles.aboutheading}`}>
                4.3 O. V. Vijayan—Khasakkinte Ithihasam.
            </p>

        <p className={`${styles.aboutheading2}`}>Unit 5</p>

            <p className={`${styles.aboutheading}`}>
                5.1 M. T. Vasudevan Nair—Vanaprastham (Collection).
            </p>
            <p className={`${styles.aboutheading}`}>
                5.2 N. S. Madhavan—Higvitta (Collection).
            </p>
            <p className={`${styles.aboutheading}`}>
                5.3 C. J. Thomas—1128-il Crime 27.
            </p>

        <p className={`${styles.aboutheading2}`}>Unit 6</p>
            <p className={`${styles.aboutheading}`}>
                6.1 Kuttikrishna Marar—Bharataparyatanam.
            </p>
            <p className={`${styles.aboutheading}`}>
                6.2 M. K. Sanu—Nakshatrangalute Snehabhajanam.
            </p>
            <p className={`${styles.aboutheading}`}>
                6.3 V. T. Bhatttathirippad—Kannirum Kinavum.
            </p>  
        
        </div>
    </div>
  </div>
</div>

{/* 39. MANIPURI Language */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        39</span> MANIPURI 
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Manipuri - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
        
    <p className={`${styles.aboutheading2} text-center`}>
         [Answers must be written in Manipuri]
    </p>

    <p className={`${styles.aboutheading2} text-center`}>
        Section A
    </p>

    <p className={`${styles.aboutheading2} `}>
        Language :
    </p>

    <p className={`${styles.aboutheading2} `}>
        (a) General characteristics of Manipuri Language and history of its development;
    </p>
        <p className={`${styles.aboutheading} `}>
            its importance and status
            among the Tibeto-Burman Languages of North-East India; recent development in the study of Manipuri
            Language; evolution and study of old Manipuri script.
        </p>

    <p className={`${styles.aboutheading2} `}>
        (b) Significant features of Manipuri Language :
    </p>

        <ul className='list-unstyled'>
            <li>(i) Phonology : Phoneme-vowels, consonants juncture, tone, consonant cluster and its occurrence,
                    syllable-its structure, pattern and types.</li>
            <li>(ii) Morphology : Word-class, root and its types; affix and its types; grammatical categories-gender,
                    number, person, case, tense and aspects, process of compounding (samas and sandhi).</li>      
            <li>(iii) Syntax : Word order; types of sentences, phrase and clause structures.</li>          
        </ul>

    <p className={`${styles.aboutheading2} text-center`}>
        Section B
    </p>

    <p className={`${styles.aboutheading2} `}>
       (a) Literary History of Manipuri :
    </p>
        <p className={`${styles.aboutheading} `}>
            Early period (up to 17th Century)–Social and cultural background; Themes, diction and style of the works.
        </p>
        <p className={`${styles.aboutheading} `}>
            Medieval period (18th and 19th Century)-Social, religious and political background; Themes, diction and style of the works.
        </p>
        <p className={`${styles.aboutheading} `}>
            Modern period-Growth of major literary forms; change of Themes, diction and style.
        </p>

    <p className={`${styles.aboutheading2} `}>
        (b) Manipuri Folk Literature :
    </p>
        <p className={`${styles.aboutheading} `}>
            Legend, Folktale, Folksong, Ballad, Proverb and Riddle.
        </p>

    <p className={`${styles.aboutheading2} `}>
        (c) Aspects of Manipuri Culture :
    </p>
        <p className={`${styles.aboutheading} `}>
            Pre-Hindu Manipuri Faith; Advent of Hinduism and the process of syncreticism; <br/>
            Performing arts-Lai Haraoba, Maha Ras;<br/>
            Indegenous games-Sagol Kangjei, Khong Kangjei, Kang.    
        </p>

 </div>
</div>

{/* MANIPURI II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
     Manipuri - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      > 
      <p className={`${styles.aboutheading2} text-center `}>
            [Answers must be written in Manipuri]
        </p>

        <p className={`${styles.aboutheading} text-center`}>
            This paper will require first hand reading of the texts prescribed and will be designed to test candidate’s critical ability to assess them.
        </p>

        <p className={`${styles.aboutheading2} text-center `}>Section A </p>

        <p className={`${styles.aboutheading2} text-center`}>Old and Medieval Manipuri Literature :</p>

       <p className={`${styles.aboutheading2} `}> (a) Old Manipuri Literature :</p>

            <p className={`${styles.aboutheading}`}>
                1. O. Bhogeswar Singh (Ed.) : Numit Kappa
            </p>
            <p className={`${styles.aboutheading}`}>
                2. M. Gourachandra Singh (Ed.) : Thawanthaba Hiran
            </p>

            <p className={`${styles.aboutheading}`}>
                3. N. Khelchandra Singh (Ed.) : Naothingkhong Phambal Kaba
            </p>

            <p className={`${styles.aboutheading}`}>
                4. M. Chandra Singh (Ed.) : Panthoibi Khonggul
            </p>

        <p className={`${styles.aboutheading2}`}>(b) Medieval Manipuri Literature :</p>

            <p className={`${styles.aboutheading}`}>
                1. M. Chandra Singh (Ed.) : Samsok Ngamba
            </p>
            <p className={`${styles.aboutheading}`}>
                2. R.K. Snahal Singh (Ed.) : Ramayana Adi Kanda
            </p>
            <p className={`${styles.aboutheading}`}>
                3. N. Khelchandra Singh (Ed.) : Dhananjoy Laibu Ningba
            </p>
            <p className={`${styles.aboutheading}`}>
                4. O. Bhogeswar Singh (Ed.) : Chandrakirti Jila Changba
            </p>

        <p className={`${styles.aboutheading2} text-center`}>Section B</p>

        <p className={`${styles.aboutheading2} `}> Modern Manipuri Literature :</p>

        <p className={`${styles.aboutheading2}`}>(a) Poetry and Epic :</p>
        <p className={`${styles.aboutheading2}`}> (I) Poetry :</p>

            <p className={`${styles.aboutheading2}`}>
               (a) Manipuri Sheireng (Pub) Manipuri Sahitya Parishad, 1998 (Ed.)
            </p>

            <p className={`${styles.aboutheading}`}>
                Kh. Chaoba Singh : Pi Thadoi, Lamgi CheklaAmada, Loktak
            </p>
            <p className={`${styles.aboutheading}`}>
                Dr. L. Kamal Singh : Nirjanata, Nirab Rajani
            </p>
            <p className={`${styles.aboutheading}`}>
                A. Minaketan Singh : Kamalda, Nonggumlalkkhoda.
            </p>
            <p className={`${styles.aboutheading}`}>
                L. Samarendra Singh : Ingagi Nong, Mamang Leikai Thambal Satle
            </p>
            <p className={`${styles.aboutheading}`}>
                E. Nilakanta Singh : Manipur, Lamangnaba
            </p>
            <p className={`${styles.aboutheading}`}>
                Shri Biren : Tangkhul Hui
            </p>
            <p className={`${styles.aboutheading}`}>
                Th. Ibopishak : Anouba Thunglaba Jiba.
            </p>
            <p className={`${styles.aboutheading2}`}>
                (b) Kanchi Sheireng. (Pub) Manipur University 1998 (Ed.)
            </p>
            <p className={`${styles.aboutheading}`}>
                Dr. L. Kamal Singh : Biswa-Prem
            </p>
            <p className={`${styles.aboutheading}`}>
               Shri Biren : Chaphadraba Laigi Yen
            </p>
            <p className={`${styles.aboutheading}`}>
               Th. Ibopishak : Norok Patal Prithivi
            </p>

        <p className={`${styles.aboutheading2}`}> (II) Epic :</p>

            <p className={`${styles.aboutheading}`}>
               1. A. Dorendrajit Singh : Kansa Bodha
            </p>
            <p className={`${styles.aboutheading}`}>
              2. H. Anganghal Singh : Khamba-Thoibi Sheireng(San-Senba, Lei Langba,Shamu Khonggi Bichar)
            </p>

        <p className={`${styles.aboutheading2}`}> (III) Drama :</p>    
            <ul className='list-unstyled'>
                <li>1. S. Lalit Singh : Areppa Marup</li>
                <li>2. G.C. Tongbra : Matric Pass</li>
                <li>3. A. Samarendra : Judge Saheb ki Imung</li>
            </ul>

        <p className={`${styles.aboutheading2}`}> (b) Novel, Short-story and Prose :</p>

        <p className={`${styles.aboutheading2}`}>(I) Novel :</p>
           <ul className='list-unstyled'>
                <li>1. Dr. L. Kamal Singh : Madhabi</li>
                <li>2. H. Anganghal Singh : Jahera</li>
                <li>3. H. Guno Singh : Laman</li>
                <li>4. Pacha Meetei : Imphal Amasung, MagiIshing, Nungsitki Phibam</li>
           </ul>

        <p className={`${styles.aboutheading2}`}>(II) Short-story :</p>
           <p className={`${styles.aboutheading2}`}> (a) Kanchi Warimacha (Pub) Manipur University 1997(Ed.)</p>
              <ul className='list-unstyled'>
                <li>R.K. Shitaljit Singh : Kamala Kamala</li>
                <li>M.K. Binodini : Eigi Thahoudraba HeitupLalu</li>
                <li>Kh. Prakash : Wanom Shareng</li>
              </ul>
            
            <p className={`${styles.aboutheading2}`}>(b) Parishadki Khangatlaba Warimacha (Pub) Manipuri Sahitya Parishad 1994 (Ed.)</p>
                <ul className='list-unstyled'>
                    <li>S. Nilbir Shastri : Loukhatpa</li>
                    <li>R.K. Elangba : Karinunggi</li>
                </ul>

            <p className={`${styles.aboutheading2}`}>(c) Anouba Manipuri Warimacha (Pub) The Cultural Forum Manipur 1992 (Ed.)</p>    
                <ul className='list-unstyled'>
                    <li>N. Kunjamohon Singh : Ijat Tanba</li>
                    <li>E. Dinamani : Nongthak Khongnang</li>
                </ul>

        <p className={`${styles.aboutheading2}`}> (III) Prose :</p>

            <p className={`${styles.aboutheading2}`}> (a) Warenggi Saklon [Due Part] (Pub) The Cultural Forum Manipur 1992 (Ed.)</p>
                <ul className='list-unstyled'>      
                    <li>Kh. Chaoba Singh : Khamba-Thoibigi WariAmasung Mahakavya</li>
                </ul>

            <p className={`${styles.aboutheading2}`}> (b) Kanchi Wareng (Pub) Manipur University, 1998 (Ed.)</p>    
                <ul className='list-unstyled'>
                    <li>B. Manisana Shastri : Phajaba</li>
                    <li>Ch. Manihar Singh : Lai-Haraoba</li>
                </ul>
 
            <p className={`${styles.aboutheading2}`}> (c) Apunba Wareng (Pub) Manipur University, 1986 (Ed.)</p>
                <ul className='list-unstyled'>
                    <li>Ch. Pishak Singh : Samaj Amasung Sanskriti</li>
                    <li>M.K. Binodini : Thoibidu Warouhouida</li>
                    <li>Eric Newton : Kalagi Mahousa (translated by I.R. Babu)</li>
                </ul>

            <p className={`${styles.aboutheading2}`}> (d) Manipuri Wareng (Pub) The Cultural Forum Manipur 1999 (Ed.) </p>
                <ul className='list-unstyled'>
                    <li>S. Krishnamohan Singh : Lan</li>
                </ul>
        
        </div>
    </div>
  </div>
</div>

{/* 40. MARATHI Language */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        40</span> MARATHI 
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Marathi - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
        
    <p className={`${styles.aboutheading2} text-center`}>
         [Answers must be written in Marathi]
    </p>

    <p className={`${styles.aboutheading2} text-center`}>
        Section A
    </p>

    <p className={`${styles.aboutheading2} `}>
        Language and Folk-lore
    </p>

    <p className={`${styles.aboutheading2} `}>
        (a) Nature and Functions of Language
    </p>
        <p className={`${styles.aboutheading} `}>
            Language as a signifying system : Langue and Parole; Basic functions; Poetic Language; Standard
            Language and dialect; Language variations according to social parameters. <br/>
            Linguistic features of Marathi in thirteenth century and seventeenth century.
        </p>

    <p className={`${styles.aboutheading2} `}>
        (b) Dialects of Marathi
    </p>
        <ul className='list-unstyled'>
            <li>Ahirani; Varhadi; Dangi.</li>
        </ul>

    <p className={`${styles.aboutheading2} `}>
      (c) Marathi Grammar
    </p>
        <p className={`${styles.aboutheading} `}>
          Parts of Speech; Case-system; Prayog-vichar (Voice).
        </p>

    <p className={`${styles.aboutheading2} `}>
        (d) Nature and kinds of Folk-lore (with special reference to Marathi)
    </p>
        <p className={`${styles.aboutheading} `}>
           Lok-Geet, Lok Katha, Lok Natya.
        </p>

    <p className={`${styles.aboutheading2} text-center`}>
        Section B
    </p>

    <p className={`${styles.aboutheading2} text-center`}>
        (History of Literature and Literary Criticism)
    </p>

   <p className={`${styles.aboutheading2} `}> 
      (a) History of Marathi Literature
    </p>

        <p className={`${styles.aboutheading} `}>
            1. From beginning to 1818 AD, with special reference to the following : The Mahanubhava writers, the
            Varkari poets, the Pandit poets, the Shahirs, Bakhar Literature.
        </p>

        <p className={`${styles.aboutheading} `}>
            2. From 1850 to 1990, with special reference to developments in the following major forms : Poetry,
            Fiction (Novel and Short Story), Drama; and major literary currents and movements, Romantic, Realist,
            Modernist, Dalit, Gramin, Feminist.
        </p>

    <p className={`${styles.aboutheading2} `}>
         (b) Literary Criticism    
    </p>
        <ul className='list-unstyled'>
            <li>1. Nature and function of Literature;</li>
            <li>2. Evaluation of Literature;</li>
            <li>3. Nature, Objectives and Methods of Criticism;</li>
            <li>4. Literature, Culture and Society.</li>
        </ul>  
 </div>
</div>

{/* Marathi II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
     Marathi - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      > 
      <p className={`${styles.aboutheading2} text-center `}>
            [Answers must be written in Marathi]
        </p>

        <p className={`${styles.aboutheading} text-center`}>
            Textual study of prescribed literary works.
        </p>


        <p className={`${styles.aboutheading2} text-center`}>The paper will require first-hand reading of the texts prescribed and will be designed to test the candidate's critical ability.</p>

        <div className="container my-4">
            <div className="row g-4 align-items-stretch">
                {/* Section A */}
                <div className="col-lg-6 d-flex">
                <div className="p-3 border rounded shadow-sm w-100">
                    <p className={`${styles.aboutheading2} text-center`}>Section A</p>
                    <p className={`${styles.aboutheading2} text-center`}>Prose :</p>

                    <p className={styles.aboutheading}>(1) ‘Smritisthala’</p>
                    <p className={styles.aboutheading}>
                    (2) Mahatma Jotiba Phule <br />
                    ‘‘Shetkaryacha Asud’ <br />
                    ‘Sarvajanik Satyadharma’
                    </p>
                    <p className={styles.aboutheading}>
                    (3) S.V. Ketkar <br /> ‘Brahmankanya’
                    </p>
                    <p className={styles.aboutheading}>
                    (4) P.K. Atre <br /> ‘Sashtang Namaskar’
                    </p>
                    <p className={styles.aboutheading}>
                    (5) Sharchchandra Muktibodh <br /> ‘Jana Hey Volatu Jethe’
                    </p>
                    <p className={styles.aboutheading}>
                    (6) Uddhav Shelke <br /> ‘Shilan’
                    </p>
                    <p className={styles.aboutheading}>
                    (7) Baburao Bagul <br /> ‘Jevha Mi Jaat Chorli Hoti’
                    </p>
                    <p className={styles.aboutheading}>
                    (8) Gouri Deshpande <br /> ‘Ekek Paan Galavaya’
                    </p>
                    <p className={styles.aboutheading}>
                    (9) P.I. Sonkamble <br /> ‘Athavaninche Pakshi’
                    </p>
                </div>
                </div>

                {/* Section B */}
                <div className="col-lg-6 d-flex">
                <div className="p-3 border rounded shadow-sm w-100">
                    <p className={`${styles.aboutheading2} text-center`}>Section B</p>
                    <p className={`${styles.aboutheading2} text-center`}>Poetry :</p>

                    <p className={styles.aboutheading}>
                        (1) ‘Namadevanchi Abhangawani’ <br />
                        Ed: Inamdar, Relekar, Mirajkar<br />
                        Modern Book Depot, Pune
                    </p>

                    <p className={styles.aboutheading}>
                    (2) ‘Painjan’ <br />
                    Ed : M.N. Adwant <br />
                    Sahitya Prasar Kendra, Nagpur
                    </p>
                    <p className={styles.aboutheading}>
                    (3) ‘Damayanti-Swayamvar’ <br /> By Raghunath Pandit
                    </p>
                    <p className={styles.aboutheading}>
                    (4) ‘Balakvinchi Kavita’ <br /> By Balkavi
                    </p>
                    <p className={styles.aboutheading}>
                    (5) ‘Vishakha’ <br /> By Kusumagraj
                    </p>
                    <p className={styles.aboutheading}>
                    (6) ‘Maridgandh’ <br /> By Vinda Karandikar
                    </p>
                    <p className={styles.aboutheading}>
                    (7)‘Jahirnama’<br /> By Narayan Surve
                    </p>
                    <p className={styles.aboutheading}>
                    (8) ‘Sandhyakalchya Kavita’<br /> By Grace
                    </p>
                    <p className={styles.aboutheading}>
                    (9) ‘Ya Sattet Jeev Ramat Nahi’<br /> By Namdev Dhasal
                    </p>
                </div>
                </div>
            </div>
        </div>

            
        </div>
    </div>
  </div>
</div>

{/* 41. NEPALI Language */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        41</span> NEPALI 
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Nepali - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
        
    <p className={`${styles.aboutheading2} text-center`}>
         [Answers must be written in Nepali]
    </p>

    <p className={`${styles.aboutheading2} text-center`}>
        Section A
    </p>

    <p className={`${styles.aboutheading2} `}>
        1. History of the origin and development of Nepali as one of the new Indo Aryan Languages.
    </p>

    <p className={`${styles.aboutheading} `}>
       2. Fundamentals of Nepali Grammar and phonology :
    </p>
    <p className={`${styles.aboutheading} `}>
        (i) Nominal forms and categories :— <br/>
            Gender, Number, Case, Adjectives, Pronouns, Avyayas
    </p>

    <p className={`${styles.aboutheading} `}>
        (ii) Verbal forms and categories :— <br/>
        Tense, Aspects, Voice, Roots and Fixes
    </p>

    <p className={`${styles.aboutheading} `}>
        (iii) Nepali Swara and Vyanjana;
    </p>

    <p className={`${styles.aboutheading} `}>
        3. Major Dialects of Nepali
    </p>

    <p className={`${styles.aboutheading} `}>
        4. Standardisation and Modernisation of Nepali with special reference to language movements (viz. Halanta Bahiskar, Jharrovad etc.)
    </p>

    <p className={`${styles.aboutheading} `}>
        5. Teaching of Nepali language in India—Its history and development with special reference to its sociocultural aspects.
    </p>

    <p className={`${styles.aboutheading2} text-center`}>
        Section B
    </p>

    <p className={`${styles.aboutheading2} `}>
        1. History of Nepali literature with special reference to its development in India.
    </p>

   <p className={`${styles.aboutheading2} `}> 
        2. Fundamental concepts and theories of Literature :
    </p>

    <p className={`${styles.aboutheading} `}>
        Kavya/Sahitya, Kavya Prayojan, Literary genres, Shabda Shakti, Rasa, Alankara, Tragedy, Comedy, Aesthetics, Stylistics.
    </p>

    <p className={`${styles.aboutheading2} `}>
       3. Kavya/Sahitya, Kavya Prayojan, Literary genres, Shabda Shakti, Rasa, Alankara, Tragedy, Comedy, Aesthetics, Stylistics.
    </p>

    <p className={`${styles.aboutheading} `}>
        Swachchhandatavad, Yatharthavad, Astitwavad, Ayamik Movement Contemporary Nepali writings, Postmodernism.
    </p>

    <p className={`${styles.aboutheading2} `}>
        4. Nepali folklores (the following folk-form only)—Sawai, Jhyaurey, Selo, Sangini, Lahari.
    </p>
 
 </div>
</div>

{/* Nepali II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
     Nepali - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      > 
        <p className={`${styles.aboutheading2} text-center `}>
            [Answers must be written in Nepali]
        </p>

        <p className={`${styles.aboutheading} text-center`}> This paper will require first hand reading of the texts prescribed below and questions will be designed to test the candidate's critical acumen.</p>
        <p className={`${styles.aboutheading2} text-center`}>Section A</p>
           <div className="container my-4">
                <div className="row g-4">
                    <div className="col-12">
                    <table className="table table-bordered table-striped table-hover align-middle text-center">
                        
                        <tbody>
                        <tr>
                            <td>1.</td>
                            <td>Santa Jnandil Das</td>
                            <td>Udaya Lahari</td>
                        </tr>
                        <tr>
                            <td>2.</td>
                            <td>Lekhnath Poudyal</td>
                            <td>
                            Tarun Tapasi <br />
                            <small className="text-muted">
                                (Vishrams III, V, VI, XII, XV, XVIII only)
                            </small>
                            </td>
                        </tr>
                        <tr>
                            <td>3.</td>
                            <td>Agam Sing Giri</td>
                            <td>
                            Jaleko Pratibimba Royeko Pratidhwani <br />
                            <small className="text-muted">
                                (The following Poems only-
                                Prasawako Chichyahatsanga Byunjheko Ek Raat, Chhorolai, Jaleko
                                Pratibimba : Royeko Pratidhwani, Hamro Akashmani Pani Hunchha
                                Ujyalo, Tihar)
                            </small>
                            </td>
                        </tr>
                        <tr>
                            <td>4.</td>
                            <td>Haribhakta Katuwal</td>
                            <td>
                            Yo Zindagi Khai Ke Zindagi <br />
                            <small className="text-muted">
                                (The following poems only-Jeevan : Ek
                                Dristi, Yo Zindagi Khai Ke Zindagi, Akashka Tara Ke Tara, Hamilai
                                Nirdho Nasamjha, Khai Manyata Yahan Atmahutiko Balidan Ko).
                            </small>
                            </td>
                        </tr>
                        <tr>
                            <td>5.</td>
                            <td>Balkrishna Sama</td>
                            <td>Prahlad</td>
                        </tr>
                        <tr>
                            <td>6.</td>
                            <td>Manbahadur Mukhia</td>
                            <td>
                            Andhyaroma Banchneharu <br />
                            <small className="text-muted">
                                (The following One-Act only-Andhyaroma Banchneharu' ‘Suskera’)
                            </small>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>

            <p className={`${styles.aboutheading2} text-center`}>Section B</p>

            <div className="container my-4">
                <div className="row g-4">
                    <div className="col-12">
                    <table className="table table-bordered table-striped table-hover align-middle text-center">
                        
                        <tbody>
                        <tr>
                            <td>1.</td>
                            <td>Indra Sundas</td>
                            <td>Sahara.</td>
                        </tr>
                        <tr>
                            <td>2.</td>
                            <td>Lilbahadur Chhetri</td>
                            <td>Brahmaputra ko Chheuchhau</td>
                        </tr>
                        <tr>
                            <td>3.</td>
                            <td>Rupnarayan Sinha</td>
                            <td>
                            Katha Navaratna  <br />
                            <small className="text-muted">
                              (The following stories only—Biteka Kura, Jimmewari
                                Kasko, Dhanamatiko Cinema—Swapna, Vidhwasta Jeevan).
                            </small>
                            </td>
                        </tr>
                        <tr>
                            <td>4.</td>
                            <td>Indrabahadur Rai</td>
                            <td>
                                 Vipana Katipaya<br />
                            <small className="text-muted">
                                (The following stories only—Raatbhari Huri Chalyo,
                                Jayamaya Aphumatra Lekhapani Aipugi, Bhagi, Ghosh Babu,Chhutuaiyo).
                            </small>
                            </td>
                        </tr>
                        <tr>
                            <td>5.</td>
                            <td>Sanu Lama</td>
                            <td>Katha Sampaad <br />
                            <small className="text-muted">
                                (The following stories only—Swasni Manchhey,
                                Khani Tarma Ekdin, Phurbale Gaun Chhadyo, Asinapo Manchhey).
                            </small>

                            </td>
                        </tr>
                        <tr>
                            <td>6.</td>
                            <td>Laxmi Prasad</td>
                            <td>
                            Laxmi Nibandha Devkota Sangraha<br />
                            <small className="text-muted">
                                (The following essays only—Sri
                                Ganeshaya Namha, Nepali Sahityako Itihasma Sarvashrestha Purus,
                                Kalpana, Kala Ra Jeevan, Gadha Buddhiman ki Guru?)
                            </small>
                            </td>
                        </tr>

                        <tr>
                            <td>7.</td>
                            <td>Ramkrishna Sharma</td>
                            <td>
                            Das Gorkha<br />
                            <small className="text-muted">
                                (The following essays only—Kavi, Samaj Ra Sahitya,
                                Sahityama Sapekshata, Sahityik Ruchiko Praudhata, Nepali
                                Sahityako Pragati).
                            </small>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</div>

{/* 42. ODIA Language */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        42</span> ODIA 
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Odia - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
        
    <p className={`${styles.aboutheading2} text-center`}>
         [Answers must be written in Odia]
    </p>

    <p className={`${styles.aboutheading2} text-center`}>
        Section A
    </p>

    <p className={`${styles.aboutheading2} `}>
       History of Odia Language
    </p>

   
    <p className={`${styles.aboutheading} `}>
        (i) Origin and development of Odia Language—Influence of Austric, Dravidian, Perso— Arabic and
            English on Odia Language.
    </p>

    <p className={`${styles.aboutheading} `}>
        (ii) Phonetics and Phonemics : Vowels, Consonants Principles of changes in Odia sounds.
    </p>

    <p className={`${styles.aboutheading} `}>
        (iii) Morphology : Morphemes (free, bound compound and complex), derivational and inflectional affixes, case inflection, conjugation of verb.
    </p>

    <p className={`${styles.aboutheading} `}>
        (iv) Syntax : Kinds of sentences and their trans-formation, structure of sentences.
    </p>

    <p className={`${styles.aboutheading} `}>
        (v) Semantics—Different types of change in meaning. Euphemism.
    </p>

    <p className={`${styles.aboutheading} `}>
        (vi) Common errors in spellings, grammatical uses and construction of sentences.
    </p>

    <p className={`${styles.aboutheading} `}>
        (vii) Regional variations in Odia Language (Western, Southern and Northern Odia) and Dialects (Bhatri and Desia).
    </p>

    <p className={`${styles.aboutheading2} text-center`}>  Section B </p>
      

    <p className={`${styles.aboutheading2} text-center`}>
        History of Odia Literature
    </p>

    <p className={`${styles.aboutheading} `}> 
      (i) Historical backgrounds (social, cultural and political) of Odia Literature of different periods.
    </p>

    <p className={`${styles.aboutheading} `}>
      (ii) Ancient epics, ornate kavyas and padavalis.
    </p>

    <p className={`${styles.aboutheading} `}>
       (iii) Typical structural forms of Odia Literature (Koili, Chautisa, Poi, Chaupadi, Champu).
    </p>

    <p className={`${styles.aboutheading} `}>
        (iv) Modern trends in poetry, drama short story, novel essay and literary criticism.  
    </p>
         
 </div>
</div>

{/* Odia II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
     Odia - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      > 
      <p className={`${styles.aboutheading2}  `}>
            Critical Study of texts—
        </p>

        <p className={`${styles.aboutheading} text-center`}>
            The paper will require first hand reading of the text and test the critical ability of the candidate.
        </p>

        <p className={`${styles.aboutheading2} text-center`}>Section A</p>
        <p className={`${styles.aboutheading2} text-center`}>Poetry</p>
       
        <p className={`${styles.aboutheading2}`}>Ancient :</p>
        <p className={`${styles.aboutheading} `}>1. Sãralã Dãs—Shanti Parva from Mahãbhãrata.</p>
        <p className={`${styles.aboutheading} `}>2. Jaganãth Dãs—Bhãgabata, XI Skadhã—Jadu Avadhuta Sambãda.</p>
       
        <p className={`${styles.aboutheading2}`}>Medieval :</p>
        <p className={`${styles.aboutheading} `}>3. Dinakrushna Dãs—Raskallola—(Chhãndas—16 & 34)</p>
        <p className={`${styles.aboutheading} `}>4. Upendra Bhanja—Lãvanyabati (Chhãndas—1 & 2).</p>
       
        <p className={`${styles.aboutheading2}`}>Modern :</p>
        <p className={`${styles.aboutheading} `}>5. Rãdhãnath Rãy—Chandrabhãgã.</p>
        <p className={`${styles.aboutheading} `}>6. Mãyãdhar Mänasinha—Jeevan—Chitã.</p>
        <p className={`${styles.aboutheading} `}>7. Sãtchidananda Routray—Kabitã—1962.</p>
        <p className={`${styles.aboutheading} `}>8. Ramãkãnta Ratha—Saptama Ritu.</p>

        <p className={`${styles.aboutheading2} text-center`}>Section B</p>

        <p className={`${styles.aboutheading2}`}>Drama :</p>
        <p className={`${styles.aboutheading} `}>9. Manoranjan Dãs—Kätha-Ghoda.</p>
        <p className={`${styles.aboutheading} `}>10. Bijay Mishra—Tata Niranjanä.</p>

        <p className={`${styles.aboutheading2}`}>Novel :</p>
        <p className={`${styles.aboutheading} `}>11. Fakir Mohan Senãpati—Chhamãna Ãthaguntha.</p>
        <p className={`${styles.aboutheading} `}>12. Gopinãth Mohãnty—Dãnãpani.</p>

        <p className={`${styles.aboutheading2} `}>Short Story :</p>
        <p className={`${styles.aboutheading} `}>13. Surendra Mohãnty—Marãlara Mrityu.</p>
        <p className={`${styles.aboutheading} `}>14. Manoj Dãs—Laxmira Abhisãra.</p>

        <p className={`${styles.aboutheading2} `}>Essay :</p>
        <p className={`${styles.aboutheading} `}>15. Chittaranjan Dãs—Tranga O Tadit (First Five essays).</p>
        <p className={`${styles.aboutheading} `}>16. Chandra Sekhar Rath — Mun Satyadharmã Kahuchhi (First five essays).</p>


        </div>
    </div>
  </div>
</div>

{/* 43. PUNJABI Language */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        43</span> PUNJABI 
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Punjabi - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
        
    <p className={`${styles.aboutheading2} text-center`}>
         Answers must be written in Punjabi in Gurumukhi script
    </p>

    <p className={`${styles.aboutheading2} text-center`}>
        Section A
    </p>
    
    <p className={`${styles.aboutheading} `}>
        (i) Origin of Punjabi Language; different stages of development and recent development in Punjabi
        Language; characteristics of Punjabi phonology and the study of its tones; classification of vowels and
        consonants.
    </p>

    <p className={`${styles.aboutheading} `}>
        (ii) Punjabi morphology; the number-gender system (animate and inanimate), prefixes, affixes and
        different categories of Post positions; Punjabi word formation; Tatsam. Tad Bhav. forms; Sentence
        structure, the notion of subject and object in Punjabi; Noun and verb phrases.
    </p>

    <p className={`${styles.aboutheading} `}>
        (iii) Morphology : Morphemes (free, bound compound and complex), derivational and inflectional affixes, case inflection, conjugation of verb.
    </p>

    <p className={`${styles.aboutheading} `}>
       (iv) Language and dialect : the notions of dialect and idiolect: major dialects of Punjabi : Pothohari, Majhi,
        Doabi, Malwai, Paudhi; the validity of speech variation on the basis of social stratification, the distinctive
        features of various dialects with special reference to tones Language and script; origin and development of
        Gurumukhi; Suitability of Gurumukhi for Punjabi.
    </p>

    <p className={`${styles.aboutheading} `}>
        (v) Classical background : Nath Jogi Sahit. <br/>
        Medieval Literature : Gurmat, Suti, Kissa and Var : janamsakhis.
    </p>


    <p className={`${styles.aboutheading2} text-center`}>  Section B </p>
      
    <p className={`${styles.aboutheading2} `}>
        (a) Modern trends
    </p>

    <p className={`${styles.aboutheading} `}> 
        Mystic, romantic, progressive and neomystic (Vir Singh, Puran Singh, Mohan Singh,
        Amrita Pritam, Bawa Balwant, Pritam Singh Safeer, J. S. Neki). 
        Experimentalist (Jasbir Singh Ahluwalia, Ravinder Ravi, Ajaib Kamal). ,<br/>
        Aesthetes (Harbhajan Singh, Tara Singh). Neo-progressive (Pash, Jagtar, Patar).
    </p>

    <p className={`${styles.aboutheading2} `}>
      (b) Folk Literature
    </p>

    <p className={`${styles.aboutheading} `}>
       Folk songs, Folk tales, Riddles, Proverbs. <br/>

       Epic  - (Vir Singh, Avtar Singh Azad, Mohan Singh). <br/>
       Lyric - (Gurus, Sufis and Modern Lyricists-Mohan Singh, Amrita Pritam, Shiv Kumar, Harbhajan Singh).
    </p>

    <p className={`${styles.aboutheading2} `}>
        (c) Drama
    </p>

    <p className={`${styles.aboutheading} `}>(I.C. Nanda, Harcharan Singh, Balwant Gargi, S.S. Sekhon, Charan Das Sidhu)</p>
    <p className={`${styles.aboutheading} `}> Novel - (Vir Singh, Nanak Singh, Jaswant Singh Kanwal, K.S. Duggal, Sukhbir, Gurdial
        Singh, Dalip Kaur Tiwana, Swaran Chandan).</p>
    <p className={`${styles.aboutheading} `}> Short Story - (Sujan Singh, K. S. Virk, Prem Parkash, Waryam Sandhu).</p>

    <p className={`${styles.aboutheading2} `}>
        (d) Socio-cultural
    </p>

    <p className={`${styles.aboutheading} `}>Sanskrit, Persian and Western. <br/> Literary influences;</p>
    <p className={`${styles.aboutheading} `}>Essay - (Puran Singh, Teja Singh, Gurbaksh Singh).</p>
    <p className={`${styles.aboutheading} `}>Literary Criticism (S.S. Sekhon, Attar Singh, Kishan Singh, Harbhajan Singh, Najam Hussain Sayyad).</p>
   
         
 </div>
</div>

{/* Punjabi II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
     Punjabi - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      > 
      
        <p className={`${styles.aboutheading2} text-center`}>
            Answers must be written in Punjabi in Gurumukhi script
        </p>

        <p className={`${styles.aboutheading} text-center`}>This paper will require first-hand reading of the texts prescribed and will be designed to test the candidate’s critical ability.</p>

        <p className={`${styles.aboutheading2} text-center`}>Section A</p>
 
        <p className={`${styles.aboutheading} `}>(a) Sheikh Farid - The complete Bani as includedin the Adi Granth.</p>
        <p className={`${styles.aboutheading} `}>(b) Guru Nanak   - Japu Ji. Baramah. Asa di Var.</p>
        <p className={`${styles.aboutheading} `}>(c) Bulleh Shah  - Kafian</p>
        <p className={`${styles.aboutheading} `}>(d) Waris Shah   - Heer</p>

        <p className={`${styles.aboutheading2} text-center`}>Section B</p>

        <p className={`${styles.aboutheading} `}>
            (a) Shah Mohammad - Jangnama (Jang Singhante Firangian) <br/> Dhani Ram Chatrik Chandan Vari <br/>(Poet) Sufi Khana <br/>Nawan Jahan
        </p>

        <p className={`${styles.aboutheading} `}>
            (b) Nanak Singh  - Chitta Lahu <br/>(Novelist) Pavittar Papi<br/>Ek Mian Do Talwaran
        </p>

        <p className={`${styles.aboutheading} `}>
           (c) Gurbaksh Singh Zindagi-di-Ras <br/>(Essayist) Nawan Shivala <br/>Merian Abhul Yadaan. <br/>Balraj Sahni Mera Roosi Safarnama <br/>(Travelogue) Mera Pakistani Safarnama
        </p>

        <p className={`${styles.aboutheading} `}>
            (d) Balwant Gargi Loha Kutt <br/> (Dramatist) Dhuni-di-Agg <br/>Sultan Razia <br/>Sant Singh Sekhon Sahityarth <br/>(Critic) Parsidh Punjabi Kavi <br/>Punjabi Kav Shiromani.
        </p>
        

        </div>
    </div>
  </div>
</div>

{/* 44. SANSKRIT Language */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        44</span> SANSKRIT 
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Sanskrit - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
        
    <p className={`${styles.aboutheading} `}>
        There will be three questions as indicated in the Question Paper which must be answered in Sanskrit. The
        Remaining questions must be answered either in Sanskrit or in the medium of examination opted by the
        candidate.
    </p>

    <p className={`${styles.aboutheading2} text-center`}>
        Section A
    </p>
    
    <p className={`${styles.aboutheading} `}>
        1.  Significant features of the grammar, with particular stress on Sanjna, Sandhi, Karaka, Samasa, Kartari
        and Karmani vacyas (voice usages) (to be answered in Sanskrit).
    </p>

    <p className={`${styles.aboutheading} `}>
          2. (a) Main characteristics of Vedic Sanskrit language <br/>
           (b) Prominent feature of classical Sanskrit language<br/>
           (c) Contribution of Sanskrit to linguistic studies
    </p>

    <p className={`${styles.aboutheading2} `}>
       3. General Knowledge of :—
    </p>

    <p className={`${styles.aboutheading} `}>
       (a) Literary history of Sanskrit <br/>
       (b) Principal trends of literary criticism <br/>
       (c) Ramayana<br/>
       (d) Mahabharata

    </p>

    <p className={`${styles.aboutheading} `}>
        (e) The origin and development of literary geners of :<br/>
        Mahakavya<br/>
        Rupaka (drama)<br/>
        Katha<br/>
        Akhyayika<br/>
        Campu<br/>
        Khandakavya<br/>
        Muktaka Kavya.
    </p>

    <p className={`${styles.aboutheading2} text-center`}>Section B</p>

    <p className={`${styles.aboutheading2} `}>4. Essential of Indian Culture with stress on :</p>
        <ul className="list-unstyled">
            <li>(a) Purusãrthas</li>
            <li>(b) Samskãras</li>
            <li>(c) Varnãsramavyavasthã</li>
            <li>(d) Arts and fine arts</li>
            <li>(e) Technical Sciences.</li>
        </ul>

    <p className={`${styles.aboutheading2} `}>5. Trends of Indian Philosophy</p>
       <ul className="list-unstyled">
        <li>(a) Mïmansã</li>
        <li>(b) Vedãnta</li>
        <li>(c) Nyaya</li>
        <li>(d) Vaisesika</li>
        <li>(e) Sãnkhya</li>
        <li>(f) Yoga</li>
        <li>(g) Bauddha</li>
        <li>(h) Jaina</li>
        <li>(i) Carvãka</li>
       </ul>

   <p className={`${styles.aboutheading2} `}>6. Short Essay (in Sanskrit)</p>
   <p className={`${styles.aboutheading2} `}>7. Unseen passage with the questions (to be answered in Sanskrit). </p>

 </div>
</div>

{/* Sanskrit II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
     Sanskrit - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", // softer than pure black
            textAlign: "justify", // book style
            }}
      > 
      
        <p className={`${styles.aboutheading2}`}>
            Question from Group 4 is to be answered in Sanskrit only. Questions from Groups 1, 2 and 3 are to be
            answered either in Sanskrit or in the medium opted by the candidate.
        </p>

        <p className={`${styles.aboutheading2} text-center`}>Section A</p>

        <p className={`${styles.aboutheading2} `}>General study of the following groups :—</p>

        <p className={`${styles.aboutheading2} `}>Group 1 :</p>

            <ul className="list-unstyled">
                <li>(a) Raghuvamsam—Kalidasa</li>
                <li>(b) Kumarasambhavam—Kalidasa</li>
                <li>(c) Kiratarjuniyam—Bharavi</li>
                <li>(d) Sisupalavadham—Magha</li>
                <li>(e) Naisadhiyacaritam—Sriharsa</li>
                <li>(f) Kadambari—Banabhatta</li>
                <li>(g) Dasakumaracaritam—Dandin</li>
                <li>(h) Sivarajyodayam—S.B. Varnekar</li>
            </ul>

        <p className={`${styles.aboutheading2} `}>Group 2 :</p>

            <ul className="list-unstyled">
                <li>(a) Isãvãsyopanisad</li>
                <li>(b) Bhagavadgitã</li>
                <li>(c) Sundarakanda of Valmiki’s Ramayana</li>
                <li>(d) Arthasastra of Kautilya</li>
            </ul>

        <p className={`${styles.aboutheading2} `}>Group 3 :</p>   

            <ul className="list-unstyled"> 
               <li>(a) Svapanavasavadattam—Bhasa</li>
               <li>(b) Abhijnanasakuntalam—Kalidasa</li>
               <li>(c) Mricchakatikam—Sudraka</li>
               <li>(d) Mudraraksasam—Visakhadatta</li>
               <li>(e) Uttararamacaritam—Bhavbhuti</li>
               <li>(f) Ratnavali—Sriharshavardhana</li>
               <li>(g) Venisamharam—Bhattanarayana</li>
            </ul>

         <p className={`${styles.aboutheading2} `}>Group 4 :</p>

         <p className={`${styles.aboutheading2} `}>Short notes in Sanskrit on the following :—</p>
            
            <ul className="list-unstyled">
                <li>(a) Meghadutam—Kalidasa</li>
                <li>(b) Nitisatakam—Bhartrhari</li>
                <li>(c) Pancatantra—</li>
                <li>(d) Rajatarangini—Kalhana</li>
                <li>(e) Harsacaritam—Banabhatta</li>
                <li>(f) Amarukasatakam—Amaruka</li>
                <li>(g) Gitagovindam—Jayadeva.</li>
            </ul> 

        <p className={`${styles.aboutheading2} text-center`}>Section B</p>

        <p className={`${styles.aboutheading} `}>
            This section will require first hand reading of the following selected texts :— (Questions from Groups 1 & 2
            are to be answered in Sanskrit only) Questions from Groups 3 and 4 are to be answered either in Sanskrit
            or in the Medium opted by the candidate.
        </p>

        <p className={`${styles.aboutheading2} `}>Group 1 :</p>
            <ul className="list-unstyled">
                <li>(a) Raghuvamsam—CantoI, Verses 1 to 10</li>
                <li>(b) Kumarasambhavam—Canto I, Verses1 to 10</li>
                <li>(c) Kiratarjuniyaue—Canto I, Verses 1 to 10</li>
            </ul>

        <p className={`${styles.aboutheading2} `}>Group 2 :</p>
            <ul className="list-unstyled">
                <li>(a) Isavasyopanisad—Verses—1, 2, 4, 6, 7, 15 and 18</li>
                <li>(b) Bhagavatgita II Chapter Verses13 to 25</li>
                <li>(c) Sundarakandam of Valmiki Canto15, Verses 15 to 30 (Geeta Press Edition)</li>
            </ul>

        <p className={`${styles.aboutheading2} `}>Group 3 :</p>
            <ul className="list-unstyled">
                <li>(a) Meghadutam—Verses 1 to 10</li>
                <li>(b) Nitisatakam—Verses 1 to 10 (Edited by D.D. Kosambi Bharatiya Vidya Bhavan Publication)</li>
                <li>(c) Kadambari—Sukanasopadesa (only)</li>
            </ul> 

        <p className={`${styles.aboutheading2} `}>Group 4 :</p>       
            <ul className="list-unstyled">
                <li>(a) Svapnavasavadattam Act VI</li>
                <li>(b) Abhijnansakuntalam Act IV Verses 15 to 30 (M.R. Kale Edition)</li>
                <li>(c) Uttararamacaritam Act I Verses 31 to 47 (M.R. Kale Edition).</li>
            </ul>
    

        </div>
    </div>
  </div>
</div>

{/* 45. SANTHALI Language */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        45</span> SANTHALI 
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Santhali - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
        
    <p className={`${styles.aboutheading2} text-center `}>
        (Answers must be written in Santhali)
    </p>

    <p className={`${styles.aboutheading2} text-center`}>
        Section A
    </p>
    
    <p className={`${styles.aboutheading2} `}>Part I—History of Santhali Language. </p>

        <ul className="list-unstyled">
            <li>1. Main Austric Language family, population and distribution.</li>
            <li>2. Grammatical structure of Santhali Language.</li>
            <li>3. Important character of Santhali Language: Phonology, Morphology, Syntax, Semantics, Translation, Lexicography.</li>
            <li>4. Impact of other languages of Santhali.</li>
            <li>5. Standardization of Santhali Language.</li>
        </ul>

    <p className={`${styles.aboutheading2} `}> Part II—History of Santhali Literature</p>

    <p className={`${styles.aboutheading} `}>1. Literary trend of the following four periods of history of Santhali Literature.</p>
         
        <ul className="list-unstyled">
            <li>(a) Ancient Literature before 1854.</li>
            <li>(b) Missionary period Literature between 1855 to 1889 AD.</li>
            <li>(c) Medieval period: Literature between 1890 to 1946 AD.</li>
            <li>(d) Modern period : Literature from 1947 AD to till date.</li>
        </ul>

    <p className={`${styles.aboutheading} `}>2. Writing tradition in History of Santhali literature.</p>
    
    <p className={`${styles.aboutheading2} text-center`}>Section B</p>

    <p className={`${styles.aboutheading} `}> Literary forms—Main characteristics, history and development of following literary forms</p>

    <p className={`${styles.aboutheading2} `}> Part I</p>
        <ul className="list-unstyled"> 
            <li>Folk Literature in Santhali—folk song, folk tale, phrase, idioms puzzles, and Kudum.</li>
        </ul>

    <p className={`${styles.aboutheading2} `}> Part II</p>

            <p className={`${styles.aboutheading2} `}> Modern literature in Santhali</p>

        <ul className="list-unstyled"> 
            <li>1. Development of poetry and prominent poets.</li>
            <li>2. Development of prose and prominent writers.</li>
            <li>(i) Novels and prominent Novelists.</li>
            <li>(ii) Stories and prominent story writers. </li>
            <li>(iii) Drama and Prominent Dramatist.</li>
            <li>(iv) Criticism and prominent critics.</li>
            <li>(v) Essay, sketches, memoirs, travelogues and prominent writers.</li>
        </ul>

   <p className={`${styles.aboutheading2} `}>Santhali writers</p>

   <p className={`${styles.aboutheading} `}>
            Shyam Sundar Hembram, Pandit Raghunath Murmu, Barha Beshra, Sadhu Ramchand Murmu,
            Narayan Soren ‘Toresutam’, Sarda Prasad Kisku, Raghunath Tudu, Kalipada Soren, Sakla Soren, Digamber
            Hansda, Aditya Mitra ‘Santhali’, Babulal Murmu ‘Adivasi’, Jadumani Beshra, Arjun Hembram, Krishna
            Chandra Tudu, Rupchand Hansda, Kalendra Nath Mandi, Mahadev, Hansda, Gour Chandra Murmu,
            Thakur Prasad Murmu, Hara Prasad Murmu, Uday Nath Majhi, Parimal Hembram, Dhirendra Nath Baske,
            Shyam Charan Hembram, Damayanti Beshra, T.K. Rapaj, Boyha Biswanath Tudu.
    </p>

    <p className={`${styles.aboutheading2} `}>Part III</p>

    <p className={`${styles.aboutheading} `}>Cultural Heritage of Santhali tradition, customs, festival and rituals (birth, marriage and death).</p>
    
  

 </div>
</div>

{/* Sanskrit II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
       Santhali - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", 
            textAlign: "justify", 
            }}
      > 
      
        <p className={`${styles.aboutheading2} text-center`}>
            (Answers must be written in Santhali)
        </p>

        <p className={`${styles.aboutheading2} text-center`}>Section A</p>
        
        <p className={`${styles.aboutheading} `}>This paper will require in-depth reading of the following texts and the questions will be designed to test the candidates’ critical ability.</p>

        <p className={`${styles.aboutheading2} `}>Ancient Literature :</p>

        <p className={`${styles.aboutheading2} `}>Prose</p> 

            <ul className="list-unstyled">

                <li>(a) Kherwal Bonso Dhorom Puthi—Majhi Ramdas Tudu “Rasika”.</li>
                <li>(b) Mare Hapramko Reyak Katha—L.O. Scrafsrud.</li>
                <li>(c) Jomsim Binti Lita—Mangal Chandra Turkulumang Soren.</li>
                <li>(d) Marang Buru Binti—Kanailal Tudu.</li>

            </ul>

        <p className={`${styles.aboutheading2} `}>Poetry</p>

            <ul className="list-unstyled">

               <li>(a) Karam Sereng—Nunku Soren.</li>
               <li>(b) Devi Dasain Sereng—Manindra Hansda.</li>
               <li>(c) Horh Sereng—W.G. Archer.</li>
               <li>(d) Baha Sereng—Balaram Tudu.</li>
               <li>(e) Dong Sereng—Padmashri Bhagwat Murmu ‘Thakur’.</li>
               <li>(f) Hor Sereng—Raghunath Murmu.</li>
               <li>(g) Soros Sereng—Babulal Murmu “Adivasi”.</li>
               <li>(h) More Sin More Ndia—Rup Chand Hansda.</li>
               <li>(i) Judasi Madwa Latar—Tez Narayan Murmu.</li>

            </ul>

        <p className={`${styles.aboutheading2} text-center`}>Section B</p>

        <p className={`${styles.aboutheading2} text-center `}>
            Modern Literature
        </p>

        <p className={`${styles.aboutheading2} `}>Part I—Poetry</p>
            <ul className="list-unstyled">  
                <li>(a) Onorhen Baha Dhalwak—Paul Jujhar Soren.</li>
                <li>(b) Asar Binti—Narayan Soren “Tore Sutam”.</li>
                <li>(c) Chand Mala—Gora Chand Tudu.</li>
                <li>(d) Onto Baha Mala—Aditya Mitra “Santhali”.</li>
                <li>(e) Tiryo Tetang—Hari Har Hansda.</li>
                <li>(f) Sisirjon Rar—Thakur Prasad Murmu.</li>
            </ul>

        <p className={`${styles.aboutheading2} `}>Part II—Novels</p>
            <ul className="list-unstyled">
                <li>(a) Harmawak Ato—R.Karstiars (Translator—R.K. Kisku Rapaz).</li>
                <li>(b) Manu Mati—Chandra Mohan Hansda.</li>
                <li>(c) Ato Orak—Doman Hansdak.</li>
                <li>(d) Ojoy Gada Dhiph re—Nathenial Murmu.</li>
            </ul>

        <p className={`${styles.aboutheading2} `}>Part III—Stories</p>
            <ul className="list-unstyled">
                <li>(a) Jiyon Gada—Rup Chand Hansda and Jadumani Beshra.</li>
                <li>(b) Mayajaal—Doman Sahu ‘Samir’ and Padmashri Bhagwat Murmu ‘Thakur’.</li>
            </ul> 

        <p className={`${styles.aboutheading2} `}>Part IV—Drama</p>       
            <ul className="list-unstyled">
                <li>(a) Kherwar Bir—Pandit Raghunath Murmu</li>
                <li>(b) Juri Khatir—Dr. K.C. Tudu.</li>
                <li>(c) Birsa Bir—Ravi Lal Tudu.</li>
            </ul>

       <p className={`${styles.aboutheading2} `}> Part V—Biography</p>
            <ul className="list-unstyled">
              <li> Santal Ko Ren Mayam Gohako—Dr. Biswanath Hansda.</li>
            </ul>
        </div>
    </div>
  </div>
</div>

{/* 46. SINDHI Language */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        46</span> SINDHI 
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Sindhi - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
        
    <p className={`${styles.aboutheading2} text-center `}>
        Answers must be written in Sindhi <br/>
        (Arabic or Devanagari Script)
    </p>

    <p className={`${styles.aboutheading2} text-center`}>
        Section A
    </p>
    
    <p className={`${styles.aboutheading2} `}>1. (a) Origin and evolution of Sindhi language—views of different scholars.</p>

        <ul className="list-unstyled">
            <li>(b) Significant linguistic features of Sindhi language, including those pertaining to its phonology, morphology and syntax.</li>
            <li>(c) Major dialects of the Sindhi language.</li>
            <li>(d) Sindhi vocabulary—stages of its growth, including those in the pre-partition and post-partition periods.</li>
            <li>(e) Historical study of various Writing Systems (Scripts) of Sindhi.</li>
            <li>(f) Changesin the structure of Sindhi language in India, after partition, due to influence of other languages and social conditions.</li>
        </ul>
 
    <p className={`${styles.aboutheading2} text-center`}>Section B</p>

    <p className={`${styles.aboutheading} `}> 2. Sindhi literature through the ages in context of socio-cultural conditions in the respective periods :</p>

        <ul className="list-unstyled"> 
            <li>(a) Early medieval literature upto 1350 A.D. including folk literature.</li>
            <li>(b) Late medieval period from 1350 A.D. to 1850 A.D.</li>
            <li>(c) Renaissance period from 1850 A.D. to 1947 A.D.</li>
            <li>(d) Modern period from 1947 and onwards.</li>
        </ul>

    <p className={`${styles.aboutheading} `}> 
        (Literary genres in Modern Sindhi literature andexperiments in poetry, drama, novel, short story,
        essay, literary criticism, biography, autobiography, memoirs and travelogues.)
    </p>


 </div>
</div>

{/* SINDHI II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
       Sindhi - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", 
            textAlign: "justify", 
            }}
      > 
      
        <p className={`${styles.aboutheading2} text-center`}>
            Answer must be written in Sindhi <br/>
                (Arabic or Devanagari script)
        </p>
        
        <p className={`${styles.aboutheading} `}> This paper will require the first-hand reading of the texts prescribed and will be designed to test the candidate’s critical ability.</p>

        <p className={`${styles.aboutheading2} text-center`}>Section A</p>
        
        <p className={`${styles.aboutheading} `}>References to context and critical appreciation of the texts included in this section.</p>

        <p className={`${styles.aboutheading2} `}>(1) Poetry</p> 

            <ul className="list-unstyled">

                <li>a. ‘‘Shah Jo Choond Shair’’ : ed. H.I. Sadarangani, Published by Sahitya Akademi (First 100 pages).</li>
                <li>b. ‘‘Sachal Jo Choond Kalam’’ : ed. Kalyan B. Advani Published by Sahitya Akademi (Kafis only).</li>
                <li>c. ‘‘Sami-a-ja Choond Sloka’’ : ed. B.H. Nagrani Published by Sahitya Akademi (First 100 pages).</li>
                <li>d. ‘‘Shair-e-Bewas’’ : by Kishinchand Bewas(“Saamoondi Sipoon’’ portion only).</li>
                <li>e. ‘‘Roshan Chhanvro’’ : Narayan Shyam.</li>
                <li>f. ‘‘Virhange Khapoi je Sindhi Shair jee Choond’’ : ed. H.I. Sadarangani, published by Sahitya Akademi.</li>

            </ul>

        <p className={`${styles.aboutheading2} `}>(2) Drama</p>

            <ul className="list-unstyled">
               <li>g. ‘‘Behtareen Sindhi Natak’’ (One-act Plays) : Edited by M. Kamal Published by Gujarat Sindhi Academy.</li>
               <li>h. ‘‘Kako Kaloomal’’ (Full-length Play ) : by Madan Jumani. </li>
            </ul>

        <p className={`${styles.aboutheading2} text-center`}>Section B</p>

        <p className={`${styles.aboutheading2} `}>
            References to context and critical appreciation of the texts included in this section.
        </p>

            <ul className="list-unstyled">  
                <li>a. ‘Pakheeara Valar Khan Vichhrya’ (Novel) : by Gobind Malhi.</li>
                <li>b. ‘Sat Deenhan’ (Novel) : by Krishin Khatwani.</li>
                <li>c. ‘Choond Sindhi Kahanyoon’ (Short Stories) Vol. III. : Edited by Prem Prakash, published by Sahitya Akademi.</li>   
            
                <li>d. ‘Bandhan’ (Short Stories) : Sundari Uttamchandani.</li>
                <li>e. ‘Behtareen Sindhi Mazmoon’ (Essays): Edited by Hiro Thakur, published by Gujarat Sindhi Academi.</li>
                <li>f. ‘Sindhi Tanqeed’ (Criticism) : Edited by Harish Vaswani : Published by Sahitya Akademi.</li>
                <li>g. ‘Mumhinjee Hayati-a-ja Sona Ropa varqa’ (Autobiography) : by Popati Hiranandani.</li>
                <li>h. ‘‘Dr. Choithram Gidwani’’ (Biography) : by Vishnu Sharma.</li>
            </ul>

        </div>
    </div>
  </div>
</div>


{/* 47. TELUGU Language */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        47</span> TELUGU 
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Telugu - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
        
    <p className={`${styles.aboutheading2} text-center `}>
       Answers must be written in Telugu 
    </p>

    <p className={`${styles.aboutheading2} text-center`}>
        Section A : Language
    </p>

    <p className={`${styles.aboutheading} `}>
        1. Place of Telugu among Dravidian languages and its antiquity—Etymological History of Telugu,Tenugu
        and Andhra.
    </p>    

   <p className={`${styles.aboutheading} `}>
        2. Major linguistic changes in phonological, morphological, grammatical and syntactical levels, from Proto-
        Dravidian to old Telugu and from old Telugu to Modern Telugu.
    </p>

   <p className={`${styles.aboutheading} `}>
        3. Evolution of spoken Telugu when compared to classical Telugu-Formal and functional view of Telugu
        language.
   </p>

    <p className={`${styles.aboutheading} `}> 4. Influence of other languages and its impact on Telugu</p>

    <p className={`${styles.aboutheading} `}> 
            5. Modernization of Telugu language :
    </p>
        <ul className="list-unstyled">
            <li>(a) Linguistic and literary movements and their role in modernization of Telugu.</li>
            <li>(b) Role of media in modernization of Telugu (News-papers, Radio, TV etc.)</li>
            <li>(c) Problems of terminology and mechanisms in coining new terms in Telugu in various discourses
                including scientific and technical.</li>
        </ul>

    <p className={`${styles.aboutheading} `}>6. Dialects of Telugu—Regional and social variations and problems of Standardization. </p>

    <p className={`${styles.aboutheading}`}> 7. Syntax—Major divisions of Telugu sentences—simple, complex and compound sentences—Noun and
        verb predications—Processes of nominalization and relativization—Direct and indirect reporting-conversion
        processes.
    </p>

    <p className={`${styles.aboutheading}`}>8. Translation—Problems of translation, cultural, social and idiomatic—Methods of translation—
        Approaches to translation—Literary and other kinds of translation—Various uses of translation.</p>

    
    <p className={`${styles.aboutheading2} text-center`}>Section B : Language</p>

    <p className={`${styles.aboutheading} `}>1. Literature in Pre-Nannaya Period—Marga and Desi poetry. </p>

    <p className={`${styles.aboutheading} `}>2. Nannaya Period—Historical and literary background of Andhra Mahabharata.</p>

    <p className={`${styles.aboutheading} `}>3. Saiva poets and their contribution—Dwipada, Sataka, Ragada, Udaharana. </p>

    <p className={`${styles.aboutheading} `}>4. Tikkana and his place in Telugu literature. </p>

    <p className={`${styles.aboutheading} `}>5. Errana and his literary works—Nachana Somana and his new approach to poetry. </p>

    <p className={`${styles.aboutheading} `}>6. Srinatha and Potana—Their works and contribution.</p>

    <p className={`${styles.aboutheading} `}>7. Bhakti poets in Telugu literature—Tallapaka Annamayya, ramadasu, tyagayya. </p>

    <p className={`${styles.aboutheading} `}>8. Evolution of prabandhas—Kavya and prabandha.</p>

    <p className={`${styles.aboutheading} `}>9. Southern school of Telugu literature-raghunatha Nayaka, chemakura vankatakavi and women poets - Literary forms like yakshagana, prose and padakavita.</p>

    <p className={`${styles.aboutheading} `}>10. Modern Telugu Literature and literary forms—Novel, Short Story, Drama, Playlet and poetic forms. </p>

    <p className={`${styles.aboutheading} `}>11. Literary Movements : Reformation, Nationalism, Neo-classisicism, Romanticism and Progressive, Revolutionary movements.</p>

    <p className={`${styles.aboutheading} `}>12. Digambarakavulu, feminist and dalit Literature.</p>

    <p className={`${styles.aboutheading} `}>13. Main divisions of folk literature—Performing folk arts.</p>

 </div>
</div>

{/* Telugu II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
       Telugu - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", 
            textAlign: "justify", 
            }}
      > 
      
        <p className={`${styles.aboutheading2} text-center`}>
            Answer must be written in Telugu   
        </p>
        
        <p className={`${styles.aboutheading} `}>  This paper will require first hand reading of the prescribed texts and will be designed to test the candidate’s
            critical ability, which will be in relation to the following approaches :—
        </p>

        <p className={`${styles.aboutheading} `}>(i) Aesthetic approach—Rassa, Dhawani, Vakroti and Auchitya—Formal and Structural-Imagery and Symbolism</p>
        <p className={`${styles.aboutheading} `}>(ii) Sociological, Historical, Ideological, Psychological approaches.</p>

        <p className={`${styles.aboutheading2} text-center`}>Section A</p>
        
        <p className={`${styles.aboutheading} `}>1. Nannaya-Dushyanta Chritra (Adiparva 4th Canto verses 5—109). </p>

        <p className={`${styles.aboutheading} `}>2. Tikkana-Sri Krishna Rayabaramu (Udyoga parva-3rd Canto verses 1—144). </p>

        <p className={`${styles.aboutheading} `}>3. Srinath-Guna Nidhi Katha (Kasikhandam, 4th Canto, verses 76—133). </p>

        <p className={`${styles.aboutheading} `}>4. Pingali Surana-sugatri Salinulakatha (Kalapurno-dayamu 4 Canto verses, 60—142).</p>

        <p className={`${styles.aboutheading} `}>5. Molla-Ramayanamu (Balakanda including avatarika).</p>

        <p className={`${styles.aboutheading} `}>6. Kasula Purushothama Kavi—Andhra Nayaka Satakamu.</p>

        <p className={`${styles.aboutheading2} text-center`}>Section B</p>

        <p className={`${styles.aboutheading} `}>7. Gurajada Appa Rao—Animutyalu (Short stories).</p>

        <p className={`${styles.aboutheading} `}>8. Viswanatha Satyanarayana—Andhra prasasti.</p>

        <p className={`${styles.aboutheading} `}>9. Devulapalli Krishna Sastry—Krishnapaksham (excluding Uravsi and Pravasam). </p>

        <p className={`${styles.aboutheading} `}>10. Sri Sri-Maha prastanam</p>

        <p className={`${styles.aboutheading} `}>11. Jashuva-Gabbilam (Part I).</p>

        <p className={`${styles.aboutheading} `}>12. C. Narayana Reddy—Karpuravasanta rayalu.</p>

        <p className={`${styles.aboutheading} `}>13. Kanuparti Varalakshmamma—Sarada lekhalu (Part I).</p>

        <p className={`${styles.aboutheading} `}>14. Atreya—N.G.O.</p>

        <p className={`${styles.aboutheading} `}>15. Racha Konda Viswanatha Sastry—Alpajaeevi.</p>

        </div>
    </div>
  </div>
</div>

{/* 48. URDU Language */}

<div className="container pt-5">
    <h2 className="fw-bold text-center mb-4" style={{fontSize: "1.5rem",letterSpacing: "0.05em",color: "#222",borderBottom: "",display: "inline-block",paddingBottom: "5px",}}>
        <span style={{display: "inline-flex", justifyContent: "center",alignItems: "center", width: "45px",height: "45px", borderRadius: "50%",background: "linear-gradient(145deg, #ffffff, #f1f1f1)",
           color: "#f00", fontWeight: "900",fontSize: "1.2rem",marginRight: "10px",border: "2px solid #ffffff",boxShadow: "3px 3px 6px rgba(0,0,0,0.25), -2px -2px 6px rgba(255,255,255,0.7)",}}>
        48</span> URDU 
      </h2>
  <div className="row justify-content-center">
    <div className="col-lg-10">
     
      <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
        Urdu - Paper I
      </h3>

      <div  className="p-4 rounded-bottom-4 shadow border mb-5" 
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333",
            textAlign: "justify",
            }}
      >
        
    <p className={`${styles.aboutheading2} text-center `}>
       Answers must be written in Urdu 
    </p>

    <p className={`${styles.aboutheading2} text-center`}>
        Section A 
    </p>

    <p className={`${styles.aboutheading2} `}>
        Development of Urdu Language
    </p>    

   <p className={`${styles.aboutheading2} `}>
       (a) Development of Indo-Aryan
    </p>
        <ul className="list-unstyled">
            <li>(i) Old Indo-Aryan</li>
            <li>(ii) Middle Indo-Aryan </li>
            <li>(iii) New Indo-Aryan.</li>
        </ul>

    <p className={`${styles.aboutheading} `}>
        (b) Western Hindi and its dialects Brij Bhasha Khadi Boli, Haryanavi, Kannauji, Bundeli—Theories about
        the origin of Urdu language.
    </p>

    <p className={`${styles.aboutheading}`}>
        (c) Dakhani Urdu—origin and development, its significant linguistic features.
    </p>

    <p className={`${styles.aboutheading}`}>
        (d) Social and Cultural roots of Urdu language— and its distinctive features.
        Script, Phonology, Morphology, Vocabulary.
    </p>

    
    <p className={`${styles.aboutheading2} text-center`}>Section B </p>

    <p className={`${styles.aboutheading2} `}>
       (a)Genres and their development :
    </p>
        <ul className="list-unstyled">
            <li>(i) Poetry: Ghazal, Masnavi, Qasida, Marsia, Rubai Jadid Nazm.</li>
            <li>(ii) Prose : Novel, Short Story, Dastan, Drama, Inshaiya, Khutoot, Biography. </li>
        </ul>

    <p className={`${styles.aboutheading2} `}>
        (b) Significant feaures of : 
    </p>   
        <ul className="list-unstyled">
            <li>(i) Deccani, Delhi and Lucknow schools, </li>
            <li>(ii) Sir Syed movement, Romantic movement, Progressive movement, Modernism.</li>
        </ul>
    <p className={`${styles.aboutheading} `}>
        (c) Literary Criticism and its development with reference to Hali, Shibli, Kaleemuddin Ahmad, Ehtisham
            Hussain, Ale-Ahmad Suroor.
    </p>

    <p className={`${styles.aboutheading} `}>(d) Essay writing (covering literary and imaginativetopics). </p>

 </div>
</div>

{/* Urdu II*/}

    <div className="col-lg-10 pt-4">
     <h3 className="fw-bold text-white text-center rounded-top-4"
          style={{
            background: "linear-gradient(to right,rgb(228, 18, 18),rgb(241, 138, 142))",
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            padding: "12px",
            }}>
       Urdu - Paper II
      </h3>
      
      <div className="p-4 rounded-bottom-4 shadow border"
            style={{
            background: "rgba(255,255,255,0.98)",
            lineHeight: "1.9em",
            fontSize: "1rem",
            color: "#333", 
            textAlign: "justify", 
            }}
      > 
      
        <p className={`${styles.aboutheading2} text-center`}>
            Answer must be written in Urdu   
        </p>
        
        <p className={`${styles.aboutheading} `}>This paper will require first hand reading of the texts prescribed and will be designed to test the candidate's critical ability.</p>

        <p className={`${styles.aboutheading2} text-center`}>Section A</p>

        <div className="container my-4">
            <div className="row g-4">
                <div className="col-12">
                    <table className="table table-bordered table-striped table-hover align-middle text-center">
                        <tbody>
                            <tr>
                                <td>1.</td>
                                <td>Mir Amman</td>
                                <td>Bagho-Babar</td>
                            </tr>

                            <tr>
                                <td>2.</td>
                                <td>Ghalib</td>
                                <td>Intikhab-e-Khutoot-e Ghalib</td>
                            </tr>

                            <tr>
                                <td>3.</td>
                                <td>Mohd. Husain Azad</td>
                                <td>Nairang-e-Khayal</td>
                           </tr>

                            <tr>
                                <td>4.</td>
                                <td>Prem Chand</td>
                                <td>Godan</td>
                            </tr>

                            <tr>
                                <td>5.</td>
                                <td>Rajendra Singh Bedi</td>
                                <td>Apne Dukh Mujhe Dedo</td>
                            </tr>

                            <tr>
                                <td>6.</td>
                                <td>Abul Kalam Azad</td>
                                <td>Ghubar-e-Khatir</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <p className={`${styles.aboutheading2} text-center`}>Section B</p>

        <div className="container my-4">
            <div className="row g-4">
                <div className="col-12">
                    <table className="table table-bordered table-striped table-hover align-middle text-center">
                        <tbody>
                            <tr>
                                <td>1.</td>
                                <td>Mir</td>
                                <td>Intikhab-e-Kalam-e-Mir (Ed. Abdul Haq.)</td>
                            </tr>

                            <tr>
                                <td>2.</td>
                                <td>Mir Hasan</td>
                                <td>Sahrul Bayan</td>
                            </tr>

                            <tr>
                                <td>3.</td>
                                <td>Ghalib</td>
                                <td>Diwan-e-Ghalib</td>
                           </tr>

                            <tr>
                                <td>4.</td>
                                <td>Iqbal</td>
                                <td>Bal-e-Jibrail</td>
                            </tr>

                            <tr>
                                <td>5.</td>
                                <td>Firaq</td>
                                <td>Gul-e-Naghma</td>
                            </tr>

                            <tr>
                                <td>6.</td>
                                <td>Faiz</td>
                                <td>Dast-e-Saba</td>
                            </tr>

                            <tr>
                                <td>7.</td>
                                <td>Akhtruliman</td>
                                <td>Bint-e-Lamhat</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        
        
        </div>
    </div>
  </div>
</div>


<Interest />
<Footer />
                            
    </>
  )
}

export default Upsc_Syllabus;